webpackJsonp([2],{

/***/ "/kga":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/prevent-body-scroll.js
var prevent_body_scroll = __webpack_require__("JkZY");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-dialog/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_dialog = ({
  mixins: [prevent_body_scroll["a" /* default */]],
  name: 'x-dialog',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    maskZIndex: [String, Number],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    dialogClass: {
      type: String,
      default: 'weui-dialog'
    },
    hideOnBlur: Boolean,
    dialogStyle: Object,
    scroll: {
      type: Boolean,
      default: true,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.warn('[VUX warn] x-dialog:scroll 已经废弃。如果你是 100% 布局，请参照文档配置 $layout 以实现阻止滚动');
        }
        return true;
      }
    }
  },
  computed: {
    maskStyle: function maskStyle() {
      if (typeof this.maskZIndex !== 'undefined') {
        return {
          zIndex: this.maskZIndex
        };
      }
    }
  },
  mounted: function mounted() {
    if (typeof window !== 'undefined') {
      if (window.VUX_CONFIG && window.VUX_CONFIG.$layout === 'VIEW_BOX') {
        this.layout = 'VIEW_BOX';
      }
    }
  },

  watch: {
    show: function show(val) {
      this.$emit('update:show', val);
      this.$emit(val ? 'on-show' : 'on-hide');
      if (val) {
        this.addModalClassName();
      } else {
        this.removeModalClassName();
      }
    }
  },
  methods: {
    shouldPreventScroll: function shouldPreventScroll() {
      // hard to get focus on iOS device with fixed position, so just ignore it
      var iOS = /iPad|iPhone|iPod/i.test(window.navigator.userAgent);
      var hasInput = this.$el.querySelector('input') || this.$el.querySelector('textarea');
      if (iOS && hasInput) {
        return true;
      }
    },
    hide: function hide() {
      if (this.hideOnBlur) {
        this.$emit('update:show', false);
        this.$emit('change', false);
        this.$emit('on-click-mask');
      }
    }
  },
  data: function data() {
    return {
      layout: ''
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347e3f32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-dialog/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-dialog",class:{'vux-x-dialog-absolute': _vm.layout === 'VIEW_BOX'}},[_c('transition',{attrs:{"name":_vm.maskTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask",style:(_vm.maskStyle),on:{"click":_vm.hide}})]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.dialogTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],class:_vm.dialogClass,style:(_vm.dialogStyle)},[_vm._t("default")],2)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var src_components_x_dialog = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-dialog/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("7zGH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  components_x_dialog,
  src_components_x_dialog,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_dialog = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0/Fx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "1qEj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2GJp":
/***/ (function(module, exports) {

module.exports = [{"name":"北京市","value":"110000"},{"name":"天津市","value":"120000"},{"name":"河北省","value":"130000"},{"name":"山西省","value":"140000"},{"name":"内蒙古自治区","value":"150000"},{"name":"辽宁省","value":"210000"},{"name":"吉林省","value":"220000"},{"name":"黑龙江省","value":"230000"},{"name":"上海市","value":"310000"},{"name":"江苏省","value":"320000"},{"name":"浙江省","value":"330000"},{"name":"安徽省","value":"340000"},{"name":"福建省","value":"350000"},{"name":"江西省","value":"360000"},{"name":"山东省","value":"370000"},{"name":"河南省","value":"410000"},{"name":"湖北省","value":"420000"},{"name":"湖南省","value":"430000"},{"name":"广东省","value":"440000"},{"name":"广西壮族自治区","value":"450000"},{"name":"海南省","value":"460000"},{"name":"重庆市","value":"500000"},{"name":"四川省","value":"510000"},{"name":"贵州省","value":"520000"},{"name":"云南省","value":"530000"},{"name":"西藏自治区","value":"540000"},{"name":"陕西省","value":"610000"},{"name":"甘肃省","value":"620000"},{"name":"青海省","value":"630000"},{"name":"宁夏回族自治区","value":"640000"},{"name":"新疆维吾尔自治区","value":"650000"},{"name":"市辖区","value":"110100","parent":"110000"},{"name":"东城区","value":"110101","parent":"110100"},{"name":"西城区","value":"110102","parent":"110100"},{"name":"朝阳区","value":"110105","parent":"110100"},{"name":"丰台区","value":"110106","parent":"110100"},{"name":"石景山区","value":"110107","parent":"110100"},{"name":"海淀区","value":"110108","parent":"110100"},{"name":"门头沟区","value":"110109","parent":"110100"},{"name":"房山区","value":"110111","parent":"110100"},{"name":"通州区","value":"110112","parent":"110100"},{"name":"顺义区","value":"110113","parent":"110100"},{"name":"昌平区","value":"110114","parent":"110100"},{"name":"大兴区","value":"110115","parent":"110100"},{"name":"怀柔区","value":"110116","parent":"110100"},{"name":"平谷区","value":"110117","parent":"110100"},{"name":"密云县","value":"110228","parent":"110100"},{"name":"延庆县","value":"110229","parent":"110100"},{"name":"市辖区","value":"120100","parent":"120000"},{"name":"和平区","value":"120101","parent":"120100"},{"name":"河东区","value":"120102","parent":"120100"},{"name":"河西区","value":"120103","parent":"120100"},{"name":"南开区","value":"120104","parent":"120100"},{"name":"河北区","value":"120105","parent":"120100"},{"name":"红桥区","value":"120106","parent":"120100"},{"name":"东丽区","value":"120110","parent":"120100"},{"name":"西青区","value":"120111","parent":"120100"},{"name":"津南区","value":"120112","parent":"120100"},{"name":"北辰区","value":"120113","parent":"120100"},{"name":"武清区","value":"120114","parent":"120100"},{"name":"宝坻区","value":"120115","parent":"120100"},{"name":"滨海新区","value":"120116","parent":"120100"},{"name":"宁河区","value":"120117","parent":"120100"},{"name":"静海区","value":"120118","parent":"120100"},{"name":"蓟县","value":"120225","parent":"120100"},{"name":"石家庄市","value":"130100","parent":"130000"},{"name":"唐山市","value":"130200","parent":"130000"},{"name":"秦皇岛市","value":"130300","parent":"130000"},{"name":"邯郸市","value":"130400","parent":"130000"},{"name":"邢台市","value":"130500","parent":"130000"},{"name":"保定市","value":"130600","parent":"130000"},{"name":"张家口市","value":"130700","parent":"130000"},{"name":"承德市","value":"130800","parent":"130000"},{"name":"沧州市","value":"130900","parent":"130000"},{"name":"廊坊市","value":"131000","parent":"130000"},{"name":"衡水市","value":"131100","parent":"130000"},{"name":"定州市","value":"139001","parent":"130000"},{"name":"辛集市","value":"139002","parent":"130000"},{"name":"长安区","value":"130102","parent":"130100"},{"name":"桥西区","value":"130104","parent":"130100"},{"name":"新华区","value":"130105","parent":"130100"},{"name":"井陉矿区","value":"130107","parent":"130100"},{"name":"裕华区","value":"130108","parent":"130100"},{"name":"藁城区","value":"130109","parent":"130100"},{"name":"鹿泉区","value":"130110","parent":"130100"},{"name":"栾城区","value":"130111","parent":"130100"},{"name":"井陉县","value":"130121","parent":"130100"},{"name":"正定县","value":"130123","parent":"130100"},{"name":"行唐县","value":"130125","parent":"130100"},{"name":"灵寿县","value":"130126","parent":"130100"},{"name":"高邑县","value":"130127","parent":"130100"},{"name":"深泽县","value":"130128","parent":"130100"},{"name":"赞皇县","value":"130129","parent":"130100"},{"name":"无极县","value":"130130","parent":"130100"},{"name":"平山县","value":"130131","parent":"130100"},{"name":"元氏县","value":"130132","parent":"130100"},{"name":"赵县","value":"130133","parent":"130100"},{"name":"晋州市","value":"130183","parent":"130100"},{"name":"新乐市","value":"130184","parent":"130100"},{"name":"路南区","value":"130202","parent":"130200"},{"name":"路北区","value":"130203","parent":"130200"},{"name":"古冶区","value":"130204","parent":"130200"},{"name":"开平区","value":"130205","parent":"130200"},{"name":"丰南区","value":"130207","parent":"130200"},{"name":"丰润区","value":"130208","parent":"130200"},{"name":"曹妃甸区","value":"130209","parent":"130200"},{"name":"滦县","value":"130223","parent":"130200"},{"name":"滦南县","value":"130224","parent":"130200"},{"name":"乐亭县","value":"130225","parent":"130200"},{"name":"迁西县","value":"130227","parent":"130200"},{"name":"玉田县","value":"130229","parent":"130200"},{"name":"遵化市","value":"130281","parent":"130200"},{"name":"迁安市","value":"130283","parent":"130200"},{"name":"海港区","value":"130302","parent":"130300"},{"name":"山海关区","value":"130303","parent":"130300"},{"name":"北戴河区","value":"130304","parent":"130300"},{"name":"抚宁区","value":"130306","parent":"130300"},{"name":"青龙满族自治县","value":"130321","parent":"130300"},{"name":"昌黎县","value":"130322","parent":"130300"},{"name":"卢龙县","value":"130324","parent":"130300"},{"name":"邯山区","value":"130402","parent":"130400"},{"name":"丛台区","value":"130403","parent":"130400"},{"name":"复兴区","value":"130404","parent":"130400"},{"name":"峰峰矿区","value":"130406","parent":"130400"},{"name":"邯郸县","value":"130421","parent":"130400"},{"name":"临漳县","value":"130423","parent":"130400"},{"name":"成安县","value":"130424","parent":"130400"},{"name":"大名县","value":"130425","parent":"130400"},{"name":"涉县","value":"130426","parent":"130400"},{"name":"磁县","value":"130427","parent":"130400"},{"name":"肥乡县","value":"130428","parent":"130400"},{"name":"永年县","value":"130429","parent":"130400"},{"name":"邱县","value":"130430","parent":"130400"},{"name":"鸡泽县","value":"130431","parent":"130400"},{"name":"广平县","value":"130432","parent":"130400"},{"name":"馆陶县","value":"130433","parent":"130400"},{"name":"魏县","value":"130434","parent":"130400"},{"name":"曲周县","value":"130435","parent":"130400"},{"name":"武安市","value":"130481","parent":"130400"},{"name":"桥东区","value":"130502","parent":"130500"},{"name":"桥西区","value":"130503","parent":"130500"},{"name":"邢台县","value":"130521","parent":"130500"},{"name":"临城县","value":"130522","parent":"130500"},{"name":"内丘县","value":"130523","parent":"130500"},{"name":"柏乡县","value":"130524","parent":"130500"},{"name":"隆尧县","value":"130525","parent":"130500"},{"name":"任县","value":"130526","parent":"130500"},{"name":"南和县","value":"130527","parent":"130500"},{"name":"宁晋县","value":"130528","parent":"130500"},{"name":"巨鹿县","value":"130529","parent":"130500"},{"name":"新河县","value":"130530","parent":"130500"},{"name":"广宗县","value":"130531","parent":"130500"},{"name":"平乡县","value":"130532","parent":"130500"},{"name":"威县","value":"130533","parent":"130500"},{"name":"清河县","value":"130534","parent":"130500"},{"name":"临西县","value":"130535","parent":"130500"},{"name":"南宫市","value":"130581","parent":"130500"},{"name":"沙河市","value":"130582","parent":"130500"},{"name":"竞秀区","value":"130602","parent":"130600"},{"name":"莲池区","value":"130606","parent":"130600"},{"name":"满城区","value":"130607","parent":"130600"},{"name":"清苑区","value":"130608","parent":"130600"},{"name":"徐水区","value":"130609","parent":"130600"},{"name":"涞水县","value":"130623","parent":"130600"},{"name":"阜平县","value":"130624","parent":"130600"},{"name":"定兴县","value":"130626","parent":"130600"},{"name":"唐县","value":"130627","parent":"130600"},{"name":"高阳县","value":"130628","parent":"130600"},{"name":"容城县","value":"130629","parent":"130600"},{"name":"涞源县","value":"130630","parent":"130600"},{"name":"望都县","value":"130631","parent":"130600"},{"name":"安新县","value":"130632","parent":"130600"},{"name":"易县","value":"130633","parent":"130600"},{"name":"曲阳县","value":"130634","parent":"130600"},{"name":"蠡县","value":"130635","parent":"130600"},{"name":"顺平县","value":"130636","parent":"130600"},{"name":"博野县","value":"130637","parent":"130600"},{"name":"雄县","value":"130638","parent":"130600"},{"name":"涿州市","value":"130681","parent":"130600"},{"name":"安国市","value":"130683","parent":"130600"},{"name":"高碑店市","value":"130684","parent":"130600"},{"name":"桥东区","value":"130702","parent":"130700"},{"name":"桥西区","value":"130703","parent":"130700"},{"name":"宣化区","value":"130705","parent":"130700"},{"name":"下花园区","value":"130706","parent":"130700"},{"name":"宣化县","value":"130721","parent":"130700"},{"name":"张北县","value":"130722","parent":"130700"},{"name":"康保县","value":"130723","parent":"130700"},{"name":"沽源县","value":"130724","parent":"130700"},{"name":"尚义县","value":"130725","parent":"130700"},{"name":"蔚县","value":"130726","parent":"130700"},{"name":"阳原县","value":"130727","parent":"130700"},{"name":"怀安县","value":"130728","parent":"130700"},{"name":"万全县","value":"130729","parent":"130700"},{"name":"怀来县","value":"130730","parent":"130700"},{"name":"涿鹿县","value":"130731","parent":"130700"},{"name":"赤城县","value":"130732","parent":"130700"},{"name":"崇礼县","value":"130733","parent":"130700"},{"name":"双桥区","value":"130802","parent":"130800"},{"name":"双滦区","value":"130803","parent":"130800"},{"name":"鹰手营子矿区","value":"130804","parent":"130800"},{"name":"承德县","value":"130821","parent":"130800"},{"name":"兴隆县","value":"130822","parent":"130800"},{"name":"平泉县","value":"130823","parent":"130800"},{"name":"滦平县","value":"130824","parent":"130800"},{"name":"隆化县","value":"130825","parent":"130800"},{"name":"丰宁满族自治县","value":"130826","parent":"130800"},{"name":"宽城满族自治县","value":"130827","parent":"130800"},{"name":"围场满族蒙古族自治县","value":"130828","parent":"130800"},{"name":"新华区","value":"130902","parent":"130900"},{"name":"运河区","value":"130903","parent":"130900"},{"name":"沧县","value":"130921","parent":"130900"},{"name":"青县","value":"130922","parent":"130900"},{"name":"东光县","value":"130923","parent":"130900"},{"name":"海兴县","value":"130924","parent":"130900"},{"name":"盐山县","value":"130925","parent":"130900"},{"name":"肃宁县","value":"130926","parent":"130900"},{"name":"南皮县","value":"130927","parent":"130900"},{"name":"吴桥县","value":"130928","parent":"130900"},{"name":"献县","value":"130929","parent":"130900"},{"name":"孟村回族自治县","value":"130930","parent":"130900"},{"name":"泊头市","value":"130981","parent":"130900"},{"name":"任丘市","value":"130982","parent":"130900"},{"name":"黄骅市","value":"130983","parent":"130900"},{"name":"河间市","value":"130984","parent":"130900"},{"name":"安次区","value":"131002","parent":"131000"},{"name":"广阳区","value":"131003","parent":"131000"},{"name":"固安县","value":"131022","parent":"131000"},{"name":"永清县","value":"131023","parent":"131000"},{"name":"香河县","value":"131024","parent":"131000"},{"name":"大城县","value":"131025","parent":"131000"},{"name":"文安县","value":"131026","parent":"131000"},{"name":"大厂回族自治县","value":"131028","parent":"131000"},{"name":"霸州市","value":"131081","parent":"131000"},{"name":"三河市","value":"131082","parent":"131000"},{"name":"桃城区","value":"131102","parent":"131100"},{"name":"枣强县","value":"131121","parent":"131100"},{"name":"武邑县","value":"131122","parent":"131100"},{"name":"武强县","value":"131123","parent":"131100"},{"name":"饶阳县","value":"131124","parent":"131100"},{"name":"安平县","value":"131125","parent":"131100"},{"name":"故城县","value":"131126","parent":"131100"},{"name":"景县","value":"131127","parent":"131100"},{"name":"阜城县","value":"131128","parent":"131100"},{"name":"冀州市","value":"131181","parent":"131100"},{"name":"深州市","value":"131182","parent":"131100"},{"name":"太原市","value":"140100","parent":"140000"},{"name":"大同市","value":"140200","parent":"140000"},{"name":"阳泉市","value":"140300","parent":"140000"},{"name":"长治市","value":"140400","parent":"140000"},{"name":"晋城市","value":"140500","parent":"140000"},{"name":"朔州市","value":"140600","parent":"140000"},{"name":"晋中市","value":"140700","parent":"140000"},{"name":"运城市","value":"140800","parent":"140000"},{"name":"忻州市","value":"140900","parent":"140000"},{"name":"临汾市","value":"141000","parent":"140000"},{"name":"吕梁市","value":"141100","parent":"140000"},{"name":"小店区","value":"140105","parent":"140100"},{"name":"迎泽区","value":"140106","parent":"140100"},{"name":"杏花岭区","value":"140107","parent":"140100"},{"name":"尖草坪区","value":"140108","parent":"140100"},{"name":"万柏林区","value":"140109","parent":"140100"},{"name":"晋源区","value":"140110","parent":"140100"},{"name":"清徐县","value":"140121","parent":"140100"},{"name":"阳曲县","value":"140122","parent":"140100"},{"name":"娄烦县","value":"140123","parent":"140100"},{"name":"古交市","value":"140181","parent":"140100"},{"name":"城区","value":"140202","parent":"140200"},{"name":"矿区","value":"140203","parent":"140200"},{"name":"南郊区","value":"140211","parent":"140200"},{"name":"新荣区","value":"140212","parent":"140200"},{"name":"阳高县","value":"140221","parent":"140200"},{"name":"天镇县","value":"140222","parent":"140200"},{"name":"广灵县","value":"140223","parent":"140200"},{"name":"灵丘县","value":"140224","parent":"140200"},{"name":"浑源县","value":"140225","parent":"140200"},{"name":"左云县","value":"140226","parent":"140200"},{"name":"大同县","value":"140227","parent":"140200"},{"name":"城区","value":"140302","parent":"140300"},{"name":"矿区","value":"140303","parent":"140300"},{"name":"郊区","value":"140311","parent":"140300"},{"name":"平定县","value":"140321","parent":"140300"},{"name":"盂县","value":"140322","parent":"140300"},{"name":"城区","value":"140402","parent":"140400"},{"name":"郊区","value":"140411","parent":"140400"},{"name":"长治县","value":"140421","parent":"140400"},{"name":"襄垣县","value":"140423","parent":"140400"},{"name":"屯留县","value":"140424","parent":"140400"},{"name":"平顺县","value":"140425","parent":"140400"},{"name":"黎城县","value":"140426","parent":"140400"},{"name":"壶关县","value":"140427","parent":"140400"},{"name":"长子县","value":"140428","parent":"140400"},{"name":"武乡县","value":"140429","parent":"140400"},{"name":"沁县","value":"140430","parent":"140400"},{"name":"沁源县","value":"140431","parent":"140400"},{"name":"潞城市","value":"140481","parent":"140400"},{"name":"城区","value":"140502","parent":"140500"},{"name":"沁水县","value":"140521","parent":"140500"},{"name":"阳城县","value":"140522","parent":"140500"},{"name":"陵川县","value":"140524","parent":"140500"},{"name":"泽州县","value":"140525","parent":"140500"},{"name":"高平市","value":"140581","parent":"140500"},{"name":"朔城区","value":"140602","parent":"140600"},{"name":"平鲁区","value":"140603","parent":"140600"},{"name":"山阴县","value":"140621","parent":"140600"},{"name":"应县","value":"140622","parent":"140600"},{"name":"右玉县","value":"140623","parent":"140600"},{"name":"怀仁县","value":"140624","parent":"140600"},{"name":"榆次区","value":"140702","parent":"140700"},{"name":"榆社县","value":"140721","parent":"140700"},{"name":"左权县","value":"140722","parent":"140700"},{"name":"和顺县","value":"140723","parent":"140700"},{"name":"昔阳县","value":"140724","parent":"140700"},{"name":"寿阳县","value":"140725","parent":"140700"},{"name":"太谷县","value":"140726","parent":"140700"},{"name":"祁县","value":"140727","parent":"140700"},{"name":"平遥县","value":"140728","parent":"140700"},{"name":"灵石县","value":"140729","parent":"140700"},{"name":"介休市","value":"140781","parent":"140700"},{"name":"盐湖区","value":"140802","parent":"140800"},{"name":"临猗县","value":"140821","parent":"140800"},{"name":"万荣县","value":"140822","parent":"140800"},{"name":"闻喜县","value":"140823","parent":"140800"},{"name":"稷山县","value":"140824","parent":"140800"},{"name":"新绛县","value":"140825","parent":"140800"},{"name":"绛县","value":"140826","parent":"140800"},{"name":"垣曲县","value":"140827","parent":"140800"},{"name":"夏县","value":"140828","parent":"140800"},{"name":"平陆县","value":"140829","parent":"140800"},{"name":"芮城县","value":"140830","parent":"140800"},{"name":"永济市","value":"140881","parent":"140800"},{"name":"河津市","value":"140882","parent":"140800"},{"name":"忻府区","value":"140902","parent":"140900"},{"name":"定襄县","value":"140921","parent":"140900"},{"name":"五台县","value":"140922","parent":"140900"},{"name":"代县","value":"140923","parent":"140900"},{"name":"繁峙县","value":"140924","parent":"140900"},{"name":"宁武县","value":"140925","parent":"140900"},{"name":"静乐县","value":"140926","parent":"140900"},{"name":"神池县","value":"140927","parent":"140900"},{"name":"五寨县","value":"140928","parent":"140900"},{"name":"岢岚县","value":"140929","parent":"140900"},{"name":"河曲县","value":"140930","parent":"140900"},{"name":"保德县","value":"140931","parent":"140900"},{"name":"偏关县","value":"140932","parent":"140900"},{"name":"原平市","value":"140981","parent":"140900"},{"name":"尧都区","value":"141002","parent":"141000"},{"name":"曲沃县","value":"141021","parent":"141000"},{"name":"翼城县","value":"141022","parent":"141000"},{"name":"襄汾县","value":"141023","parent":"141000"},{"name":"洪洞县","value":"141024","parent":"141000"},{"name":"古县","value":"141025","parent":"141000"},{"name":"安泽县","value":"141026","parent":"141000"},{"name":"浮山县","value":"141027","parent":"141000"},{"name":"吉县","value":"141028","parent":"141000"},{"name":"乡宁县","value":"141029","parent":"141000"},{"name":"大宁县","value":"141030","parent":"141000"},{"name":"隰县","value":"141031","parent":"141000"},{"name":"永和县","value":"141032","parent":"141000"},{"name":"蒲县","value":"141033","parent":"141000"},{"name":"汾西县","value":"141034","parent":"141000"},{"name":"侯马市","value":"141081","parent":"141000"},{"name":"霍州市","value":"141082","parent":"141000"},{"name":"离石区","value":"141102","parent":"141100"},{"name":"文水县","value":"141121","parent":"141100"},{"name":"交城县","value":"141122","parent":"141100"},{"name":"兴县","value":"141123","parent":"141100"},{"name":"临县","value":"141124","parent":"141100"},{"name":"柳林县","value":"141125","parent":"141100"},{"name":"石楼县","value":"141126","parent":"141100"},{"name":"岚县","value":"141127","parent":"141100"},{"name":"方山县","value":"141128","parent":"141100"},{"name":"中阳县","value":"141129","parent":"141100"},{"name":"交口县","value":"141130","parent":"141100"},{"name":"孝义市","value":"141181","parent":"141100"},{"name":"汾阳市","value":"141182","parent":"141100"},{"name":"呼和浩特市","value":"150100","parent":"150000"},{"name":"包头市","value":"150200","parent":"150000"},{"name":"乌海市","value":"150300","parent":"150000"},{"name":"赤峰市","value":"150400","parent":"150000"},{"name":"通辽市","value":"150500","parent":"150000"},{"name":"鄂尔多斯市","value":"150600","parent":"150000"},{"name":"呼伦贝尔市","value":"150700","parent":"150000"},{"name":"巴彦淖尔市","value":"150800","parent":"150000"},{"name":"乌兰察布市","value":"150900","parent":"150000"},{"name":"兴安盟","value":"152200","parent":"150000"},{"name":"锡林郭勒盟","value":"152500","parent":"150000"},{"name":"阿拉善盟","value":"152900","parent":"150000"},{"name":"新城区","value":"150102","parent":"150100"},{"name":"回民区","value":"150103","parent":"150100"},{"name":"玉泉区","value":"150104","parent":"150100"},{"name":"赛罕区","value":"150105","parent":"150100"},{"name":"土默特左旗","value":"150121","parent":"150100"},{"name":"托克托县","value":"150122","parent":"150100"},{"name":"和林格尔县","value":"150123","parent":"150100"},{"name":"清水河县","value":"150124","parent":"150100"},{"name":"武川县","value":"150125","parent":"150100"},{"name":"东河区","value":"150202","parent":"150200"},{"name":"昆都仑区","value":"150203","parent":"150200"},{"name":"青山区","value":"150204","parent":"150200"},{"name":"石拐区","value":"150205","parent":"150200"},{"name":"白云鄂博矿区","value":"150206","parent":"150200"},{"name":"九原区","value":"150207","parent":"150200"},{"name":"土默特右旗","value":"150221","parent":"150200"},{"name":"固阳县","value":"150222","parent":"150200"},{"name":"达尔罕茂明安联合旗","value":"150223","parent":"150200"},{"name":"海勃湾区","value":"150302","parent":"150300"},{"name":"海南区","value":"150303","parent":"150300"},{"name":"乌达区","value":"150304","parent":"150300"},{"name":"红山区","value":"150402","parent":"150400"},{"name":"元宝山区","value":"150403","parent":"150400"},{"name":"松山区","value":"150404","parent":"150400"},{"name":"阿鲁科尔沁旗","value":"150421","parent":"150400"},{"name":"巴林左旗","value":"150422","parent":"150400"},{"name":"巴林右旗","value":"150423","parent":"150400"},{"name":"林西县","value":"150424","parent":"150400"},{"name":"克什克腾旗","value":"150425","parent":"150400"},{"name":"翁牛特旗","value":"150426","parent":"150400"},{"name":"喀喇沁旗","value":"150428","parent":"150400"},{"name":"宁城县","value":"150429","parent":"150400"},{"name":"敖汉旗","value":"150430","parent":"150400"},{"name":"科尔沁区","value":"150502","parent":"150500"},{"name":"科尔沁左翼中旗","value":"150521","parent":"150500"},{"name":"科尔沁左翼后旗","value":"150522","parent":"150500"},{"name":"开鲁县","value":"150523","parent":"150500"},{"name":"库伦旗","value":"150524","parent":"150500"},{"name":"奈曼旗","value":"150525","parent":"150500"},{"name":"扎鲁特旗","value":"150526","parent":"150500"},{"name":"霍林郭勒市","value":"150581","parent":"150500"},{"name":"东胜区","value":"150602","parent":"150600"},{"name":"达拉特旗","value":"150621","parent":"150600"},{"name":"准格尔旗","value":"150622","parent":"150600"},{"name":"鄂托克前旗","value":"150623","parent":"150600"},{"name":"鄂托克旗","value":"150624","parent":"150600"},{"name":"杭锦旗","value":"150625","parent":"150600"},{"name":"乌审旗","value":"150626","parent":"150600"},{"name":"伊金霍洛旗","value":"150627","parent":"150600"},{"name":"海拉尔区","value":"150702","parent":"150700"},{"name":"扎赉诺尔区","value":"150703","parent":"150700"},{"name":"阿荣旗","value":"150721","parent":"150700"},{"name":"莫力达瓦达斡尔族自治旗","value":"150722","parent":"150700"},{"name":"鄂伦春自治旗","value":"150723","parent":"150700"},{"name":"鄂温克族自治旗","value":"150724","parent":"150700"},{"name":"陈巴尔虎旗","value":"150725","parent":"150700"},{"name":"新巴尔虎左旗","value":"150726","parent":"150700"},{"name":"新巴尔虎右旗","value":"150727","parent":"150700"},{"name":"满洲里市","value":"150781","parent":"150700"},{"name":"牙克石市","value":"150782","parent":"150700"},{"name":"扎兰屯市","value":"150783","parent":"150700"},{"name":"额尔古纳市","value":"150784","parent":"150700"},{"name":"根河市","value":"150785","parent":"150700"},{"name":"临河区","value":"150802","parent":"150800"},{"name":"五原县","value":"150821","parent":"150800"},{"name":"磴口县","value":"150822","parent":"150800"},{"name":"乌拉特前旗","value":"150823","parent":"150800"},{"name":"乌拉特中旗","value":"150824","parent":"150800"},{"name":"乌拉特后旗","value":"150825","parent":"150800"},{"name":"杭锦后旗","value":"150826","parent":"150800"},{"name":"集宁区","value":"150902","parent":"150900"},{"name":"卓资县","value":"150921","parent":"150900"},{"name":"化德县","value":"150922","parent":"150900"},{"name":"商都县","value":"150923","parent":"150900"},{"name":"兴和县","value":"150924","parent":"150900"},{"name":"凉城县","value":"150925","parent":"150900"},{"name":"察哈尔右翼前旗","value":"150926","parent":"150900"},{"name":"察哈尔右翼中旗","value":"150927","parent":"150900"},{"name":"察哈尔右翼后旗","value":"150928","parent":"150900"},{"name":"四子王旗","value":"150929","parent":"150900"},{"name":"丰镇市","value":"150981","parent":"150900"},{"name":"乌兰浩特市","value":"152201","parent":"152200"},{"name":"阿尔山市","value":"152202","parent":"152200"},{"name":"科尔沁右翼前旗","value":"152221","parent":"152200"},{"name":"科尔沁右翼中旗","value":"152222","parent":"152200"},{"name":"扎赉特旗","value":"152223","parent":"152200"},{"name":"突泉县","value":"152224","parent":"152200"},{"name":"二连浩特市","value":"152501","parent":"152500"},{"name":"锡林浩特市","value":"152502","parent":"152500"},{"name":"阿巴嘎旗","value":"152522","parent":"152500"},{"name":"苏尼特左旗","value":"152523","parent":"152500"},{"name":"苏尼特右旗","value":"152524","parent":"152500"},{"name":"东乌珠穆沁旗","value":"152525","parent":"152500"},{"name":"西乌珠穆沁旗","value":"152526","parent":"152500"},{"name":"太仆寺旗","value":"152527","parent":"152500"},{"name":"镶黄旗","value":"152528","parent":"152500"},{"name":"正镶白旗","value":"152529","parent":"152500"},{"name":"正蓝旗","value":"152530","parent":"152500"},{"name":"多伦县","value":"152531","parent":"152500"},{"name":"阿拉善左旗","value":"152921","parent":"152900"},{"name":"阿拉善右旗","value":"152922","parent":"152900"},{"name":"额济纳旗","value":"152923","parent":"152900"},{"name":"沈阳市","value":"210100","parent":"210000"},{"name":"大连市","value":"210200","parent":"210000"},{"name":"鞍山市","value":"210300","parent":"210000"},{"name":"抚顺市","value":"210400","parent":"210000"},{"name":"本溪市","value":"210500","parent":"210000"},{"name":"丹东市","value":"210600","parent":"210000"},{"name":"锦州市","value":"210700","parent":"210000"},{"name":"营口市","value":"210800","parent":"210000"},{"name":"阜新市","value":"210900","parent":"210000"},{"name":"辽阳市","value":"211000","parent":"210000"},{"name":"盘锦市","value":"211100","parent":"210000"},{"name":"铁岭市","value":"211200","parent":"210000"},{"name":"朝阳市","value":"211300","parent":"210000"},{"name":"葫芦岛市","value":"211400","parent":"210000"},{"name":"和平区","value":"210102","parent":"210100"},{"name":"沈河区","value":"210103","parent":"210100"},{"name":"大东区","value":"210104","parent":"210100"},{"name":"皇姑区","value":"210105","parent":"210100"},{"name":"铁西区","value":"210106","parent":"210100"},{"name":"苏家屯区","value":"210111","parent":"210100"},{"name":"浑南区","value":"210112","parent":"210100"},{"name":"沈北新区","value":"210113","parent":"210100"},{"name":"于洪区","value":"210114","parent":"210100"},{"name":"辽中县","value":"210122","parent":"210100"},{"name":"康平县","value":"210123","parent":"210100"},{"name":"法库县","value":"210124","parent":"210100"},{"name":"新民市","value":"210181","parent":"210100"},{"name":"中山区","value":"210202","parent":"210200"},{"name":"西岗区","value":"210203","parent":"210200"},{"name":"沙河口区","value":"210204","parent":"210200"},{"name":"甘井子区","value":"210211","parent":"210200"},{"name":"旅顺口区","value":"210212","parent":"210200"},{"name":"金州区","value":"210213","parent":"210200"},{"name":"长海县","value":"210224","parent":"210200"},{"name":"瓦房店市","value":"210281","parent":"210200"},{"name":"普兰店市","value":"210282","parent":"210200"},{"name":"庄河市","value":"210283","parent":"210200"},{"name":"铁东区","value":"210302","parent":"210300"},{"name":"铁西区","value":"210303","parent":"210300"},{"name":"立山区","value":"210304","parent":"210300"},{"name":"千山区","value":"210311","parent":"210300"},{"name":"台安县","value":"210321","parent":"210300"},{"name":"岫岩满族自治县","value":"210323","parent":"210300"},{"name":"海城市","value":"210381","parent":"210300"},{"name":"新抚区","value":"210402","parent":"210400"},{"name":"东洲区","value":"210403","parent":"210400"},{"name":"望花区","value":"210404","parent":"210400"},{"name":"顺城区","value":"210411","parent":"210400"},{"name":"抚顺县","value":"210421","parent":"210400"},{"name":"新宾满族自治县","value":"210422","parent":"210400"},{"name":"清原满族自治县","value":"210423","parent":"210400"},{"name":"平山区","value":"210502","parent":"210500"},{"name":"溪湖区","value":"210503","parent":"210500"},{"name":"明山区","value":"210504","parent":"210500"},{"name":"南芬区","value":"210505","parent":"210500"},{"name":"本溪满族自治县","value":"210521","parent":"210500"},{"name":"桓仁满族自治县","value":"210522","parent":"210500"},{"name":"元宝区","value":"210602","parent":"210600"},{"name":"振兴区","value":"210603","parent":"210600"},{"name":"振安区","value":"210604","parent":"210600"},{"name":"宽甸满族自治县","value":"210624","parent":"210600"},{"name":"东港市","value":"210681","parent":"210600"},{"name":"凤城市","value":"210682","parent":"210600"},{"name":"古塔区","value":"210702","parent":"210700"},{"name":"凌河区","value":"210703","parent":"210700"},{"name":"太和区","value":"210711","parent":"210700"},{"name":"黑山县","value":"210726","parent":"210700"},{"name":"义县","value":"210727","parent":"210700"},{"name":"凌海市","value":"210781","parent":"210700"},{"name":"北镇市","value":"210782","parent":"210700"},{"name":"站前区","value":"210802","parent":"210800"},{"name":"西市区","value":"210803","parent":"210800"},{"name":"鲅鱼圈区","value":"210804","parent":"210800"},{"name":"老边区","value":"210811","parent":"210800"},{"name":"盖州市","value":"210881","parent":"210800"},{"name":"大石桥市","value":"210882","parent":"210800"},{"name":"海州区","value":"210902","parent":"210900"},{"name":"新邱区","value":"210903","parent":"210900"},{"name":"太平区","value":"210904","parent":"210900"},{"name":"清河门区","value":"210905","parent":"210900"},{"name":"细河区","value":"210911","parent":"210900"},{"name":"阜新蒙古族自治县","value":"210921","parent":"210900"},{"name":"彰武县","value":"210922","parent":"210900"},{"name":"白塔区","value":"211002","parent":"211000"},{"name":"文圣区","value":"211003","parent":"211000"},{"name":"宏伟区","value":"211004","parent":"211000"},{"name":"弓长岭区","value":"211005","parent":"211000"},{"name":"太子河区","value":"211011","parent":"211000"},{"name":"辽阳县","value":"211021","parent":"211000"},{"name":"灯塔市","value":"211081","parent":"211000"},{"name":"双台子区","value":"211102","parent":"211100"},{"name":"兴隆台区","value":"211103","parent":"211100"},{"name":"大洼县","value":"211121","parent":"211100"},{"name":"盘山县","value":"211122","parent":"211100"},{"name":"银州区","value":"211202","parent":"211200"},{"name":"清河区","value":"211204","parent":"211200"},{"name":"铁岭县","value":"211221","parent":"211200"},{"name":"西丰县","value":"211223","parent":"211200"},{"name":"昌图县","value":"211224","parent":"211200"},{"name":"调兵山市","value":"211281","parent":"211200"},{"name":"开原市","value":"211282","parent":"211200"},{"name":"双塔区","value":"211302","parent":"211300"},{"name":"龙城区","value":"211303","parent":"211300"},{"name":"朝阳县","value":"211321","parent":"211300"},{"name":"建平县","value":"211322","parent":"211300"},{"name":"喀喇沁左翼蒙古族自治县","value":"211324","parent":"211300"},{"name":"北票市","value":"211381","parent":"211300"},{"name":"凌源市","value":"211382","parent":"211300"},{"name":"连山区","value":"211402","parent":"211400"},{"name":"龙港区","value":"211403","parent":"211400"},{"name":"南票区","value":"211404","parent":"211400"},{"name":"绥中县","value":"211421","parent":"211400"},{"name":"建昌县","value":"211422","parent":"211400"},{"name":"兴城市","value":"211481","parent":"211400"},{"name":"长春市","value":"220100","parent":"220000"},{"name":"吉林市","value":"220200","parent":"220000"},{"name":"四平市","value":"220300","parent":"220000"},{"name":"辽源市","value":"220400","parent":"220000"},{"name":"通化市","value":"220500","parent":"220000"},{"name":"白山市","value":"220600","parent":"220000"},{"name":"松原市","value":"220700","parent":"220000"},{"name":"白城市","value":"220800","parent":"220000"},{"name":"延边朝鲜族自治州","value":"222400","parent":"220000"},{"name":"南关区","value":"220102","parent":"220100"},{"name":"宽城区","value":"220103","parent":"220100"},{"name":"朝阳区","value":"220104","parent":"220100"},{"name":"二道区","value":"220105","parent":"220100"},{"name":"绿园区","value":"220106","parent":"220100"},{"name":"双阳区","value":"220112","parent":"220100"},{"name":"九台区","value":"220113","parent":"220100"},{"name":"农安县","value":"220122","parent":"220100"},{"name":"榆树市","value":"220182","parent":"220100"},{"name":"德惠市","value":"220183","parent":"220100"},{"name":"昌邑区","value":"220202","parent":"220200"},{"name":"龙潭区","value":"220203","parent":"220200"},{"name":"船营区","value":"220204","parent":"220200"},{"name":"丰满区","value":"220211","parent":"220200"},{"name":"永吉县","value":"220221","parent":"220200"},{"name":"蛟河市","value":"220281","parent":"220200"},{"name":"桦甸市","value":"220282","parent":"220200"},{"name":"舒兰市","value":"220283","parent":"220200"},{"name":"磐石市","value":"220284","parent":"220200"},{"name":"铁西区","value":"220302","parent":"220300"},{"name":"铁东区","value":"220303","parent":"220300"},{"name":"梨树县","value":"220322","parent":"220300"},{"name":"伊通满族自治县","value":"220323","parent":"220300"},{"name":"公主岭市","value":"220381","parent":"220300"},{"name":"双辽市","value":"220382","parent":"220300"},{"name":"龙山区","value":"220402","parent":"220400"},{"name":"西安区","value":"220403","parent":"220400"},{"name":"东丰县","value":"220421","parent":"220400"},{"name":"东辽县","value":"220422","parent":"220400"},{"name":"东昌区","value":"220502","parent":"220500"},{"name":"二道江区","value":"220503","parent":"220500"},{"name":"通化县","value":"220521","parent":"220500"},{"name":"辉南县","value":"220523","parent":"220500"},{"name":"柳河县","value":"220524","parent":"220500"},{"name":"梅河口市","value":"220581","parent":"220500"},{"name":"集安市","value":"220582","parent":"220500"},{"name":"浑江区","value":"220602","parent":"220600"},{"name":"江源区","value":"220605","parent":"220600"},{"name":"抚松县","value":"220621","parent":"220600"},{"name":"靖宇县","value":"220622","parent":"220600"},{"name":"长白朝鲜族自治县","value":"220623","parent":"220600"},{"name":"临江市","value":"220681","parent":"220600"},{"name":"宁江区","value":"220702","parent":"220700"},{"name":"前郭尔罗斯蒙古族自治县","value":"220721","parent":"220700"},{"name":"长岭县","value":"220722","parent":"220700"},{"name":"乾安县","value":"220723","parent":"220700"},{"name":"扶余市","value":"220781","parent":"220700"},{"name":"洮北区","value":"220802","parent":"220800"},{"name":"镇赉县","value":"220821","parent":"220800"},{"name":"通榆县","value":"220822","parent":"220800"},{"name":"洮南市","value":"220881","parent":"220800"},{"name":"大安市","value":"220882","parent":"220800"},{"name":"延吉市","value":"222401","parent":"222400"},{"name":"图们市","value":"222402","parent":"222400"},{"name":"敦化市","value":"222403","parent":"222400"},{"name":"珲春市","value":"222404","parent":"222400"},{"name":"龙井市","value":"222405","parent":"222400"},{"name":"和龙市","value":"222406","parent":"222400"},{"name":"汪清县","value":"222424","parent":"222400"},{"name":"安图县","value":"222426","parent":"222400"},{"name":"哈尔滨市","value":"230100","parent":"230000"},{"name":"齐齐哈尔市","value":"230200","parent":"230000"},{"name":"鸡西市","value":"230300","parent":"230000"},{"name":"鹤岗市","value":"230400","parent":"230000"},{"name":"双鸭山市","value":"230500","parent":"230000"},{"name":"大庆市","value":"230600","parent":"230000"},{"name":"伊春市","value":"230700","parent":"230000"},{"name":"佳木斯市","value":"230800","parent":"230000"},{"name":"七台河市","value":"230900","parent":"230000"},{"name":"牡丹江市","value":"231000","parent":"230000"},{"name":"黑河市","value":"231100","parent":"230000"},{"name":"绥化市","value":"231200","parent":"230000"},{"name":"大兴安岭地区","value":"232700","parent":"230000"},{"name":"道里区","value":"230102","parent":"230100"},{"name":"南岗区","value":"230103","parent":"230100"},{"name":"道外区","value":"230104","parent":"230100"},{"name":"平房区","value":"230108","parent":"230100"},{"name":"松北区","value":"230109","parent":"230100"},{"name":"香坊区","value":"230110","parent":"230100"},{"name":"呼兰区","value":"230111","parent":"230100"},{"name":"阿城区","value":"230112","parent":"230100"},{"name":"双城区","value":"230113","parent":"230100"},{"name":"依兰县","value":"230123","parent":"230100"},{"name":"方正县","value":"230124","parent":"230100"},{"name":"宾县","value":"230125","parent":"230100"},{"name":"巴彦县","value":"230126","parent":"230100"},{"name":"木兰县","value":"230127","parent":"230100"},{"name":"通河县","value":"230128","parent":"230100"},{"name":"延寿县","value":"230129","parent":"230100"},{"name":"尚志市","value":"230183","parent":"230100"},{"name":"五常市","value":"230184","parent":"230100"},{"name":"龙沙区","value":"230202","parent":"230200"},{"name":"建华区","value":"230203","parent":"230200"},{"name":"铁锋区","value":"230204","parent":"230200"},{"name":"昂昂溪区","value":"230205","parent":"230200"},{"name":"富拉尔基区","value":"230206","parent":"230200"},{"name":"碾子山区","value":"230207","parent":"230200"},{"name":"梅里斯达斡尔族区","value":"230208","parent":"230200"},{"name":"龙江县","value":"230221","parent":"230200"},{"name":"依安县","value":"230223","parent":"230200"},{"name":"泰来县","value":"230224","parent":"230200"},{"name":"甘南县","value":"230225","parent":"230200"},{"name":"富裕县","value":"230227","parent":"230200"},{"name":"克山县","value":"230229","parent":"230200"},{"name":"克东县","value":"230230","parent":"230200"},{"name":"拜泉县","value":"230231","parent":"230200"},{"name":"讷河市","value":"230281","parent":"230200"},{"name":"鸡冠区","value":"230302","parent":"230300"},{"name":"恒山区","value":"230303","parent":"230300"},{"name":"滴道区","value":"230304","parent":"230300"},{"name":"梨树区","value":"230305","parent":"230300"},{"name":"城子河区","value":"230306","parent":"230300"},{"name":"麻山区","value":"230307","parent":"230300"},{"name":"鸡东县","value":"230321","parent":"230300"},{"name":"虎林市","value":"230381","parent":"230300"},{"name":"密山市","value":"230382","parent":"230300"},{"name":"向阳区","value":"230402","parent":"230400"},{"name":"工农区","value":"230403","parent":"230400"},{"name":"南山区","value":"230404","parent":"230400"},{"name":"兴安区","value":"230405","parent":"230400"},{"name":"东山区","value":"230406","parent":"230400"},{"name":"兴山区","value":"230407","parent":"230400"},{"name":"萝北县","value":"230421","parent":"230400"},{"name":"绥滨县","value":"230422","parent":"230400"},{"name":"尖山区","value":"230502","parent":"230500"},{"name":"岭东区","value":"230503","parent":"230500"},{"name":"四方台区","value":"230505","parent":"230500"},{"name":"宝山区","value":"230506","parent":"230500"},{"name":"集贤县","value":"230521","parent":"230500"},{"name":"友谊县","value":"230522","parent":"230500"},{"name":"宝清县","value":"230523","parent":"230500"},{"name":"饶河县","value":"230524","parent":"230500"},{"name":"萨尔图区","value":"230602","parent":"230600"},{"name":"龙凤区","value":"230603","parent":"230600"},{"name":"让胡路区","value":"230604","parent":"230600"},{"name":"红岗区","value":"230605","parent":"230600"},{"name":"大同区","value":"230606","parent":"230600"},{"name":"肇州县","value":"230621","parent":"230600"},{"name":"肇源县","value":"230622","parent":"230600"},{"name":"林甸县","value":"230623","parent":"230600"},{"name":"杜尔伯特蒙古族自治县","value":"230624","parent":"230600"},{"name":"伊春区","value":"230702","parent":"230700"},{"name":"南岔区","value":"230703","parent":"230700"},{"name":"友好区","value":"230704","parent":"230700"},{"name":"西林区","value":"230705","parent":"230700"},{"name":"翠峦区","value":"230706","parent":"230700"},{"name":"新青区","value":"230707","parent":"230700"},{"name":"美溪区","value":"230708","parent":"230700"},{"name":"金山屯区","value":"230709","parent":"230700"},{"name":"五营区","value":"230710","parent":"230700"},{"name":"乌马河区","value":"230711","parent":"230700"},{"name":"汤旺河区","value":"230712","parent":"230700"},{"name":"带岭区","value":"230713","parent":"230700"},{"name":"乌伊岭区","value":"230714","parent":"230700"},{"name":"红星区","value":"230715","parent":"230700"},{"name":"上甘岭区","value":"230716","parent":"230700"},{"name":"嘉荫县","value":"230722","parent":"230700"},{"name":"铁力市","value":"230781","parent":"230700"},{"name":"向阳区","value":"230803","parent":"230800"},{"name":"前进区","value":"230804","parent":"230800"},{"name":"东风区","value":"230805","parent":"230800"},{"name":"郊区","value":"230811","parent":"230800"},{"name":"桦南县","value":"230822","parent":"230800"},{"name":"桦川县","value":"230826","parent":"230800"},{"name":"汤原县","value":"230828","parent":"230800"},{"name":"抚远县","value":"230833","parent":"230800"},{"name":"同江市","value":"230881","parent":"230800"},{"name":"富锦市","value":"230882","parent":"230800"},{"name":"新兴区","value":"230902","parent":"230900"},{"name":"桃山区","value":"230903","parent":"230900"},{"name":"茄子河区","value":"230904","parent":"230900"},{"name":"勃利县","value":"230921","parent":"230900"},{"name":"东安区","value":"231002","parent":"231000"},{"name":"阳明区","value":"231003","parent":"231000"},{"name":"爱民区","value":"231004","parent":"231000"},{"name":"西安区","value":"231005","parent":"231000"},{"name":"东宁县","value":"231024","parent":"231000"},{"name":"林口县","value":"231025","parent":"231000"},{"name":"绥芬河市","value":"231081","parent":"231000"},{"name":"海林市","value":"231083","parent":"231000"},{"name":"宁安市","value":"231084","parent":"231000"},{"name":"穆棱市","value":"231085","parent":"231000"},{"name":"爱辉区","value":"231102","parent":"231100"},{"name":"嫩江县","value":"231121","parent":"231100"},{"name":"逊克县","value":"231123","parent":"231100"},{"name":"孙吴县","value":"231124","parent":"231100"},{"name":"北安市","value":"231181","parent":"231100"},{"name":"五大连池市","value":"231182","parent":"231100"},{"name":"北林区","value":"231202","parent":"231200"},{"name":"望奎县","value":"231221","parent":"231200"},{"name":"兰西县","value":"231222","parent":"231200"},{"name":"青冈县","value":"231223","parent":"231200"},{"name":"庆安县","value":"231224","parent":"231200"},{"name":"明水县","value":"231225","parent":"231200"},{"name":"绥棱县","value":"231226","parent":"231200"},{"name":"安达市","value":"231281","parent":"231200"},{"name":"肇东市","value":"231282","parent":"231200"},{"name":"海伦市","value":"231283","parent":"231200"},{"name":"呼玛县","value":"232721","parent":"232700"},{"name":"塔河县","value":"232722","parent":"232700"},{"name":"漠河县","value":"232723","parent":"232700"},{"name":"市辖区","value":"310100","parent":"310000"},{"name":"黄浦区","value":"310101","parent":"310100"},{"name":"徐汇区","value":"310104","parent":"310100"},{"name":"长宁区","value":"310105","parent":"310100"},{"name":"静安区","value":"310106","parent":"310100"},{"name":"普陀区","value":"310107","parent":"310100"},{"name":"闸北区","value":"310108","parent":"310100"},{"name":"虹口区","value":"310109","parent":"310100"},{"name":"杨浦区","value":"310110","parent":"310100"},{"name":"闵行区","value":"310112","parent":"310100"},{"name":"宝山区","value":"310113","parent":"310100"},{"name":"嘉定区","value":"310114","parent":"310100"},{"name":"浦东新区","value":"310115","parent":"310100"},{"name":"金山区","value":"310116","parent":"310100"},{"name":"松江区","value":"310117","parent":"310100"},{"name":"青浦区","value":"310118","parent":"310100"},{"name":"奉贤区","value":"310120","parent":"310100"},{"name":"崇明县","value":"310230","parent":"310100"},{"name":"南京市","value":"320100","parent":"320000"},{"name":"无锡市","value":"320200","parent":"320000"},{"name":"徐州市","value":"320300","parent":"320000"},{"name":"常州市","value":"320400","parent":"320000"},{"name":"苏州市","value":"320500","parent":"320000"},{"name":"南通市","value":"320600","parent":"320000"},{"name":"连云港市","value":"320700","parent":"320000"},{"name":"淮安市","value":"320800","parent":"320000"},{"name":"盐城市","value":"320900","parent":"320000"},{"name":"扬州市","value":"321000","parent":"320000"},{"name":"镇江市","value":"321100","parent":"320000"},{"name":"泰州市","value":"321200","parent":"320000"},{"name":"宿迁市","value":"321300","parent":"320000"},{"name":"玄武区","value":"320102","parent":"320100"},{"name":"秦淮区","value":"320104","parent":"320100"},{"name":"建邺区","value":"320105","parent":"320100"},{"name":"鼓楼区","value":"320106","parent":"320100"},{"name":"浦口区","value":"320111","parent":"320100"},{"name":"栖霞区","value":"320113","parent":"320100"},{"name":"雨花台区","value":"320114","parent":"320100"},{"name":"江宁区","value":"320115","parent":"320100"},{"name":"六合区","value":"320116","parent":"320100"},{"name":"溧水区","value":"320117","parent":"320100"},{"name":"高淳区","value":"320118","parent":"320100"},{"name":"崇安区","value":"320202","parent":"320200"},{"name":"南长区","value":"320203","parent":"320200"},{"name":"北塘区","value":"320204","parent":"320200"},{"name":"锡山区","value":"320205","parent":"320200"},{"name":"惠山区","value":"320206","parent":"320200"},{"name":"滨湖区","value":"320211","parent":"320200"},{"name":"江阴市","value":"320281","parent":"320200"},{"name":"宜兴市","value":"320282","parent":"320200"},{"name":"鼓楼区","value":"320302","parent":"320300"},{"name":"云龙区","value":"320303","parent":"320300"},{"name":"贾汪区","value":"320305","parent":"320300"},{"name":"泉山区","value":"320311","parent":"320300"},{"name":"铜山区","value":"320312","parent":"320300"},{"name":"丰县","value":"320321","parent":"320300"},{"name":"沛县","value":"320322","parent":"320300"},{"name":"睢宁县","value":"320324","parent":"320300"},{"name":"新沂市","value":"320381","parent":"320300"},{"name":"邳州市","value":"320382","parent":"320300"},{"name":"天宁区","value":"320402","parent":"320400"},{"name":"钟楼区","value":"320404","parent":"320400"},{"name":"新北区","value":"320411","parent":"320400"},{"name":"武进区","value":"320412","parent":"320400"},{"name":"金坛区","value":"320413","parent":"320400"},{"name":"溧阳市","value":"320481","parent":"320400"},{"name":"虎丘区","value":"320505","parent":"320500"},{"name":"吴中区","value":"320506","parent":"320500"},{"name":"相城区","value":"320507","parent":"320500"},{"name":"姑苏区","value":"320508","parent":"320500"},{"name":"吴江区","value":"320509","parent":"320500"},{"name":"常熟市","value":"320581","parent":"320500"},{"name":"张家港市","value":"320582","parent":"320500"},{"name":"昆山市","value":"320583","parent":"320500"},{"name":"太仓市","value":"320585","parent":"320500"},{"name":"崇川区","value":"320602","parent":"320600"},{"name":"港闸区","value":"320611","parent":"320600"},{"name":"通州区","value":"320612","parent":"320600"},{"name":"海安县","value":"320621","parent":"320600"},{"name":"如东县","value":"320623","parent":"320600"},{"name":"启东市","value":"320681","parent":"320600"},{"name":"如皋市","value":"320682","parent":"320600"},{"name":"海门市","value":"320684","parent":"320600"},{"name":"连云区","value":"320703","parent":"320700"},{"name":"海州区","value":"320706","parent":"320700"},{"name":"赣榆区","value":"320707","parent":"320700"},{"name":"东海县","value":"320722","parent":"320700"},{"name":"灌云县","value":"320723","parent":"320700"},{"name":"灌南县","value":"320724","parent":"320700"},{"name":"清河区","value":"320802","parent":"320800"},{"name":"淮安区","value":"320803","parent":"320800"},{"name":"淮阴区","value":"320804","parent":"320800"},{"name":"清浦区","value":"320811","parent":"320800"},{"name":"涟水县","value":"320826","parent":"320800"},{"name":"洪泽县","value":"320829","parent":"320800"},{"name":"盱眙县","value":"320830","parent":"320800"},{"name":"金湖县","value":"320831","parent":"320800"},{"name":"亭湖区","value":"320902","parent":"320900"},{"name":"盐都区","value":"320903","parent":"320900"},{"name":"大丰区","value":"320904","parent":"320900"},{"name":"响水县","value":"320921","parent":"320900"},{"name":"滨海县","value":"320922","parent":"320900"},{"name":"阜宁县","value":"320923","parent":"320900"},{"name":"射阳县","value":"320924","parent":"320900"},{"name":"建湖县","value":"320925","parent":"320900"},{"name":"东台市","value":"320981","parent":"320900"},{"name":"广陵区","value":"321002","parent":"321000"},{"name":"邗江区","value":"321003","parent":"321000"},{"name":"江都区","value":"321012","parent":"321000"},{"name":"宝应县","value":"321023","parent":"321000"},{"name":"仪征市","value":"321081","parent":"321000"},{"name":"高邮市","value":"321084","parent":"321000"},{"name":"京口区","value":"321102","parent":"321100"},{"name":"润州区","value":"321111","parent":"321100"},{"name":"丹徒区","value":"321112","parent":"321100"},{"name":"丹阳市","value":"321181","parent":"321100"},{"name":"扬中市","value":"321182","parent":"321100"},{"name":"句容市","value":"321183","parent":"321100"},{"name":"海陵区","value":"321202","parent":"321200"},{"name":"高港区","value":"321203","parent":"321200"},{"name":"姜堰区","value":"321204","parent":"321200"},{"name":"兴化市","value":"321281","parent":"321200"},{"name":"靖江市","value":"321282","parent":"321200"},{"name":"泰兴市","value":"321283","parent":"321200"},{"name":"宿城区","value":"321302","parent":"321300"},{"name":"宿豫区","value":"321311","parent":"321300"},{"name":"沭阳县","value":"321322","parent":"321300"},{"name":"泗阳县","value":"321323","parent":"321300"},{"name":"泗洪县","value":"321324","parent":"321300"},{"name":"杭州市","value":"330100","parent":"330000"},{"name":"宁波市","value":"330200","parent":"330000"},{"name":"温州市","value":"330300","parent":"330000"},{"name":"嘉兴市","value":"330400","parent":"330000"},{"name":"湖州市","value":"330500","parent":"330000"},{"name":"绍兴市","value":"330600","parent":"330000"},{"name":"金华市","value":"330700","parent":"330000"},{"name":"衢州市","value":"330800","parent":"330000"},{"name":"舟山市","value":"330900","parent":"330000"},{"name":"台州市","value":"331000","parent":"330000"},{"name":"丽水市","value":"331100","parent":"330000"},{"name":"上城区","value":"330102","parent":"330100"},{"name":"下城区","value":"330103","parent":"330100"},{"name":"江干区","value":"330104","parent":"330100"},{"name":"拱墅区","value":"330105","parent":"330100"},{"name":"西湖区","value":"330106","parent":"330100"},{"name":"滨江区","value":"330108","parent":"330100"},{"name":"萧山区","value":"330109","parent":"330100"},{"name":"余杭区","value":"330110","parent":"330100"},{"name":"富阳区","value":"330111","parent":"330100"},{"name":"桐庐县","value":"330122","parent":"330100"},{"name":"淳安县","value":"330127","parent":"330100"},{"name":"建德市","value":"330182","parent":"330100"},{"name":"临安市","value":"330185","parent":"330100"},{"name":"海曙区","value":"330203","parent":"330200"},{"name":"江东区","value":"330204","parent":"330200"},{"name":"江北区","value":"330205","parent":"330200"},{"name":"北仑区","value":"330206","parent":"330200"},{"name":"镇海区","value":"330211","parent":"330200"},{"name":"鄞州区","value":"330212","parent":"330200"},{"name":"象山县","value":"330225","parent":"330200"},{"name":"宁海县","value":"330226","parent":"330200"},{"name":"余姚市","value":"330281","parent":"330200"},{"name":"慈溪市","value":"330282","parent":"330200"},{"name":"奉化市","value":"330283","parent":"330200"},{"name":"鹿城区","value":"330302","parent":"330300"},{"name":"龙湾区","value":"330303","parent":"330300"},{"name":"瓯海区","value":"330304","parent":"330300"},{"name":"洞头区","value":"330305","parent":"330300"},{"name":"永嘉县","value":"330324","parent":"330300"},{"name":"平阳县","value":"330326","parent":"330300"},{"name":"苍南县","value":"330327","parent":"330300"},{"name":"文成县","value":"330328","parent":"330300"},{"name":"泰顺县","value":"330329","parent":"330300"},{"name":"瑞安市","value":"330381","parent":"330300"},{"name":"乐清市","value":"330382","parent":"330300"},{"name":"南湖区","value":"330402","parent":"330400"},{"name":"秀洲区","value":"330411","parent":"330400"},{"name":"嘉善县","value":"330421","parent":"330400"},{"name":"海盐县","value":"330424","parent":"330400"},{"name":"海宁市","value":"330481","parent":"330400"},{"name":"平湖市","value":"330482","parent":"330400"},{"name":"桐乡市","value":"330483","parent":"330400"},{"name":"吴兴区","value":"330502","parent":"330500"},{"name":"南浔区","value":"330503","parent":"330500"},{"name":"德清县","value":"330521","parent":"330500"},{"name":"长兴县","value":"330522","parent":"330500"},{"name":"安吉县","value":"330523","parent":"330500"},{"name":"越城区","value":"330602","parent":"330600"},{"name":"柯桥区","value":"330603","parent":"330600"},{"name":"上虞区","value":"330604","parent":"330600"},{"name":"新昌县","value":"330624","parent":"330600"},{"name":"诸暨市","value":"330681","parent":"330600"},{"name":"嵊州市","value":"330683","parent":"330600"},{"name":"婺城区","value":"330702","parent":"330700"},{"name":"金东区","value":"330703","parent":"330700"},{"name":"武义县","value":"330723","parent":"330700"},{"name":"浦江县","value":"330726","parent":"330700"},{"name":"磐安县","value":"330727","parent":"330700"},{"name":"兰溪市","value":"330781","parent":"330700"},{"name":"义乌市","value":"330782","parent":"330700"},{"name":"东阳市","value":"330783","parent":"330700"},{"name":"永康市","value":"330784","parent":"330700"},{"name":"柯城区","value":"330802","parent":"330800"},{"name":"衢江区","value":"330803","parent":"330800"},{"name":"常山县","value":"330822","parent":"330800"},{"name":"开化县","value":"330824","parent":"330800"},{"name":"龙游县","value":"330825","parent":"330800"},{"name":"江山市","value":"330881","parent":"330800"},{"name":"定海区","value":"330902","parent":"330900"},{"name":"普陀区","value":"330903","parent":"330900"},{"name":"岱山县","value":"330921","parent":"330900"},{"name":"嵊泗县","value":"330922","parent":"330900"},{"name":"椒江区","value":"331002","parent":"331000"},{"name":"黄岩区","value":"331003","parent":"331000"},{"name":"路桥区","value":"331004","parent":"331000"},{"name":"玉环县","value":"331021","parent":"331000"},{"name":"三门县","value":"331022","parent":"331000"},{"name":"天台县","value":"331023","parent":"331000"},{"name":"仙居县","value":"331024","parent":"331000"},{"name":"温岭市","value":"331081","parent":"331000"},{"name":"临海市","value":"331082","parent":"331000"},{"name":"莲都区","value":"331102","parent":"331100"},{"name":"青田县","value":"331121","parent":"331100"},{"name":"缙云县","value":"331122","parent":"331100"},{"name":"遂昌县","value":"331123","parent":"331100"},{"name":"松阳县","value":"331124","parent":"331100"},{"name":"云和县","value":"331125","parent":"331100"},{"name":"庆元县","value":"331126","parent":"331100"},{"name":"景宁畲族自治县","value":"331127","parent":"331100"},{"name":"龙泉市","value":"331181","parent":"331100"},{"name":"合肥市","value":"340100","parent":"340000"},{"name":"芜湖市","value":"340200","parent":"340000"},{"name":"蚌埠市","value":"340300","parent":"340000"},{"name":"淮南市","value":"340400","parent":"340000"},{"name":"马鞍山市","value":"340500","parent":"340000"},{"name":"淮北市","value":"340600","parent":"340000"},{"name":"铜陵市","value":"340700","parent":"340000"},{"name":"安庆市","value":"340800","parent":"340000"},{"name":"黄山市","value":"341000","parent":"340000"},{"name":"滁州市","value":"341100","parent":"340000"},{"name":"阜阳市","value":"341200","parent":"340000"},{"name":"宿州市","value":"341300","parent":"340000"},{"name":"六安市","value":"341500","parent":"340000"},{"name":"亳州市","value":"341600","parent":"340000"},{"name":"池州市","value":"341700","parent":"340000"},{"name":"宣城市","value":"341800","parent":"340000"},{"name":"瑶海区","value":"340102","parent":"340100"},{"name":"庐阳区","value":"340103","parent":"340100"},{"name":"蜀山区","value":"340104","parent":"340100"},{"name":"包河区","value":"340111","parent":"340100"},{"name":"长丰县","value":"340121","parent":"340100"},{"name":"肥东县","value":"340122","parent":"340100"},{"name":"肥西县","value":"340123","parent":"340100"},{"name":"庐江县","value":"340124","parent":"340100"},{"name":"巢湖市","value":"340181","parent":"340100"},{"name":"镜湖区","value":"340202","parent":"340200"},{"name":"弋江区","value":"340203","parent":"340200"},{"name":"鸠江区","value":"340207","parent":"340200"},{"name":"三山区","value":"340208","parent":"340200"},{"name":"芜湖县","value":"340221","parent":"340200"},{"name":"繁昌县","value":"340222","parent":"340200"},{"name":"南陵县","value":"340223","parent":"340200"},{"name":"无为县","value":"340225","parent":"340200"},{"name":"龙子湖区","value":"340302","parent":"340300"},{"name":"蚌山区","value":"340303","parent":"340300"},{"name":"禹会区","value":"340304","parent":"340300"},{"name":"淮上区","value":"340311","parent":"340300"},{"name":"怀远县","value":"340321","parent":"340300"},{"name":"五河县","value":"340322","parent":"340300"},{"name":"固镇县","value":"340323","parent":"340300"},{"name":"大通区","value":"340402","parent":"340400"},{"name":"田家庵区","value":"340403","parent":"340400"},{"name":"谢家集区","value":"340404","parent":"340400"},{"name":"八公山区","value":"340405","parent":"340400"},{"name":"潘集区","value":"340406","parent":"340400"},{"name":"凤台县","value":"340421","parent":"340400"},{"name":"花山区","value":"340503","parent":"340500"},{"name":"雨山区","value":"340504","parent":"340500"},{"name":"博望区","value":"340506","parent":"340500"},{"name":"当涂县","value":"340521","parent":"340500"},{"name":"含山县","value":"340522","parent":"340500"},{"name":"和县","value":"340523","parent":"340500"},{"name":"杜集区","value":"340602","parent":"340600"},{"name":"相山区","value":"340603","parent":"340600"},{"name":"烈山区","value":"340604","parent":"340600"},{"name":"濉溪县","value":"340621","parent":"340600"},{"name":"铜官山区","value":"340702","parent":"340700"},{"name":"狮子山区","value":"340703","parent":"340700"},{"name":"郊区","value":"340711","parent":"340700"},{"name":"铜陵县","value":"340721","parent":"340700"},{"name":"迎江区","value":"340802","parent":"340800"},{"name":"大观区","value":"340803","parent":"340800"},{"name":"宜秀区","value":"340811","parent":"340800"},{"name":"怀宁县","value":"340822","parent":"340800"},{"name":"枞阳县","value":"340823","parent":"340800"},{"name":"潜山县","value":"340824","parent":"340800"},{"name":"太湖县","value":"340825","parent":"340800"},{"name":"宿松县","value":"340826","parent":"340800"},{"name":"望江县","value":"340827","parent":"340800"},{"name":"岳西县","value":"340828","parent":"340800"},{"name":"桐城市","value":"340881","parent":"340800"},{"name":"屯溪区","value":"341002","parent":"341000"},{"name":"黄山区","value":"341003","parent":"341000"},{"name":"徽州区","value":"341004","parent":"341000"},{"name":"歙县","value":"341021","parent":"341000"},{"name":"休宁县","value":"341022","parent":"341000"},{"name":"黟县","value":"341023","parent":"341000"},{"name":"祁门县","value":"341024","parent":"341000"},{"name":"琅琊区","value":"341102","parent":"341100"},{"name":"南谯区","value":"341103","parent":"341100"},{"name":"来安县","value":"341122","parent":"341100"},{"name":"全椒县","value":"341124","parent":"341100"},{"name":"定远县","value":"341125","parent":"341100"},{"name":"凤阳县","value":"341126","parent":"341100"},{"name":"天长市","value":"341181","parent":"341100"},{"name":"明光市","value":"341182","parent":"341100"},{"name":"颍州区","value":"341202","parent":"341200"},{"name":"颍东区","value":"341203","parent":"341200"},{"name":"颍泉区","value":"341204","parent":"341200"},{"name":"临泉县","value":"341221","parent":"341200"},{"name":"太和县","value":"341222","parent":"341200"},{"name":"阜南县","value":"341225","parent":"341200"},{"name":"颍上县","value":"341226","parent":"341200"},{"name":"界首市","value":"341282","parent":"341200"},{"name":"埇桥区","value":"341302","parent":"341300"},{"name":"砀山县","value":"341321","parent":"341300"},{"name":"萧县","value":"341322","parent":"341300"},{"name":"灵璧县","value":"341323","parent":"341300"},{"name":"泗县","value":"341324","parent":"341300"},{"name":"金安区","value":"341502","parent":"341500"},{"name":"裕安区","value":"341503","parent":"341500"},{"name":"寿县","value":"341521","parent":"341500"},{"name":"霍邱县","value":"341522","parent":"341500"},{"name":"舒城县","value":"341523","parent":"341500"},{"name":"金寨县","value":"341524","parent":"341500"},{"name":"霍山县","value":"341525","parent":"341500"},{"name":"谯城区","value":"341602","parent":"341600"},{"name":"涡阳县","value":"341621","parent":"341600"},{"name":"蒙城县","value":"341622","parent":"341600"},{"name":"利辛县","value":"341623","parent":"341600"},{"name":"贵池区","value":"341702","parent":"341700"},{"name":"东至县","value":"341721","parent":"341700"},{"name":"石台县","value":"341722","parent":"341700"},{"name":"青阳县","value":"341723","parent":"341700"},{"name":"宣州区","value":"341802","parent":"341800"},{"name":"郎溪县","value":"341821","parent":"341800"},{"name":"广德县","value":"341822","parent":"341800"},{"name":"泾县","value":"341823","parent":"341800"},{"name":"绩溪县","value":"341824","parent":"341800"},{"name":"旌德县","value":"341825","parent":"341800"},{"name":"宁国市","value":"341881","parent":"341800"},{"name":"福州市","value":"350100","parent":"350000"},{"name":"厦门市","value":"350200","parent":"350000"},{"name":"莆田市","value":"350300","parent":"350000"},{"name":"三明市","value":"350400","parent":"350000"},{"name":"泉州市","value":"350500","parent":"350000"},{"name":"漳州市","value":"350600","parent":"350000"},{"name":"南平市","value":"350700","parent":"350000"},{"name":"龙岩市","value":"350800","parent":"350000"},{"name":"宁德市","value":"350900","parent":"350000"},{"name":"鼓楼区","value":"350102","parent":"350100"},{"name":"台江区","value":"350103","parent":"350100"},{"name":"仓山区","value":"350104","parent":"350100"},{"name":"马尾区","value":"350105","parent":"350100"},{"name":"晋安区","value":"350111","parent":"350100"},{"name":"闽侯县","value":"350121","parent":"350100"},{"name":"连江县","value":"350122","parent":"350100"},{"name":"罗源县","value":"350123","parent":"350100"},{"name":"闽清县","value":"350124","parent":"350100"},{"name":"永泰县","value":"350125","parent":"350100"},{"name":"平潭县","value":"350128","parent":"350100"},{"name":"福清市","value":"350181","parent":"350100"},{"name":"长乐市","value":"350182","parent":"350100"},{"name":"思明区","value":"350203","parent":"350200"},{"name":"海沧区","value":"350205","parent":"350200"},{"name":"湖里区","value":"350206","parent":"350200"},{"name":"集美区","value":"350211","parent":"350200"},{"name":"同安区","value":"350212","parent":"350200"},{"name":"翔安区","value":"350213","parent":"350200"},{"name":"城厢区","value":"350302","parent":"350300"},{"name":"涵江区","value":"350303","parent":"350300"},{"name":"荔城区","value":"350304","parent":"350300"},{"name":"秀屿区","value":"350305","parent":"350300"},{"name":"仙游县","value":"350322","parent":"350300"},{"name":"梅列区","value":"350402","parent":"350400"},{"name":"三元区","value":"350403","parent":"350400"},{"name":"明溪县","value":"350421","parent":"350400"},{"name":"清流县","value":"350423","parent":"350400"},{"name":"宁化县","value":"350424","parent":"350400"},{"name":"大田县","value":"350425","parent":"350400"},{"name":"尤溪县","value":"350426","parent":"350400"},{"name":"沙县","value":"350427","parent":"350400"},{"name":"将乐县","value":"350428","parent":"350400"},{"name":"泰宁县","value":"350429","parent":"350400"},{"name":"建宁县","value":"350430","parent":"350400"},{"name":"永安市","value":"350481","parent":"350400"},{"name":"鲤城区","value":"350502","parent":"350500"},{"name":"丰泽区","value":"350503","parent":"350500"},{"name":"洛江区","value":"350504","parent":"350500"},{"name":"泉港区","value":"350505","parent":"350500"},{"name":"惠安县","value":"350521","parent":"350500"},{"name":"安溪县","value":"350524","parent":"350500"},{"name":"永春县","value":"350525","parent":"350500"},{"name":"德化县","value":"350526","parent":"350500"},{"name":"金门县","value":"350527","parent":"350500"},{"name":"石狮市","value":"350581","parent":"350500"},{"name":"晋江市","value":"350582","parent":"350500"},{"name":"南安市","value":"350583","parent":"350500"},{"name":"芗城区","value":"350602","parent":"350600"},{"name":"龙文区","value":"350603","parent":"350600"},{"name":"云霄县","value":"350622","parent":"350600"},{"name":"漳浦县","value":"350623","parent":"350600"},{"name":"诏安县","value":"350624","parent":"350600"},{"name":"长泰县","value":"350625","parent":"350600"},{"name":"东山县","value":"350626","parent":"350600"},{"name":"南靖县","value":"350627","parent":"350600"},{"name":"平和县","value":"350628","parent":"350600"},{"name":"华安县","value":"350629","parent":"350600"},{"name":"龙海市","value":"350681","parent":"350600"},{"name":"延平区","value":"350702","parent":"350700"},{"name":"建阳区","value":"350703","parent":"350700"},{"name":"顺昌县","value":"350721","parent":"350700"},{"name":"浦城县","value":"350722","parent":"350700"},{"name":"光泽县","value":"350723","parent":"350700"},{"name":"松溪县","value":"350724","parent":"350700"},{"name":"政和县","value":"350725","parent":"350700"},{"name":"邵武市","value":"350781","parent":"350700"},{"name":"武夷山市","value":"350782","parent":"350700"},{"name":"建瓯市","value":"350783","parent":"350700"},{"name":"新罗区","value":"350802","parent":"350800"},{"name":"永定区","value":"350803","parent":"350800"},{"name":"长汀县","value":"350821","parent":"350800"},{"name":"上杭县","value":"350823","parent":"350800"},{"name":"武平县","value":"350824","parent":"350800"},{"name":"连城县","value":"350825","parent":"350800"},{"name":"漳平市","value":"350881","parent":"350800"},{"name":"蕉城区","value":"350902","parent":"350900"},{"name":"霞浦县","value":"350921","parent":"350900"},{"name":"古田县","value":"350922","parent":"350900"},{"name":"屏南县","value":"350923","parent":"350900"},{"name":"寿宁县","value":"350924","parent":"350900"},{"name":"周宁县","value":"350925","parent":"350900"},{"name":"柘荣县","value":"350926","parent":"350900"},{"name":"福安市","value":"350981","parent":"350900"},{"name":"福鼎市","value":"350982","parent":"350900"},{"name":"南昌市","value":"360100","parent":"360000"},{"name":"景德镇市","value":"360200","parent":"360000"},{"name":"萍乡市","value":"360300","parent":"360000"},{"name":"九江市","value":"360400","parent":"360000"},{"name":"新余市","value":"360500","parent":"360000"},{"name":"鹰潭市","value":"360600","parent":"360000"},{"name":"赣州市","value":"360700","parent":"360000"},{"name":"吉安市","value":"360800","parent":"360000"},{"name":"宜春市","value":"360900","parent":"360000"},{"name":"抚州市","value":"361000","parent":"360000"},{"name":"上饶市","value":"361100","parent":"360000"},{"name":"东湖区","value":"360102","parent":"360100"},{"name":"西湖区","value":"360103","parent":"360100"},{"name":"青云谱区","value":"360104","parent":"360100"},{"name":"湾里区","value":"360105","parent":"360100"},{"name":"青山湖区","value":"360111","parent":"360100"},{"name":"新建区","value":"360112","parent":"360100"},{"name":"南昌县","value":"360121","parent":"360100"},{"name":"安义县","value":"360123","parent":"360100"},{"name":"进贤县","value":"360124","parent":"360100"},{"name":"昌江区","value":"360202","parent":"360200"},{"name":"珠山区","value":"360203","parent":"360200"},{"name":"浮梁县","value":"360222","parent":"360200"},{"name":"乐平市","value":"360281","parent":"360200"},{"name":"安源区","value":"360302","parent":"360300"},{"name":"湘东区","value":"360313","parent":"360300"},{"name":"莲花县","value":"360321","parent":"360300"},{"name":"上栗县","value":"360322","parent":"360300"},{"name":"芦溪县","value":"360323","parent":"360300"},{"name":"庐山区","value":"360402","parent":"360400"},{"name":"浔阳区","value":"360403","parent":"360400"},{"name":"九江县","value":"360421","parent":"360400"},{"name":"武宁县","value":"360423","parent":"360400"},{"name":"修水县","value":"360424","parent":"360400"},{"name":"永修县","value":"360425","parent":"360400"},{"name":"德安县","value":"360426","parent":"360400"},{"name":"星子县","value":"360427","parent":"360400"},{"name":"都昌县","value":"360428","parent":"360400"},{"name":"湖口县","value":"360429","parent":"360400"},{"name":"彭泽县","value":"360430","parent":"360400"},{"name":"瑞昌市","value":"360481","parent":"360400"},{"name":"共青城市","value":"360482","parent":"360400"},{"name":"渝水区","value":"360502","parent":"360500"},{"name":"分宜县","value":"360521","parent":"360500"},{"name":"月湖区","value":"360602","parent":"360600"},{"name":"余江县","value":"360622","parent":"360600"},{"name":"贵溪市","value":"360681","parent":"360600"},{"name":"章贡区","value":"360702","parent":"360700"},{"name":"南康区","value":"360703","parent":"360700"},{"name":"赣县","value":"360721","parent":"360700"},{"name":"信丰县","value":"360722","parent":"360700"},{"name":"大余县","value":"360723","parent":"360700"},{"name":"上犹县","value":"360724","parent":"360700"},{"name":"崇义县","value":"360725","parent":"360700"},{"name":"安远县","value":"360726","parent":"360700"},{"name":"龙南县","value":"360727","parent":"360700"},{"name":"定南县","value":"360728","parent":"360700"},{"name":"全南县","value":"360729","parent":"360700"},{"name":"宁都县","value":"360730","parent":"360700"},{"name":"于都县","value":"360731","parent":"360700"},{"name":"兴国县","value":"360732","parent":"360700"},{"name":"会昌县","value":"360733","parent":"360700"},{"name":"寻乌县","value":"360734","parent":"360700"},{"name":"石城县","value":"360735","parent":"360700"},{"name":"瑞金市","value":"360781","parent":"360700"},{"name":"吉州区","value":"360802","parent":"360800"},{"name":"青原区","value":"360803","parent":"360800"},{"name":"吉安县","value":"360821","parent":"360800"},{"name":"吉水县","value":"360822","parent":"360800"},{"name":"峡江县","value":"360823","parent":"360800"},{"name":"新干县","value":"360824","parent":"360800"},{"name":"永丰县","value":"360825","parent":"360800"},{"name":"泰和县","value":"360826","parent":"360800"},{"name":"遂川县","value":"360827","parent":"360800"},{"name":"万安县","value":"360828","parent":"360800"},{"name":"安福县","value":"360829","parent":"360800"},{"name":"永新县","value":"360830","parent":"360800"},{"name":"井冈山市","value":"360881","parent":"360800"},{"name":"袁州区","value":"360902","parent":"360900"},{"name":"奉新县","value":"360921","parent":"360900"},{"name":"万载县","value":"360922","parent":"360900"},{"name":"上高县","value":"360923","parent":"360900"},{"name":"宜丰县","value":"360924","parent":"360900"},{"name":"靖安县","value":"360925","parent":"360900"},{"name":"铜鼓县","value":"360926","parent":"360900"},{"name":"丰城市","value":"360981","parent":"360900"},{"name":"樟树市","value":"360982","parent":"360900"},{"name":"高安市","value":"360983","parent":"360900"},{"name":"临川区","value":"361002","parent":"361000"},{"name":"南城县","value":"361021","parent":"361000"},{"name":"黎川县","value":"361022","parent":"361000"},{"name":"南丰县","value":"361023","parent":"361000"},{"name":"崇仁县","value":"361024","parent":"361000"},{"name":"乐安县","value":"361025","parent":"361000"},{"name":"宜黄县","value":"361026","parent":"361000"},{"name":"金溪县","value":"361027","parent":"361000"},{"name":"资溪县","value":"361028","parent":"361000"},{"name":"东乡县","value":"361029","parent":"361000"},{"name":"广昌县","value":"361030","parent":"361000"},{"name":"信州区","value":"361102","parent":"361100"},{"name":"广丰区","value":"361103","parent":"361100"},{"name":"上饶县","value":"361121","parent":"361100"},{"name":"玉山县","value":"361123","parent":"361100"},{"name":"铅山县","value":"361124","parent":"361100"},{"name":"横峰县","value":"361125","parent":"361100"},{"name":"弋阳县","value":"361126","parent":"361100"},{"name":"余干县","value":"361127","parent":"361100"},{"name":"鄱阳县","value":"361128","parent":"361100"},{"name":"万年县","value":"361129","parent":"361100"},{"name":"婺源县","value":"361130","parent":"361100"},{"name":"德兴市","value":"361181","parent":"361100"},{"name":"济南市","value":"370100","parent":"370000"},{"name":"青岛市","value":"370200","parent":"370000"},{"name":"淄博市","value":"370300","parent":"370000"},{"name":"枣庄市","value":"370400","parent":"370000"},{"name":"东营市","value":"370500","parent":"370000"},{"name":"烟台市","value":"370600","parent":"370000"},{"name":"潍坊市","value":"370700","parent":"370000"},{"name":"济宁市","value":"370800","parent":"370000"},{"name":"泰安市","value":"370900","parent":"370000"},{"name":"威海市","value":"371000","parent":"370000"},{"name":"日照市","value":"371100","parent":"370000"},{"name":"莱芜市","value":"371200","parent":"370000"},{"name":"临沂市","value":"371300","parent":"370000"},{"name":"德州市","value":"371400","parent":"370000"},{"name":"聊城市","value":"371500","parent":"370000"},{"name":"滨州市","value":"371600","parent":"370000"},{"name":"菏泽市","value":"371700","parent":"370000"},{"name":"历下区","value":"370102","parent":"370100"},{"name":"市中区","value":"370103","parent":"370100"},{"name":"槐荫区","value":"370104","parent":"370100"},{"name":"天桥区","value":"370105","parent":"370100"},{"name":"历城区","value":"370112","parent":"370100"},{"name":"长清区","value":"370113","parent":"370100"},{"name":"平阴县","value":"370124","parent":"370100"},{"name":"济阳县","value":"370125","parent":"370100"},{"name":"商河县","value":"370126","parent":"370100"},{"name":"章丘市","value":"370181","parent":"370100"},{"name":"市南区","value":"370202","parent":"370200"},{"name":"市北区","value":"370203","parent":"370200"},{"name":"黄岛区","value":"370211","parent":"370200"},{"name":"崂山区","value":"370212","parent":"370200"},{"name":"李沧区","value":"370213","parent":"370200"},{"name":"城阳区","value":"370214","parent":"370200"},{"name":"胶州市","value":"370281","parent":"370200"},{"name":"即墨市","value":"370282","parent":"370200"},{"name":"平度市","value":"370283","parent":"370200"},{"name":"莱西市","value":"370285","parent":"370200"},{"name":"淄川区","value":"370302","parent":"370300"},{"name":"张店区","value":"370303","parent":"370300"},{"name":"博山区","value":"370304","parent":"370300"},{"name":"临淄区","value":"370305","parent":"370300"},{"name":"周村区","value":"370306","parent":"370300"},{"name":"桓台县","value":"370321","parent":"370300"},{"name":"高青县","value":"370322","parent":"370300"},{"name":"沂源县","value":"370323","parent":"370300"},{"name":"市中区","value":"370402","parent":"370400"},{"name":"薛城区","value":"370403","parent":"370400"},{"name":"峄城区","value":"370404","parent":"370400"},{"name":"台儿庄区","value":"370405","parent":"370400"},{"name":"山亭区","value":"370406","parent":"370400"},{"name":"滕州市","value":"370481","parent":"370400"},{"name":"东营区","value":"370502","parent":"370500"},{"name":"河口区","value":"370503","parent":"370500"},{"name":"垦利县","value":"370521","parent":"370500"},{"name":"利津县","value":"370522","parent":"370500"},{"name":"广饶县","value":"370523","parent":"370500"},{"name":"芝罘区","value":"370602","parent":"370600"},{"name":"福山区","value":"370611","parent":"370600"},{"name":"牟平区","value":"370612","parent":"370600"},{"name":"莱山区","value":"370613","parent":"370600"},{"name":"长岛县","value":"370634","parent":"370600"},{"name":"龙口市","value":"370681","parent":"370600"},{"name":"莱阳市","value":"370682","parent":"370600"},{"name":"莱州市","value":"370683","parent":"370600"},{"name":"蓬莱市","value":"370684","parent":"370600"},{"name":"招远市","value":"370685","parent":"370600"},{"name":"栖霞市","value":"370686","parent":"370600"},{"name":"海阳市","value":"370687","parent":"370600"},{"name":"潍城区","value":"370702","parent":"370700"},{"name":"寒亭区","value":"370703","parent":"370700"},{"name":"坊子区","value":"370704","parent":"370700"},{"name":"奎文区","value":"370705","parent":"370700"},{"name":"临朐县","value":"370724","parent":"370700"},{"name":"昌乐县","value":"370725","parent":"370700"},{"name":"青州市","value":"370781","parent":"370700"},{"name":"诸城市","value":"370782","parent":"370700"},{"name":"寿光市","value":"370783","parent":"370700"},{"name":"安丘市","value":"370784","parent":"370700"},{"name":"高密市","value":"370785","parent":"370700"},{"name":"昌邑市","value":"370786","parent":"370700"},{"name":"任城区","value":"370811","parent":"370800"},{"name":"兖州区","value":"370812","parent":"370800"},{"name":"微山县","value":"370826","parent":"370800"},{"name":"鱼台县","value":"370827","parent":"370800"},{"name":"金乡县","value":"370828","parent":"370800"},{"name":"嘉祥县","value":"370829","parent":"370800"},{"name":"汶上县","value":"370830","parent":"370800"},{"name":"泗水县","value":"370831","parent":"370800"},{"name":"梁山县","value":"370832","parent":"370800"},{"name":"曲阜市","value":"370881","parent":"370800"},{"name":"邹城市","value":"370883","parent":"370800"},{"name":"泰山区","value":"370902","parent":"370900"},{"name":"岱岳区","value":"370911","parent":"370900"},{"name":"宁阳县","value":"370921","parent":"370900"},{"name":"东平县","value":"370923","parent":"370900"},{"name":"新泰市","value":"370982","parent":"370900"},{"name":"肥城市","value":"370983","parent":"370900"},{"name":"环翠区","value":"371002","parent":"371000"},{"name":"文登区","value":"371003","parent":"371000"},{"name":"荣成市","value":"371082","parent":"371000"},{"name":"乳山市","value":"371083","parent":"371000"},{"name":"东港区","value":"371102","parent":"371100"},{"name":"岚山区","value":"371103","parent":"371100"},{"name":"五莲县","value":"371121","parent":"371100"},{"name":"莒县","value":"371122","parent":"371100"},{"name":"莱城区","value":"371202","parent":"371200"},{"name":"钢城区","value":"371203","parent":"371200"},{"name":"兰山区","value":"371302","parent":"371300"},{"name":"罗庄区","value":"371311","parent":"371300"},{"name":"河东区","value":"371312","parent":"371300"},{"name":"沂南县","value":"371321","parent":"371300"},{"name":"郯城县","value":"371322","parent":"371300"},{"name":"沂水县","value":"371323","parent":"371300"},{"name":"兰陵县","value":"371324","parent":"371300"},{"name":"费县","value":"371325","parent":"371300"},{"name":"平邑县","value":"371326","parent":"371300"},{"name":"莒南县","value":"371327","parent":"371300"},{"name":"蒙阴县","value":"371328","parent":"371300"},{"name":"临沭县","value":"371329","parent":"371300"},{"name":"德城区","value":"371402","parent":"371400"},{"name":"陵城区","value":"371403","parent":"371400"},{"name":"宁津县","value":"371422","parent":"371400"},{"name":"庆云县","value":"371423","parent":"371400"},{"name":"临邑县","value":"371424","parent":"371400"},{"name":"齐河县","value":"371425","parent":"371400"},{"name":"平原县","value":"371426","parent":"371400"},{"name":"夏津县","value":"371427","parent":"371400"},{"name":"武城县","value":"371428","parent":"371400"},{"name":"乐陵市","value":"371481","parent":"371400"},{"name":"禹城市","value":"371482","parent":"371400"},{"name":"东昌府区","value":"371502","parent":"371500"},{"name":"阳谷县","value":"371521","parent":"371500"},{"name":"莘县","value":"371522","parent":"371500"},{"name":"茌平县","value":"371523","parent":"371500"},{"name":"东阿县","value":"371524","parent":"371500"},{"name":"冠县","value":"371525","parent":"371500"},{"name":"高唐县","value":"371526","parent":"371500"},{"name":"临清市","value":"371581","parent":"371500"},{"name":"滨城区","value":"371602","parent":"371600"},{"name":"沾化区","value":"371603","parent":"371600"},{"name":"惠民县","value":"371621","parent":"371600"},{"name":"阳信县","value":"371622","parent":"371600"},{"name":"无棣县","value":"371623","parent":"371600"},{"name":"博兴县","value":"371625","parent":"371600"},{"name":"邹平县","value":"371626","parent":"371600"},{"name":"牡丹区","value":"371702","parent":"371700"},{"name":"曹县","value":"371721","parent":"371700"},{"name":"单县","value":"371722","parent":"371700"},{"name":"成武县","value":"371723","parent":"371700"},{"name":"巨野县","value":"371724","parent":"371700"},{"name":"郓城县","value":"371725","parent":"371700"},{"name":"鄄城县","value":"371726","parent":"371700"},{"name":"定陶县","value":"371727","parent":"371700"},{"name":"东明县","value":"371728","parent":"371700"},{"name":"郑州市","value":"410100","parent":"410000"},{"name":"开封市","value":"410200","parent":"410000"},{"name":"洛阳市","value":"410300","parent":"410000"},{"name":"平顶山市","value":"410400","parent":"410000"},{"name":"安阳市","value":"410500","parent":"410000"},{"name":"鹤壁市","value":"410600","parent":"410000"},{"name":"新乡市","value":"410700","parent":"410000"},{"name":"焦作市","value":"410800","parent":"410000"},{"name":"濮阳市","value":"410900","parent":"410000"},{"name":"许昌市","value":"411000","parent":"410000"},{"name":"漯河市","value":"411100","parent":"410000"},{"name":"三门峡市","value":"411200","parent":"410000"},{"name":"南阳市","value":"411300","parent":"410000"},{"name":"商丘市","value":"411400","parent":"410000"},{"name":"信阳市","value":"411500","parent":"410000"},{"name":"周口市","value":"411600","parent":"410000"},{"name":"驻马店市","value":"411700","parent":"410000"},{"name":"济源市","value":"419001","parent":"410000"},{"name":"中原区","value":"410102","parent":"410100"},{"name":"二七区","value":"410103","parent":"410100"},{"name":"管城回族区","value":"410104","parent":"410100"},{"name":"金水区","value":"410105","parent":"410100"},{"name":"上街区","value":"410106","parent":"410100"},{"name":"惠济区","value":"410108","parent":"410100"},{"name":"中牟县","value":"410122","parent":"410100"},{"name":"巩义市","value":"410181","parent":"410100"},{"name":"荥阳市","value":"410182","parent":"410100"},{"name":"新密市","value":"410183","parent":"410100"},{"name":"新郑市","value":"410184","parent":"410100"},{"name":"登封市","value":"410185","parent":"410100"},{"name":"龙亭区","value":"410202","parent":"410200"},{"name":"顺河回族区","value":"410203","parent":"410200"},{"name":"鼓楼区","value":"410204","parent":"410200"},{"name":"禹王台区","value":"410205","parent":"410200"},{"name":"金明区","value":"410211","parent":"410200"},{"name":"祥符区","value":"410212","parent":"410200"},{"name":"杞县","value":"410221","parent":"410200"},{"name":"通许县","value":"410222","parent":"410200"},{"name":"尉氏县","value":"410223","parent":"410200"},{"name":"兰考县","value":"410225","parent":"410200"},{"name":"老城区","value":"410302","parent":"410300"},{"name":"西工区","value":"410303","parent":"410300"},{"name":"瀍河回族区","value":"410304","parent":"410300"},{"name":"涧西区","value":"410305","parent":"410300"},{"name":"吉利区","value":"410306","parent":"410300"},{"name":"洛龙区","value":"410311","parent":"410300"},{"name":"孟津县","value":"410322","parent":"410300"},{"name":"新安县","value":"410323","parent":"410300"},{"name":"栾川县","value":"410324","parent":"410300"},{"name":"嵩县","value":"410325","parent":"410300"},{"name":"汝阳县","value":"410326","parent":"410300"},{"name":"宜阳县","value":"410327","parent":"410300"},{"name":"洛宁县","value":"410328","parent":"410300"},{"name":"伊川县","value":"410329","parent":"410300"},{"name":"偃师市","value":"410381","parent":"410300"},{"name":"新华区","value":"410402","parent":"410400"},{"name":"卫东区","value":"410403","parent":"410400"},{"name":"石龙区","value":"410404","parent":"410400"},{"name":"湛河区","value":"410411","parent":"410400"},{"name":"宝丰县","value":"410421","parent":"410400"},{"name":"叶县","value":"410422","parent":"410400"},{"name":"鲁山县","value":"410423","parent":"410400"},{"name":"郏县","value":"410425","parent":"410400"},{"name":"舞钢市","value":"410481","parent":"410400"},{"name":"汝州市","value":"410482","parent":"410400"},{"name":"文峰区","value":"410502","parent":"410500"},{"name":"北关区","value":"410503","parent":"410500"},{"name":"殷都区","value":"410505","parent":"410500"},{"name":"龙安区","value":"410506","parent":"410500"},{"name":"安阳县","value":"410522","parent":"410500"},{"name":"汤阴县","value":"410523","parent":"410500"},{"name":"滑县","value":"410526","parent":"410500"},{"name":"内黄县","value":"410527","parent":"410500"},{"name":"林州市","value":"410581","parent":"410500"},{"name":"鹤山区","value":"410602","parent":"410600"},{"name":"山城区","value":"410603","parent":"410600"},{"name":"淇滨区","value":"410611","parent":"410600"},{"name":"浚县","value":"410621","parent":"410600"},{"name":"淇县","value":"410622","parent":"410600"},{"name":"红旗区","value":"410702","parent":"410700"},{"name":"卫滨区","value":"410703","parent":"410700"},{"name":"凤泉区","value":"410704","parent":"410700"},{"name":"牧野区","value":"410711","parent":"410700"},{"name":"新乡县","value":"410721","parent":"410700"},{"name":"获嘉县","value":"410724","parent":"410700"},{"name":"原阳县","value":"410725","parent":"410700"},{"name":"延津县","value":"410726","parent":"410700"},{"name":"封丘县","value":"410727","parent":"410700"},{"name":"长垣县","value":"410728","parent":"410700"},{"name":"卫辉市","value":"410781","parent":"410700"},{"name":"辉县市","value":"410782","parent":"410700"},{"name":"解放区","value":"410802","parent":"410800"},{"name":"中站区","value":"410803","parent":"410800"},{"name":"马村区","value":"410804","parent":"410800"},{"name":"山阳区","value":"410811","parent":"410800"},{"name":"修武县","value":"410821","parent":"410800"},{"name":"博爱县","value":"410822","parent":"410800"},{"name":"武陟县","value":"410823","parent":"410800"},{"name":"温县","value":"410825","parent":"410800"},{"name":"沁阳市","value":"410882","parent":"410800"},{"name":"孟州市","value":"410883","parent":"410800"},{"name":"华龙区","value":"410902","parent":"410900"},{"name":"清丰县","value":"410922","parent":"410900"},{"name":"南乐县","value":"410923","parent":"410900"},{"name":"范县","value":"410926","parent":"410900"},{"name":"台前县","value":"410927","parent":"410900"},{"name":"濮阳县","value":"410928","parent":"410900"},{"name":"魏都区","value":"411002","parent":"411000"},{"name":"许昌县","value":"411023","parent":"411000"},{"name":"鄢陵县","value":"411024","parent":"411000"},{"name":"襄城县","value":"411025","parent":"411000"},{"name":"禹州市","value":"411081","parent":"411000"},{"name":"长葛市","value":"411082","parent":"411000"},{"name":"源汇区","value":"411102","parent":"411100"},{"name":"郾城区","value":"411103","parent":"411100"},{"name":"召陵区","value":"411104","parent":"411100"},{"name":"舞阳县","value":"411121","parent":"411100"},{"name":"临颍县","value":"411122","parent":"411100"},{"name":"湖滨区","value":"411202","parent":"411200"},{"name":"渑池县","value":"411221","parent":"411200"},{"name":"陕县","value":"411222","parent":"411200"},{"name":"卢氏县","value":"411224","parent":"411200"},{"name":"义马市","value":"411281","parent":"411200"},{"name":"灵宝市","value":"411282","parent":"411200"},{"name":"宛城区","value":"411302","parent":"411300"},{"name":"卧龙区","value":"411303","parent":"411300"},{"name":"南召县","value":"411321","parent":"411300"},{"name":"方城县","value":"411322","parent":"411300"},{"name":"西峡县","value":"411323","parent":"411300"},{"name":"镇平县","value":"411324","parent":"411300"},{"name":"内乡县","value":"411325","parent":"411300"},{"name":"淅川县","value":"411326","parent":"411300"},{"name":"社旗县","value":"411327","parent":"411300"},{"name":"唐河县","value":"411328","parent":"411300"},{"name":"新野县","value":"411329","parent":"411300"},{"name":"桐柏县","value":"411330","parent":"411300"},{"name":"邓州市","value":"411381","parent":"411300"},{"name":"梁园区","value":"411402","parent":"411400"},{"name":"睢阳区","value":"411403","parent":"411400"},{"name":"民权县","value":"411421","parent":"411400"},{"name":"睢县","value":"411422","parent":"411400"},{"name":"宁陵县","value":"411423","parent":"411400"},{"name":"柘城县","value":"411424","parent":"411400"},{"name":"虞城县","value":"411425","parent":"411400"},{"name":"夏邑县","value":"411426","parent":"411400"},{"name":"永城市","value":"411481","parent":"411400"},{"name":"浉河区","value":"411502","parent":"411500"},{"name":"平桥区","value":"411503","parent":"411500"},{"name":"罗山县","value":"411521","parent":"411500"},{"name":"光山县","value":"411522","parent":"411500"},{"name":"新县","value":"411523","parent":"411500"},{"name":"商城县","value":"411524","parent":"411500"},{"name":"固始县","value":"411525","parent":"411500"},{"name":"潢川县","value":"411526","parent":"411500"},{"name":"淮滨县","value":"411527","parent":"411500"},{"name":"息县","value":"411528","parent":"411500"},{"name":"川汇区","value":"411602","parent":"411600"},{"name":"扶沟县","value":"411621","parent":"411600"},{"name":"西华县","value":"411622","parent":"411600"},{"name":"商水县","value":"411623","parent":"411600"},{"name":"沈丘县","value":"411624","parent":"411600"},{"name":"郸城县","value":"411625","parent":"411600"},{"name":"淮阳县","value":"411626","parent":"411600"},{"name":"太康县","value":"411627","parent":"411600"},{"name":"鹿邑县","value":"411628","parent":"411600"},{"name":"项城市","value":"411681","parent":"411600"},{"name":"驿城区","value":"411702","parent":"411700"},{"name":"西平县","value":"411721","parent":"411700"},{"name":"上蔡县","value":"411722","parent":"411700"},{"name":"平舆县","value":"411723","parent":"411700"},{"name":"正阳县","value":"411724","parent":"411700"},{"name":"确山县","value":"411725","parent":"411700"},{"name":"泌阳县","value":"411726","parent":"411700"},{"name":"汝南县","value":"411727","parent":"411700"},{"name":"遂平县","value":"411728","parent":"411700"},{"name":"新蔡县","value":"411729","parent":"411700"},{"name":"武汉市","value":"420100","parent":"420000"},{"name":"黄石市","value":"420200","parent":"420000"},{"name":"十堰市","value":"420300","parent":"420000"},{"name":"宜昌市","value":"420500","parent":"420000"},{"name":"襄阳市","value":"420600","parent":"420000"},{"name":"鄂州市","value":"420700","parent":"420000"},{"name":"荆门市","value":"420800","parent":"420000"},{"name":"孝感市","value":"420900","parent":"420000"},{"name":"荆州市","value":"421000","parent":"420000"},{"name":"黄冈市","value":"421100","parent":"420000"},{"name":"咸宁市","value":"421200","parent":"420000"},{"name":"随州市","value":"421300","parent":"420000"},{"name":"恩施土家族苗族自治州","value":"422800","parent":"420000"},{"name":"仙桃市","value":"429004","parent":"420000"},{"name":"潜江市","value":"429005","parent":"420000"},{"name":"天门市","value":"429006","parent":"420000"},{"name":"神农架林区","value":"429021","parent":"420000"},{"name":"江岸区","value":"420102","parent":"420100"},{"name":"江汉区","value":"420103","parent":"420100"},{"name":"硚口区","value":"420104","parent":"420100"},{"name":"汉阳区","value":"420105","parent":"420100"},{"name":"武昌区","value":"420106","parent":"420100"},{"name":"青山区","value":"420107","parent":"420100"},{"name":"洪山区","value":"420111","parent":"420100"},{"name":"东西湖区","value":"420112","parent":"420100"},{"name":"汉南区","value":"420113","parent":"420100"},{"name":"蔡甸区","value":"420114","parent":"420100"},{"name":"江夏区","value":"420115","parent":"420100"},{"name":"黄陂区","value":"420116","parent":"420100"},{"name":"新洲区","value":"420117","parent":"420100"},{"name":"黄石港区","value":"420202","parent":"420200"},{"name":"西塞山区","value":"420203","parent":"420200"},{"name":"下陆区","value":"420204","parent":"420200"},{"name":"铁山区","value":"420205","parent":"420200"},{"name":"阳新县","value":"420222","parent":"420200"},{"name":"大冶市","value":"420281","parent":"420200"},{"name":"茅箭区","value":"420302","parent":"420300"},{"name":"张湾区","value":"420303","parent":"420300"},{"name":"郧阳区","value":"420304","parent":"420300"},{"name":"郧西县","value":"420322","parent":"420300"},{"name":"竹山县","value":"420323","parent":"420300"},{"name":"竹溪县","value":"420324","parent":"420300"},{"name":"房县","value":"420325","parent":"420300"},{"name":"丹江口市","value":"420381","parent":"420300"},{"name":"西陵区","value":"420502","parent":"420500"},{"name":"伍家岗区","value":"420503","parent":"420500"},{"name":"点军区","value":"420504","parent":"420500"},{"name":"猇亭区","value":"420505","parent":"420500"},{"name":"夷陵区","value":"420506","parent":"420500"},{"name":"远安县","value":"420525","parent":"420500"},{"name":"兴山县","value":"420526","parent":"420500"},{"name":"秭归县","value":"420527","parent":"420500"},{"name":"长阳土家族自治县","value":"420528","parent":"420500"},{"name":"五峰土家族自治县","value":"420529","parent":"420500"},{"name":"宜都市","value":"420581","parent":"420500"},{"name":"当阳市","value":"420582","parent":"420500"},{"name":"枝江市","value":"420583","parent":"420500"},{"name":"襄城区","value":"420602","parent":"420600"},{"name":"樊城区","value":"420606","parent":"420600"},{"name":"襄州区","value":"420607","parent":"420600"},{"name":"南漳县","value":"420624","parent":"420600"},{"name":"谷城县","value":"420625","parent":"420600"},{"name":"保康县","value":"420626","parent":"420600"},{"name":"老河口市","value":"420682","parent":"420600"},{"name":"枣阳市","value":"420683","parent":"420600"},{"name":"宜城市","value":"420684","parent":"420600"},{"name":"梁子湖区","value":"420702","parent":"420700"},{"name":"华容区","value":"420703","parent":"420700"},{"name":"鄂城区","value":"420704","parent":"420700"},{"name":"东宝区","value":"420802","parent":"420800"},{"name":"掇刀区","value":"420804","parent":"420800"},{"name":"京山县","value":"420821","parent":"420800"},{"name":"沙洋县","value":"420822","parent":"420800"},{"name":"钟祥市","value":"420881","parent":"420800"},{"name":"孝南区","value":"420902","parent":"420900"},{"name":"孝昌县","value":"420921","parent":"420900"},{"name":"大悟县","value":"420922","parent":"420900"},{"name":"云梦县","value":"420923","parent":"420900"},{"name":"应城市","value":"420981","parent":"420900"},{"name":"安陆市","value":"420982","parent":"420900"},{"name":"汉川市","value":"420984","parent":"420900"},{"name":"沙市区","value":"421002","parent":"421000"},{"name":"荆州区","value":"421003","parent":"421000"},{"name":"公安县","value":"421022","parent":"421000"},{"name":"监利县","value":"421023","parent":"421000"},{"name":"江陵县","value":"421024","parent":"421000"},{"name":"石首市","value":"421081","parent":"421000"},{"name":"洪湖市","value":"421083","parent":"421000"},{"name":"松滋市","value":"421087","parent":"421000"},{"name":"黄州区","value":"421102","parent":"421100"},{"name":"团风县","value":"421121","parent":"421100"},{"name":"红安县","value":"421122","parent":"421100"},{"name":"罗田县","value":"421123","parent":"421100"},{"name":"英山县","value":"421124","parent":"421100"},{"name":"浠水县","value":"421125","parent":"421100"},{"name":"蕲春县","value":"421126","parent":"421100"},{"name":"黄梅县","value":"421127","parent":"421100"},{"name":"麻城市","value":"421181","parent":"421100"},{"name":"武穴市","value":"421182","parent":"421100"},{"name":"咸安区","value":"421202","parent":"421200"},{"name":"嘉鱼县","value":"421221","parent":"421200"},{"name":"通城县","value":"421222","parent":"421200"},{"name":"崇阳县","value":"421223","parent":"421200"},{"name":"通山县","value":"421224","parent":"421200"},{"name":"赤壁市","value":"421281","parent":"421200"},{"name":"曾都区","value":"421303","parent":"421300"},{"name":"随县","value":"421321","parent":"421300"},{"name":"广水市","value":"421381","parent":"421300"},{"name":"恩施市","value":"422801","parent":"422800"},{"name":"利川市","value":"422802","parent":"422800"},{"name":"建始县","value":"422822","parent":"422800"},{"name":"巴东县","value":"422823","parent":"422800"},{"name":"宣恩县","value":"422825","parent":"422800"},{"name":"咸丰县","value":"422826","parent":"422800"},{"name":"来凤县","value":"422827","parent":"422800"},{"name":"鹤峰县","value":"422828","parent":"422800"},{"name":"长沙市","value":"430100","parent":"430000"},{"name":"株洲市","value":"430200","parent":"430000"},{"name":"湘潭市","value":"430300","parent":"430000"},{"name":"衡阳市","value":"430400","parent":"430000"},{"name":"邵阳市","value":"430500","parent":"430000"},{"name":"岳阳市","value":"430600","parent":"430000"},{"name":"常德市","value":"430700","parent":"430000"},{"name":"张家界市","value":"430800","parent":"430000"},{"name":"益阳市","value":"430900","parent":"430000"},{"name":"郴州市","value":"431000","parent":"430000"},{"name":"永州市","value":"431100","parent":"430000"},{"name":"怀化市","value":"431200","parent":"430000"},{"name":"娄底市","value":"431300","parent":"430000"},{"name":"湘西土家族苗族自治州","value":"433100","parent":"430000"},{"name":"芙蓉区","value":"430102","parent":"430100"},{"name":"天心区","value":"430103","parent":"430100"},{"name":"岳麓区","value":"430104","parent":"430100"},{"name":"开福区","value":"430105","parent":"430100"},{"name":"雨花区","value":"430111","parent":"430100"},{"name":"望城区","value":"430112","parent":"430100"},{"name":"长沙县","value":"430121","parent":"430100"},{"name":"宁乡县","value":"430124","parent":"430100"},{"name":"浏阳市","value":"430181","parent":"430100"},{"name":"荷塘区","value":"430202","parent":"430200"},{"name":"芦淞区","value":"430203","parent":"430200"},{"name":"石峰区","value":"430204","parent":"430200"},{"name":"天元区","value":"430211","parent":"430200"},{"name":"株洲县","value":"430221","parent":"430200"},{"name":"攸县","value":"430223","parent":"430200"},{"name":"茶陵县","value":"430224","parent":"430200"},{"name":"炎陵县","value":"430225","parent":"430200"},{"name":"醴陵市","value":"430281","parent":"430200"},{"name":"雨湖区","value":"430302","parent":"430300"},{"name":"岳塘区","value":"430304","parent":"430300"},{"name":"湘潭县","value":"430321","parent":"430300"},{"name":"湘乡市","value":"430381","parent":"430300"},{"name":"韶山市","value":"430382","parent":"430300"},{"name":"珠晖区","value":"430405","parent":"430400"},{"name":"雁峰区","value":"430406","parent":"430400"},{"name":"石鼓区","value":"430407","parent":"430400"},{"name":"蒸湘区","value":"430408","parent":"430400"},{"name":"南岳区","value":"430412","parent":"430400"},{"name":"衡阳县","value":"430421","parent":"430400"},{"name":"衡南县","value":"430422","parent":"430400"},{"name":"衡山县","value":"430423","parent":"430400"},{"name":"衡东县","value":"430424","parent":"430400"},{"name":"祁东县","value":"430426","parent":"430400"},{"name":"耒阳市","value":"430481","parent":"430400"},{"name":"常宁市","value":"430482","parent":"430400"},{"name":"双清区","value":"430502","parent":"430500"},{"name":"大祥区","value":"430503","parent":"430500"},{"name":"北塔区","value":"430511","parent":"430500"},{"name":"邵东县","value":"430521","parent":"430500"},{"name":"新邵县","value":"430522","parent":"430500"},{"name":"邵阳县","value":"430523","parent":"430500"},{"name":"隆回县","value":"430524","parent":"430500"},{"name":"洞口县","value":"430525","parent":"430500"},{"name":"绥宁县","value":"430527","parent":"430500"},{"name":"新宁县","value":"430528","parent":"430500"},{"name":"城步苗族自治县","value":"430529","parent":"430500"},{"name":"武冈市","value":"430581","parent":"430500"},{"name":"岳阳楼区","value":"430602","parent":"430600"},{"name":"云溪区","value":"430603","parent":"430600"},{"name":"君山区","value":"430611","parent":"430600"},{"name":"岳阳县","value":"430621","parent":"430600"},{"name":"华容县","value":"430623","parent":"430600"},{"name":"湘阴县","value":"430624","parent":"430600"},{"name":"平江县","value":"430626","parent":"430600"},{"name":"汨罗市","value":"430681","parent":"430600"},{"name":"临湘市","value":"430682","parent":"430600"},{"name":"武陵区","value":"430702","parent":"430700"},{"name":"鼎城区","value":"430703","parent":"430700"},{"name":"安乡县","value":"430721","parent":"430700"},{"name":"汉寿县","value":"430722","parent":"430700"},{"name":"澧县","value":"430723","parent":"430700"},{"name":"临澧县","value":"430724","parent":"430700"},{"name":"桃源县","value":"430725","parent":"430700"},{"name":"石门县","value":"430726","parent":"430700"},{"name":"津市市","value":"430781","parent":"430700"},{"name":"永定区","value":"430802","parent":"430800"},{"name":"武陵源区","value":"430811","parent":"430800"},{"name":"慈利县","value":"430821","parent":"430800"},{"name":"桑植县","value":"430822","parent":"430800"},{"name":"资阳区","value":"430902","parent":"430900"},{"name":"赫山区","value":"430903","parent":"430900"},{"name":"南县","value":"430921","parent":"430900"},{"name":"桃江县","value":"430922","parent":"430900"},{"name":"安化县","value":"430923","parent":"430900"},{"name":"沅江市","value":"430981","parent":"430900"},{"name":"北湖区","value":"431002","parent":"431000"},{"name":"苏仙区","value":"431003","parent":"431000"},{"name":"桂阳县","value":"431021","parent":"431000"},{"name":"宜章县","value":"431022","parent":"431000"},{"name":"永兴县","value":"431023","parent":"431000"},{"name":"嘉禾县","value":"431024","parent":"431000"},{"name":"临武县","value":"431025","parent":"431000"},{"name":"汝城县","value":"431026","parent":"431000"},{"name":"桂东县","value":"431027","parent":"431000"},{"name":"安仁县","value":"431028","parent":"431000"},{"name":"资兴市","value":"431081","parent":"431000"},{"name":"零陵区","value":"431102","parent":"431100"},{"name":"冷水滩区","value":"431103","parent":"431100"},{"name":"祁阳县","value":"431121","parent":"431100"},{"name":"东安县","value":"431122","parent":"431100"},{"name":"双牌县","value":"431123","parent":"431100"},{"name":"道县","value":"431124","parent":"431100"},{"name":"江永县","value":"431125","parent":"431100"},{"name":"宁远县","value":"431126","parent":"431100"},{"name":"蓝山县","value":"431127","parent":"431100"},{"name":"新田县","value":"431128","parent":"431100"},{"name":"江华瑶族自治县","value":"431129","parent":"431100"},{"name":"鹤城区","value":"431202","parent":"431200"},{"name":"中方县","value":"431221","parent":"431200"},{"name":"沅陵县","value":"431222","parent":"431200"},{"name":"辰溪县","value":"431223","parent":"431200"},{"name":"溆浦县","value":"431224","parent":"431200"},{"name":"会同县","value":"431225","parent":"431200"},{"name":"麻阳苗族自治县","value":"431226","parent":"431200"},{"name":"新晃侗族自治县","value":"431227","parent":"431200"},{"name":"芷江侗族自治县","value":"431228","parent":"431200"},{"name":"靖州苗族侗族自治县","value":"431229","parent":"431200"},{"name":"通道侗族自治县","value":"431230","parent":"431200"},{"name":"洪江市","value":"431281","parent":"431200"},{"name":"娄星区","value":"431302","parent":"431300"},{"name":"双峰县","value":"431321","parent":"431300"},{"name":"新化县","value":"431322","parent":"431300"},{"name":"冷水江市","value":"431381","parent":"431300"},{"name":"涟源市","value":"431382","parent":"431300"},{"name":"吉首市","value":"433101","parent":"433100"},{"name":"泸溪县","value":"433122","parent":"433100"},{"name":"凤凰县","value":"433123","parent":"433100"},{"name":"花垣县","value":"433124","parent":"433100"},{"name":"保靖县","value":"433125","parent":"433100"},{"name":"古丈县","value":"433126","parent":"433100"},{"name":"永顺县","value":"433127","parent":"433100"},{"name":"龙山县","value":"433130","parent":"433100"},{"name":"广州市","value":"440100","parent":"440000"},{"name":"韶关市","value":"440200","parent":"440000"},{"name":"深圳市","value":"440300","parent":"440000"},{"name":"珠海市","value":"440400","parent":"440000"},{"name":"汕头市","value":"440500","parent":"440000"},{"name":"佛山市","value":"440600","parent":"440000"},{"name":"江门市","value":"440700","parent":"440000"},{"name":"湛江市","value":"440800","parent":"440000"},{"name":"茂名市","value":"440900","parent":"440000"},{"name":"肇庆市","value":"441200","parent":"440000"},{"name":"惠州市","value":"441300","parent":"440000"},{"name":"梅州市","value":"441400","parent":"440000"},{"name":"汕尾市","value":"441500","parent":"440000"},{"name":"河源市","value":"441600","parent":"440000"},{"name":"阳江市","value":"441700","parent":"440000"},{"name":"清远市","value":"441800","parent":"440000"},{"name":"东莞市","value":"441900","parent":"440000"},{"name":"中山市","value":"442000","parent":"440000"},{"name":"潮州市","value":"445100","parent":"440000"},{"name":"揭阳市","value":"445200","parent":"440000"},{"name":"云浮市","value":"445300","parent":"440000"},{"name":"荔湾区","value":"440103","parent":"440100"},{"name":"越秀区","value":"440104","parent":"440100"},{"name":"海珠区","value":"440105","parent":"440100"},{"name":"天河区","value":"440106","parent":"440100"},{"name":"白云区","value":"440111","parent":"440100"},{"name":"黄埔区","value":"440112","parent":"440100"},{"name":"番禺区","value":"440113","parent":"440100"},{"name":"花都区","value":"440114","parent":"440100"},{"name":"南沙区","value":"440115","parent":"440100"},{"name":"从化区","value":"440117","parent":"440100"},{"name":"增城区","value":"440118","parent":"440100"},{"name":"武江区","value":"440203","parent":"440200"},{"name":"浈江区","value":"440204","parent":"440200"},{"name":"曲江区","value":"440205","parent":"440200"},{"name":"始兴县","value":"440222","parent":"440200"},{"name":"仁化县","value":"440224","parent":"440200"},{"name":"翁源县","value":"440229","parent":"440200"},{"name":"乳源瑶族自治县","value":"440232","parent":"440200"},{"name":"新丰县","value":"440233","parent":"440200"},{"name":"乐昌市","value":"440281","parent":"440200"},{"name":"南雄市","value":"440282","parent":"440200"},{"name":"罗湖区","value":"440303","parent":"440300"},{"name":"福田区","value":"440304","parent":"440300"},{"name":"南山区","value":"440305","parent":"440300"},{"name":"宝安区","value":"440306","parent":"440300"},{"name":"龙岗区","value":"440307","parent":"440300"},{"name":"盐田区","value":"440308","parent":"440300"},{"name":"香洲区","value":"440402","parent":"440400"},{"name":"斗门区","value":"440403","parent":"440400"},{"name":"金湾区","value":"440404","parent":"440400"},{"name":"龙湖区","value":"440507","parent":"440500"},{"name":"金平区","value":"440511","parent":"440500"},{"name":"濠江区","value":"440512","parent":"440500"},{"name":"潮阳区","value":"440513","parent":"440500"},{"name":"潮南区","value":"440514","parent":"440500"},{"name":"澄海区","value":"440515","parent":"440500"},{"name":"南澳县","value":"440523","parent":"440500"},{"name":"禅城区","value":"440604","parent":"440600"},{"name":"南海区","value":"440605","parent":"440600"},{"name":"顺德区","value":"440606","parent":"440600"},{"name":"三水区","value":"440607","parent":"440600"},{"name":"高明区","value":"440608","parent":"440600"},{"name":"蓬江区","value":"440703","parent":"440700"},{"name":"江海区","value":"440704","parent":"440700"},{"name":"新会区","value":"440705","parent":"440700"},{"name":"台山市","value":"440781","parent":"440700"},{"name":"开平市","value":"440783","parent":"440700"},{"name":"鹤山市","value":"440784","parent":"440700"},{"name":"恩平市","value":"440785","parent":"440700"},{"name":"赤坎区","value":"440802","parent":"440800"},{"name":"霞山区","value":"440803","parent":"440800"},{"name":"坡头区","value":"440804","parent":"440800"},{"name":"麻章区","value":"440811","parent":"440800"},{"name":"遂溪县","value":"440823","parent":"440800"},{"name":"徐闻县","value":"440825","parent":"440800"},{"name":"廉江市","value":"440881","parent":"440800"},{"name":"雷州市","value":"440882","parent":"440800"},{"name":"吴川市","value":"440883","parent":"440800"},{"name":"茂南区","value":"440902","parent":"440900"},{"name":"电白区","value":"440904","parent":"440900"},{"name":"高州市","value":"440981","parent":"440900"},{"name":"化州市","value":"440982","parent":"440900"},{"name":"信宜市","value":"440983","parent":"440900"},{"name":"端州区","value":"441202","parent":"441200"},{"name":"鼎湖区","value":"441203","parent":"441200"},{"name":"高要区","value":"441204","parent":"441200"},{"name":"广宁县","value":"441223","parent":"441200"},{"name":"怀集县","value":"441224","parent":"441200"},{"name":"封开县","value":"441225","parent":"441200"},{"name":"德庆县","value":"441226","parent":"441200"},{"name":"四会市","value":"441284","parent":"441200"},{"name":"惠城区","value":"441302","parent":"441300"},{"name":"惠阳区","value":"441303","parent":"441300"},{"name":"博罗县","value":"441322","parent":"441300"},{"name":"惠东县","value":"441323","parent":"441300"},{"name":"龙门县","value":"441324","parent":"441300"},{"name":"梅江区","value":"441402","parent":"441400"},{"name":"梅县区","value":"441403","parent":"441400"},{"name":"大埔县","value":"441422","parent":"441400"},{"name":"丰顺县","value":"441423","parent":"441400"},{"name":"五华县","value":"441424","parent":"441400"},{"name":"平远县","value":"441426","parent":"441400"},{"name":"蕉岭县","value":"441427","parent":"441400"},{"name":"兴宁市","value":"441481","parent":"441400"},{"name":"城区","value":"441502","parent":"441500"},{"name":"海丰县","value":"441521","parent":"441500"},{"name":"陆河县","value":"441523","parent":"441500"},{"name":"陆丰市","value":"441581","parent":"441500"},{"name":"源城区","value":"441602","parent":"441600"},{"name":"紫金县","value":"441621","parent":"441600"},{"name":"龙川县","value":"441622","parent":"441600"},{"name":"连平县","value":"441623","parent":"441600"},{"name":"和平县","value":"441624","parent":"441600"},{"name":"东源县","value":"441625","parent":"441600"},{"name":"江城区","value":"441702","parent":"441700"},{"name":"阳东区","value":"441704","parent":"441700"},{"name":"阳西县","value":"441721","parent":"441700"},{"name":"阳春市","value":"441781","parent":"441700"},{"name":"清城区","value":"441802","parent":"441800"},{"name":"清新区","value":"441803","parent":"441800"},{"name":"佛冈县","value":"441821","parent":"441800"},{"name":"阳山县","value":"441823","parent":"441800"},{"name":"连山壮族瑶族自治县","value":"441825","parent":"441800"},{"name":"连南瑶族自治县","value":"441826","parent":"441800"},{"name":"英德市","value":"441881","parent":"441800"},{"name":"连州市","value":"441882","parent":"441800"},{"name":"湘桥区","value":"445102","parent":"445100"},{"name":"潮安区","value":"445103","parent":"445100"},{"name":"饶平县","value":"445122","parent":"445100"},{"name":"榕城区","value":"445202","parent":"445200"},{"name":"揭东区","value":"445203","parent":"445200"},{"name":"揭西县","value":"445222","parent":"445200"},{"name":"惠来县","value":"445224","parent":"445200"},{"name":"普宁市","value":"445281","parent":"445200"},{"name":"云城区","value":"445302","parent":"445300"},{"name":"云安区","value":"445303","parent":"445300"},{"name":"新兴县","value":"445321","parent":"445300"},{"name":"郁南县","value":"445322","parent":"445300"},{"name":"罗定市","value":"445381","parent":"445300"},{"name":"南宁市","value":"450100","parent":"450000"},{"name":"柳州市","value":"450200","parent":"450000"},{"name":"桂林市","value":"450300","parent":"450000"},{"name":"梧州市","value":"450400","parent":"450000"},{"name":"北海市","value":"450500","parent":"450000"},{"name":"防城港市","value":"450600","parent":"450000"},{"name":"钦州市","value":"450700","parent":"450000"},{"name":"贵港市","value":"450800","parent":"450000"},{"name":"玉林市","value":"450900","parent":"450000"},{"name":"百色市","value":"451000","parent":"450000"},{"name":"贺州市","value":"451100","parent":"450000"},{"name":"河池市","value":"451200","parent":"450000"},{"name":"来宾市","value":"451300","parent":"450000"},{"name":"崇左市","value":"451400","parent":"450000"},{"name":"兴宁区","value":"450102","parent":"450100"},{"name":"青秀区","value":"450103","parent":"450100"},{"name":"江南区","value":"450105","parent":"450100"},{"name":"西乡塘区","value":"450107","parent":"450100"},{"name":"良庆区","value":"450108","parent":"450100"},{"name":"邕宁区","value":"450109","parent":"450100"},{"name":"武鸣区","value":"450110","parent":"450100"},{"name":"隆安县","value":"450123","parent":"450100"},{"name":"马山县","value":"450124","parent":"450100"},{"name":"上林县","value":"450125","parent":"450100"},{"name":"宾阳县","value":"450126","parent":"450100"},{"name":"横县","value":"450127","parent":"450100"},{"name":"城中区","value":"450202","parent":"450200"},{"name":"鱼峰区","value":"450203","parent":"450200"},{"name":"柳南区","value":"450204","parent":"450200"},{"name":"柳北区","value":"450205","parent":"450200"},{"name":"柳江县","value":"450221","parent":"450200"},{"name":"柳城县","value":"450222","parent":"450200"},{"name":"鹿寨县","value":"450223","parent":"450200"},{"name":"融安县","value":"450224","parent":"450200"},{"name":"融水苗族自治县","value":"450225","parent":"450200"},{"name":"三江侗族自治县","value":"450226","parent":"450200"},{"name":"秀峰区","value":"450302","parent":"450300"},{"name":"叠彩区","value":"450303","parent":"450300"},{"name":"象山区","value":"450304","parent":"450300"},{"name":"七星区","value":"450305","parent":"450300"},{"name":"雁山区","value":"450311","parent":"450300"},{"name":"临桂区","value":"450312","parent":"450300"},{"name":"阳朔县","value":"450321","parent":"450300"},{"name":"灵川县","value":"450323","parent":"450300"},{"name":"全州县","value":"450324","parent":"450300"},{"name":"兴安县","value":"450325","parent":"450300"},{"name":"永福县","value":"450326","parent":"450300"},{"name":"灌阳县","value":"450327","parent":"450300"},{"name":"龙胜各族自治县","value":"450328","parent":"450300"},{"name":"资源县","value":"450329","parent":"450300"},{"name":"平乐县","value":"450330","parent":"450300"},{"name":"荔浦县","value":"450331","parent":"450300"},{"name":"恭城瑶族自治县","value":"450332","parent":"450300"},{"name":"万秀区","value":"450403","parent":"450400"},{"name":"长洲区","value":"450405","parent":"450400"},{"name":"龙圩区","value":"450406","parent":"450400"},{"name":"苍梧县","value":"450421","parent":"450400"},{"name":"藤县","value":"450422","parent":"450400"},{"name":"蒙山县","value":"450423","parent":"450400"},{"name":"岑溪市","value":"450481","parent":"450400"},{"name":"海城区","value":"450502","parent":"450500"},{"name":"银海区","value":"450503","parent":"450500"},{"name":"铁山港区","value":"450512","parent":"450500"},{"name":"合浦县","value":"450521","parent":"450500"},{"name":"港口区","value":"450602","parent":"450600"},{"name":"防城区","value":"450603","parent":"450600"},{"name":"上思县","value":"450621","parent":"450600"},{"name":"东兴市","value":"450681","parent":"450600"},{"name":"钦南区","value":"450702","parent":"450700"},{"name":"钦北区","value":"450703","parent":"450700"},{"name":"灵山县","value":"450721","parent":"450700"},{"name":"浦北县","value":"450722","parent":"450700"},{"name":"港北区","value":"450802","parent":"450800"},{"name":"港南区","value":"450803","parent":"450800"},{"name":"覃塘区","value":"450804","parent":"450800"},{"name":"平南县","value":"450821","parent":"450800"},{"name":"桂平市","value":"450881","parent":"450800"},{"name":"玉州区","value":"450902","parent":"450900"},{"name":"福绵区","value":"450903","parent":"450900"},{"name":"容县","value":"450921","parent":"450900"},{"name":"陆川县","value":"450922","parent":"450900"},{"name":"博白县","value":"450923","parent":"450900"},{"name":"兴业县","value":"450924","parent":"450900"},{"name":"北流市","value":"450981","parent":"450900"},{"name":"右江区","value":"451002","parent":"451000"},{"name":"田阳县","value":"451021","parent":"451000"},{"name":"田东县","value":"451022","parent":"451000"},{"name":"平果县","value":"451023","parent":"451000"},{"name":"德保县","value":"451024","parent":"451000"},{"name":"那坡县","value":"451026","parent":"451000"},{"name":"凌云县","value":"451027","parent":"451000"},{"name":"乐业县","value":"451028","parent":"451000"},{"name":"田林县","value":"451029","parent":"451000"},{"name":"西林县","value":"451030","parent":"451000"},{"name":"隆林各族自治县","value":"451031","parent":"451000"},{"name":"靖西市","value":"451081","parent":"451000"},{"name":"八步区","value":"451102","parent":"451100"},{"name":"昭平县","value":"451121","parent":"451100"},{"name":"钟山县","value":"451122","parent":"451100"},{"name":"富川瑶族自治县","value":"451123","parent":"451100"},{"name":"金城江区","value":"451202","parent":"451200"},{"name":"南丹县","value":"451221","parent":"451200"},{"name":"天峨县","value":"451222","parent":"451200"},{"name":"凤山县","value":"451223","parent":"451200"},{"name":"东兰县","value":"451224","parent":"451200"},{"name":"罗城仫佬族自治县","value":"451225","parent":"451200"},{"name":"环江毛南族自治县","value":"451226","parent":"451200"},{"name":"巴马瑶族自治县","value":"451227","parent":"451200"},{"name":"都安瑶族自治县","value":"451228","parent":"451200"},{"name":"大化瑶族自治县","value":"451229","parent":"451200"},{"name":"宜州市","value":"451281","parent":"451200"},{"name":"兴宾区","value":"451302","parent":"451300"},{"name":"忻城县","value":"451321","parent":"451300"},{"name":"象州县","value":"451322","parent":"451300"},{"name":"武宣县","value":"451323","parent":"451300"},{"name":"金秀瑶族自治县","value":"451324","parent":"451300"},{"name":"合山市","value":"451381","parent":"451300"},{"name":"江州区","value":"451402","parent":"451400"},{"name":"扶绥县","value":"451421","parent":"451400"},{"name":"宁明县","value":"451422","parent":"451400"},{"name":"龙州县","value":"451423","parent":"451400"},{"name":"大新县","value":"451424","parent":"451400"},{"name":"天等县","value":"451425","parent":"451400"},{"name":"凭祥市","value":"451481","parent":"451400"},{"name":"海口市","value":"460100","parent":"460000"},{"name":"三亚市","value":"460200","parent":"460000"},{"name":"三沙市","value":"460300","parent":"460000"},{"name":"五指山市","value":"469001","parent":"460000"},{"name":"琼海市","value":"469002","parent":"460000"},{"name":"儋州市","value":"469003","parent":"460000"},{"name":"文昌市","value":"469005","parent":"460000"},{"name":"万宁市","value":"469006","parent":"460000"},{"name":"东方市","value":"469007","parent":"460000"},{"name":"定安县","value":"469021","parent":"460000"},{"name":"屯昌县","value":"469022","parent":"460000"},{"name":"澄迈县","value":"469023","parent":"460000"},{"name":"临高县","value":"469024","parent":"460000"},{"name":"白沙黎族自治县","value":"469025","parent":"460000"},{"name":"昌江黎族自治县","value":"469026","parent":"460000"},{"name":"乐东黎族自治县","value":"469027","parent":"460000"},{"name":"陵水黎族自治县","value":"469028","parent":"460000"},{"name":"保亭黎族苗族自治县","value":"469029","parent":"460000"},{"name":"琼中黎族苗族自治县","value":"469030","parent":"460000"},{"name":"秀英区","value":"460105","parent":"460100"},{"name":"龙华区","value":"460106","parent":"460100"},{"name":"琼山区","value":"460107","parent":"460100"},{"name":"美兰区","value":"460108","parent":"460100"},{"name":"海棠区","value":"460202","parent":"460200"},{"name":"吉阳区","value":"460203","parent":"460200"},{"name":"天涯区","value":"460204","parent":"460200"},{"name":"崖州区","value":"460205","parent":"460200"},{"name":"西沙群岛","value":"460321","parent":"460300"},{"name":"南沙群岛","value":"460322","parent":"460300"},{"name":"中沙群岛的岛礁及其海域","value":"460323","parent":"460300"},{"name":"市辖区","value":"500100","parent":"500000"},{"name":"万州区","value":"500101","parent":"500100"},{"name":"涪陵区","value":"500102","parent":"500100"},{"name":"渝中区","value":"500103","parent":"500100"},{"name":"大渡口区","value":"500104","parent":"500100"},{"name":"江北区","value":"500105","parent":"500100"},{"name":"沙坪坝区","value":"500106","parent":"500100"},{"name":"九龙坡区","value":"500107","parent":"500100"},{"name":"南岸区","value":"500108","parent":"500100"},{"name":"北碚区","value":"500109","parent":"500100"},{"name":"綦江区","value":"500110","parent":"500100"},{"name":"大足区","value":"500111","parent":"500100"},{"name":"渝北区","value":"500112","parent":"500100"},{"name":"巴南区","value":"500113","parent":"500100"},{"name":"黔江区","value":"500114","parent":"500100"},{"name":"长寿区","value":"500115","parent":"500100"},{"name":"江津区","value":"500116","parent":"500100"},{"name":"合川区","value":"500117","parent":"500100"},{"name":"永川区","value":"500118","parent":"500100"},{"name":"南川区","value":"500119","parent":"500100"},{"name":"璧山区","value":"500120","parent":"500100"},{"name":"铜梁区","value":"500151","parent":"500100"},{"name":"潼南区","value":"500152","parent":"500100"},{"name":"荣昌区","value":"500153","parent":"500100"},{"name":"梁平县","value":"500228","parent":"500100"},{"name":"城口县","value":"500229","parent":"500100"},{"name":"丰都县","value":"500230","parent":"500100"},{"name":"垫江县","value":"500231","parent":"500100"},{"name":"武隆县","value":"500232","parent":"500100"},{"name":"忠县","value":"500233","parent":"500100"},{"name":"开县","value":"500234","parent":"500100"},{"name":"云阳县","value":"500235","parent":"500100"},{"name":"奉节县","value":"500236","parent":"500100"},{"name":"巫山县","value":"500237","parent":"500100"},{"name":"巫溪县","value":"500238","parent":"500100"},{"name":"石柱土家族自治县","value":"500240","parent":"500100"},{"name":"秀山土家族苗族自治县","value":"500241","parent":"500100"},{"name":"酉阳土家族苗族自治县","value":"500242","parent":"500100"},{"name":"彭水苗族土家族自治县","value":"500243","parent":"500100"},{"name":"成都市","value":"510100","parent":"510000"},{"name":"自贡市","value":"510300","parent":"510000"},{"name":"攀枝花市","value":"510400","parent":"510000"},{"name":"泸州市","value":"510500","parent":"510000"},{"name":"德阳市","value":"510600","parent":"510000"},{"name":"绵阳市","value":"510700","parent":"510000"},{"name":"广元市","value":"510800","parent":"510000"},{"name":"遂宁市","value":"510900","parent":"510000"},{"name":"内江市","value":"511000","parent":"510000"},{"name":"乐山市","value":"511100","parent":"510000"},{"name":"南充市","value":"511300","parent":"510000"},{"name":"眉山市","value":"511400","parent":"510000"},{"name":"宜宾市","value":"511500","parent":"510000"},{"name":"广安市","value":"511600","parent":"510000"},{"name":"达州市","value":"511700","parent":"510000"},{"name":"雅安市","value":"511800","parent":"510000"},{"name":"巴中市","value":"511900","parent":"510000"},{"name":"资阳市","value":"512000","parent":"510000"},{"name":"阿坝藏族羌族自治州","value":"513200","parent":"510000"},{"name":"甘孜藏族自治州","value":"513300","parent":"510000"},{"name":"凉山彝族自治州","value":"513400","parent":"510000"},{"name":"锦江区","value":"510104","parent":"510100"},{"name":"青羊区","value":"510105","parent":"510100"},{"name":"金牛区","value":"510106","parent":"510100"},{"name":"武侯区","value":"510107","parent":"510100"},{"name":"成华区","value":"510108","parent":"510100"},{"name":"龙泉驿区","value":"510112","parent":"510100"},{"name":"青白江区","value":"510113","parent":"510100"},{"name":"新都区","value":"510114","parent":"510100"},{"name":"温江区","value":"510115","parent":"510100"},{"name":"金堂县","value":"510121","parent":"510100"},{"name":"双流县","value":"510122","parent":"510100"},{"name":"郫县","value":"510124","parent":"510100"},{"name":"大邑县","value":"510129","parent":"510100"},{"name":"蒲江县","value":"510131","parent":"510100"},{"name":"新津县","value":"510132","parent":"510100"},{"name":"都江堰市","value":"510181","parent":"510100"},{"name":"彭州市","value":"510182","parent":"510100"},{"name":"邛崃市","value":"510183","parent":"510100"},{"name":"崇州市","value":"510184","parent":"510100"},{"name":"自流井区","value":"510302","parent":"510300"},{"name":"贡井区","value":"510303","parent":"510300"},{"name":"大安区","value":"510304","parent":"510300"},{"name":"沿滩区","value":"510311","parent":"510300"},{"name":"荣县","value":"510321","parent":"510300"},{"name":"富顺县","value":"510322","parent":"510300"},{"name":"东区","value":"510402","parent":"510400"},{"name":"西区","value":"510403","parent":"510400"},{"name":"仁和区","value":"510411","parent":"510400"},{"name":"米易县","value":"510421","parent":"510400"},{"name":"盐边县","value":"510422","parent":"510400"},{"name":"江阳区","value":"510502","parent":"510500"},{"name":"纳溪区","value":"510503","parent":"510500"},{"name":"龙马潭区","value":"510504","parent":"510500"},{"name":"泸县","value":"510521","parent":"510500"},{"name":"合江县","value":"510522","parent":"510500"},{"name":"叙永县","value":"510524","parent":"510500"},{"name":"古蔺县","value":"510525","parent":"510500"},{"name":"旌阳区","value":"510603","parent":"510600"},{"name":"中江县","value":"510623","parent":"510600"},{"name":"罗江县","value":"510626","parent":"510600"},{"name":"广汉市","value":"510681","parent":"510600"},{"name":"什邡市","value":"510682","parent":"510600"},{"name":"绵竹市","value":"510683","parent":"510600"},{"name":"涪城区","value":"510703","parent":"510700"},{"name":"游仙区","value":"510704","parent":"510700"},{"name":"三台县","value":"510722","parent":"510700"},{"name":"盐亭县","value":"510723","parent":"510700"},{"name":"安县","value":"510724","parent":"510700"},{"name":"梓潼县","value":"510725","parent":"510700"},{"name":"北川羌族自治县","value":"510726","parent":"510700"},{"name":"平武县","value":"510727","parent":"510700"},{"name":"江油市","value":"510781","parent":"510700"},{"name":"利州区","value":"510802","parent":"510800"},{"name":"昭化区","value":"510811","parent":"510800"},{"name":"朝天区","value":"510812","parent":"510800"},{"name":"旺苍县","value":"510821","parent":"510800"},{"name":"青川县","value":"510822","parent":"510800"},{"name":"剑阁县","value":"510823","parent":"510800"},{"name":"苍溪县","value":"510824","parent":"510800"},{"name":"船山区","value":"510903","parent":"510900"},{"name":"安居区","value":"510904","parent":"510900"},{"name":"蓬溪县","value":"510921","parent":"510900"},{"name":"射洪县","value":"510922","parent":"510900"},{"name":"大英县","value":"510923","parent":"510900"},{"name":"市中区","value":"511002","parent":"511000"},{"name":"东兴区","value":"511011","parent":"511000"},{"name":"威远县","value":"511024","parent":"511000"},{"name":"资中县","value":"511025","parent":"511000"},{"name":"隆昌县","value":"511028","parent":"511000"},{"name":"市中区","value":"511102","parent":"511100"},{"name":"沙湾区","value":"511111","parent":"511100"},{"name":"五通桥区","value":"511112","parent":"511100"},{"name":"金口河区","value":"511113","parent":"511100"},{"name":"犍为县","value":"511123","parent":"511100"},{"name":"井研县","value":"511124","parent":"511100"},{"name":"夹江县","value":"511126","parent":"511100"},{"name":"沐川县","value":"511129","parent":"511100"},{"name":"峨边彝族自治县","value":"511132","parent":"511100"},{"name":"马边彝族自治县","value":"511133","parent":"511100"},{"name":"峨眉山市","value":"511181","parent":"511100"},{"name":"顺庆区","value":"511302","parent":"511300"},{"name":"高坪区","value":"511303","parent":"511300"},{"name":"嘉陵区","value":"511304","parent":"511300"},{"name":"南部县","value":"511321","parent":"511300"},{"name":"营山县","value":"511322","parent":"511300"},{"name":"蓬安县","value":"511323","parent":"511300"},{"name":"仪陇县","value":"511324","parent":"511300"},{"name":"西充县","value":"511325","parent":"511300"},{"name":"阆中市","value":"511381","parent":"511300"},{"name":"东坡区","value":"511402","parent":"511400"},{"name":"彭山区","value":"511403","parent":"511400"},{"name":"仁寿县","value":"511421","parent":"511400"},{"name":"洪雅县","value":"511423","parent":"511400"},{"name":"丹棱县","value":"511424","parent":"511400"},{"name":"青神县","value":"511425","parent":"511400"},{"name":"翠屏区","value":"511502","parent":"511500"},{"name":"南溪区","value":"511503","parent":"511500"},{"name":"宜宾县","value":"511521","parent":"511500"},{"name":"江安县","value":"511523","parent":"511500"},{"name":"长宁县","value":"511524","parent":"511500"},{"name":"高县","value":"511525","parent":"511500"},{"name":"珙县","value":"511526","parent":"511500"},{"name":"筠连县","value":"511527","parent":"511500"},{"name":"兴文县","value":"511528","parent":"511500"},{"name":"屏山县","value":"511529","parent":"511500"},{"name":"广安区","value":"511602","parent":"511600"},{"name":"前锋区","value":"511603","parent":"511600"},{"name":"岳池县","value":"511621","parent":"511600"},{"name":"武胜县","value":"511622","parent":"511600"},{"name":"邻水县","value":"511623","parent":"511600"},{"name":"华蓥市","value":"511681","parent":"511600"},{"name":"通川区","value":"511702","parent":"511700"},{"name":"达川区","value":"511703","parent":"511700"},{"name":"宣汉县","value":"511722","parent":"511700"},{"name":"开江县","value":"511723","parent":"511700"},{"name":"大竹县","value":"511724","parent":"511700"},{"name":"渠县","value":"511725","parent":"511700"},{"name":"万源市","value":"511781","parent":"511700"},{"name":"雨城区","value":"511802","parent":"511800"},{"name":"名山区","value":"511803","parent":"511800"},{"name":"荥经县","value":"511822","parent":"511800"},{"name":"汉源县","value":"511823","parent":"511800"},{"name":"石棉县","value":"511824","parent":"511800"},{"name":"天全县","value":"511825","parent":"511800"},{"name":"芦山县","value":"511826","parent":"511800"},{"name":"宝兴县","value":"511827","parent":"511800"},{"name":"巴州区","value":"511902","parent":"511900"},{"name":"恩阳区","value":"511903","parent":"511900"},{"name":"通江县","value":"511921","parent":"511900"},{"name":"南江县","value":"511922","parent":"511900"},{"name":"平昌县","value":"511923","parent":"511900"},{"name":"雁江区","value":"512002","parent":"512000"},{"name":"安岳县","value":"512021","parent":"512000"},{"name":"乐至县","value":"512022","parent":"512000"},{"name":"简阳市","value":"512081","parent":"512000"},{"name":"汶川县","value":"513221","parent":"513200"},{"name":"理县","value":"513222","parent":"513200"},{"name":"茂县","value":"513223","parent":"513200"},{"name":"松潘县","value":"513224","parent":"513200"},{"name":"九寨沟县","value":"513225","parent":"513200"},{"name":"金川县","value":"513226","parent":"513200"},{"name":"小金县","value":"513227","parent":"513200"},{"name":"黑水县","value":"513228","parent":"513200"},{"name":"马尔康县","value":"513229","parent":"513200"},{"name":"壤塘县","value":"513230","parent":"513200"},{"name":"阿坝县","value":"513231","parent":"513200"},{"name":"若尔盖县","value":"513232","parent":"513200"},{"name":"红原县","value":"513233","parent":"513200"},{"name":"康定市","value":"513301","parent":"513300"},{"name":"泸定县","value":"513322","parent":"513300"},{"name":"丹巴县","value":"513323","parent":"513300"},{"name":"九龙县","value":"513324","parent":"513300"},{"name":"雅江县","value":"513325","parent":"513300"},{"name":"道孚县","value":"513326","parent":"513300"},{"name":"炉霍县","value":"513327","parent":"513300"},{"name":"甘孜县","value":"513328","parent":"513300"},{"name":"新龙县","value":"513329","parent":"513300"},{"name":"德格县","value":"513330","parent":"513300"},{"name":"白玉县","value":"513331","parent":"513300"},{"name":"石渠县","value":"513332","parent":"513300"},{"name":"色达县","value":"513333","parent":"513300"},{"name":"理塘县","value":"513334","parent":"513300"},{"name":"巴塘县","value":"513335","parent":"513300"},{"name":"乡城县","value":"513336","parent":"513300"},{"name":"稻城县","value":"513337","parent":"513300"},{"name":"得荣县","value":"513338","parent":"513300"},{"name":"西昌市","value":"513401","parent":"513400"},{"name":"木里藏族自治县","value":"513422","parent":"513400"},{"name":"盐源县","value":"513423","parent":"513400"},{"name":"德昌县","value":"513424","parent":"513400"},{"name":"会理县","value":"513425","parent":"513400"},{"name":"会东县","value":"513426","parent":"513400"},{"name":"宁南县","value":"513427","parent":"513400"},{"name":"普格县","value":"513428","parent":"513400"},{"name":"布拖县","value":"513429","parent":"513400"},{"name":"金阳县","value":"513430","parent":"513400"},{"name":"昭觉县","value":"513431","parent":"513400"},{"name":"喜德县","value":"513432","parent":"513400"},{"name":"冕宁县","value":"513433","parent":"513400"},{"name":"越西县","value":"513434","parent":"513400"},{"name":"甘洛县","value":"513435","parent":"513400"},{"name":"美姑县","value":"513436","parent":"513400"},{"name":"雷波县","value":"513437","parent":"513400"},{"name":"贵阳市","value":"520100","parent":"520000"},{"name":"六盘水市","value":"520200","parent":"520000"},{"name":"遵义市","value":"520300","parent":"520000"},{"name":"安顺市","value":"520400","parent":"520000"},{"name":"毕节市","value":"520500","parent":"520000"},{"name":"铜仁市","value":"520600","parent":"520000"},{"name":"黔西南布依族苗族自治州","value":"522300","parent":"520000"},{"name":"黔东南苗族侗族自治州","value":"522600","parent":"520000"},{"name":"黔南布依族苗族自治州","value":"522700","parent":"520000"},{"name":"南明区","value":"520102","parent":"520100"},{"name":"云岩区","value":"520103","parent":"520100"},{"name":"花溪区","value":"520111","parent":"520100"},{"name":"乌当区","value":"520112","parent":"520100"},{"name":"白云区","value":"520113","parent":"520100"},{"name":"观山湖区","value":"520115","parent":"520100"},{"name":"开阳县","value":"520121","parent":"520100"},{"name":"息烽县","value":"520122","parent":"520100"},{"name":"修文县","value":"520123","parent":"520100"},{"name":"清镇市","value":"520181","parent":"520100"},{"name":"钟山区","value":"520201","parent":"520200"},{"name":"六枝特区","value":"520203","parent":"520200"},{"name":"水城县","value":"520221","parent":"520200"},{"name":"盘县","value":"520222","parent":"520200"},{"name":"红花岗区","value":"520302","parent":"520300"},{"name":"汇川区","value":"520303","parent":"520300"},{"name":"遵义县","value":"520321","parent":"520300"},{"name":"桐梓县","value":"520322","parent":"520300"},{"name":"绥阳县","value":"520323","parent":"520300"},{"name":"正安县","value":"520324","parent":"520300"},{"name":"道真仡佬族苗族自治县","value":"520325","parent":"520300"},{"name":"务川仡佬族苗族自治县","value":"520326","parent":"520300"},{"name":"凤冈县","value":"520327","parent":"520300"},{"name":"湄潭县","value":"520328","parent":"520300"},{"name":"余庆县","value":"520329","parent":"520300"},{"name":"习水县","value":"520330","parent":"520300"},{"name":"赤水市","value":"520381","parent":"520300"},{"name":"仁怀市","value":"520382","parent":"520300"},{"name":"西秀区","value":"520402","parent":"520400"},{"name":"平坝区","value":"520403","parent":"520400"},{"name":"普定县","value":"520422","parent":"520400"},{"name":"镇宁布依族苗族自治县","value":"520423","parent":"520400"},{"name":"关岭布依族苗族自治县","value":"520424","parent":"520400"},{"name":"紫云苗族布依族自治县","value":"520425","parent":"520400"},{"name":"七星关区","value":"520502","parent":"520500"},{"name":"大方县","value":"520521","parent":"520500"},{"name":"黔西县","value":"520522","parent":"520500"},{"name":"金沙县","value":"520523","parent":"520500"},{"name":"织金县","value":"520524","parent":"520500"},{"name":"纳雍县","value":"520525","parent":"520500"},{"name":"威宁彝族回族苗族自治县","value":"520526","parent":"520500"},{"name":"赫章县","value":"520527","parent":"520500"},{"name":"碧江区","value":"520602","parent":"520600"},{"name":"万山区","value":"520603","parent":"520600"},{"name":"江口县","value":"520621","parent":"520600"},{"name":"玉屏侗族自治县","value":"520622","parent":"520600"},{"name":"石阡县","value":"520623","parent":"520600"},{"name":"思南县","value":"520624","parent":"520600"},{"name":"印江土家族苗族自治县","value":"520625","parent":"520600"},{"name":"德江县","value":"520626","parent":"520600"},{"name":"沿河土家族自治县","value":"520627","parent":"520600"},{"name":"松桃苗族自治县","value":"520628","parent":"520600"},{"name":"兴义市","value":"522301","parent":"522300"},{"name":"兴仁县","value":"522322","parent":"522300"},{"name":"普安县","value":"522323","parent":"522300"},{"name":"晴隆县","value":"522324","parent":"522300"},{"name":"贞丰县","value":"522325","parent":"522300"},{"name":"望谟县","value":"522326","parent":"522300"},{"name":"册亨县","value":"522327","parent":"522300"},{"name":"安龙县","value":"522328","parent":"522300"},{"name":"凯里市","value":"522601","parent":"522600"},{"name":"黄平县","value":"522622","parent":"522600"},{"name":"施秉县","value":"522623","parent":"522600"},{"name":"三穗县","value":"522624","parent":"522600"},{"name":"镇远县","value":"522625","parent":"522600"},{"name":"岑巩县","value":"522626","parent":"522600"},{"name":"天柱县","value":"522627","parent":"522600"},{"name":"锦屏县","value":"522628","parent":"522600"},{"name":"剑河县","value":"522629","parent":"522600"},{"name":"台江县","value":"522630","parent":"522600"},{"name":"黎平县","value":"522631","parent":"522600"},{"name":"榕江县","value":"522632","parent":"522600"},{"name":"从江县","value":"522633","parent":"522600"},{"name":"雷山县","value":"522634","parent":"522600"},{"name":"麻江县","value":"522635","parent":"522600"},{"name":"丹寨县","value":"522636","parent":"522600"},{"name":"都匀市","value":"522701","parent":"522700"},{"name":"福泉市","value":"522702","parent":"522700"},{"name":"荔波县","value":"522722","parent":"522700"},{"name":"贵定县","value":"522723","parent":"522700"},{"name":"瓮安县","value":"522725","parent":"522700"},{"name":"独山县","value":"522726","parent":"522700"},{"name":"平塘县","value":"522727","parent":"522700"},{"name":"罗甸县","value":"522728","parent":"522700"},{"name":"长顺县","value":"522729","parent":"522700"},{"name":"龙里县","value":"522730","parent":"522700"},{"name":"惠水县","value":"522731","parent":"522700"},{"name":"三都水族自治县","value":"522732","parent":"522700"},{"name":"昆明市","value":"530100","parent":"530000"},{"name":"曲靖市","value":"530300","parent":"530000"},{"name":"玉溪市","value":"530400","parent":"530000"},{"name":"保山市","value":"530500","parent":"530000"},{"name":"昭通市","value":"530600","parent":"530000"},{"name":"丽江市","value":"530700","parent":"530000"},{"name":"普洱市","value":"530800","parent":"530000"},{"name":"临沧市","value":"530900","parent":"530000"},{"name":"楚雄彝族自治州","value":"532300","parent":"530000"},{"name":"红河哈尼族彝族自治州","value":"532500","parent":"530000"},{"name":"文山壮族苗族自治州","value":"532600","parent":"530000"},{"name":"西双版纳傣族自治州","value":"532800","parent":"530000"},{"name":"大理白族自治州","value":"532900","parent":"530000"},{"name":"德宏傣族景颇族自治州","value":"533100","parent":"530000"},{"name":"怒江傈僳族自治州","value":"533300","parent":"530000"},{"name":"迪庆藏族自治州","value":"533400","parent":"530000"},{"name":"五华区","value":"530102","parent":"530100"},{"name":"盘龙区","value":"530103","parent":"530100"},{"name":"官渡区","value":"530111","parent":"530100"},{"name":"西山区","value":"530112","parent":"530100"},{"name":"东川区","value":"530113","parent":"530100"},{"name":"呈贡区","value":"530114","parent":"530100"},{"name":"晋宁县","value":"530122","parent":"530100"},{"name":"富民县","value":"530124","parent":"530100"},{"name":"宜良县","value":"530125","parent":"530100"},{"name":"石林彝族自治县","value":"530126","parent":"530100"},{"name":"嵩明县","value":"530127","parent":"530100"},{"name":"禄劝彝族苗族自治县","value":"530128","parent":"530100"},{"name":"寻甸回族彝族自治县","value":"530129","parent":"530100"},{"name":"安宁市","value":"530181","parent":"530100"},{"name":"麒麟区","value":"530302","parent":"530300"},{"name":"马龙县","value":"530321","parent":"530300"},{"name":"陆良县","value":"530322","parent":"530300"},{"name":"师宗县","value":"530323","parent":"530300"},{"name":"罗平县","value":"530324","parent":"530300"},{"name":"富源县","value":"530325","parent":"530300"},{"name":"会泽县","value":"530326","parent":"530300"},{"name":"沾益县","value":"530328","parent":"530300"},{"name":"宣威市","value":"530381","parent":"530300"},{"name":"红塔区","value":"530402","parent":"530400"},{"name":"江川县","value":"530421","parent":"530400"},{"name":"澄江县","value":"530422","parent":"530400"},{"name":"通海县","value":"530423","parent":"530400"},{"name":"华宁县","value":"530424","parent":"530400"},{"name":"易门县","value":"530425","parent":"530400"},{"name":"峨山彝族自治县","value":"530426","parent":"530400"},{"name":"新平彝族傣族自治县","value":"530427","parent":"530400"},{"name":"元江哈尼族彝族傣族自治县","value":"530428","parent":"530400"},{"name":"隆阳区","value":"530502","parent":"530500"},{"name":"施甸县","value":"530521","parent":"530500"},{"name":"龙陵县","value":"530523","parent":"530500"},{"name":"昌宁县","value":"530524","parent":"530500"},{"name":"腾冲市","value":"530581","parent":"530500"},{"name":"昭阳区","value":"530602","parent":"530600"},{"name":"鲁甸县","value":"530621","parent":"530600"},{"name":"巧家县","value":"530622","parent":"530600"},{"name":"盐津县","value":"530623","parent":"530600"},{"name":"大关县","value":"530624","parent":"530600"},{"name":"永善县","value":"530625","parent":"530600"},{"name":"绥江县","value":"530626","parent":"530600"},{"name":"镇雄县","value":"530627","parent":"530600"},{"name":"彝良县","value":"530628","parent":"530600"},{"name":"威信县","value":"530629","parent":"530600"},{"name":"水富县","value":"530630","parent":"530600"},{"name":"古城区","value":"530702","parent":"530700"},{"name":"玉龙纳西族自治县","value":"530721","parent":"530700"},{"name":"永胜县","value":"530722","parent":"530700"},{"name":"华坪县","value":"530723","parent":"530700"},{"name":"宁蒗彝族自治县","value":"530724","parent":"530700"},{"name":"思茅区","value":"530802","parent":"530800"},{"name":"宁洱哈尼族彝族自治县","value":"530821","parent":"530800"},{"name":"墨江哈尼族自治县","value":"530822","parent":"530800"},{"name":"景东彝族自治县","value":"530823","parent":"530800"},{"name":"景谷傣族彝族自治县","value":"530824","parent":"530800"},{"name":"镇沅彝族哈尼族拉祜族自治县","value":"530825","parent":"530800"},{"name":"江城哈尼族彝族自治县","value":"530826","parent":"530800"},{"name":"孟连傣族拉祜族佤族自治县","value":"530827","parent":"530800"},{"name":"澜沧拉祜族自治县","value":"530828","parent":"530800"},{"name":"西盟佤族自治县","value":"530829","parent":"530800"},{"name":"临翔区","value":"530902","parent":"530900"},{"name":"凤庆县","value":"530921","parent":"530900"},{"name":"云县","value":"530922","parent":"530900"},{"name":"永德县","value":"530923","parent":"530900"},{"name":"镇康县","value":"530924","parent":"530900"},{"name":"双江拉祜族佤族布朗族傣族自治县","value":"530925","parent":"530900"},{"name":"耿马傣族佤族自治县","value":"530926","parent":"530900"},{"name":"沧源佤族自治县","value":"530927","parent":"530900"},{"name":"楚雄市","value":"532301","parent":"532300"},{"name":"双柏县","value":"532322","parent":"532300"},{"name":"牟定县","value":"532323","parent":"532300"},{"name":"南华县","value":"532324","parent":"532300"},{"name":"姚安县","value":"532325","parent":"532300"},{"name":"大姚县","value":"532326","parent":"532300"},{"name":"永仁县","value":"532327","parent":"532300"},{"name":"元谋县","value":"532328","parent":"532300"},{"name":"武定县","value":"532329","parent":"532300"},{"name":"禄丰县","value":"532331","parent":"532300"},{"name":"个旧市","value":"532501","parent":"532500"},{"name":"开远市","value":"532502","parent":"532500"},{"name":"蒙自市","value":"532503","parent":"532500"},{"name":"弥勒市","value":"532504","parent":"532500"},{"name":"屏边苗族自治县","value":"532523","parent":"532500"},{"name":"建水县","value":"532524","parent":"532500"},{"name":"石屏县","value":"532525","parent":"532500"},{"name":"泸西县","value":"532527","parent":"532500"},{"name":"元阳县","value":"532528","parent":"532500"},{"name":"红河县","value":"532529","parent":"532500"},{"name":"金平苗族瑶族傣族自治县","value":"532530","parent":"532500"},{"name":"绿春县","value":"532531","parent":"532500"},{"name":"河口瑶族自治县","value":"532532","parent":"532500"},{"name":"文山市","value":"532601","parent":"532600"},{"name":"砚山县","value":"532622","parent":"532600"},{"name":"西畴县","value":"532623","parent":"532600"},{"name":"麻栗坡县","value":"532624","parent":"532600"},{"name":"马关县","value":"532625","parent":"532600"},{"name":"丘北县","value":"532626","parent":"532600"},{"name":"广南县","value":"532627","parent":"532600"},{"name":"富宁县","value":"532628","parent":"532600"},{"name":"景洪市","value":"532801","parent":"532800"},{"name":"勐海县","value":"532822","parent":"532800"},{"name":"勐腊县","value":"532823","parent":"532800"},{"name":"大理市","value":"532901","parent":"532900"},{"name":"漾濞彝族自治县","value":"532922","parent":"532900"},{"name":"祥云县","value":"532923","parent":"532900"},{"name":"宾川县","value":"532924","parent":"532900"},{"name":"弥渡县","value":"532925","parent":"532900"},{"name":"南涧彝族自治县","value":"532926","parent":"532900"},{"name":"巍山彝族回族自治县","value":"532927","parent":"532900"},{"name":"永平县","value":"532928","parent":"532900"},{"name":"云龙县","value":"532929","parent":"532900"},{"name":"洱源县","value":"532930","parent":"532900"},{"name":"剑川县","value":"532931","parent":"532900"},{"name":"鹤庆县","value":"532932","parent":"532900"},{"name":"瑞丽市","value":"533102","parent":"533100"},{"name":"芒市","value":"533103","parent":"533100"},{"name":"梁河县","value":"533122","parent":"533100"},{"name":"盈江县","value":"533123","parent":"533100"},{"name":"陇川县","value":"533124","parent":"533100"},{"name":"泸水县","value":"533321","parent":"533300"},{"name":"福贡县","value":"533323","parent":"533300"},{"name":"贡山独龙族怒族自治县","value":"533324","parent":"533300"},{"name":"兰坪白族普米族自治县","value":"533325","parent":"533300"},{"name":"香格里拉市","value":"533401","parent":"533400"},{"name":"德钦县","value":"533422","parent":"533400"},{"name":"维西傈僳族自治县","value":"533423","parent":"533400"},{"name":"拉萨市","value":"540100","parent":"540000"},{"name":"日喀则市","value":"540200","parent":"540000"},{"name":"昌都市","value":"540300","parent":"540000"},{"name":"林芝市","value":"540400","parent":"540000"},{"name":"山南地区","value":"542200","parent":"540000"},{"name":"那曲地区","value":"542400","parent":"540000"},{"name":"阿里地区","value":"542500","parent":"540000"},{"name":"城关区","value":"540102","parent":"540100"},{"name":"林周县","value":"540121","parent":"540100"},{"name":"当雄县","value":"540122","parent":"540100"},{"name":"尼木县","value":"540123","parent":"540100"},{"name":"曲水县","value":"540124","parent":"540100"},{"name":"堆龙德庆县","value":"540125","parent":"540100"},{"name":"达孜县","value":"540126","parent":"540100"},{"name":"墨竹工卡县","value":"540127","parent":"540100"},{"name":"桑珠孜区","value":"540202","parent":"540200"},{"name":"南木林县","value":"540221","parent":"540200"},{"name":"江孜县","value":"540222","parent":"540200"},{"name":"定日县","value":"540223","parent":"540200"},{"name":"萨迦县","value":"540224","parent":"540200"},{"name":"拉孜县","value":"540225","parent":"540200"},{"name":"昂仁县","value":"540226","parent":"540200"},{"name":"谢通门县","value":"540227","parent":"540200"},{"name":"白朗县","value":"540228","parent":"540200"},{"name":"仁布县","value":"540229","parent":"540200"},{"name":"康马县","value":"540230","parent":"540200"},{"name":"定结县","value":"540231","parent":"540200"},{"name":"仲巴县","value":"540232","parent":"540200"},{"name":"亚东县","value":"540233","parent":"540200"},{"name":"吉隆县","value":"540234","parent":"540200"},{"name":"聂拉木县","value":"540235","parent":"540200"},{"name":"萨嘎县","value":"540236","parent":"540200"},{"name":"岗巴县","value":"540237","parent":"540200"},{"name":"卡若区","value":"540302","parent":"540300"},{"name":"江达县","value":"540321","parent":"540300"},{"name":"贡觉县","value":"540322","parent":"540300"},{"name":"类乌齐县","value":"540323","parent":"540300"},{"name":"丁青县","value":"540324","parent":"540300"},{"name":"察雅县","value":"540325","parent":"540300"},{"name":"八宿县","value":"540326","parent":"540300"},{"name":"左贡县","value":"540327","parent":"540300"},{"name":"芒康县","value":"540328","parent":"540300"},{"name":"洛隆县","value":"540329","parent":"540300"},{"name":"边坝县","value":"540330","parent":"540300"},{"name":"巴宜区","value":"540402","parent":"540400"},{"name":"工布江达县","value":"540421","parent":"540400"},{"name":"米林县","value":"540422","parent":"540400"},{"name":"墨脱县","value":"540423","parent":"540400"},{"name":"波密县","value":"540424","parent":"540400"},{"name":"察隅县","value":"540425","parent":"540400"},{"name":"朗县","value":"540426","parent":"540400"},{"name":"乃东县","value":"542221","parent":"542200"},{"name":"扎囊县","value":"542222","parent":"542200"},{"name":"贡嘎县","value":"542223","parent":"542200"},{"name":"桑日县","value":"542224","parent":"542200"},{"name":"琼结县","value":"542225","parent":"542200"},{"name":"曲松县","value":"542226","parent":"542200"},{"name":"措美县","value":"542227","parent":"542200"},{"name":"洛扎县","value":"542228","parent":"542200"},{"name":"加查县","value":"542229","parent":"542200"},{"name":"隆子县","value":"542231","parent":"542200"},{"name":"错那县","value":"542232","parent":"542200"},{"name":"浪卡子县","value":"542233","parent":"542200"},{"name":"那曲县","value":"542421","parent":"542400"},{"name":"嘉黎县","value":"542422","parent":"542400"},{"name":"比如县","value":"542423","parent":"542400"},{"name":"聂荣县","value":"542424","parent":"542400"},{"name":"安多县","value":"542425","parent":"542400"},{"name":"申扎县","value":"542426","parent":"542400"},{"name":"索县","value":"542427","parent":"542400"},{"name":"班戈县","value":"542428","parent":"542400"},{"name":"巴青县","value":"542429","parent":"542400"},{"name":"尼玛县","value":"542430","parent":"542400"},{"name":"双湖县","value":"542431","parent":"542400"},{"name":"普兰县","value":"542521","parent":"542500"},{"name":"札达县","value":"542522","parent":"542500"},{"name":"噶尔县","value":"542523","parent":"542500"},{"name":"日土县","value":"542524","parent":"542500"},{"name":"革吉县","value":"542525","parent":"542500"},{"name":"改则县","value":"542526","parent":"542500"},{"name":"措勤县","value":"542527","parent":"542500"},{"name":"西安市","value":"610100","parent":"610000"},{"name":"铜川市","value":"610200","parent":"610000"},{"name":"宝鸡市","value":"610300","parent":"610000"},{"name":"咸阳市","value":"610400","parent":"610000"},{"name":"渭南市","value":"610500","parent":"610000"},{"name":"延安市","value":"610600","parent":"610000"},{"name":"汉中市","value":"610700","parent":"610000"},{"name":"榆林市","value":"610800","parent":"610000"},{"name":"安康市","value":"610900","parent":"610000"},{"name":"商洛市","value":"611000","parent":"610000"},{"name":"新城区","value":"610102","parent":"610100"},{"name":"碑林区","value":"610103","parent":"610100"},{"name":"莲湖区","value":"610104","parent":"610100"},{"name":"灞桥区","value":"610111","parent":"610100"},{"name":"未央区","value":"610112","parent":"610100"},{"name":"雁塔区","value":"610113","parent":"610100"},{"name":"阎良区","value":"610114","parent":"610100"},{"name":"临潼区","value":"610115","parent":"610100"},{"name":"长安区","value":"610116","parent":"610100"},{"name":"高陵区","value":"610117","parent":"610100"},{"name":"蓝田县","value":"610122","parent":"610100"},{"name":"周至县","value":"610124","parent":"610100"},{"name":"户县","value":"610125","parent":"610100"},{"name":"王益区","value":"610202","parent":"610200"},{"name":"印台区","value":"610203","parent":"610200"},{"name":"耀州区","value":"610204","parent":"610200"},{"name":"宜君县","value":"610222","parent":"610200"},{"name":"渭滨区","value":"610302","parent":"610300"},{"name":"金台区","value":"610303","parent":"610300"},{"name":"陈仓区","value":"610304","parent":"610300"},{"name":"凤翔县","value":"610322","parent":"610300"},{"name":"岐山县","value":"610323","parent":"610300"},{"name":"扶风县","value":"610324","parent":"610300"},{"name":"眉县","value":"610326","parent":"610300"},{"name":"陇县","value":"610327","parent":"610300"},{"name":"千阳县","value":"610328","parent":"610300"},{"name":"麟游县","value":"610329","parent":"610300"},{"name":"凤县","value":"610330","parent":"610300"},{"name":"太白县","value":"610331","parent":"610300"},{"name":"秦都区","value":"610402","parent":"610400"},{"name":"杨陵区","value":"610403","parent":"610400"},{"name":"渭城区","value":"610404","parent":"610400"},{"name":"三原县","value":"610422","parent":"610400"},{"name":"泾阳县","value":"610423","parent":"610400"},{"name":"乾县","value":"610424","parent":"610400"},{"name":"礼泉县","value":"610425","parent":"610400"},{"name":"永寿县","value":"610426","parent":"610400"},{"name":"彬县","value":"610427","parent":"610400"},{"name":"长武县","value":"610428","parent":"610400"},{"name":"旬邑县","value":"610429","parent":"610400"},{"name":"淳化县","value":"610430","parent":"610400"},{"name":"武功县","value":"610431","parent":"610400"},{"name":"兴平市","value":"610481","parent":"610400"},{"name":"临渭区","value":"610502","parent":"610500"},{"name":"华县","value":"610521","parent":"610500"},{"name":"潼关县","value":"610522","parent":"610500"},{"name":"大荔县","value":"610523","parent":"610500"},{"name":"合阳县","value":"610524","parent":"610500"},{"name":"澄城县","value":"610525","parent":"610500"},{"name":"蒲城县","value":"610526","parent":"610500"},{"name":"白水县","value":"610527","parent":"610500"},{"name":"富平县","value":"610528","parent":"610500"},{"name":"韩城市","value":"610581","parent":"610500"},{"name":"华阴市","value":"610582","parent":"610500"},{"name":"宝塔区","value":"610602","parent":"610600"},{"name":"延长县","value":"610621","parent":"610600"},{"name":"延川县","value":"610622","parent":"610600"},{"name":"子长县","value":"610623","parent":"610600"},{"name":"安塞县","value":"610624","parent":"610600"},{"name":"志丹县","value":"610625","parent":"610600"},{"name":"吴起县","value":"610626","parent":"610600"},{"name":"甘泉县","value":"610627","parent":"610600"},{"name":"富县","value":"610628","parent":"610600"},{"name":"洛川县","value":"610629","parent":"610600"},{"name":"宜川县","value":"610630","parent":"610600"},{"name":"黄龙县","value":"610631","parent":"610600"},{"name":"黄陵县","value":"610632","parent":"610600"},{"name":"汉台区","value":"610702","parent":"610700"},{"name":"南郑县","value":"610721","parent":"610700"},{"name":"城固县","value":"610722","parent":"610700"},{"name":"洋县","value":"610723","parent":"610700"},{"name":"西乡县","value":"610724","parent":"610700"},{"name":"勉县","value":"610725","parent":"610700"},{"name":"宁强县","value":"610726","parent":"610700"},{"name":"略阳县","value":"610727","parent":"610700"},{"name":"镇巴县","value":"610728","parent":"610700"},{"name":"留坝县","value":"610729","parent":"610700"},{"name":"佛坪县","value":"610730","parent":"610700"},{"name":"榆阳区","value":"610802","parent":"610800"},{"name":"神木县","value":"610821","parent":"610800"},{"name":"府谷县","value":"610822","parent":"610800"},{"name":"横山县","value":"610823","parent":"610800"},{"name":"靖边县","value":"610824","parent":"610800"},{"name":"定边县","value":"610825","parent":"610800"},{"name":"绥德县","value":"610826","parent":"610800"},{"name":"米脂县","value":"610827","parent":"610800"},{"name":"佳县","value":"610828","parent":"610800"},{"name":"吴堡县","value":"610829","parent":"610800"},{"name":"清涧县","value":"610830","parent":"610800"},{"name":"子洲县","value":"610831","parent":"610800"},{"name":"汉滨区","value":"610902","parent":"610900"},{"name":"汉阴县","value":"610921","parent":"610900"},{"name":"石泉县","value":"610922","parent":"610900"},{"name":"宁陕县","value":"610923","parent":"610900"},{"name":"紫阳县","value":"610924","parent":"610900"},{"name":"岚皋县","value":"610925","parent":"610900"},{"name":"平利县","value":"610926","parent":"610900"},{"name":"镇坪县","value":"610927","parent":"610900"},{"name":"旬阳县","value":"610928","parent":"610900"},{"name":"白河县","value":"610929","parent":"610900"},{"name":"商州区","value":"611002","parent":"611000"},{"name":"洛南县","value":"611021","parent":"611000"},{"name":"丹凤县","value":"611022","parent":"611000"},{"name":"商南县","value":"611023","parent":"611000"},{"name":"山阳县","value":"611024","parent":"611000"},{"name":"镇安县","value":"611025","parent":"611000"},{"name":"柞水县","value":"611026","parent":"611000"},{"name":"兰州市","value":"620100","parent":"620000"},{"name":"嘉峪关市","value":"620200","parent":"620000"},{"name":"金昌市","value":"620300","parent":"620000"},{"name":"白银市","value":"620400","parent":"620000"},{"name":"天水市","value":"620500","parent":"620000"},{"name":"武威市","value":"620600","parent":"620000"},{"name":"张掖市","value":"620700","parent":"620000"},{"name":"平凉市","value":"620800","parent":"620000"},{"name":"酒泉市","value":"620900","parent":"620000"},{"name":"庆阳市","value":"621000","parent":"620000"},{"name":"定西市","value":"621100","parent":"620000"},{"name":"陇南市","value":"621200","parent":"620000"},{"name":"临夏回族自治州","value":"622900","parent":"620000"},{"name":"甘南藏族自治州","value":"623000","parent":"620000"},{"name":"城关区","value":"620102","parent":"620100"},{"name":"七里河区","value":"620103","parent":"620100"},{"name":"西固区","value":"620104","parent":"620100"},{"name":"安宁区","value":"620105","parent":"620100"},{"name":"红古区","value":"620111","parent":"620100"},{"name":"永登县","value":"620121","parent":"620100"},{"name":"皋兰县","value":"620122","parent":"620100"},{"name":"榆中县","value":"620123","parent":"620100"},{"name":"金川区","value":"620302","parent":"620300"},{"name":"永昌县","value":"620321","parent":"620300"},{"name":"白银区","value":"620402","parent":"620400"},{"name":"平川区","value":"620403","parent":"620400"},{"name":"靖远县","value":"620421","parent":"620400"},{"name":"会宁县","value":"620422","parent":"620400"},{"name":"景泰县","value":"620423","parent":"620400"},{"name":"秦州区","value":"620502","parent":"620500"},{"name":"麦积区","value":"620503","parent":"620500"},{"name":"清水县","value":"620521","parent":"620500"},{"name":"秦安县","value":"620522","parent":"620500"},{"name":"甘谷县","value":"620523","parent":"620500"},{"name":"武山县","value":"620524","parent":"620500"},{"name":"张家川回族自治县","value":"620525","parent":"620500"},{"name":"凉州区","value":"620602","parent":"620600"},{"name":"民勤县","value":"620621","parent":"620600"},{"name":"古浪县","value":"620622","parent":"620600"},{"name":"天祝藏族自治县","value":"620623","parent":"620600"},{"name":"甘州区","value":"620702","parent":"620700"},{"name":"肃南裕固族自治县","value":"620721","parent":"620700"},{"name":"民乐县","value":"620722","parent":"620700"},{"name":"临泽县","value":"620723","parent":"620700"},{"name":"高台县","value":"620724","parent":"620700"},{"name":"山丹县","value":"620725","parent":"620700"},{"name":"崆峒区","value":"620802","parent":"620800"},{"name":"泾川县","value":"620821","parent":"620800"},{"name":"灵台县","value":"620822","parent":"620800"},{"name":"崇信县","value":"620823","parent":"620800"},{"name":"华亭县","value":"620824","parent":"620800"},{"name":"庄浪县","value":"620825","parent":"620800"},{"name":"静宁县","value":"620826","parent":"620800"},{"name":"肃州区","value":"620902","parent":"620900"},{"name":"金塔县","value":"620921","parent":"620900"},{"name":"瓜州县","value":"620922","parent":"620900"},{"name":"肃北蒙古族自治县","value":"620923","parent":"620900"},{"name":"阿克塞哈萨克族自治县","value":"620924","parent":"620900"},{"name":"玉门市","value":"620981","parent":"620900"},{"name":"敦煌市","value":"620982","parent":"620900"},{"name":"西峰区","value":"621002","parent":"621000"},{"name":"庆城县","value":"621021","parent":"621000"},{"name":"环县","value":"621022","parent":"621000"},{"name":"华池县","value":"621023","parent":"621000"},{"name":"合水县","value":"621024","parent":"621000"},{"name":"正宁县","value":"621025","parent":"621000"},{"name":"宁县","value":"621026","parent":"621000"},{"name":"镇原县","value":"621027","parent":"621000"},{"name":"安定区","value":"621102","parent":"621100"},{"name":"通渭县","value":"621121","parent":"621100"},{"name":"陇西县","value":"621122","parent":"621100"},{"name":"渭源县","value":"621123","parent":"621100"},{"name":"临洮县","value":"621124","parent":"621100"},{"name":"漳县","value":"621125","parent":"621100"},{"name":"岷县","value":"621126","parent":"621100"},{"name":"武都区","value":"621202","parent":"621200"},{"name":"成县","value":"621221","parent":"621200"},{"name":"文县","value":"621222","parent":"621200"},{"name":"宕昌县","value":"621223","parent":"621200"},{"name":"康县","value":"621224","parent":"621200"},{"name":"西和县","value":"621225","parent":"621200"},{"name":"礼县","value":"621226","parent":"621200"},{"name":"徽县","value":"621227","parent":"621200"},{"name":"两当县","value":"621228","parent":"621200"},{"name":"临夏市","value":"622901","parent":"622900"},{"name":"临夏县","value":"622921","parent":"622900"},{"name":"康乐县","value":"622922","parent":"622900"},{"name":"永靖县","value":"622923","parent":"622900"},{"name":"广河县","value":"622924","parent":"622900"},{"name":"和政县","value":"622925","parent":"622900"},{"name":"东乡族自治县","value":"622926","parent":"622900"},{"name":"积石山保安族东乡族撒拉族自治县","value":"622927","parent":"622900"},{"name":"合作市","value":"623001","parent":"623000"},{"name":"临潭县","value":"623021","parent":"623000"},{"name":"卓尼县","value":"623022","parent":"623000"},{"name":"舟曲县","value":"623023","parent":"623000"},{"name":"迭部县","value":"623024","parent":"623000"},{"name":"玛曲县","value":"623025","parent":"623000"},{"name":"碌曲县","value":"623026","parent":"623000"},{"name":"夏河县","value":"623027","parent":"623000"},{"name":"西宁市","value":"630100","parent":"630000"},{"name":"海东市","value":"630200","parent":"630000"},{"name":"海北藏族自治州","value":"632200","parent":"630000"},{"name":"黄南藏族自治州","value":"632300","parent":"630000"},{"name":"海南藏族自治州","value":"632500","parent":"630000"},{"name":"果洛藏族自治州","value":"632600","parent":"630000"},{"name":"玉树藏族自治州","value":"632700","parent":"630000"},{"name":"海西蒙古族藏族自治州","value":"632800","parent":"630000"},{"name":"城东区","value":"630102","parent":"630100"},{"name":"城中区","value":"630103","parent":"630100"},{"name":"城西区","value":"630104","parent":"630100"},{"name":"城北区","value":"630105","parent":"630100"},{"name":"大通回族土族自治县","value":"630121","parent":"630100"},{"name":"湟中县","value":"630122","parent":"630100"},{"name":"湟源县","value":"630123","parent":"630100"},{"name":"乐都区","value":"630202","parent":"630200"},{"name":"平安区","value":"630203","parent":"630200"},{"name":"民和回族土族自治县","value":"630222","parent":"630200"},{"name":"互助土族自治县","value":"630223","parent":"630200"},{"name":"化隆回族自治县","value":"630224","parent":"630200"},{"name":"循化撒拉族自治县","value":"630225","parent":"630200"},{"name":"门源回族自治县","value":"632221","parent":"632200"},{"name":"祁连县","value":"632222","parent":"632200"},{"name":"海晏县","value":"632223","parent":"632200"},{"name":"刚察县","value":"632224","parent":"632200"},{"name":"同仁县","value":"632321","parent":"632300"},{"name":"尖扎县","value":"632322","parent":"632300"},{"name":"泽库县","value":"632323","parent":"632300"},{"name":"河南蒙古族自治县","value":"632324","parent":"632300"},{"name":"共和县","value":"632521","parent":"632500"},{"name":"同德县","value":"632522","parent":"632500"},{"name":"贵德县","value":"632523","parent":"632500"},{"name":"兴海县","value":"632524","parent":"632500"},{"name":"贵南县","value":"632525","parent":"632500"},{"name":"玛沁县","value":"632621","parent":"632600"},{"name":"班玛县","value":"632622","parent":"632600"},{"name":"甘德县","value":"632623","parent":"632600"},{"name":"达日县","value":"632624","parent":"632600"},{"name":"久治县","value":"632625","parent":"632600"},{"name":"玛多县","value":"632626","parent":"632600"},{"name":"玉树市","value":"632701","parent":"632700"},{"name":"杂多县","value":"632722","parent":"632700"},{"name":"称多县","value":"632723","parent":"632700"},{"name":"治多县","value":"632724","parent":"632700"},{"name":"囊谦县","value":"632725","parent":"632700"},{"name":"曲麻莱县","value":"632726","parent":"632700"},{"name":"格尔木市","value":"632801","parent":"632800"},{"name":"德令哈市","value":"632802","parent":"632800"},{"name":"乌兰县","value":"632821","parent":"632800"},{"name":"都兰县","value":"632822","parent":"632800"},{"name":"天峻县","value":"632823","parent":"632800"},{"name":"银川市","value":"640100","parent":"640000"},{"name":"石嘴山市","value":"640200","parent":"640000"},{"name":"吴忠市","value":"640300","parent":"640000"},{"name":"固原市","value":"640400","parent":"640000"},{"name":"中卫市","value":"640500","parent":"640000"},{"name":"兴庆区","value":"640104","parent":"640100"},{"name":"西夏区","value":"640105","parent":"640100"},{"name":"金凤区","value":"640106","parent":"640100"},{"name":"永宁县","value":"640121","parent":"640100"},{"name":"贺兰县","value":"640122","parent":"640100"},{"name":"灵武市","value":"640181","parent":"640100"},{"name":"大武口区","value":"640202","parent":"640200"},{"name":"惠农区","value":"640205","parent":"640200"},{"name":"平罗县","value":"640221","parent":"640200"},{"name":"利通区","value":"640302","parent":"640300"},{"name":"红寺堡区","value":"640303","parent":"640300"},{"name":"盐池县","value":"640323","parent":"640300"},{"name":"同心县","value":"640324","parent":"640300"},{"name":"青铜峡市","value":"640381","parent":"640300"},{"name":"原州区","value":"640402","parent":"640400"},{"name":"西吉县","value":"640422","parent":"640400"},{"name":"隆德县","value":"640423","parent":"640400"},{"name":"泾源县","value":"640424","parent":"640400"},{"name":"彭阳县","value":"640425","parent":"640400"},{"name":"沙坡头区","value":"640502","parent":"640500"},{"name":"中宁县","value":"640521","parent":"640500"},{"name":"海原县","value":"640522","parent":"640500"},{"name":"乌鲁木齐市","value":"650100","parent":"650000"},{"name":"克拉玛依市","value":"650200","parent":"650000"},{"name":"吐鲁番市","value":"650400","parent":"650000"},{"name":"哈密地区","value":"652200","parent":"650000"},{"name":"昌吉回族自治州","value":"652300","parent":"650000"},{"name":"博尔塔拉蒙古自治州","value":"652700","parent":"650000"},{"name":"巴音郭楞蒙古自治州","value":"652800","parent":"650000"},{"name":"阿克苏地区","value":"652900","parent":"650000"},{"name":"克孜勒苏柯尔克孜自治州","value":"653000","parent":"650000"},{"name":"喀什地区","value":"653100","parent":"650000"},{"name":"和田地区","value":"653200","parent":"650000"},{"name":"伊犁哈萨克自治州","value":"654000","parent":"650000"},{"name":"塔城地区","value":"654200","parent":"650000"},{"name":"阿勒泰地区","value":"654300","parent":"650000"},{"name":"石河子市","value":"659001","parent":"650000"},{"name":"阿拉尔市","value":"659002","parent":"650000"},{"name":"图木舒克市","value":"659003","parent":"650000"},{"name":"五家渠市","value":"659004","parent":"650000"},{"name":"天山区","value":"650102","parent":"650100"},{"name":"沙依巴克区","value":"650103","parent":"650100"},{"name":"新市区","value":"650104","parent":"650100"},{"name":"水磨沟区","value":"650105","parent":"650100"},{"name":"头屯河区","value":"650106","parent":"650100"},{"name":"达坂城区","value":"650107","parent":"650100"},{"name":"米东区","value":"650109","parent":"650100"},{"name":"乌鲁木齐县","value":"650121","parent":"650100"},{"name":"独山子区","value":"650202","parent":"650200"},{"name":"克拉玛依区","value":"650203","parent":"650200"},{"name":"白碱滩区","value":"650204","parent":"650200"},{"name":"乌尔禾区","value":"650205","parent":"650200"},{"name":"高昌区","value":"650402","parent":"650400"},{"name":"鄯善县","value":"650421","parent":"650400"},{"name":"托克逊县","value":"650422","parent":"650400"},{"name":"哈密市","value":"652201","parent":"652200"},{"name":"巴里坤哈萨克自治县","value":"652222","parent":"652200"},{"name":"伊吾县","value":"652223","parent":"652200"},{"name":"昌吉市","value":"652301","parent":"652300"},{"name":"阜康市","value":"652302","parent":"652300"},{"name":"呼图壁县","value":"652323","parent":"652300"},{"name":"玛纳斯县","value":"652324","parent":"652300"},{"name":"奇台县","value":"652325","parent":"652300"},{"name":"吉木萨尔县","value":"652327","parent":"652300"},{"name":"木垒哈萨克自治县","value":"652328","parent":"652300"},{"name":"博乐市","value":"652701","parent":"652700"},{"name":"阿拉山口市","value":"652702","parent":"652700"},{"name":"精河县","value":"652722","parent":"652700"},{"name":"温泉县","value":"652723","parent":"652700"},{"name":"库尔勒市","value":"652801","parent":"652800"},{"name":"轮台县","value":"652822","parent":"652800"},{"name":"尉犁县","value":"652823","parent":"652800"},{"name":"若羌县","value":"652824","parent":"652800"},{"name":"且末县","value":"652825","parent":"652800"},{"name":"焉耆回族自治县","value":"652826","parent":"652800"},{"name":"和静县","value":"652827","parent":"652800"},{"name":"和硕县","value":"652828","parent":"652800"},{"name":"博湖县","value":"652829","parent":"652800"},{"name":"阿克苏市","value":"652901","parent":"652900"},{"name":"温宿县","value":"652922","parent":"652900"},{"name":"库车县","value":"652923","parent":"652900"},{"name":"沙雅县","value":"652924","parent":"652900"},{"name":"新和县","value":"652925","parent":"652900"},{"name":"拜城县","value":"652926","parent":"652900"},{"name":"乌什县","value":"652927","parent":"652900"},{"name":"阿瓦提县","value":"652928","parent":"652900"},{"name":"柯坪县","value":"652929","parent":"652900"},{"name":"阿图什市","value":"653001","parent":"653000"},{"name":"阿克陶县","value":"653022","parent":"653000"},{"name":"阿合奇县","value":"653023","parent":"653000"},{"name":"乌恰县","value":"653024","parent":"653000"},{"name":"喀什市","value":"653101","parent":"653100"},{"name":"疏附县","value":"653121","parent":"653100"},{"name":"疏勒县","value":"653122","parent":"653100"},{"name":"英吉沙县","value":"653123","parent":"653100"},{"name":"泽普县","value":"653124","parent":"653100"},{"name":"莎车县","value":"653125","parent":"653100"},{"name":"叶城县","value":"653126","parent":"653100"},{"name":"麦盖提县","value":"653127","parent":"653100"},{"name":"岳普湖县","value":"653128","parent":"653100"},{"name":"伽师县","value":"653129","parent":"653100"},{"name":"巴楚县","value":"653130","parent":"653100"},{"name":"塔什库尔干塔吉克自治县","value":"653131","parent":"653100"},{"name":"和田市","value":"653201","parent":"653200"},{"name":"和田县","value":"653221","parent":"653200"},{"name":"墨玉县","value":"653222","parent":"653200"},{"name":"皮山县","value":"653223","parent":"653200"},{"name":"洛浦县","value":"653224","parent":"653200"},{"name":"策勒县","value":"653225","parent":"653200"},{"name":"于田县","value":"653226","parent":"653200"},{"name":"民丰县","value":"653227","parent":"653200"},{"name":"伊宁市","value":"654002","parent":"654000"},{"name":"奎屯市","value":"654003","parent":"654000"},{"name":"霍尔果斯市","value":"654004","parent":"654000"},{"name":"伊宁县","value":"654021","parent":"654000"},{"name":"察布查尔锡伯自治县","value":"654022","parent":"654000"},{"name":"霍城县","value":"654023","parent":"654000"},{"name":"巩留县","value":"654024","parent":"654000"},{"name":"新源县","value":"654025","parent":"654000"},{"name":"昭苏县","value":"654026","parent":"654000"},{"name":"特克斯县","value":"654027","parent":"654000"},{"name":"尼勒克县","value":"654028","parent":"654000"},{"name":"塔城市","value":"654201","parent":"654200"},{"name":"乌苏市","value":"654202","parent":"654200"},{"name":"额敏县","value":"654221","parent":"654200"},{"name":"沙湾县","value":"654223","parent":"654200"},{"name":"托里县","value":"654224","parent":"654200"},{"name":"裕民县","value":"654225","parent":"654200"},{"name":"和布克赛尔蒙古自治县","value":"654226","parent":"654200"},{"name":"阿勒泰市","value":"654301","parent":"654300"},{"name":"布尔津县","value":"654321","parent":"654300"},{"name":"富蕴县","value":"654322","parent":"654300"},{"name":"福海县","value":"654323","parent":"654300"},{"name":"哈巴河县","value":"654324","parent":"654300"},{"name":"青河县","value":"654325","parent":"654300"},{"name":"吉木乃县","value":"654326","parent":"654300"},{"name":"中西區","value":"810001","parent":"810000"},{"name":"灣仔區","value":"810002","parent":"810000"},{"name":"東區","value":"810003","parent":"810000"},{"name":"南區","value":"810004","parent":"810000"},{"name":"油尖旺區","value":"810005","parent":"810000"},{"name":"深水埗區","value":"810006","parent":"810000"},{"name":"九龍城區","value":"810007","parent":"810000"},{"name":"黃大仙區","value":"810008","parent":"810000"},{"name":"觀塘區","value":"810009","parent":"810000"},{"name":"荃灣區","value":"810010","parent":"810000"},{"name":"屯門區","value":"810011","parent":"810000"},{"name":"元朗區","value":"810012","parent":"810000"},{"name":"北區","value":"810013","parent":"810000"},{"name":"大埔區","value":"810014","parent":"810000"},{"name":"西貢區","value":"810015","parent":"810000"},{"name":"沙田區","value":"810016","parent":"810000"},{"name":"葵青區","value":"810017","parent":"810000"},{"name":"離島區","value":"810018","parent":"810000"},{"name":"花地瑪堂區","value":"820001","parent":"820000"},{"name":"花王堂區","value":"820002","parent":"820000"},{"name":"望德堂區","value":"820003","parent":"820000"},{"name":"大堂區","value":"820004","parent":"820000"},{"name":"風順堂區","value":"820005","parent":"820000"},{"name":"嘉模堂區","value":"820006","parent":"820000"},{"name":"路氹填海區","value":"820007","parent":"820000"},{"name":"聖方濟各堂區","value":"820008","parent":"820000"},{"name":"--","value":"--","parent":"110200"},{"name":"--","value":"--","parent":"120200"},{"name":"--","value":"--","parent":"139000"},{"name":"--","value":"--","parent":"139001"},{"name":"--","value":"--","parent":"139002"},{"name":"--","value":"--","parent":"310200"},{"name":"--","value":"--","parent":"419000"},{"name":"--","value":"--","parent":"419001"},{"name":"--","value":"--","parent":"429000"},{"name":"--","value":"--","parent":"429004"},{"name":"--","value":"--","parent":"429005"},{"name":"--","value":"--","parent":"429006"},{"name":"--","value":"--","parent":"429021"},{"name":"--","value":"--","parent":"441900"},{"name":"--","value":"--","parent":"442000"},{"name":"--","value":"--","parent":"469000"},{"name":"--","value":"--","parent":"469001"},{"name":"--","value":"--","parent":"469002"},{"name":"--","value":"--","parent":"469003"},{"name":"--","value":"--","parent":"469005"},{"name":"--","value":"--","parent":"469006"},{"name":"--","value":"--","parent":"469007"},{"name":"--","value":"--","parent":"469021"},{"name":"--","value":"--","parent":"469022"},{"name":"--","value":"--","parent":"469023"},{"name":"--","value":"--","parent":"469024"},{"name":"--","value":"--","parent":"469025"},{"name":"--","value":"--","parent":"469026"},{"name":"--","value":"--","parent":"469027"},{"name":"--","value":"--","parent":"469028"},{"name":"--","value":"--","parent":"469029"},{"name":"--","value":"--","parent":"469030"},{"name":"--","value":"--","parent":"500200"},{"name":"--","value":"--","parent":"620200"},{"name":"--","value":"--","parent":"659000"},{"name":"--","value":"--","parent":"659001"},{"name":"--","value":"--","parent":"659002"},{"name":"--","value":"--","parent":"659003"},{"name":"--","value":"--","parent":"659004"}]

/***/ }),

/***/ "2lnh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "3Lt7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < prefixList.length; i++) {
          styles[prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
//
//
//
//
//
//

var flexbox_item_prefixList = ['-moz-box-', '-webkit-box-', ''];

/* harmony default export */ var flexbox_flexbox_item = ({
  name: 'flexbox-item',
  props: {
    span: [Number, String],
    order: [Number, String]
  },
  beforeMount: function beforeMount() {
    this.bodyWidth = document.documentElement.offsetWidth;
  },

  methods: {
    buildWidth: function buildWidth(width) {
      if (typeof width === 'number') {
        if (width < 1) {
          return width;
        } else {
          return width / 12;
        }
      } else if (typeof width === 'string') {
        return width.replace('px', '') / this.bodyWidth;
      }
    }
  },
  computed: {
    style: function style() {
      var styles = {};
      var marginName = this.$parent.orient === 'horizontal' ? 'marginLeft' : 'marginTop';

      if (this.$parent.gutter * 1 !== 0) {
        styles[marginName] = this.$parent.gutter + 'px';
      }

      if (this.span) {
        for (var i = 0; i < flexbox_item_prefixList.length; i++) {
          styles[flexbox_item_prefixList[i] + 'flex'] = '0 0 ' + this.buildWidth(this.span) * 100 + '%';
        }
      }
      if (typeof this.order !== 'undefined') {
        styles.order = this.order;
      }
      return styles;
    }
  },
  data: function data() {
    return {
      bodyWidth: 0
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f79b7cb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox-item.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox-item",style:(_vm.style)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox_item = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox-item.vue
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox_item,
  components_flexbox_flexbox_item,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox_item = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "3k2l":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "429B":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "55wj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6p1R":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "78BN":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7Otq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo.613f907.png";

/***/ }),

/***/ "7zGH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9TJo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9u+O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/*
 * @Author: chen_yong
 * @Date: 2020-04-21 20:29:08
 * @Version: 1.0.0
 * @LastEditTime: 2021-02-20 17:10:32
 * @Description: 
 */
/* harmony default export */ __webpack_exports__["a"] = ({
  // 通用基础接口
  common: {
    // 当前登录用户的权限
    login: '/exhibition/loginCheck',
    tokenCheck: '/exhibition/tokenCheck',
    logout: '/logout',
    oss: '/exhibition/getOssAuth',
    checkCode: '/getMobilCode'

  },
  exhibition: {
    list: '/exhibition/exhibitionMasters',
    add: '/exhibition/add',
    getModel: '/exhibition/getExhibitionInfoById',
    update: '/exhibition/update',
    getMasterModel: '/exhibition/getMasterInfoById',
    stores: '/exhibition/exhibitionStores',
    getStoreModel: '/exhibition/getExhibitionStoreById',
    getSwiper: "/exhibition/getSwiperById",
    swipersIndex: "/exhibition/getSwipersIndex",
    sendEmail: '/exhibition/sendEmail'
  }
});

/***/ }),

/***/ "A61V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ApxZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BMgP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "ByaA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DPlV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DbKU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Del0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Dm7L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "GnSU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Gz2+":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KHby":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/common-top.744ce28.png";

/***/ }),

/***/ "Kkag":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__("mtWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);

/*
 * @Author: chen_yong
 * @Date: 2020-04-21 20:29:08
 * @Version: 1.0.0
 * @LastEditTime: 2021-02-19 11:26:09
 * @Description: 
 */
/**
 * @file Axios的Vue插件（添加全局请求/响应拦截器）
 */

// https://github.com/mzabriskie/axios


var location = global.location;
var localStorage = global.localStorage;
var baseUrl = 'https://manage.zhhlxh.org.cn/mapi';
// const baseUrl = 'http://192.168.3.38:15588/mapi';

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.defaults.baseURL = baseUrl;

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.request.use(function (config) {
  var token = localStorage.getItem('X_TOKEN');
  if (token) {
    config.headers.token = '' + token;
  }
  return config;
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.interceptors.response.use(function (response) {

  // 下载文件
  if (response.request.responseType === 'blob') {
    return response;
  }

  var data = response.data;

  switch (data.code) {
    case 0:
    case '0':
      return data;
    case '99':
    case 99:
      return location.href = '/';
    default:
  }

  var err = new Error(data.msg);

  err.data = data;
  err.response = response;

  throw err;
}, function (err) {
  if (err && err.response) {
    switch (err.response.status) {
      case 401:
        err.message = '请登录';
        break;

      case 404:
        err.message = '\u8BF7\u6C42\u5730\u5740\u51FA\u9519:';
        break;

      case 500:
      case 503:
        err.message = '服务器错误';
        break;

      case 502:
        err.message = '请求数据超时，请刷新页面重试';
        break;

      default:
    }
  }

  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(err);
});

__WEBPACK_IMPORTED_MODULE_1_axios___default.a.install = function (Vue) {
  Vue.prototype.$axios = __WEBPACK_IMPORTED_MODULE_1_axios___default.a;
};

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_axios___default.a);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "Klsc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Live":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/show1.7f3c1a7.jpeg";

/***/ }),

/***/ "Luh7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MHfV":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhhlxh-logo.d9ec8f7.png";

/***/ }),

/***/ "MMr7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MUCD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: "app",
  provide: {
    $oss: {}
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  provide: {
    $oss: {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74d16754","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("0/Fx")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/vux/src/components/swiper/swiper.js
var swiper = __webpack_require__("NjrX");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/router.js
var router = __webpack_require__("0FxO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_swiper_swiper = ({
  name: 'swiper',
  created: function created() {
    this.index = this.value || 0;
    if (this.index) {
      this.current = this.index;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.hasTwoLoopItem();
    this.$nextTick(function () {
      if (!(_this2.list && _this2.list.length === 0)) {
        _this2.render(_this2.index);
      }
      _this2.xheight = _this2.getHeight();
      _this2.$emit('on-get-height', _this2.xheight);
    });
  },

  methods: {
    hasTwoLoopItem: function hasTwoLoopItem() {
      if (this.list.length === 2 && this.loop) {
        this.listTwoLoopItem = this.list;
      } else {
        this.listTwoLoopItem = [];
      }
    },
    clickListItem: function clickListItem(item) {
      Object(router["b" /* go */])(item.url, this.$router);
      this.$emit('on-click-list-item', JSON.parse(stringify_default()(item)));
    },
    buildBackgroundUrl: function buildBackgroundUrl(item) {
      return item.fallbackImg ? 'url(' + item.img + '), url(' + item.fallbackImg + ')' : 'url(' + item.img + ')';
    },
    render: function render() {
      var _this3 = this;

      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.swiper && this.swiper.destroy();
      this.swiper = new swiper["a" /* default */]({
        container: this.$el,
        direction: this.direction,
        auto: this.auto,
        loop: this.loop,
        interval: this.interval,
        threshold: this.threshold,
        duration: this.duration,
        height: this.height || this._height,
        minMovingDistance: this.minMovingDistance,
        imgList: this.imgList
      }).on('swiped', function (prev, index) {
        _this3.current = index % _this3.length;
        _this3.index = index % _this3.length;
      });
      if (index > 0) {
        this.swiper.go(index);
      }
    },
    rerender: function rerender() {
      var _this4 = this;

      if (!this.$el || this.hasRender) {
        return;
      }
      this.hasRender = true;
      this.hasTwoLoopItem();
      this.$nextTick(function () {
        _this4.index = _this4.value || 0;
        _this4.current = _this4.value || 0;
        _this4.length = _this4.list.length || _this4.$children.length;
        _this4.destroy();
        _this4.render(_this4.value);
      });
    },
    destroy: function destroy() {
      this.hasRender = false;
      this.swiper && this.swiper.destroy();
    },
    getHeight: function getHeight() {
      var hasHeight = parseInt(this.height, 10);
      if (hasHeight) return this.height;
      if (!hasHeight) {
        if (this.aspectRatio) {
          return this.$el.offsetWidth * this.aspectRatio + 'px';
        }
        return '180px';
      }
    }
  },
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    direction: {
      type: String,
      default: 'horizontal'
    },
    showDots: {
      type: Boolean,
      default: true
    },
    showDescMask: {
      type: Boolean,
      default: true
    },
    dotsPosition: {
      type: String,
      default: 'right'
    },
    dotsClass: String,
    auto: Boolean,
    loop: Boolean,
    interval: {
      type: Number,
      default: 3000
    },
    threshold: {
      type: Number,
      default: 50
    },
    duration: {
      type: Number,
      default: 300
    },
    height: {
      type: String,
      default: 'auto'
    },
    aspectRatio: Number,
    minMovingDistance: {
      type: Number,
      default: 0
    },
    value: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      hasRender: false,
      current: this.index || 0,
      xheight: 'auto',
      length: this.list.length,
      index: 0,
      listTwoLoopItem: [] // issue #1484
    };
  },

  watch: {
    auto: function auto(val) {
      if (!val) {
        this.swiper && this.swiper.stop();
      } else {
        this.swiper && this.swiper._auto();
      }
    },
    list: function list(val, oldVal) {
      if (stringify_default()(val) !== stringify_default()(oldVal)) {
        this.rerender();
      }
    },
    current: function current(currentIndex) {
      this.index = currentIndex;
      this.$emit('on-index-change', currentIndex);
    },
    index: function index(val) {
      var _this = this;
      if (val !== this.current) {
        this.$nextTick(function () {
          _this.swiper && _this.swiper.go(val);
        });
      }
      this.$emit('input', val);
    },
    value: function value(val) {
      this.index = val;
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fe8f518","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper.vue
var swiper_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-slider"},[_c('div',{staticClass:"vux-swiper",style:({height: _vm.xheight})},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.list),function(item,index){return _c('div',{staticClass:"vux-swiper-item",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])])}),_vm._v(" "),_vm._l((_vm.listTwoLoopItem),function(item,index){return (_vm.listTwoLoopItem.length > 0)?_c('div',{staticClass:"vux-swiper-item vux-swiper-item-clone",attrs:{"data-index":index},on:{"click":function($event){return _vm.clickListItem(item)}}},[_c('a',{attrs:{"href":"javascript:"}},[_c('div',{staticClass:"vux-img",style:({backgroundImage: _vm.buildBackgroundUrl(item)})}),_vm._v(" "),(_vm.showDescMask)?_c('p',{staticClass:"vux-swiper-desc"},[_vm._v(_vm._s(item.title))]):_vm._e()])]):_vm._e()})],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showDots),expression:"showDots"}],class:[_vm.dotsClass, 'vux-indicator', ("vux-indicator-" + _vm.dotsPosition)]},_vm._l((_vm.length),function(key){return _c('a',{attrs:{"href":"javascript:"}},[_c('i',{staticClass:"vux-icon-dot",class:{'active': key - 1 === _vm.current}})])}),0)])}
var swiper_staticRenderFns = []
var swiper_esExports = { render: swiper_render, staticRenderFns: swiper_staticRenderFns }
/* harmony default export */ var src_components_swiper_swiper = (swiper_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper.vue
function swiper_injectStyle (ssrContext) {
  __webpack_require__("d1Im")
}
var swiper_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper___vue_template_functional__ = false
/* styles */
var swiper___vue_styles__ = swiper_injectStyle
/* scopeId */
var swiper___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper___vue_module_identifier__ = null
var swiper_Component = swiper_normalizeComponent(
  components_swiper_swiper,
  src_components_swiper_swiper,
  swiper___vue_template_functional__,
  swiper___vue_styles__,
  swiper___vue_scopeId__,
  swiper___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_swiper_swiper = (swiper_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/index.vue





/* harmony default export */ var components = ({
  beforeCreate: function beforeCreate() {
    document.querySelector("body").setAttribute("style", "margin-bottom:30px;background-color:#d2e7e6");

    document.querySelector("html").setAttribute("style", "height:100%");
  },
  data: function data() {
    return {
      errorMsg: "",
      showPositionValue: false,
      activeId: "",
      topImg: __webpack_require__("MHfV"),
      zsbmImg: __webpack_require__("RlV+"),
      dhrcImg: __webpack_require__("BMgP"),
      zsjsImg: __webpack_require__("zyhK"),
      spzbImg: __webpack_require__("iD+u"),
      tpzbImg: __webpack_require__("Rzzg"),
      logoImg: __webpack_require__("7Otq"),
      proPdf: "",
      zsList: [],
      swipers: [{
        url: "/register",
        img: __webpack_require__("Live"),
        title: "展商1"
      }, {
        url: "javascript:",
        img: __webpack_require__("ZXp/"),
        title: "展商2"
      }, {
        url: "javascript:",
        img: __webpack_require__("chSg"),
        title: "展商3"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.id;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }

              _this.queryInfo(_this.activeId);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    Swiper: vux_src_components_swiper_swiper
  },
  methods: {
    /**
    * 跳转到展商列表
    *
    */
    toStores: function toStores() {
      this.$router.push({
        name: "storelist",
        params: { activeId: this.activeId }
      });
    },

    /**
    * 跳转大会日程pdf
    */
    toProgramme: function toProgramme() {
      if (this.proPdf) {
        this.$router.push({
          name: "pdfView",
          params: { activeId: this.activeId, pdfSrc: this.proPdf, pdfType: 'pro' }
        });
      } else {
        this.showMsg("尚未上传大会日程");
      }
    },

    /**
    * 跳转到直播页面
    */
    toLive: function toLive() {
      window.location.href = "http://live.zhhlxh.org.cn/video";
    },

    /**
    * 获取提交信息
    *
    */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data, i, val;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getMasterModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {

                  _this2.$router.push({ name: "error" });
                }
                /*   this.topImg = data.data.activePicUrl; */
                _this2.swipers = [];
                _this2.zsList = [{
                  url: "javascript:",
                  img: data.data.activePicUrl,
                  title: ""
                }];
                _this2.proPdf = data.data.proPdf;
                for (i = 0; i < data.showList.length; i++) {
                  val = data.showList[i];

                  _this2.swipers.push({
                    url: "javascript:",
                    img: val.indexUrl,
                    title: val.storeName
                  });
                }
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1 || _context2.t1.msg || _context2.t1.data.msg);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 16]]);
      }))();
    },

    /**
    * 跳转注册页
    */
    toRegister: function toRegister() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var tokenCheck, _ref2, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokenCheck = _this3.$apis.common.tokenCheck;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$axios.get(tokenCheck + "/" + _this3.activeId);

              case 4:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 7;
                  break;
                }

                _context3.t0 = {};

              case 7:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this3.$router.push({
                  name: "info",
                  params: { id: data.id, cellPhone: data.cellPhone }
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t1 = _context3["catch"](1);

                _this3.$router.push({
                  name: "loginSelect",
                  params: { activeId: _this3.activeId }
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 12]]);
      }))();
    },

    /**
    * 显示提示信息
    *
    */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
    autoSwap: function autoSwap(item) {}
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/index.vue





/* harmony default export */ var selectortype_script_index_0_src_components = ({
  beforeCreate: function beforeCreate() {
    document.querySelector("body").setAttribute("style", "margin-bottom:30px;background-color:#d2e7e6");

    document.querySelector("html").setAttribute("style", "height:100%");
  },
  data: function data() {
    return {
      errorMsg: "",
      showPositionValue: false,
      activeId: "",
      topImg: __webpack_require__("MHfV"),
      zsbmImg: __webpack_require__("RlV+"),
      dhrcImg: __webpack_require__("BMgP"),
      zsjsImg: __webpack_require__("zyhK"),
      spzbImg: __webpack_require__("iD+u"),
      tpzbImg: __webpack_require__("Rzzg"),
      logoImg: __webpack_require__("7Otq"),
      proPdf: "",
      zsList: [],
      swipers: [{
        url: "/register",
        img: __webpack_require__("Live"),
        title: "展商1"
      }, {
        url: "javascript:",
        img: __webpack_require__("ZXp/"),
        title: "展商2"
      }, {
        url: "javascript:",
        img: __webpack_require__("chSg"),
        title: "展商3"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.id;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }

              _this.queryInfo(_this.activeId);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  components: {
    Swiper: vux_src_components_swiper_swiper
  },
  methods: {
    /**
    * 跳转到展商列表
    *
    */
    toStores: function toStores() {
      this.$router.push({
        name: "storelist",
        params: { activeId: this.activeId }
      });
    },

    /**
    * 跳转大会日程pdf
    */
    toProgramme: function toProgramme() {
      if (this.proPdf) {
        this.$router.push({
          name: "pdfView",
          params: { activeId: this.activeId, pdfSrc: this.proPdf, pdfType: 'pro' }
        });
      } else {
        this.showMsg("尚未上传大会日程");
      }
    },

    /**
    * 跳转到直播页面
    */
    toLive: function toLive() {
      window.location.href = "http://live.zhhlxh.org.cn/video";
    },

    /**
    * 获取提交信息
    *
    */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data, i, val;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getMasterModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {

                  _this2.$router.push({ name: "error" });
                }
                /*   this.topImg = data.data.activePicUrl; */
                _this2.swipers = [];
                _this2.zsList = [{
                  url: "javascript:",
                  img: data.data.activePicUrl,
                  title: ""
                }];
                _this2.proPdf = data.data.proPdf;
                for (i = 0; i < data.showList.length; i++) {
                  val = data.showList[i];

                  _this2.swipers.push({
                    url: "javascript:",
                    img: val.indexUrl,
                    title: val.storeName
                  });
                }
                _context2.next = 19;
                break;

              case 16:
                _context2.prev = 16;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1 || _context2.t1.msg || _context2.t1.data.msg);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 16]]);
      }))();
    },

    /**
    * 跳转注册页
    */
    toRegister: function toRegister() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var tokenCheck, _ref2, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                tokenCheck = _this3.$apis.common.tokenCheck;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$axios.get(tokenCheck + "/" + _this3.activeId);

              case 4:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 7;
                  break;
                }

                _context3.t0 = {};

              case 7:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this3.$router.push({
                  name: "info",
                  params: { id: data.id, cellPhone: data.cellPhone }
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t1 = _context3["catch"](1);

                _this3.$router.push({
                  name: "loginSelect",
                  params: { activeId: _this3.activeId }
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 12]]);
      }))();
    },

    /**
    * 显示提示信息
    *
    */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },
    autoSwap: function autoSwap(item) {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-20159f8e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
var components_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"pics"},[_c('swiper',{attrs:{"list":_vm.zsList,"auto":"","interval":2000}})],1),_vm._v(" "),_c('div',{staticClass:"body-container"},[_c('div',{staticClass:"content"},[_c('div',{staticClass:"first"},[_c('div',{staticClass:"fleft",on:{"click":_vm.toProgramme}},[_c('img',{attrs:{"src":_vm.dhrcImg}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("大会日程")])]),_vm._v(" "),_c('div',{staticClass:"fright",on:{"click":_vm.toStores}},[_c('img',{attrs:{"src":_vm.zsjsImg}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("展商介绍")])])]),_vm._v(" "),_c('div',{staticClass:"first first-padding"},[_c('div',{staticClass:"fleft",on:{"click":_vm.toLive}},[_c('img',{attrs:{"src":_vm.spzbImg}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("视频直播")])]),_vm._v(" "),_c('div',{staticClass:"fright"},[_c('img',{attrs:{"src":_vm.tpzbImg}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',[_vm._v("图文直播")])])])]),_vm._v(" "),_c('div',{staticClass:"swip-pics"},[_c('swiper',{attrs:{"list":_vm.swipers,"auto":"","interval":2000},on:{"on-index-change":function($event){return _vm.autoSwap()}}})],1)]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('button',{staticClass:"signup",attrs:{"type":"button"},on:{"click":_vm.toRegister}},[_vm._v("参展报名")])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var components_staticRenderFns = []
var components_esExports = { render: components_render, staticRenderFns: components_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components = (components_esExports);
// CONCATENATED MODULE: ./src/components/index.vue
function components_injectStyle (ssrContext) {
  __webpack_require__("6p1R")
}
var components_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var components___vue_template_functional__ = false
/* styles */
var components___vue_styles__ = components_injectStyle
/* scopeId */
var components___vue_scopeId__ = "data-v-20159f8e"
/* moduleIdentifier (server only) */
var components___vue_module_identifier__ = null
var components_Component = components_normalizeComponent(
  selectortype_script_index_0_src_components,
  selectortype_template_index_0_src_components,
  components___vue_template_functional__,
  components___vue_styles__,
  components___vue_scopeId__,
  components___vue_module_identifier__
)

/* harmony default export */ var src_components = (components_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/register.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var register = ({
  data: function data() {
    return {
      show: false,
      isShow: false,
      loading: false,
      isDisabled: false,
      topImg: __webpack_require__("hSo9"),
      logoImg: __webpack_require__("7Otq"),
      typeList: ["标准展位", "特装展位"],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        tel: "",
        address: "",
        telAddress: "",
        bank: "",
        bcount: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0,
        checkCode: ""
      },
      rules: {
        supportOption: "请选择参与性质",
        exhibitionType: "请选择展位类别",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
        checkCode: "请输入验证码"
      },
      // showListNum: [["0", "1", "2", "3", "4", "5"]],
      // sateListNum: [["0", "1", "2", "3"]],
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm = _this.$route.params;
              if (_this.addForm.supportOption === '参展') {
                _this.isShow = true;
              } else {
                _this.addForm.sateCount = 0;
                _this.addForm.showCount = 0;
                _this.addForm.exhibitionType = 'S';
                _this.addForm.invoiceType = '财政专用票据';
              }
              console.log(_this.addForm);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  methods: {
    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 确认提交
     */
    onConfirm: function onConfirm() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isDisabled = true;
                _this2.addForm.telAddress = _this2.addForm.tel + _this2.addForm.address;
                _this2.addForm.bankCount = _this2.addForm.bank + _this2.addForm.bcount;
                _this2.addForm.id = "";
                add = _this2.$apis.exhibition.add;
                _context2.prev = 5;
                _context2.next = 8;
                return _this2.$axios.post(add, _this2.addForm);

              case 8:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                _context2.t0 = {};

              case 11:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg("提交成功！");
                localStorage.setItem('X_TOKEN', data.token);
                _this2.$router.push({
                  name: "success",
                  params: { activeId: _this2.addForm.activeId }
                });
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2["catch"](5);

                _this2.showMsg(_context2.t1.data.msg);
                _this2.isDisabled = false;

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 18]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var key;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = regenerator_default.a.keys(_this3.rules);

              case 1:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 8;
                  break;
                }

                key = _context3.t1.value;

                if (_this3.addForm[key]) {
                  _context3.next = 6;
                  break;
                }

                _this3.showMsg(_this3.rules[key]);
                // this.isDisabled = false;
                return _context3.abrupt("return");

              case 6:
                _context3.next = 1;
                break;

              case 8:
                _this3.show = true;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.addForm.cellPhone) {
                  _context4.next = 3;
                  break;
                }

                _this4.showMsg("请先输入手机号！");
                return _context4.abrupt("return");

              case 3:
                if (!_this4.count) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:

                if (_this4.interval) {
                  clearInterval(_this4.interval);
                }
                _context4.prev = 6;
                getCheckCode = _this4.$apis.common.checkCode;
                _context4.next = 10;
                return _this4.$axios.get(getCheckCode + "/" + _this4.addForm.cellPhone + "/" + _this4.addForm.activeId + "/1");

              case 10:
                _this4.showMsg("短信发送成功！");
                _this4.count = 59;
                _this4.interval = setInterval(function () {
                  if (_this4.count <= 0) {
                    clearInterval(_this4.interval);
                    return;
                  }
                  return _this4.count--;
                }, 1000);
                _context4.next = 21;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](6);

                console.log(_context4.t0);
                if (_this4.interval) {
                  clearInterval(_this4.interval);
                }
                _this4.count = 0;
                _this4.showMsg(_context4.t0);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/register.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_register = ({
  data: function data() {
    return {
      show: false,
      isShow: false,
      loading: false,
      isDisabled: false,
      topImg: __webpack_require__("hSo9"),
      logoImg: __webpack_require__("7Otq"),
      typeList: ["标准展位", "特装展位"],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        tel: "",
        address: "",
        telAddress: "",
        bank: "",
        bcount: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0,
        checkCode: ""
      },
      rules: {
        supportOption: "请选择参与性质",
        exhibitionType: "请选择展位类别",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
        checkCode: "请输入验证码"
      },
      // showListNum: [["0", "1", "2", "3", "4", "5"]],
      // sateListNum: [["0", "1", "2", "3"]],
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm = _this.$route.params;
              if (_this.addForm.supportOption === '参展') {
                _this.isShow = true;
              } else {
                _this.addForm.sateCount = 0;
                _this.addForm.showCount = 0;
                _this.addForm.exhibitionType = 'S';
                _this.addForm.invoiceType = '财政专用票据';
              }
              console.log(_this.addForm);

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  methods: {
    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 确认提交
     */
    onConfirm: function onConfirm() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isDisabled = true;
                _this2.addForm.telAddress = _this2.addForm.tel + _this2.addForm.address;
                _this2.addForm.bankCount = _this2.addForm.bank + _this2.addForm.bcount;
                _this2.addForm.id = "";
                add = _this2.$apis.exhibition.add;
                _context2.prev = 5;
                _context2.next = 8;
                return _this2.$axios.post(add, _this2.addForm);

              case 8:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 11;
                  break;
                }

                _context2.t0 = {};

              case 11:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg("提交成功！");
                localStorage.setItem('X_TOKEN', data.token);
                _this2.$router.push({
                  name: "success",
                  params: { activeId: _this2.addForm.activeId }
                });
                _context2.next = 22;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t1 = _context2["catch"](5);

                _this2.showMsg(_context2.t1.data.msg);
                _this2.isDisabled = false;

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[5, 18]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var key;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = regenerator_default.a.keys(_this3.rules);

              case 1:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 8;
                  break;
                }

                key = _context3.t1.value;

                if (_this3.addForm[key]) {
                  _context3.next = 6;
                  break;
                }

                _this3.showMsg(_this3.rules[key]);
                // this.isDisabled = false;
                return _context3.abrupt("return");

              case 6:
                _context3.next = 1;
                break;

              case 8:
                _this3.show = true;

              case 9:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.addForm.cellPhone) {
                  _context4.next = 3;
                  break;
                }

                _this4.showMsg("请先输入手机号！");
                return _context4.abrupt("return");

              case 3:
                if (!_this4.count) {
                  _context4.next = 5;
                  break;
                }

                return _context4.abrupt("return");

              case 5:

                if (_this4.interval) {
                  clearInterval(_this4.interval);
                }
                _context4.prev = 6;
                getCheckCode = _this4.$apis.common.checkCode;
                _context4.next = 10;
                return _this4.$axios.get(getCheckCode + "/" + _this4.addForm.cellPhone + "/" + _this4.addForm.activeId + "/1");

              case 10:
                _this4.showMsg("短信发送成功！");
                _this4.count = 59;
                _this4.interval = setInterval(function () {
                  if (_this4.count <= 0) {
                    clearInterval(_this4.interval);
                    return;
                  }
                  return _this4.count--;
                }, 1000);
                _context4.next = 21;
                break;

              case 15:
                _context4.prev = 15;
                _context4.t0 = _context4["catch"](6);

                console.log(_context4.t0);
                if (_this4.interval) {
                  clearInterval(_this4.interval);
                }
                _this4.count = 0;
                _this4.showMsg(_context4.t0);

              case 21:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6423fe1f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register.vue
var register_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('x-header',{staticClass:"goBack",attrs:{"slot":"overwrite-left"},slot:"overwrite-left"},[_vm._v("展商报名表填写")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('Form',{ref:"addForm",attrs:{"v-model":_vm.addForm}},[_c('group',{attrs:{"title":"联系信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('x-input',{attrs:{"title":"","placeholder":"请输入联系人姓名","required":true},model:{value:(_vm.addForm.userName),callback:function ($$v) {_vm.$set(_vm.addForm, "userName", $$v)},expression:"addForm.userName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"","max":11,"is-type":"china-mobile","required":true,"placeholder":"请输入联系手机号"},model:{value:(_vm.addForm.cellPhone),callback:function ($$v) {_vm.$set(_vm.addForm, "cellPhone", $$v)},expression:"addForm.cellPhone"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"","placeholder":"请输入验证码","required":true},model:{value:(_vm.addForm.checkCode),callback:function ($$v) {_vm.$set(_vm.addForm, "checkCode", $$v)},expression:"addForm.checkCode"}},[_c('x-button',{class:(!_vm.addForm.cellPhone || _vm.count) && 'disable-btn',attrs:{"slot":"right","gradients":['#1eb5b5', '#1eb5b5'],"type":"primary","action-type":"button","mini":""},nativeOn:{"click":function($event){return _vm.getMobilCode()}},slot:"right"},[_vm._v(_vm._s(_vm.smsMessage))])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"","is-type":"email","required":true,"placeholder":"请输入联系邮箱"},model:{value:(_vm.addForm.email),callback:function ($$v) {_vm.$set(_vm.addForm, "email", $$v)},expression:"addForm.email"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"开票信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v(_vm._s(_vm.isShow ? '发票类别' : '财政专用票据'))]),_vm._v(" "),(_vm.isShow)?_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.invoiceType),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceType", $$v)},expression:"addForm.invoiceType"}},[_c('checker-item',{attrs:{"value":"专票"}},[_vm._v("专票")])],1)],1):_vm._e(),_vm._v(" "),_c('x-input',{ref:"refCode",attrs:{"title":"","placeholder":"请输入发票抬头"},model:{value:(_vm.addForm.invoiceTitle),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceTitle", $$v)},expression:"addForm.invoiceTitle"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"","min":15,"max":18,"placeholder":"请输入税号"},model:{value:(_vm.addForm.taxNo),callback:function ($$v) {_vm.$set(_vm.addForm, "taxNo", $$v)},expression:"addForm.taxNo"}}),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入地址"},model:{value:(_vm.addForm.tel),callback:function ($$v) {_vm.$set(_vm.addForm, "tel", $$v)},expression:"addForm.tel"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入电话"},model:{value:(_vm.addForm.address),callback:function ($$v) {_vm.$set(_vm.addForm, "address", $$v)},expression:"addForm.address"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入开户银行"},model:{value:(_vm.addForm.bank),callback:function ($$v) {_vm.$set(_vm.addForm, "bank", $$v)},expression:"addForm.bank"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入账号"},model:{value:(_vm.addForm.bcount),callback:function ($$v) {_vm.$set(_vm.addForm, "bcount", $$v)},expression:"addForm.bcount"}}):_vm._e(),_vm._v(" "),_c('x-textarea',{attrs:{"placeholder":"请输入发票邮寄地址","show-counter":false,"rows":3,"required":true},model:{value:(_vm.addForm.mailAddress),callback:function ($$v) {_vm.$set(_vm.addForm, "mailAddress", $$v)},expression:"addForm.mailAddress"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.submitAdd()}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('div',[_c('confirm',{attrs:{"title":"提交确认"},on:{"on-cancel":_vm.onCancel,"on-confirm":_vm.onConfirm,"on-show":_vm.onShow,"on-hide":_vm.onHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("确定提交?")])])],1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_vm._m(0)],1)}
var register_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"chinese"},[_vm._v("\n      技术支持：\n       易康维\n    ")])])}]
var register_esExports = { render: register_render, staticRenderFns: register_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_register = (register_esExports);
// CONCATENATED MODULE: ./src/components/register.vue
function register_injectStyle (ssrContext) {
  __webpack_require__("Del0")
}
var register_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var register___vue_template_functional__ = false
/* styles */
var register___vue_styles__ = register_injectStyle
/* scopeId */
var register___vue_scopeId__ = "data-v-6423fe1f"
/* moduleIdentifier (server only) */
var register___vue_module_identifier__ = null
var register_Component = register_normalizeComponent(
  components_register,
  selectortype_template_index_0_src_components_register,
  register___vue_template_functional__,
  register___vue_styles__,
  register___vue_scopeId__,
  register___vue_module_identifier__
)

/* harmony default export */ var src_components_register = (register_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/msg/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_msg = ({
  name: 'msg',
  props: ['icon', 'title', 'description', 'buttons'],
  methods: {
    onClick: function onClick(handler, link) {
      typeof handler === 'function' && handler();
      link && Object(router["b" /* go */])(link, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46168f67","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/msg/index.vue
var msg_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-msg"},[_c('div',{staticClass:"weui-msg__icon-area"},[_c('i',{staticClass:"weui-icon_msg",class:("weui-icon-" + (_vm.icon || 'success'))})]),_vm._v(" "),_c('div',{staticClass:"weui-msg__text-area"},[_c('h2',{staticClass:"weui-msg__title",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-msg__desc"},[_vm._t("description")],2),_vm._v(" "),(_vm.description)?_c('p',{staticClass:"weui-msg__desc",domProps:{"innerHTML":_vm._s(_vm.description)}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-msg__opr-area"},[_c('p',{staticClass:"weui-btn-area"},[_vm._t("buttons",_vm._l((_vm.buttons),function(button){return _c('a',{staticClass:"weui-btn",class:("weui-btn_" + (button.type)),attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.onClick(button.onClick, button.link)}}},[_vm._v(_vm._s(button.text))])}))],2)])])}
var msg_staticRenderFns = []
var msg_esExports = { render: msg_render, staticRenderFns: msg_staticRenderFns }
/* harmony default export */ var src_components_msg = (msg_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/msg/index.vue
function msg_injectStyle (ssrContext) {
  __webpack_require__("qKv7")
}
var msg_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var msg___vue_template_functional__ = false
/* styles */
var msg___vue_styles__ = msg_injectStyle
/* scopeId */
var msg___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var msg___vue_module_identifier__ = null
var msg_Component = msg_normalizeComponent(
  components_msg,
  src_components_msg,
  msg___vue_template_functional__,
  msg___vue_styles__,
  msg___vue_scopeId__,
  msg___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_msg = (msg_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/divider/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_divider = ({
  name: 'divider'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65b3ca5e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/divider/index.vue
var divider_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"vux-divider"},[_vm._t("default")],2)}
var divider_staticRenderFns = []
var divider_esExports = { render: divider_render, staticRenderFns: divider_staticRenderFns }
/* harmony default export */ var src_components_divider = (divider_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/divider/index.vue
function divider_injectStyle (ssrContext) {
  __webpack_require__("78BN")
}
var divider_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var divider___vue_template_functional__ = false
/* styles */
var divider___vue_styles__ = divider_injectStyle
/* scopeId */
var divider___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var divider___vue_module_identifier__ = null
var divider_Component = divider_normalizeComponent(
  components_divider,
  src_components_divider,
  divider___vue_template_functional__,
  divider___vue_styles__,
  divider___vue_scopeId__,
  divider___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_divider = (divider_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-button/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_button = ({
  name: 'x-button',
  props: {
    type: {
      default: 'default'
    },
    disabled: Boolean,
    mini: Boolean,
    plain: Boolean,
    text: String,
    actionType: String,
    showLoading: Boolean,
    link: [String, Object],
    gradients: {
      type: Array,
      validator: function validator(val) {
        return val.length === 2;
      }
    }
  },
  methods: {
    onClick: function onClick() {
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  computed: {
    noBorder: function noBorder() {
      return Array.isArray(this.gradients);
    },
    buttonStyle: function buttonStyle() {
      if (this.gradients) {
        return {
          background: 'linear-gradient(90deg, ' + this.gradients[0] + ', ' + this.gradients[1] + ')',
          color: '#FFFFFF'
        };
      }
    },
    classes: function classes() {
      return [{
        'weui-btn_disabled': !this.plain && this.disabled,
        'weui-btn_plain-disabled': this.plain && this.disabled,
        'weui-btn_mini': this.mini,
        'vux-x-button-no-border': this.noBorder
      }, !this.plain ? 'weui-btn_' + this.type : '', this.plain ? 'weui-btn_plain-' + this.type : '', this.showLoading ? 'weui-btn_loading' : ''];
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5f075ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-button/index.vue
var x_button_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"weui-btn",class:_vm.classes,style:(_vm.buttonStyle),attrs:{"disabled":_vm.disabled,"type":_vm.actionType},on:{"click":_vm.onClick}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.text))])],2)}
var x_button_staticRenderFns = []
var x_button_esExports = { render: x_button_render, staticRenderFns: x_button_staticRenderFns }
/* harmony default export */ var src_components_x_button = (x_button_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-button/index.vue
function x_button_injectStyle (ssrContext) {
  __webpack_require__("RMDY")
}
var x_button_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_button___vue_template_functional__ = false
/* styles */
var x_button___vue_styles__ = x_button_injectStyle
/* scopeId */
var x_button___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_button___vue_module_identifier__ = null
var x_button_Component = x_button_normalizeComponent(
  components_x_button,
  src_components_x_button,
  x_button___vue_template_functional__,
  x_button___vue_styles__,
  x_button___vue_scopeId__,
  x_button___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_button = (x_button_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/success.vue







/* harmony default export */ var success = ({
  components: {
    Msg: vux_src_components_msg,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      activeId: "",
      icon: "success",
      title: "提交成功",
      description: '您已经成功提交展商信息，请等待负责人通知。<br/>',
      buttons: [{
        type: "primary",
        text: "返回首页",
        link: "/"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.buttons[0].link = "/index/" + _this.activeId;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/success.vue







/* harmony default export */ var components_success = ({
  components: {
    Msg: vux_src_components_msg,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      activeId: "",
      icon: "success",
      title: "提交成功",
      description: '您已经成功提交展商信息，请等待负责人通知。<br/>',
      buttons: [{
        type: "primary",
        text: "返回首页",
        link: "/"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.buttons[0].link = "/index/" + _this.activeId;

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27585484","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/success.vue
var success_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msg',{attrs:{"title":_vm.title,"description":_vm.description,"buttons":_vm.buttons,"icon":_vm.icon}})],1)}
var success_staticRenderFns = []
var success_esExports = { render: success_render, staticRenderFns: success_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_success = (success_esExports);
// CONCATENATED MODULE: ./src/components/success.vue
function success_injectStyle (ssrContext) {
  __webpack_require__("ByaA")
}
var success_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var success___vue_template_functional__ = false
/* styles */
var success___vue_styles__ = success_injectStyle
/* scopeId */
var success___vue_scopeId__ = "data-v-27585484"
/* moduleIdentifier (server only) */
var success___vue_module_identifier__ = null
var success_Component = success_normalizeComponent(
  components_success,
  selectortype_template_index_0_src_components_success,
  success___vue_template_functional__,
  success___vue_styles__,
  success___vue_scopeId__,
  success___vue_module_identifier__
)

/* harmony default export */ var src_components_success = (success_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_login = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("KHby"),
      footerImg: __webpack_require__("nCxI"),
      logoImg: __webpack_require__("7Otq"),
      isDisabled: false,
      activeId: "",
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      addForm: {
        activeId: "",
        cellPhone: "",
        checkCode: ""
      }
    };
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.addForm.activeId = _this.activeId;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 跳转注册
     */
    goRegister: function goRegister() {
      this.$router.push({
        name: "choose",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "loginSelect", params: { activeId: this.activeId } });
    },

    /**
     * 登陆
     *
     */
    submitLogin: function submitLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var login, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.addForm.cellPhone) {
                  _context2.next = 3;
                  break;
                }

                _this2.showMsg("请输入手机号");
                return _context2.abrupt("return");

              case 3:
                if (!(!_this2.addForm.checkCode || _this2.addForm.checkCode.length != 6)) {
                  _context2.next = 6;
                  break;
                }

                _this2.showMsg("请输入正确的校验码");
                return _context2.abrupt("return");

              case 6:
                login = _this2.$apis.common.login;
                _context2.prev = 7;
                _context2.next = 10;
                return _this2.$axios.post(login, _this2.addForm);

              case 10:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 13;
                  break;
                }

                _context2.t0 = {};

              case 13:
                _ref = _context2.t0;
                data = _ref.data;

                localStorage.setItem('X_TOKEN', data.token);
                _this2.$router.push({
                  name: "info",
                  params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t1 = _context2["catch"](7);

                _this2.showMsg(_context2.t1);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 19]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.addForm.cellPhone) {
                  _context3.next = 3;
                  break;
                }

                _this3.showMsg("请先输入手机号！");
                return _context3.abrupt("return");

              case 3:
                if (!_this3.count) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:

                if (_this3.interval) {
                  clearInterval(_this3.interval);
                }
                _context3.prev = 6;
                getCheckCode = _this3.$apis.common.checkCode;
                _context3.next = 10;
                return _this3.$axios.get(getCheckCode + "/" + _this3.addForm.cellPhone + "/" + _this3.addForm.activeId + "/2");

              case 10:
                _this3.showMsg("短信发送成功！");
                _this3.count = 59;
                _this3.interval = setInterval(function () {
                  if (_this3.count <= 0) {
                    clearInterval(_this3.interval);
                    return;
                  }
                  return _this3.count--;
                }, 1000);
                _context3.next = 21;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);

                console.log(_context3.t0);
                if (_this3.interval) {
                  clearInterval(_this3.interval);
                }
                _this3.count = 0;
                _this3.showMsg("请先注册！");

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/login.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_components_login = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("KHby"),
      footerImg: __webpack_require__("nCxI"),
      logoImg: __webpack_require__("7Otq"),
      isDisabled: false,
      activeId: "",
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      addForm: {
        activeId: "",
        cellPhone: "",
        checkCode: ""
      }
    };
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.addForm.activeId = _this.activeId;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 跳转注册
     */
    goRegister: function goRegister() {
      this.$router.push({
        name: "choose",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "loginSelect", params: { activeId: this.activeId } });
    },

    /**
     * 登陆
     *
     */
    submitLogin: function submitLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var login, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.addForm.cellPhone) {
                  _context2.next = 3;
                  break;
                }

                _this2.showMsg("请输入手机号");
                return _context2.abrupt("return");

              case 3:
                if (!(!_this2.addForm.checkCode || _this2.addForm.checkCode.length != 6)) {
                  _context2.next = 6;
                  break;
                }

                _this2.showMsg("请输入正确的校验码");
                return _context2.abrupt("return");

              case 6:
                login = _this2.$apis.common.login;
                _context2.prev = 7;
                _context2.next = 10;
                return _this2.$axios.post(login, _this2.addForm);

              case 10:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 13;
                  break;
                }

                _context2.t0 = {};

              case 13:
                _ref = _context2.t0;
                data = _ref.data;

                localStorage.setItem('X_TOKEN', data.token);
                _this2.$router.push({
                  name: "info",
                  params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
                _context2.next = 22;
                break;

              case 19:
                _context2.prev = 19;
                _context2.t1 = _context2["catch"](7);

                _this2.showMsg(_context2.t1);

              case 22:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[7, 19]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this3.addForm.cellPhone) {
                  _context3.next = 3;
                  break;
                }

                _this3.showMsg("请先输入手机号！");
                return _context3.abrupt("return");

              case 3:
                if (!_this3.count) {
                  _context3.next = 5;
                  break;
                }

                return _context3.abrupt("return");

              case 5:

                if (_this3.interval) {
                  clearInterval(_this3.interval);
                }
                _context3.prev = 6;
                getCheckCode = _this3.$apis.common.checkCode;
                _context3.next = 10;
                return _this3.$axios.get(getCheckCode + "/" + _this3.addForm.cellPhone + "/" + _this3.addForm.activeId + "/2");

              case 10:
                _this3.showMsg("短信发送成功！");
                _this3.count = 59;
                _this3.interval = setInterval(function () {
                  if (_this3.count <= 0) {
                    clearInterval(_this3.interval);
                    return;
                  }
                  return _this3.count--;
                }, 1000);
                _context3.next = 21;
                break;

              case 15:
                _context3.prev = 15;
                _context3.t0 = _context3["catch"](6);

                console.log(_context3.t0);
                if (_this3.interval) {
                  clearInterval(_this3.interval);
                }
                _this3.count = 0;
                _this3.showMsg("请先注册！");

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d55ca16","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
var login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bg"},[_c('div',{staticClass:"footer"},[_c('img',{staticClass:"imgShow",attrs:{"src":_vm.footerImg}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.zhhlxh}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"login-body"},[_c('Form',{ref:"addForm",attrs:{"v-model":_vm.addForm}},[_c('group',{attrs:{"label-width":"3.5em","label-margin-right":"1em","label-align":"justify"}},[_c('x-input',{attrs:{"max":11,"is-type":"china-mobile","required":true,"placeholder":"请输入手机号"},model:{value:(_vm.addForm.cellPhone),callback:function ($$v) {_vm.$set(_vm.addForm, "cellPhone", $$v)},expression:"addForm.cellPhone"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"required":true,"placeholder":"请输入验证码"},model:{value:(_vm.addForm.checkCode),callback:function ($$v) {_vm.$set(_vm.addForm, "checkCode", $$v)},expression:"addForm.checkCode"}},[_c('x-button',{class:(!_vm.addForm.cellPhone || _vm.count) && 'disable-btn',attrs:{"slot":"right","plain":"","type":"primary","action-type":"button","mini":""},nativeOn:{"click":function($event){return _vm.getMobilCode()}},slot:"right"},[_vm._v(_vm._s(_vm.smsMessage))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{staticStyle:{"border-radius":"99px"},attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.submitLogin()}}},[_vm._v("登录")]),_vm._v(" "),_c('div',{staticClass:"btn-next"},[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goRegister()}}},[_vm._v("去报名")]),_vm._v("  | \n        "),_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])])],1)],1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var login_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-body"},[_c('span',{staticClass:"chinese"},[_vm._v("\n        技术支持：\n         易康维\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("登录")])])}]
var login_esExports = { render: login_render, staticRenderFns: login_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_login = (login_esExports);
// CONCATENATED MODULE: ./src/components/login.vue
function login_injectStyle (ssrContext) {
  __webpack_require__("OJg6")
}
var login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var login___vue_template_functional__ = false
/* styles */
var login___vue_styles__ = login_injectStyle
/* scopeId */
var login___vue_scopeId__ = "data-v-2d55ca16"
/* moduleIdentifier (server only) */
var login___vue_module_identifier__ = null
var login_Component = login_normalizeComponent(
  selectortype_script_index_0_src_components_login,
  selectortype_template_index_0_src_components_login,
  login___vue_template_functional__,
  login___vue_styles__,
  login___vue_scopeId__,
  login___vue_module_identifier__
)

/* harmony default export */ var src_components_login = (login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginSelect.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var loginSelect = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("KHby"),
      footerImg: __webpack_require__("nCxI"),
      logoImg: __webpack_require__("7Otq"),
      isDisabled: false,
      showGraph: false,
      activeId: "",
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      pdfSrc: "",
      planarGraph: "",
      addForm: {
        activeId: "",
        cellPhone: "",
        checkCode: ""
      }
    };
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.id;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.addForm.activeId = _this.activeId;
              _this.queryInfo(_this.activeId);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goHome: function goHome() {
      console.log(111);
      this.$router.push({
        name: "indexlist"
      });
    },

    /**
     * 获取提交信息
     *
     */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getMasterModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {
                  // 访问的活动不存在，返回到错误页面
                  _this2.$router.push({ name: "error" });
                }
                if (data.data) {
                  _this2.pdfSrc = data.data.zshPdf;
                  _this2.planarGraph = data.data.planarGraph ? data.data.planarGraph : _this2.planarGraph;
                }
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](1);

                console.log(_context2.t1);
                _this2.showMsg(_context2.t1.data.msg);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },

    /**
     * 查看招商函
     */
    goPdf: function goPdf() {
      this.$router.push({
        name: "pdfView",
        params: { activeId: this.activeId, pdfSrc: this.pdfSrc, pdfType: 'zsh' }
      });
    },

    /**
     * 跳转注册
     */
    goRegister: function goRegister() {
      this.$router.push({
        name: "choose",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 跳转注册页
     */
    goLogin: function goLogin() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var tokenCheck, _ref2, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 先校验是否有token，如果有就跳转到详情，如果没有就登陆页面
                tokenCheck = _this3.$apis.common.tokenCheck;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$axios.get(tokenCheck + "/" + _this3.activeId);

              case 4:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 7;
                  break;
                }

                _context3.t0 = {};

              case 7:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this3.$router.push({
                  name: "info",
                  params: { id: data.id, cellPhone: data.cellPhone }
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t1 = _context3["catch"](1);

                _this3.$router.push({
                  name: "login",
                  params: { activeId: _this3.activeId }
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 12]]);
      }))();
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "index", params: { id: this.activeId } });
    },

    /**
     * 登陆
     *
     */
    submitLogin: function submitLogin() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var login, _ref3, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.addForm.cellPhone) {
                  _context4.next = 3;
                  break;
                }

                _this4.showMsg("请输入手机号");
                return _context4.abrupt("return");

              case 3:
                if (!(!_this4.addForm.checkCode || _this4.addForm.checkCode.length != 6)) {
                  _context4.next = 6;
                  break;
                }

                _this4.showMsg("请输入正确的校验码");
                return _context4.abrupt("return");

              case 6:
                login = _this4.$apis.common.login;
                _context4.prev = 7;
                _context4.next = 10;
                return _this4.$axios.post(login, _this4.addForm);

              case 10:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 13;
                  break;
                }

                _context4.t0 = {};

              case 13:
                _ref3 = _context4.t0;
                data = _ref3.data;

                localStorage.setItem("X_TOKEN", data.token);
                _this4.$router.push({
                  name: "info",
                  params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
                _context4.next = 22;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4["catch"](7);

                _this4.showMsg(_context4.t1);

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[7, 19]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.addForm.cellPhone) {
                  _context5.next = 3;
                  break;
                }

                _this5.showMsg("请先输入手机号！");
                return _context5.abrupt("return");

              case 3:
                if (!_this5.count) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:

                if (_this5.interval) {
                  clearInterval(_this5.interval);
                }
                _context5.prev = 6;
                getCheckCode = _this5.$apis.common.checkCode;
                _context5.next = 10;
                return _this5.$axios.get(getCheckCode + "/" + _this5.addForm.cellPhone + "/" + _this5.addForm.activeId + "/2");

              case 10:
                _this5.showMsg("短信发送成功！");
                _this5.count = 59;
                _this5.interval = setInterval(function () {
                  if (_this5.count <= 0) {
                    clearInterval(_this5.interval);
                    return;
                  }
                  return _this5.count--;
                }, 1000);
                _context5.next = 21;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](6);

                console.log(_context5.t0);
                if (_this5.interval) {
                  clearInterval(_this5.interval);
                }
                _this5.count = 0;
                _this5.showMsg("请先注册！");

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/loginSelect.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_loginSelect = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("KHby"),
      footerImg: __webpack_require__("nCxI"),
      logoImg: __webpack_require__("7Otq"),
      isDisabled: false,
      showGraph: false,
      activeId: "",
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null,
      pdfSrc: "",
      planarGraph: "",
      addForm: {
        activeId: "",
        cellPhone: "",
        checkCode: ""
      }
    };
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.id;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _this.addForm.activeId = _this.activeId;
              _this.queryInfo(_this.activeId);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goHome: function goHome() {
      console.log(111);
      this.$router.push({
        name: "indexlist"
      });
    },

    /**
     * 获取提交信息
     *
     */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getMasterModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {
                  // 访问的活动不存在，返回到错误页面
                  _this2.$router.push({ name: "error" });
                }
                if (data.data) {
                  _this2.pdfSrc = data.data.zshPdf;
                  _this2.planarGraph = data.data.planarGraph ? data.data.planarGraph : _this2.planarGraph;
                }
                _context2.next = 17;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](1);

                console.log(_context2.t1);
                _this2.showMsg(_context2.t1.data.msg);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },

    /**
     * 查看招商函
     */
    goPdf: function goPdf() {
      this.$router.push({
        name: "pdfView",
        params: { activeId: this.activeId, pdfSrc: this.pdfSrc, pdfType: 'zsh' }
      });
    },

    /**
     * 跳转注册
     */
    goRegister: function goRegister() {
      this.$router.push({
        name: "choose",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 跳转注册页
     */
    goLogin: function goLogin() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var tokenCheck, _ref2, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // 先校验是否有token，如果有就跳转到详情，如果没有就登陆页面
                tokenCheck = _this3.$apis.common.tokenCheck;
                _context3.prev = 1;
                _context3.next = 4;
                return _this3.$axios.get(tokenCheck + "/" + _this3.activeId);

              case 4:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 7;
                  break;
                }

                _context3.t0 = {};

              case 7:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this3.$router.push({
                  name: "info",
                  params: { id: data.id, cellPhone: data.cellPhone }
                });
                _context3.next = 15;
                break;

              case 12:
                _context3.prev = 12;
                _context3.t1 = _context3["catch"](1);

                _this3.$router.push({
                  name: "login",
                  params: { activeId: _this3.activeId }
                });

              case 15:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[1, 12]]);
      }))();
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "index", params: { id: this.activeId } });
    },

    /**
     * 登陆
     *
     */
    submitLogin: function submitLogin() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var login, _ref3, data;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this4.addForm.cellPhone) {
                  _context4.next = 3;
                  break;
                }

                _this4.showMsg("请输入手机号");
                return _context4.abrupt("return");

              case 3:
                if (!(!_this4.addForm.checkCode || _this4.addForm.checkCode.length != 6)) {
                  _context4.next = 6;
                  break;
                }

                _this4.showMsg("请输入正确的校验码");
                return _context4.abrupt("return");

              case 6:
                login = _this4.$apis.common.login;
                _context4.prev = 7;
                _context4.next = 10;
                return _this4.$axios.post(login, _this4.addForm);

              case 10:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 13;
                  break;
                }

                _context4.t0 = {};

              case 13:
                _ref3 = _context4.t0;
                data = _ref3.data;

                localStorage.setItem("X_TOKEN", data.token);
                _this4.$router.push({
                  name: "info",
                  params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
                _context4.next = 22;
                break;

              case 19:
                _context4.prev = 19;
                _context4.t1 = _context4["catch"](7);

                _this4.showMsg(_context4.t1);

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[7, 19]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this5 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee5() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this5.addForm.cellPhone) {
                  _context5.next = 3;
                  break;
                }

                _this5.showMsg("请先输入手机号！");
                return _context5.abrupt("return");

              case 3:
                if (!_this5.count) {
                  _context5.next = 5;
                  break;
                }

                return _context5.abrupt("return");

              case 5:

                if (_this5.interval) {
                  clearInterval(_this5.interval);
                }
                _context5.prev = 6;
                getCheckCode = _this5.$apis.common.checkCode;
                _context5.next = 10;
                return _this5.$axios.get(getCheckCode + "/" + _this5.addForm.cellPhone + "/" + _this5.addForm.activeId + "/2");

              case 10:
                _this5.showMsg("短信发送成功！");
                _this5.count = 59;
                _this5.interval = setInterval(function () {
                  if (_this5.count <= 0) {
                    clearInterval(_this5.interval);
                    return;
                  }
                  return _this5.count--;
                }, 1000);
                _context5.next = 21;
                break;

              case 15:
                _context5.prev = 15;
                _context5.t0 = _context5["catch"](6);

                console.log(_context5.t0);
                if (_this5.interval) {
                  clearInterval(_this5.interval);
                }
                _this5.count = 0;
                _this5.showMsg("请先注册！");

              case 21:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, _this5, [[6, 15]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50e53c4c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginSelect.vue
var loginSelect_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bg"},[_c('x-header',{staticClass:"goBack",attrs:{"slot":"overwrite-left","left-options":{showBack: true, preventGoBack: true}},on:{"on-click-back":function($event){return _vm.goHome()}},slot:"overwrite-left"},[_vm._v("报名")]),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('img',{staticClass:"imgShow",attrs:{"src":_vm.footerImg}}),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.zhhlxh}})]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"login-body"},[_c('div',{staticClass:"btnShow"},[_c('x-button',{staticStyle:{"border-radius":"99px"},attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.goRegister()}}},[_vm._v("去报名")]),_vm._v(" "),_c('x-button',{staticStyle:{"border-radius":"99px"},attrs:{"plain":"","type":"primary","action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.goLogin()}}},[_vm._v("已报名")]),_vm._v(" "),_c('div',{staticClass:"btn-next"},[_c('a',{staticClass:"a-left",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goPdf()}}},[_vm._v("查看招商函")]),_vm._v(" "),_c('a',{staticClass:"a-center",attrs:{"href":"javascript:;"},on:{"click":function($event){_vm.showGraph = true}}},[_vm._v("展厅平面图")]),_vm._v(" "),_c('a',{staticClass:"a-right",attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])])],1)]),_vm._v(" "),_c('popup',{attrs:{"height":"100%"},model:{value:(_vm.showGraph),callback:function ($$v) {_vm.showGraph=$$v},expression:"showGraph"}},[_c('div',{staticClass:"popup1"},[_c('span',{staticClass:"vux-close close-site",on:{"click":function($event){_vm.showGraph = false}}})]),_vm._v(" "),_c('div',[(!_vm.planarGraph)?_c('span',{staticClass:"img-site",staticStyle:{"justify-content":"center"}},[_vm._v("尚未上传展厅平面图")]):_vm._e(),_vm._v(" "),_c('img',{staticClass:"img-site",attrs:{"src":_vm.planarGraph,"container":"#vux_view_box_body"}})])]),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var loginSelect_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer-body"},[_c('span',{staticClass:"chinese"},[_vm._v("\n        技术支持：\n         易康维\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"title"},[_c('span',[_vm._v("招商管理报名中心")])])}]
var loginSelect_esExports = { render: loginSelect_render, staticRenderFns: loginSelect_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_loginSelect = (loginSelect_esExports);
// CONCATENATED MODULE: ./src/components/loginSelect.vue
function loginSelect_injectStyle (ssrContext) {
  __webpack_require__("vNBe")
}
var loginSelect_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var loginSelect___vue_template_functional__ = false
/* styles */
var loginSelect___vue_styles__ = loginSelect_injectStyle
/* scopeId */
var loginSelect___vue_scopeId__ = "data-v-50e53c4c"
/* moduleIdentifier (server only) */
var loginSelect___vue_module_identifier__ = null
var loginSelect_Component = loginSelect_normalizeComponent(
  components_loginSelect,
  selectortype_template_index_0_src_components_loginSelect,
  loginSelect___vue_template_functional__,
  loginSelect___vue_styles__,
  loginSelect___vue_scopeId__,
  loginSelect___vue_module_identifier__
)

/* harmony default export */ var src_components_loginSelect = (loginSelect_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/choose.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var choose = ({
  data: function data() {
    var _addForm;

    return {
      showPositionValue: false,
      isActive: true,
      loading: false,
      isShow: true, // 已作废，之前捐赠的标志
      isDisabled: false,
      show: false,
      showApply: false,
      errorMsg: "",
      count: 0, // 倒计时
      inShowList: [{
        // title: '参展说明',
        desc: "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
        meta: {
          source: "展位5万元/个",
          date: "",
          other: "卫星会10万元/场/30min"
        }
      }],
      donateList: [{
        // title: '捐赠说明',
        desc: "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
      }],
      addForm: (_addForm = {
        // 参展选择
        activeId: "",
        supportOption: "参展",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        // 报名表填写字段
        id: ""
      }, defineProperty_default()(_addForm, "activeId", ""), defineProperty_default()(_addForm, "showCount", 0), defineProperty_default()(_addForm, "sateCount", 0), defineProperty_default()(_addForm, "remarks", ""), defineProperty_default()(_addForm, "userName", ""), defineProperty_default()(_addForm, "cellPhone", ""), defineProperty_default()(_addForm, "email", ""), defineProperty_default()(_addForm, "invoiceType", "专票"), defineProperty_default()(_addForm, "invoiceTitle", ""), defineProperty_default()(_addForm, "taxNo", ""), defineProperty_default()(_addForm, "tel", ""), defineProperty_default()(_addForm, "address", ""), defineProperty_default()(_addForm, "telAddress", ""), defineProperty_default()(_addForm, "bank", ""), defineProperty_default()(_addForm, "bcount", ""), defineProperty_default()(_addForm, "bankCount", ""), defineProperty_default()(_addForm, "mailAddress", ""), defineProperty_default()(_addForm, "dynamicCount", 0), defineProperty_default()(_addForm, "businessCount", 0), defineProperty_default()(_addForm, "sponsorCount", 0), defineProperty_default()(_addForm, "drink", 0), defineProperty_default()(_addForm, "teaBreak", 0), defineProperty_default()(_addForm, "guide", 0), defineProperty_default()(_addForm, "checkCode", ""), _addForm),
      rules: {
        supportOption: "请选择参与性质",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
        checkCode: "请输入验证码"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm.activeId = _this.$route.params.activeId;
              if (!_this.addForm.activeId) {
                _this.addForm.activeId = _this.$route.params.id;
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "login", params: { activeId: this.addForm.activeId } });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 参展
     *
     */
    inShow: function inShow() {
      this.isActive = true;
      this.addForm.supportOption = "参展";
    },

    /**
     * 下一步
     */
    inShowNext: function inShowNext() {
      if (!this.addForm.showCount && !this.addForm.sateCount) {
        this.showMsg("展位数和卫星会不能同时为空");
        return;
      }
      this.showApply = true;
      console.log(this.addForm);
      // this.$router.push({ name: "register", params: this.addForm });
    },

    /**
     * 上一步
     */
    inShowPrev: function inShowPrev() {
      this.showApply = false;
      // this.$router.push({ name: "register", params: this.addForm });
    },

    /**
     * 捐赠
     *
     */
    donate: function donate() {
      this.isActive = false;
      this.addForm.supportOption = "捐赠";
    },

    /**
     * 下一步
     */
    donateNext: function donateNext() {
      this.$router.push({ name: "register", params: this.addForm });
    },

    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.addForm.cellPhone) {
                  _context2.next = 3;
                  break;
                }

                _this2.showMsg("请先输入手机号！");
                return _context2.abrupt("return");

              case 3:
                if (_this2.isCellPhone(_this2.addForm.cellPhone)) {
                  _context2.next = 6;
                  break;
                }

                _this2.showMsg("请输入有效的手机号！");
                return _context2.abrupt("return");

              case 6:
                if (!_this2.count) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:

                if (_this2.interval) {
                  clearInterval(_this2.interval);
                }
                _context2.prev = 9;
                getCheckCode = _this2.$apis.common.checkCode;
                _context2.next = 13;
                return _this2.$axios.get(getCheckCode + "/" + _this2.addForm.cellPhone + "/" + _this2.addForm.activeId + "/1");

              case 13:
                _this2.showMsg("短信发送成功！");
                _this2.count = 59;
                _this2.interval = setInterval(function () {
                  if (_this2.count <= 0) {
                    clearInterval(_this2.interval);
                    return;
                  }
                  return _this2.count--;
                }, 1000);
                _context2.next = 24;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](9);

                console.log(_context2.t0.data.msg);
                if (_this2.interval) {
                  clearInterval(_this2.interval);
                }
                _this2.count = 0;
                _this2.showMsg(_context2.t0.data.msg);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 18]]);
      }))();
    },

    /** 
     * 报名表单取消提交操作
     */
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 报名表单确认提交
     */
    onConfirm: function onConfirm() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isDisabled = true;
                _this3.addForm.telAddress = _this3.addForm.tel + _this3.addForm.address;
                _this3.addForm.bankCount = _this3.addForm.bank + _this3.addForm.bcount;
                _this3.addForm.id = "";
                add = _this3.$apis.exhibition.add;
                _context3.prev = 5;
                _context3.next = 8;
                return _this3.$axios.post(add, _this3.addForm);

              case 8:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 11;
                  break;
                }

                _context3.t0 = {};

              case 11:
                _ref = _context3.t0;
                data = _ref.data;

                _this3.showMsg("提交成功！");
                localStorage.setItem('X_TOKEN', data.token);
                _this3.$router.push({
                  name: "success",
                  params: { activeId: _this3.addForm.activeId }
                });
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](5);

                _this3.showMsg(_context3.t1.data.msg);
                _this3.isDisabled = false;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 18]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var key;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = regenerator_default.a.keys(_this4.rules);

              case 1:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 8;
                  break;
                }

                key = _context4.t1.value;

                if (_this4.addForm[key]) {
                  _context4.next = 6;
                  break;
                }

                _this4.showMsg(_this4.rules[key]);
                // this.isDisabled = false;
                return _context4.abrupt("return");

              case 6:
                _context4.next = 1;
                break;

              case 8:
                _this4.show = true;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/choose.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_choose = ({
  data: function data() {
    var _addForm;

    return {
      showPositionValue: false,
      isActive: true,
      loading: false,
      isShow: true, // 已作废，之前捐赠的标志
      isDisabled: false,
      show: false,
      showApply: false,
      errorMsg: "",
      count: 0, // 倒计时
      inShowList: [{
        // title: '参展说明',
        desc: "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
        meta: {
          source: "展位5万元/个",
          date: "",
          other: "卫星会10万元/场/30min"
        }
      }],
      donateList: [{
        // title: '捐赠说明',
        desc: "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
      }],
      addForm: (_addForm = {
        // 参展选择
        activeId: "",
        supportOption: "参展",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        // 报名表填写字段
        id: ""
      }, defineProperty_default()(_addForm, "activeId", ""), defineProperty_default()(_addForm, "showCount", 0), defineProperty_default()(_addForm, "sateCount", 0), defineProperty_default()(_addForm, "remarks", ""), defineProperty_default()(_addForm, "userName", ""), defineProperty_default()(_addForm, "cellPhone", ""), defineProperty_default()(_addForm, "email", ""), defineProperty_default()(_addForm, "invoiceType", "专票"), defineProperty_default()(_addForm, "invoiceTitle", ""), defineProperty_default()(_addForm, "taxNo", ""), defineProperty_default()(_addForm, "tel", ""), defineProperty_default()(_addForm, "address", ""), defineProperty_default()(_addForm, "telAddress", ""), defineProperty_default()(_addForm, "bank", ""), defineProperty_default()(_addForm, "bcount", ""), defineProperty_default()(_addForm, "bankCount", ""), defineProperty_default()(_addForm, "mailAddress", ""), defineProperty_default()(_addForm, "dynamicCount", 0), defineProperty_default()(_addForm, "businessCount", 0), defineProperty_default()(_addForm, "sponsorCount", 0), defineProperty_default()(_addForm, "drink", 0), defineProperty_default()(_addForm, "teaBreak", 0), defineProperty_default()(_addForm, "guide", 0), defineProperty_default()(_addForm, "checkCode", ""), _addForm),
      rules: {
        supportOption: "请选择参与性质",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址",
        checkCode: "请输入验证码"
      }
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm.activeId = _this.$route.params.activeId;
              if (!_this.addForm.activeId) {
                _this.addForm.activeId = _this.$route.params.id;
              }

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  computed: {
    smsMessage: function smsMessage() {
      return this.count ? this.count + " \u79D2" : "获取验证码";
    }
  },
  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({ name: "login", params: { activeId: this.addForm.activeId } });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 参展
     *
     */
    inShow: function inShow() {
      this.isActive = true;
      this.addForm.supportOption = "参展";
    },

    /**
     * 下一步
     */
    inShowNext: function inShowNext() {
      if (!this.addForm.showCount && !this.addForm.sateCount) {
        this.showMsg("展位数和卫星会不能同时为空");
        return;
      }
      this.showApply = true;
      console.log(this.addForm);
      // this.$router.push({ name: "register", params: this.addForm });
    },

    /**
     * 上一步
     */
    inShowPrev: function inShowPrev() {
      this.showApply = false;
      // this.$router.push({ name: "register", params: this.addForm });
    },

    /**
     * 捐赠
     *
     */
    donate: function donate() {
      this.isActive = false;
      this.addForm.supportOption = "捐赠";
    },

    /**
     * 下一步
     */
    donateNext: function donateNext() {
      this.$router.push({ name: "register", params: this.addForm });
    },

    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },

    /**
     * 获取短信验证码
     * @return {Object} Promise
     */
    getMobilCode: function getMobilCode() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getCheckCode;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (_this2.addForm.cellPhone) {
                  _context2.next = 3;
                  break;
                }

                _this2.showMsg("请先输入手机号！");
                return _context2.abrupt("return");

              case 3:
                if (_this2.isCellPhone(_this2.addForm.cellPhone)) {
                  _context2.next = 6;
                  break;
                }

                _this2.showMsg("请输入有效的手机号！");
                return _context2.abrupt("return");

              case 6:
                if (!_this2.count) {
                  _context2.next = 8;
                  break;
                }

                return _context2.abrupt("return");

              case 8:

                if (_this2.interval) {
                  clearInterval(_this2.interval);
                }
                _context2.prev = 9;
                getCheckCode = _this2.$apis.common.checkCode;
                _context2.next = 13;
                return _this2.$axios.get(getCheckCode + "/" + _this2.addForm.cellPhone + "/" + _this2.addForm.activeId + "/1");

              case 13:
                _this2.showMsg("短信发送成功！");
                _this2.count = 59;
                _this2.interval = setInterval(function () {
                  if (_this2.count <= 0) {
                    clearInterval(_this2.interval);
                    return;
                  }
                  return _this2.count--;
                }, 1000);
                _context2.next = 24;
                break;

              case 18:
                _context2.prev = 18;
                _context2.t0 = _context2["catch"](9);

                console.log(_context2.t0.data.msg);
                if (_this2.interval) {
                  clearInterval(_this2.interval);
                }
                _this2.count = 0;
                _this2.showMsg(_context2.t0.data.msg);

              case 24:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[9, 18]]);
      }))();
    },

    /** 
     * 报名表单取消提交操作
     */
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 报名表单确认提交
     */
    onConfirm: function onConfirm() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.isDisabled = true;
                _this3.addForm.telAddress = _this3.addForm.tel + _this3.addForm.address;
                _this3.addForm.bankCount = _this3.addForm.bank + _this3.addForm.bcount;
                _this3.addForm.id = "";
                add = _this3.$apis.exhibition.add;
                _context3.prev = 5;
                _context3.next = 8;
                return _this3.$axios.post(add, _this3.addForm);

              case 8:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 11;
                  break;
                }

                _context3.t0 = {};

              case 11:
                _ref = _context3.t0;
                data = _ref.data;

                _this3.showMsg("提交成功！");
                localStorage.setItem('X_TOKEN', data.token);
                _this3.$router.push({
                  name: "success",
                  params: { activeId: _this3.addForm.activeId }
                });
                _context3.next = 22;
                break;

              case 18:
                _context3.prev = 18;
                _context3.t1 = _context3["catch"](5);

                _this3.showMsg(_context3.t1.data.msg);
                _this3.isDisabled = false;

              case 22:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[5, 18]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this4 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var key;
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.t0 = regenerator_default.a.keys(_this4.rules);

              case 1:
                if ((_context4.t1 = _context4.t0()).done) {
                  _context4.next = 8;
                  break;
                }

                key = _context4.t1.value;

                if (_this4.addForm[key]) {
                  _context4.next = 6;
                  break;
                }

                _this4.showMsg(_this4.rules[key]);
                // this.isDisabled = false;
                return _context4.abrupt("return");

              case 6:
                _context4.next = 1;
                break;

              case 8:
                _this4.show = true;

              case 9:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this4);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2393154a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/choose.vue
var choose_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.showApply)?_c('tab',{attrs:{"line-width":1}},[_c('tab-item',{attrs:{"selected":""},nativeOn:{"click":function($event){return _vm.inShow()}}},[_vm._v("参展")])],1):_vm._e(),_vm._v(" "),(_vm.isActive && !_vm.showApply)?_c('group',[_c('Form',{ref:"addForm",attrs:{"v-model":_vm.addForm}},[_c('group',{attrs:{"title":"展位需求","label-width":"5.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v("展位类别")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.exhibitionType),callback:function ($$v) {_vm.$set(_vm.addForm, "exhibitionType", $$v)},expression:"addForm.exhibitionType"}},[_c('checker-item',{attrs:{"value":"S"}},[_vm._v("标准展位")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"T"}},[_vm._v("特装展位")])],1)],1),_vm._v(" "),_c('x-number',{attrs:{"title":"展位数","align":"left","button-style":"round","min":0,"max":30},model:{value:(_vm.addForm.showCount),callback:function ($$v) {_vm.$set(_vm.addForm, "showCount", $$v)},expression:"addForm.showCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"卫星会","align":"left","button-style":"round","min":0,"max":20},model:{value:(_vm.addForm.sateCount),callback:function ($$v) {_vm.$set(_vm.addForm, "sateCount", $$v)},expression:"addForm.sateCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"动态展示页","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.dynamicCount),callback:function ($$v) {_vm.$set(_vm.addForm, "dynamicCount", $$v)},expression:"addForm.dynamicCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"企业展示页","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.businessCount),callback:function ($$v) {_vm.$set(_vm.addForm, "businessCount", $$v)},expression:"addForm.businessCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"网络赞助商","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.sponsorCount),callback:function ($$v) {_vm.$set(_vm.addForm, "sponsorCount", $$v)},expression:"addForm.sponsorCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"大会饮水","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.drink),callback:function ($$v) {_vm.$set(_vm.addForm, "drink", $$v)},expression:"addForm.drink"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"会议茶歇","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.teaBreak),callback:function ($$v) {_vm.$set(_vm.addForm, "teaBreak", $$v)},expression:"addForm.teaBreak"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"会议指引牌","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.guide),callback:function ($$v) {_vm.$set(_vm.addForm, "guide", $$v)},expression:"addForm.guide"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"其他需求","placeholder":"请填写其他需求信息","show-counter":false,"rows":3},model:{value:(_vm.addForm.remarks),callback:function ($$v) {_vm.$set(_vm.addForm, "remarks", $$v)},expression:"addForm.remarks"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"button"},nativeOn:{"click":function($event){return _vm.inShowNext()}}},[_vm._v("下一步")]),_vm._v(" "),_c('x-button',{attrs:{"plain":"","type":"primary","action-type":"button"},nativeOn:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])],1)],1):_vm._e(),_vm._v(" "),(!_vm.isActive)?_c('group',[_c('panel',{attrs:{"header":"捐赠说明","list":_vm.donateList}}),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"button"},nativeOn:{"click":function($event){return _vm.donateNext()}}},[_vm._v("下一步")]),_vm._v(" "),_c('x-button',{attrs:{"plain":"","type":"primary","action-type":"button"},nativeOn:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])],1)],1):_vm._e(),_vm._v(" "),(_vm.showApply)?_c('div',{staticClass:"content"},[_c('Form',{ref:"addForm",attrs:{"v-model":_vm.addForm}},[_c('group',{attrs:{"title":"联系信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('x-input',{attrs:{"title":"","placeholder":"请输入联系人姓名","required":true},model:{value:(_vm.addForm.userName),callback:function ($$v) {_vm.$set(_vm.addForm, "userName", $$v)},expression:"addForm.userName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"","max":11,"is-type":"china-mobile","required":true,"placeholder":"请输入联系手机号"},model:{value:(_vm.addForm.cellPhone),callback:function ($$v) {_vm.$set(_vm.addForm, "cellPhone", $$v)},expression:"addForm.cellPhone"}}),_vm._v(" "),_c('x-input',{staticClass:"weui-vcode",attrs:{"title":"","placeholder":"请输入验证码","required":true},model:{value:(_vm.addForm.checkCode),callback:function ($$v) {_vm.$set(_vm.addForm, "checkCode", $$v)},expression:"addForm.checkCode"}},[_c('x-button',{class:(!_vm.addForm.cellPhone || _vm.count) && 'disable-btn',attrs:{"slot":"right","gradients":['#1eb5b5', '#1eb5b5'],"type":"primary","action-type":"button","mini":""},nativeOn:{"click":function($event){return _vm.getMobilCode()}},slot:"right"},[_vm._v(_vm._s(_vm.smsMessage))])],1),_vm._v(" "),_c('x-input',{attrs:{"title":"","is-type":"email","required":true,"placeholder":"请输入联系邮箱"},model:{value:(_vm.addForm.email),callback:function ($$v) {_vm.$set(_vm.addForm, "email", $$v)},expression:"addForm.email"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"开票信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v(_vm._s(_vm.isShow ? '发票类别' : '财政专用票据'))]),_vm._v(" "),(_vm.isShow)?_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.invoiceType),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceType", $$v)},expression:"addForm.invoiceType"}},[_c('checker-item',{attrs:{"value":"专票"}},[_vm._v("专票")])],1)],1):_vm._e(),_vm._v(" "),_c('x-input',{ref:"refCode",attrs:{"title":"","placeholder":"请输入发票抬头","required":""},model:{value:(_vm.addForm.invoiceTitle),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceTitle", $$v)},expression:"addForm.invoiceTitle"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"","min":15,"max":18,"placeholder":"请输入税号","required":""},model:{value:(_vm.addForm.taxNo),callback:function ($$v) {_vm.$set(_vm.addForm, "taxNo", $$v)},expression:"addForm.taxNo"}}),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入地址","required":""},model:{value:(_vm.addForm.address),callback:function ($$v) {_vm.$set(_vm.addForm, "address", $$v)},expression:"addForm.address"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入电话","required":""},model:{value:(_vm.addForm.tel),callback:function ($$v) {_vm.$set(_vm.addForm, "tel", $$v)},expression:"addForm.tel"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入开户银行","required":""},model:{value:(_vm.addForm.bank),callback:function ($$v) {_vm.$set(_vm.addForm, "bank", $$v)},expression:"addForm.bank"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"","placeholder":"请输入账号","required":""},model:{value:(_vm.addForm.bcount),callback:function ($$v) {_vm.$set(_vm.addForm, "bcount", $$v)},expression:"addForm.bcount"}}):_vm._e(),_vm._v(" "),_c('x-textarea',{attrs:{"placeholder":"请输入发票邮寄地址","show-counter":false,"rows":3,"required":true},model:{value:(_vm.addForm.mailAddress),callback:function ($$v) {_vm.$set(_vm.addForm, "mailAddress", $$v)},expression:"addForm.mailAddress"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"primary","gradients":['#909399', '#909399'],"action-type":"button"},nativeOn:{"click":function($event){return _vm.inShowPrev()}}},[_vm._v("上一步")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","gradients":['#1eb5b5', '#1eb5b5'],"action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.submitAdd()}}},[_vm._v("提交")])],1)],1):_vm._e(),_vm._v(" "),_c('div',[_c('confirm',{attrs:{"title":"提交确认"},on:{"on-cancel":_vm.onCancel,"on-confirm":_vm.onConfirm,"on-show":_vm.onShow,"on-hide":_vm.onHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("确定提交?")])])],1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var choose_staticRenderFns = []
var choose_esExports = { render: choose_render, staticRenderFns: choose_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_choose = (choose_esExports);
// CONCATENATED MODULE: ./src/components/choose.vue
function choose_injectStyle (ssrContext) {
  __webpack_require__("Klsc")
}
var choose_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var choose___vue_template_functional__ = false
/* styles */
var choose___vue_styles__ = choose_injectStyle
/* scopeId */
var choose___vue_scopeId__ = "data-v-2393154a"
/* moduleIdentifier (server only) */
var choose___vue_module_identifier__ = null
var choose_Component = choose_normalizeComponent(
  components_choose,
  selectortype_template_index_0_src_components_choose,
  choose___vue_template_functional__,
  choose___vue_styles__,
  choose___vue_scopeId__,
  choose___vue_module_identifier__
)

/* harmony default export */ var src_components_choose = (choose_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/info.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var info = ({
  data: function data() {
    return {
      isShow: false,
      show: false,
      showMenus: false,
      menus: { menu1: "修改" },
      showList: [],
      contactList: [],
      invoiceList: [],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0
      },
      inShowList: [{
        // title: '参展说明',
        desc: "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
        meta: {
          source: "展位5万元/个",
          date: "",
          other: "卫星会10万元/场/30min"
        }
      }],
      donateList: [{
        // title: '捐赠说明',
        desc: "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm.id = _this.$route.params.id;
              _this.addForm.cellPhone = _this.$route.params.cellPhone;
              _context.next = 4;
              return _this.queryInfo(_this.$route.params.id);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.addForm.activeId }
      });
    },

    /**
     * 获取提交信息
     *
     */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.addForm = data;
                _this2.modelInit();
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1.data.msg);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },

    /**
     * 修改跳转
     *
     */
    editClick: function editClick() {
      console.log("修改");
      this.$router.push({
        name: "edit",
        params: this.addForm
      });
    },

    /**
     * 数据初始化
     *
     */
    modelInit: function modelInit() {
      this.showList.push({
        label: "参与性质",
        value: this.addForm.supportOption
      });
      if (this.addForm.supportOption === '参展') {
        this.isShow = true;
        if (this.addForm.exhibitionType === "S") {
          this.showList.push({ label: "展位类别", value: "标准展位" });
        } else {
          this.showList.push({ label: "展位类别", value: "特装展位" });
        }
        this.showList.push({
          label: "展位数",
          value: this.addForm.showCount
        });
        this.showList.push({
          label: "卫星会",
          value: this.addForm.sateCount
        });
        this.showList.push({
          label: "动态展示页",
          value: this.addForm.dynamicCount
        });
        this.showList.push({
          label: "企业展示页",
          value: this.addForm.businessCount
        });
        this.showList.push({
          label: "网络赞助商",
          value: this.addForm.sponsorCount
        });
        this.showList.push({
          label: "大会饮水",
          value: this.addForm.drink
        });
        this.showList.push({
          label: "会议茶歇",
          value: this.addForm.teaBreak
        });
        this.showList.push({
          label: "会议指引牌",
          value: this.addForm.guide
        });
        this.showList.push({
          label: "其他需求",
          value: this.addForm.remarks
        });
      }

      this.contactList.push({
        label: "姓名",
        value: this.addForm.userName
      });
      this.contactList.push({
        label: "联系手机",
        value: this.addForm.cellPhone
      });
      this.contactList.push({ label: "邮箱", value: this.addForm.email });

      this.invoiceList.push({
        label: "发票类别",
        value: this.addForm.invoiceType
      });
      this.invoiceList.push({
        label: "抬头",
        value: this.addForm.invoiceTitle
      });
      this.invoiceList.push({ label: "税号", value: this.addForm.taxNo });
      if (this.addForm.supportOption === '参展') {
        this.invoiceList.push({
          label: "地址电话",
          value: this.addForm.telAddress
        });
        this.invoiceList.push({
          label: "银行账号",
          value: this.addForm.bankCount
        });
      }
      this.invoiceList.push({
        label: "邮寄地址",
        value: this.addForm.mailAddress
      });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/info.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_info = ({
  data: function data() {
    return {
      isShow: false,
      show: false,
      showMenus: false,
      menus: { menu1: "修改" },
      showList: [],
      contactList: [],
      invoiceList: [],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0
      },
      inShowList: [{
        // title: '参展说明',
        desc: "展位规格3m*3m，特装展位需自付特装费，标准展位免费提供一桌两凳。",
        meta: {
          source: "展位5万元/个",
          date: "",
          other: "卫星会10万元/场/30min"
        }
      }],
      donateList: [{
        // title: '捐赠说明',
        desc: "捐赠不提供任何形式的展览或卫星会，捐赠前务必明确捐赠类型，可具体咨询学会负责人。"
      }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm.id = _this.$route.params.id;
              _this.addForm.cellPhone = _this.$route.params.cellPhone;
              _context.next = 4;
              return _this.queryInfo(_this.$route.params.id);

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.addForm.activeId }
      });
    },

    /**
     * 获取提交信息
     *
     */
    queryInfo: function queryInfo(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.addForm = data;
                _this2.modelInit();
                _context2.next = 16;
                break;

              case 13:
                _context2.prev = 13;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1.data.msg);

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 13]]);
      }))();
    },

    /**
     * 修改跳转
     *
     */
    editClick: function editClick() {
      console.log("修改");
      this.$router.push({
        name: "edit",
        params: this.addForm
      });
    },

    /**
     * 数据初始化
     *
     */
    modelInit: function modelInit() {
      this.showList.push({
        label: "参与性质",
        value: this.addForm.supportOption
      });
      if (this.addForm.supportOption === '参展') {
        this.isShow = true;
        if (this.addForm.exhibitionType === "S") {
          this.showList.push({ label: "展位类别", value: "标准展位" });
        } else {
          this.showList.push({ label: "展位类别", value: "特装展位" });
        }
        this.showList.push({
          label: "展位数",
          value: this.addForm.showCount
        });
        this.showList.push({
          label: "卫星会",
          value: this.addForm.sateCount
        });
        this.showList.push({
          label: "动态展示页",
          value: this.addForm.dynamicCount
        });
        this.showList.push({
          label: "企业展示页",
          value: this.addForm.businessCount
        });
        this.showList.push({
          label: "网络赞助商",
          value: this.addForm.sponsorCount
        });
        this.showList.push({
          label: "大会饮水",
          value: this.addForm.drink
        });
        this.showList.push({
          label: "会议茶歇",
          value: this.addForm.teaBreak
        });
        this.showList.push({
          label: "会议指引牌",
          value: this.addForm.guide
        });
        this.showList.push({
          label: "其他需求",
          value: this.addForm.remarks
        });
      }

      this.contactList.push({
        label: "姓名",
        value: this.addForm.userName
      });
      this.contactList.push({
        label: "联系手机",
        value: this.addForm.cellPhone
      });
      this.contactList.push({ label: "邮箱", value: this.addForm.email });

      this.invoiceList.push({
        label: "发票类别",
        value: this.addForm.invoiceType
      });
      this.invoiceList.push({
        label: "抬头",
        value: this.addForm.invoiceTitle
      });
      this.invoiceList.push({ label: "税号", value: this.addForm.taxNo });
      if (this.addForm.supportOption === '参展') {
        this.invoiceList.push({
          label: "地址电话",
          value: this.addForm.telAddress
        });
        this.invoiceList.push({
          label: "银行账号",
          value: this.addForm.bankCount
        });
      }
      this.invoiceList.push({
        label: "邮寄地址",
        value: this.addForm.mailAddress
      });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-632087a6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/info.vue
var info_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('x-header',{attrs:{"left-options":{showBack: false},"right-options":{showMore: true}},on:{"on-click-more":function($event){_vm.showMenus = true}}},[_vm._v("信息")]),_vm._v(" "),(!_vm.isShow)?_c('panel',{attrs:{"header":"捐赠说明","list":_vm.donateList}}):_vm._e(),_vm._v(" "),_c('form-preview',{attrs:{"header-label":"参与信息","header-value":"","body-items":_vm.showList}}),_vm._v(" "),_c('form-preview',{attrs:{"header-label":"联系信息","header-value":"","body-items":_vm.contactList}}),_vm._v(" "),_c('form-preview',{attrs:{"header-label":"发票信息","header-value":"","body-items":_vm.invoiceList}}),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"primary","action-type":"button"},nativeOn:{"click":function($event){return _vm.editClick()}}},[_vm._v("修改")]),_vm._v(" "),_c('x-button',{attrs:{"plain":"","type":"primary","action-type":"button"},nativeOn:{"click":function($event){return _vm.goback()}}},[_vm._v("返回")])],1),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom"}]},[_c('actionsheet',{attrs:{"menus":_vm.menus,"show-cancel":""},on:{"on-click-menu":_vm.editClick},model:{value:(_vm.showMenus),callback:function ($$v) {_vm.showMenus=$$v},expression:"showMenus"}})],1)],1)}
var info_staticRenderFns = []
var info_esExports = { render: info_render, staticRenderFns: info_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_info = (info_esExports);
// CONCATENATED MODULE: ./src/components/info.vue
function info_injectStyle (ssrContext) {
  __webpack_require__("GnSU")
}
var info_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var info___vue_template_functional__ = false
/* styles */
var info___vue_styles__ = info_injectStyle
/* scopeId */
var info___vue_scopeId__ = "data-v-632087a6"
/* moduleIdentifier (server only) */
var info___vue_module_identifier__ = null
var info_Component = info_normalizeComponent(
  components_info,
  selectortype_template_index_0_src_components_info,
  info___vue_template_functional__,
  info___vue_styles__,
  info___vue_scopeId__,
  info___vue_module_identifier__
)

/* harmony default export */ var src_components_info = (info_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/edit.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var edit = ({
  data: function data() {
    return {
      isShow: false,
      show: false,
      loading: false,
      isDisabled: false,
      topImg: __webpack_require__("hSo9"),
      logoImg: __webpack_require__("7Otq"),
      typeList: ["标准展位", "特装展位"],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0
      },
      rules: {
        supportOption: "请选择参与性质",
        exhibitionType: "请选择展位类别",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址"
      },
      // showListNum: [["0", "1", "2", "3", "4", "5"]],
      // sateListNum: [["0", "1", "2", "3"]],
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null

    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm = _this.$route.params;
              if (!_this.addForm.id) {
                _this.$router.push({
                  name: "info"
                  // params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
              }
              if (_this.addForm.supportOption === '参展') {
                _this.isShow = true;
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 确认提交
     */
    onConfirm: function onConfirm() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isDisabled = true;
                add = _this2.$apis.exhibition.update;
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.$axios.post(add, _this2.addForm);

              case 5:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 8;
                  break;
                }

                _context2.t0 = {};

              case 8:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg("提交成功！");
                _this2.$router.push({
                  name: "info",
                  params: _this2.addForm
                });
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](2);

                _this2.showMsg(_context2.t1.data.msg);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 14]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var key;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = regenerator_default.a.keys(_this3.rules);

              case 1:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 9;
                  break;
                }

                key = _context3.t1.value;

                if (_this3.addForm[key]) {
                  _context3.next = 7;
                  break;
                }

                _this3.showMsg(_this3.rules[key]);
                _this3.isDisabled = false;
                return _context3.abrupt("return");

              case 7:
                _context3.next = 1;
                break;

              case 9:
                _this3.show = true;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * 取消修改
     */
    cancel: function cancel() {
      this.$router.push({
        name: "info"
        // params: { id: data.data.id, cellPhone: data.data.cellPhone }
      });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/edit.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_edit = ({
  data: function data() {
    return {
      isShow: false,
      show: false,
      loading: false,
      isDisabled: false,
      topImg: __webpack_require__("hSo9"),
      logoImg: __webpack_require__("7Otq"),
      typeList: ["标准展位", "特装展位"],
      addForm: {
        id: "",
        activeId: "",
        supportOption: "",
        exhibitionType: "",
        showCount: 0,
        sateCount: 0,
        remarks: "",
        userName: "",
        cellPhone: "",
        email: "",
        invoiceType: "",
        invoiceTitle: "",
        taxNo: "",
        telAddress: "",
        bankCount: "",
        mailAddress: "",
        dynamicCount: 0,
        businessCount: 0,
        sponsorCount: 0,
        drink: 0,
        teaBreak: 0,
        guide: 0
      },
      rules: {
        supportOption: "请选择参与性质",
        exhibitionType: "请选择展位类别",
        userName: "请输入联系人姓名",
        cellPhone: "请输入手机号",
        email: "请输入邮箱",
        invoiceType: "请选择发票类别",
        invoiceTitle: "请输入发票抬头",
        taxNo: "请输入税号",
        mailAddress: "请输入发票邮寄地址"
      },
      // showListNum: [["0", "1", "2", "3", "4", "5"]],
      // sateListNum: [["0", "1", "2", "3"]],
      showPositionValue: false,
      errorMsg: "",
      position: "",
      count: 0, // 倒计时
      interval: null

    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.addForm = _this.$route.params;
              if (!_this.addForm.id) {
                _this.$router.push({
                  name: "info"
                  // params: { id: data.data.id, cellPhone: data.data.cellPhone }
                });
              }
              if (_this.addForm.supportOption === '参展') {
                _this.isShow = true;
              }

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    //检查手机号
    isCellPhone: function isCellPhone(val) {
      if (!/^1(3|4|5|6|7|8)\d{9}$/.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    onCancel: function onCancel() {
      console.log("on cancel");
    },

    /**
     * 确认提交
     */
    onConfirm: function onConfirm() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var add, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.isDisabled = true;
                add = _this2.$apis.exhibition.update;
                _context2.prev = 2;
                _context2.next = 5;
                return _this2.$axios.post(add, _this2.addForm);

              case 5:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 8;
                  break;
                }

                _context2.t0 = {};

              case 8:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg("提交成功！");
                _this2.$router.push({
                  name: "info",
                  params: _this2.addForm
                });
                _context2.next = 17;
                break;

              case 14:
                _context2.prev = 14;
                _context2.t1 = _context2["catch"](2);

                _this2.showMsg(_context2.t1.data.msg);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[2, 14]]);
      }))();
    },
    onHide: function onHide() {
      console.log("on hide");
    },
    onShow: function onShow() {
      console.log("on show");
    },

    /**
     * 提交报名数据
     *
     */
    submitAdd: function submitAdd() {
      var _this3 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var key;
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.t0 = regenerator_default.a.keys(_this3.rules);

              case 1:
                if ((_context3.t1 = _context3.t0()).done) {
                  _context3.next = 9;
                  break;
                }

                key = _context3.t1.value;

                if (_this3.addForm[key]) {
                  _context3.next = 7;
                  break;
                }

                _this3.showMsg(_this3.rules[key]);
                _this3.isDisabled = false;
                return _context3.abrupt("return");

              case 7:
                _context3.next = 1;
                break;

              case 9:
                _this3.show = true;

              case 10:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },

    /**
     * 取消修改
     */
    cancel: function cancel() {
      this.$router.push({
        name: "info"
        // params: { id: data.data.id, cellPhone: data.data.cellPhone }
      });
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30a6849c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit.vue
var edit_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('x-header',{staticClass:"goBack",attrs:{"slot":"overwrite-left"},slot:"overwrite-left"},[_vm._v("报名信息修改")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('Form',{ref:"addForm",attrs:{"v-model":_vm.addForm}},[(!_vm.isShow)?_c('group',{attrs:{"title":"展位需求","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v("参与性质")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.supportOption),callback:function ($$v) {_vm.$set(_vm.addForm, "supportOption", $$v)},expression:"addForm.supportOption"}},[(_vm.isShow)?_c('checker-item',{attrs:{"value":"参展"}},[_vm._v("参展")]):_vm._e(),_vm._v(" "),_c('checker-item',{attrs:{"value":"捐赠"}},[_vm._v("捐赠")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('group',{attrs:{"title":"展位需求","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v("参与性质")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.supportOption),callback:function ($$v) {_vm.$set(_vm.addForm, "supportOption", $$v)},expression:"addForm.supportOption"}},[(_vm.isShow)?_c('checker-item',{attrs:{"value":"参展"}},[_vm._v("参展")]):_vm._e(),_vm._v(" "),(!_vm.isShow)?_c('checker-item',{attrs:{"value":"捐赠"}},[_vm._v("捐赠")]):_vm._e()],1)],1),_vm._v(" "),_c('divider',[_vm._v("展位类别")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.exhibitionType),callback:function ($$v) {_vm.$set(_vm.addForm, "exhibitionType", $$v)},expression:"addForm.exhibitionType"}},[_c('checker-item',{attrs:{"value":"S"}},[_vm._v("标准展位")]),_vm._v(" "),_c('checker-item',{attrs:{"value":"T"}},[_vm._v("特装展位")])],1)],1),_vm._v(" "),_c('x-number',{attrs:{"title":"展位数","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.showCount),callback:function ($$v) {_vm.$set(_vm.addForm, "showCount", $$v)},expression:"addForm.showCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"卫星会","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.sateCount),callback:function ($$v) {_vm.$set(_vm.addForm, "sateCount", $$v)},expression:"addForm.sateCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"动态展示页","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.dynamicCount),callback:function ($$v) {_vm.$set(_vm.addForm, "dynamicCount", $$v)},expression:"addForm.dynamicCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"企业展示页","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.businessCount),callback:function ($$v) {_vm.$set(_vm.addForm, "businessCount", $$v)},expression:"addForm.businessCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"网络赞助商","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.sponsorCount),callback:function ($$v) {_vm.$set(_vm.addForm, "sponsorCount", $$v)},expression:"addForm.sponsorCount"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"大会饮水","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.drink),callback:function ($$v) {_vm.$set(_vm.addForm, "drink", $$v)},expression:"addForm.drink"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"会议茶歇","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.teaBreak),callback:function ($$v) {_vm.$set(_vm.addForm, "teaBreak", $$v)},expression:"addForm.teaBreak"}}),_vm._v(" "),_c('x-number',{attrs:{"title":"会议指引牌","align":"left","button-style":"round","min":0,"max":5},model:{value:(_vm.addForm.guide),callback:function ($$v) {_vm.$set(_vm.addForm, "guide", $$v)},expression:"addForm.guide"}}),_vm._v(" "),_c('x-textarea',{attrs:{"title":"其他需求","placeholder":"请填写其他需求信息","show-counter":false,"rows":3},model:{value:(_vm.addForm.remarks),callback:function ($$v) {_vm.$set(_vm.addForm, "remarks", $$v)},expression:"addForm.remarks"}})],1):_vm._e(),_vm._v(" "),_c('group',{attrs:{"title":"联系信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('x-input',{attrs:{"title":"姓名","placeholder":"请输入联系人姓名","required":true},model:{value:(_vm.addForm.userName),callback:function ($$v) {_vm.$set(_vm.addForm, "userName", $$v)},expression:"addForm.userName"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"手机号","max":11,"readonly":true,"is-type":"china-mobile","required":true,"placeholder":"请输入联系手机号"},model:{value:(_vm.addForm.cellPhone),callback:function ($$v) {_vm.$set(_vm.addForm, "cellPhone", $$v)},expression:"addForm.cellPhone"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"邮箱","is-type":"email","required":true,"placeholder":"请输入联系邮箱"},model:{value:(_vm.addForm.email),callback:function ($$v) {_vm.$set(_vm.addForm, "email", $$v)},expression:"addForm.email"}})],1),_vm._v(" "),_c('group',{attrs:{"title":"开票信息","label-width":"4.5em","label-margin-right":"2em","label-align":"justify"}},[_c('divider',[_vm._v("发票类别")]),_vm._v(" "),_c('div',{staticClass:"box"},[_c('checker',{attrs:{"default-item-class":"demo5-item","selected-item-class":"demo5-item-selected"},model:{value:(_vm.addForm.invoiceType),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceType", $$v)},expression:"addForm.invoiceType"}},[(_vm.isShow)?_c('checker-item',{attrs:{"value":"专票"}},[_vm._v("专票")]):_vm._e(),_vm._v(" "),(!_vm.isShow)?_c('checker-item',{attrs:{"value":"财政专用票据"}},[_vm._v("财政票据")]):_vm._e()],1)],1),_vm._v(" "),_c('x-input',{ref:"refCode",attrs:{"title":"发票抬头","placeholder":"请输入发票抬头"},model:{value:(_vm.addForm.invoiceTitle),callback:function ($$v) {_vm.$set(_vm.addForm, "invoiceTitle", $$v)},expression:"addForm.invoiceTitle"}}),_vm._v(" "),_c('x-input',{attrs:{"title":"税号","min":15,"max":18,"placeholder":"请输入税号"},model:{value:(_vm.addForm.taxNo),callback:function ($$v) {_vm.$set(_vm.addForm, "taxNo", $$v)},expression:"addForm.taxNo"}}),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"地址电话","placeholder":"请输入地址、电话"},model:{value:(_vm.addForm.telAddress),callback:function ($$v) {_vm.$set(_vm.addForm, "telAddress", $$v)},expression:"addForm.telAddress"}}):_vm._e(),_vm._v(" "),(_vm.isShow)?_c('x-input',{attrs:{"title":"银行账号","placeholder":"请输入开户银行、账号"},model:{value:(_vm.addForm.bankCount),callback:function ($$v) {_vm.$set(_vm.addForm, "bankCount", $$v)},expression:"addForm.bankCount"}}):_vm._e(),_vm._v(" "),_c('x-textarea',{attrs:{"title":"邮寄地址","placeholder":"请输入发票邮寄地址","show-counter":false,"rows":3,"required":true},model:{value:(_vm.addForm.mailAddress),callback:function ($$v) {_vm.$set(_vm.addForm, "mailAddress", $$v)},expression:"addForm.mailAddress"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('x-button',{attrs:{"type":"cancel","gradients":['#E6A23C', '#E6A23C'],"action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.cancel()}}},[_vm._v("取消")]),_vm._v(" "),_c('x-button',{attrs:{"type":"primary","action-type":"submit","disabled":_vm.isDisabled},nativeOn:{"click":function($event){return _vm.submitAdd()}}},[_vm._v("提交")])],1)],1),_vm._v(" "),_c('div',[_c('confirm',{attrs:{"title":"提交确认"},on:{"on-cancel":_vm.onCancel,"on-confirm":_vm.onConfirm,"on-show":_vm.onShow,"on-hide":_vm.onHide},model:{value:(_vm.show),callback:function ($$v) {_vm.show=$$v},expression:"show"}},[_c('p',{staticStyle:{"text-align":"center"}},[_vm._v("确定提交?")])])],1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}}),_vm._v(" "),_vm._m(0)],1)}
var edit_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"chinese"},[_vm._v("\n      技术支持：\n       易康维\n    ")])])}]
var edit_esExports = { render: edit_render, staticRenderFns: edit_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_edit = (edit_esExports);
// CONCATENATED MODULE: ./src/components/edit.vue
function edit_injectStyle (ssrContext) {
  __webpack_require__("e8KX")
}
var edit_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var edit___vue_template_functional__ = false
/* styles */
var edit___vue_styles__ = edit_injectStyle
/* scopeId */
var edit___vue_scopeId__ = "data-v-30a6849c"
/* moduleIdentifier (server only) */
var edit___vue_module_identifier__ = null
var edit_Component = edit_normalizeComponent(
  components_edit,
  selectortype_template_index_0_src_components_edit,
  edit___vue_template_functional__,
  edit___vue_styles__,
  edit___vue_scopeId__,
  edit___vue_module_identifier__
)

/* harmony default export */ var src_components_edit = (edit_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/error.vue







/* harmony default export */ var error = ({
  components: {
    Msg: vux_src_components_msg,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      activeId: "",
      icon: "warn",
      title: "访问错误",
      description: '您访问的活动不存在！'

    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/error.vue







/* harmony default export */ var components_error = ({
  components: {
    Msg: vux_src_components_msg,
    Divider: vux_src_components_divider,
    XButton: vux_src_components_x_button
  },
  data: function data() {
    return {
      activeId: "",
      icon: "warn",
      title: "访问错误",
      description: '您访问的活动不存在！'

    };
  },
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07f51a24","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/error.vue
var error_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('msg',{attrs:{"title":_vm.title,"description":_vm.description,"icon":_vm.icon}})],1)}
var error_staticRenderFns = []
var error_esExports = { render: error_render, staticRenderFns: error_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_error = (error_esExports);
// CONCATENATED MODULE: ./src/components/error.vue
function error_injectStyle (ssrContext) {
  __webpack_require__("mZb/")
}
var error_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var error___vue_template_functional__ = false
/* styles */
var error___vue_styles__ = error_injectStyle
/* scopeId */
var error___vue_scopeId__ = "data-v-07f51a24"
/* moduleIdentifier (server only) */
var error___vue_module_identifier__ = null
var error_Component = error_normalizeComponent(
  components_error,
  selectortype_template_index_0_src_components_error,
  error___vue_template_functional__,
  error___vue_styles__,
  error___vue_scopeId__,
  error___vue_module_identifier__
)

/* harmony default export */ var src_components_error = (error_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/indexlist.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var indexlist = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("rrtQ"),
      logoImg: __webpack_require__("7Otq"),
      zsList: [],
      disabled: false,
      showPositionValue: false,
      loading: false,
      overLoading: false,
      errorMsg: "",
      type: "1",
      footer: {
        title: "more"
        // url: 'http://vux.li'
      },
      list: [],
      count: 0,
      allPageCount: 0,
      pageInfo: {
        pageSize: 5,
        pageIndex: 1
      },
      searchFilter: {
        param: "",
        isBefore: 1,
        activeYear: String(new Date().getFullYear())
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.queryList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 选择tab更新数据
     */
    onItemClick: function onItemClick(index) {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        this.$refs.scrollerBottom.reset({ top: 0 });
        this.searchFilter.isBefore = index + 1;
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
        this.loading = false;
      }
    },

    /**
     * 下拉加载
     */
    onScroll: function onScroll(pos) {
      this.scrollTop = pos.top;
    },

    /**
     * 上拉加载
     *
     */
    onScrollBottom: function onScrollBottom() {
      var _this2 = this;

      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        if (this.allPageCount > this.pageInfo.pageIndex) {
          this.pageInfo.pageIndex = this.pageInfo.pageIndex + 1;
          this.queryList();
          setTimeout(function () {
            _this2.loading = false;
          }, 2000);
        } else {
          this.loading = false;
          this.overLoading = true;
          setTimeout(function () {
            _this2.overLoading = false;
          }, 1200);
        }
      }
    },

    /**
     * 获取所有活动信息
     *
     */
    queryList: function queryList() {
      var _this3 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, params, _ref, data, i, val;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                list = _this3.$apis.exhibition.list;
                params = assign_default()({}, _this3.pageInfo, _this3.searchFilter, param);
                _context2.prev = 3;
                _context2.next = 6;
                return _this3.$axios.post(list, params);

              case 6:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 9;
                  break;
                }

                _context2.t0 = {};

              case 9:
                _ref = _context2.t0;
                data = _ref.data;

                _this3.count = data.count;
                _this3.allPageCount = Math.ceil(data.count / _this3.pageInfo.pageSize);
                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this3.list.push({
                    src: val.activePicUrl ? val.activePicUrl : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.activeName,
                    desc: val.startDate + "~" + val.endDate,
                    url: "/index/" + val.id
                  });
                }
                _this3.loading = false;
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](3);

                _this3.showMsg(_context2.t1.data.msg);
                _this3.loading = false;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 17]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/indexlist.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_indexlist = ({
  data: function data() {
    return {
      zhhlxh: __webpack_require__("rrtQ"),
      logoImg: __webpack_require__("7Otq"),
      zsList: [],
      disabled: false,
      showPositionValue: false,
      loading: false,
      overLoading: false,
      errorMsg: "",
      type: "1",
      footer: {
        title: "more"
        // url: 'http://vux.li'
      },
      list: [],
      count: 0,
      allPageCount: 0,
      pageInfo: {
        pageSize: 5,
        pageIndex: 1
      },
      searchFilter: {
        param: "",
        isBefore: 1,
        activeYear: String(new Date().getFullYear())
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.queryList();

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 选择tab更新数据
     */
    onItemClick: function onItemClick(index) {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        this.$refs.scrollerBottom.reset({ top: 0 });
        this.searchFilter.isBefore = index + 1;
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
        this.loading = false;
      }
    },

    /**
     * 下拉加载
     */
    onScroll: function onScroll(pos) {
      this.scrollTop = pos.top;
    },

    /**
     * 上拉加载
     *
     */
    onScrollBottom: function onScrollBottom() {
      var _this2 = this;

      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        if (this.allPageCount > this.pageInfo.pageIndex) {
          this.pageInfo.pageIndex = this.pageInfo.pageIndex + 1;
          this.queryList();
          setTimeout(function () {
            _this2.loading = false;
          }, 2000);
        } else {
          this.loading = false;
          this.overLoading = true;
          setTimeout(function () {
            _this2.overLoading = false;
          }, 1200);
        }
      }
    },

    /**
     * 获取所有活动信息
     *
     */
    queryList: function queryList() {
      var _this3 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var list, params, _ref, data, i, val;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.loading = true;
                list = _this3.$apis.exhibition.list;
                params = assign_default()({}, _this3.pageInfo, _this3.searchFilter, param);
                _context2.prev = 3;
                _context2.next = 6;
                return _this3.$axios.post(list, params);

              case 6:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 9;
                  break;
                }

                _context2.t0 = {};

              case 9:
                _ref = _context2.t0;
                data = _ref.data;

                _this3.count = data.count;
                _this3.allPageCount = Math.ceil(data.count / _this3.pageInfo.pageSize);
                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this3.list.push({
                    src: val.activePicUrl ? val.activePicUrl : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.activeName,
                    desc: val.startDate + "~" + val.endDate,
                    url: "/index/" + val.id
                  });
                }
                _this3.loading = false;
                _context2.next = 21;
                break;

              case 17:
                _context2.prev = 17;
                _context2.t1 = _context2["catch"](3);

                _this3.showMsg(_context2.t1.data.msg);
                _this3.loading = false;

              case 21:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[3, 17]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e14dba0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/indexlist.vue
var indexlist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bg"},[_c('div',{staticClass:"btnShow"},[_c('div',{staticStyle:{"height":"44px"}},[_c('sticky',{ref:"sticky",attrs:{"scroll-box":"vux_view_box_body","offset":46,"check-sticky-support":false,"disabled":_vm.disabled}},[_c('tab',{attrs:{"line-width":1}},[_c('tab-item',{attrs:{"selected":""},on:{"on-item-click":_vm.onItemClick}},[_vm._v("近期活动")]),_vm._v(" "),_c('tab-item',{on:{"on-item-click":_vm.onItemClick}},[_vm._v("往期活动")])],1)],1),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","height":"460px","scroll-bottom-offst":200},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_c('panel',{attrs:{"list":_vm.list,"type":_vm.type}}),_vm._v(" "),(_vm.loading)?_c('load-more',{attrs:{"tip":"正在加载"}}):_vm._e(),_vm._v(" "),(_vm.overLoading)?_c('load-more',{attrs:{"show-loading":false,"tip":"已经到底啦","background-color":"#fbf9fe"}}):_vm._e()],1)])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var indexlist_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"chinese"},[_vm._v("\n      技术支持：\n       易康维\n    ")])])}]
var indexlist_esExports = { render: indexlist_render, staticRenderFns: indexlist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_indexlist = (indexlist_esExports);
// CONCATENATED MODULE: ./src/components/indexlist.vue
function indexlist_injectStyle (ssrContext) {
  __webpack_require__("A61V")
}
var indexlist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var indexlist___vue_template_functional__ = false
/* styles */
var indexlist___vue_styles__ = indexlist_injectStyle
/* scopeId */
var indexlist___vue_scopeId__ = "data-v-6e14dba0"
/* moduleIdentifier (server only) */
var indexlist___vue_module_identifier__ = null
var indexlist_Component = indexlist_normalizeComponent(
  components_indexlist,
  selectortype_template_index_0_src_components_indexlist,
  indexlist___vue_template_functional__,
  indexlist___vue_styles__,
  indexlist___vue_scopeId__,
  indexlist___vue_module_identifier__
)

/* harmony default export */ var src_components_indexlist = (indexlist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/storelist.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var storelist = ({
  data: function data() {
    return {
      activeId: "",
      zhhlxh: __webpack_require__("rrtQ"),
      logoImg: __webpack_require__("7Otq"),
      zsList: [],
      disabled: false,
      showPositionValue: false,
      loading: false,
      overLoading: false,
      errorMsg: "",
      type: "5",
      footer: {
        title: "more"
        // url: 'http://vux.li'
      },
      results: [],
      list: [],
      count: 0,
      allPageCount: 0,
      pageInfo: {
        pageSize: 5,
        pageIndex: 1
      },
      searchFilter: {
        param: "",
        activeId: "",
        activeYear: String(new Date().getFullYear())
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _context.next = 4;
              return _this.queryTopSwiper(_this.activeId);

            case 4:
              _context.next = 6;
              return _this.queryList();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * @Description: 获取轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 20:39:17
     */
    queryTopSwiper: function queryTopSwiper(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var url, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = _this2.$apis.exhibition.getSwiper;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(url + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.handlerZsList(data);
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1.data.msg);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 12]]);
      }))();
    },


    /**
     * @Description: 处理下轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 17:45:32
     */
    handlerZsList: function handlerZsList(swipers) {
      var temList = new Array();
      if (swipers) {
        for (var i = 0; i < swipers.length; i++) {
          var temp = {};
          temp.img = swipers[i].url;
          this.zsList[i] = temp;
        }
      }
    },
    resultClick: function resultClick(item) {
      this.searchFilter.param = item.title;
      this.list = [];
      this.pageInfo.pageSize = 5;
      this.pageInfo.pageIndex = 1;
      this.queryList();
    },

    /**
     * 搜索数据
     */
    getResult: function getResult(val) {
      if (val) {
        this.searchFilter.param = val;
        this.results = [];
        this.searchList();
      } else {}
    },
    onCancel: function onCancel() {
      if (this.loading) {
        // do nothing
      } else {
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
      }
    },
    onFocus: function onFocus() {},
    onSubmit: function onSubmit() {
      console.log("aaaa");
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: "text",
        position: "top",
        text: "on submit"
      });
    },

    /**
     * 选择tab更新数据
     */
    onItemClick: function onItemClick(index) {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        this.$refs.scrollerBottom.reset({ top: 0 });
        this.searchFilter.isBefore = index + 1;
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
        this.loading = false;
      }
    },

    /**
     * 下拉加载
     */
    onScroll: function onScroll(pos) {
      this.scrollTop = pos.top;
    },

    /**
     * 上拉加载
     *
     */
    onScrollBottom: function onScrollBottom() {
      var _this3 = this;

      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        if (this.allPageCount > this.pageInfo.pageIndex) {
          this.pageInfo.pageIndex = this.pageInfo.pageIndex + 1;
          this.queryList();
          setTimeout(function () {
            _this3.loading = false;
          }, 2000);
        } else {
          this.loading = false;
          this.overLoading = true;
          setTimeout(function () {
            _this3.overLoading = false;
          }, 1200);
        }
      }
    },

    /**
     * 获取所有活动信息
     *
     */
    queryList: function queryList() {
      var _this4 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var list, params, _ref2, data, i, val;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = true;
                list = _this4.$apis.exhibition.stores;
                params = assign_default()({}, _this4.pageInfo, _this4.searchFilter, param);
                _context3.prev = 3;
                _context3.next = 6;
                return _this4.$axios.post(list, params);

              case 6:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 9;
                  break;
                }

                _context3.t0 = {};

              case 9:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this4.count = data.count;
                _this4.allPageCount = Math.ceil(data.count / _this4.pageInfo.pageSize);
                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this4.list.push({
                    src: val.storeLogo ? val.storeLogo : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.storeName,
                    desc: val.content,
                    url: "/storedetail/" + val.id + "/" + val.activeId,
                    meta: {
                      source: "展位",
                      date: val.storeLocation,
                      other: ""
                    }
                  });
                }
                _this4.loading = false;
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t1 = _context3["catch"](3);

                _this4.showMsg(_context3.t1.data.msg);
                _this4.loading = false;

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 17]]);
      }))();
    },

    /**
     * 获取所有活动信息
     *
     */
    searchList: function searchList() {
      var _this5 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var list, params, _ref3, data, i, val;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                list = _this5.$apis.exhibition.stores;
                params = assign_default()({}, _this5.pageInfo, _this5.searchFilter, param);
                _context4.prev = 3;
                _context4.next = 6;
                return _this5.$axios.post(list, params);

              case 6:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 9;
                  break;
                }

                _context4.t0 = {};

              case 9:
                _ref3 = _context4.t0;
                data = _ref3.data;

                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this5.results.push({
                    src: val.storeLogo ? val.storeLogo : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.storeName,
                    desc: val.content,
                    url: "/index/" + val.id
                  });
                  _this5.loading = false;
                }
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t1 = _context4["catch"](3);

                _this5.showMsg(_context4.t1.data.msg);
                _this5.loading = false;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 14]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/storelist.vue



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_storelist = ({
  data: function data() {
    return {
      activeId: "",
      zhhlxh: __webpack_require__("rrtQ"),
      logoImg: __webpack_require__("7Otq"),
      zsList: [],
      disabled: false,
      showPositionValue: false,
      loading: false,
      overLoading: false,
      errorMsg: "",
      type: "5",
      footer: {
        title: "more"
        // url: 'http://vux.li'
      },
      results: [],
      list: [],
      count: 0,
      allPageCount: 0,
      pageInfo: {
        pageSize: 5,
        pageIndex: 1
      },
      searchFilter: {
        param: "",
        activeId: "",
        activeYear: String(new Date().getFullYear())
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              _context.next = 4;
              return _this.queryTopSwiper(_this.activeId);

            case 4:
              _context.next = 6;
              return _this.queryList();

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * @Description: 获取轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 20:39:17
     */
    queryTopSwiper: function queryTopSwiper(id) {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var url, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                url = _this2.$apis.exhibition.getSwiper;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(url + "/" + id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.handlerZsList(data);
                _context2.next = 15;
                break;

              case 12:
                _context2.prev = 12;
                _context2.t1 = _context2["catch"](1);

                _this2.showMsg(_context2.t1.data.msg);

              case 15:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 12]]);
      }))();
    },


    /**
     * @Description: 处理下轮播
     * @Param:
     * @Author: chen_yong
     * @Version: 1.0.0
     * @Date: 2020-07-31 17:45:32
     */
    handlerZsList: function handlerZsList(swipers) {
      var temList = new Array();
      if (swipers) {
        for (var i = 0; i < swipers.length; i++) {
          var temp = {};
          temp.img = swipers[i].url;
          this.zsList[i] = temp;
        }
      }
    },
    resultClick: function resultClick(item) {
      this.searchFilter.param = item.title;
      this.list = [];
      this.pageInfo.pageSize = 5;
      this.pageInfo.pageIndex = 1;
      this.queryList();
    },

    /**
     * 搜索数据
     */
    getResult: function getResult(val) {
      if (val) {
        this.searchFilter.param = val;
        this.results = [];
        this.searchList();
      } else {}
    },
    onCancel: function onCancel() {
      if (this.loading) {
        // do nothing
      } else {
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
      }
    },
    onFocus: function onFocus() {},
    onSubmit: function onSubmit() {
      console.log("aaaa");
      this.$refs.search.setBlur();
      this.$vux.toast.show({
        type: "text",
        position: "top",
        text: "on submit"
      });
    },

    /**
     * 选择tab更新数据
     */
    onItemClick: function onItemClick(index) {
      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        this.$refs.scrollerBottom.reset({ top: 0 });
        this.searchFilter.isBefore = index + 1;
        this.list = [];
        this.pageInfo.pageSize = 5;
        this.pageInfo.pageIndex = 1;
        this.queryList();
        this.loading = false;
      }
    },

    /**
     * 下拉加载
     */
    onScroll: function onScroll(pos) {
      this.scrollTop = pos.top;
    },

    /**
     * 上拉加载
     *
     */
    onScrollBottom: function onScrollBottom() {
      var _this3 = this;

      if (this.loading) {
        // do nothing
      } else {
        this.loading = true;
        if (this.allPageCount > this.pageInfo.pageIndex) {
          this.pageInfo.pageIndex = this.pageInfo.pageIndex + 1;
          this.queryList();
          setTimeout(function () {
            _this3.loading = false;
          }, 2000);
        } else {
          this.loading = false;
          this.overLoading = true;
          setTimeout(function () {
            _this3.overLoading = false;
          }, 1200);
        }
      }
    },

    /**
     * 获取所有活动信息
     *
     */
    queryList: function queryList() {
      var _this4 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee3() {
        var list, params, _ref2, data, i, val;

        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = true;
                list = _this4.$apis.exhibition.stores;
                params = assign_default()({}, _this4.pageInfo, _this4.searchFilter, param);
                _context3.prev = 3;
                _context3.next = 6;
                return _this4.$axios.post(list, params);

              case 6:
                _context3.t0 = _context3.sent;

                if (_context3.t0) {
                  _context3.next = 9;
                  break;
                }

                _context3.t0 = {};

              case 9:
                _ref2 = _context3.t0;
                data = _ref2.data;

                _this4.count = data.count;
                _this4.allPageCount = Math.ceil(data.count / _this4.pageInfo.pageSize);
                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this4.list.push({
                    src: val.storeLogo ? val.storeLogo : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.storeName,
                    desc: val.content,
                    url: "/storedetail/" + val.id + "/" + val.activeId,
                    meta: {
                      source: "展位",
                      date: val.storeLocation,
                      other: ""
                    }
                  });
                }
                _this4.loading = false;
                _context3.next = 21;
                break;

              case 17:
                _context3.prev = 17;
                _context3.t1 = _context3["catch"](3);

                _this4.showMsg(_context3.t1.data.msg);
                _this4.loading = false;

              case 21:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4, [[3, 17]]);
      }))();
    },

    /**
     * 获取所有活动信息
     *
     */
    searchList: function searchList() {
      var _this5 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee4() {
        var list, params, _ref3, data, i, val;

        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this5.loading = true;
                list = _this5.$apis.exhibition.stores;
                params = assign_default()({}, _this5.pageInfo, _this5.searchFilter, param);
                _context4.prev = 3;
                _context4.next = 6;
                return _this5.$axios.post(list, params);

              case 6:
                _context4.t0 = _context4.sent;

                if (_context4.t0) {
                  _context4.next = 9;
                  break;
                }

                _context4.t0 = {};

              case 9:
                _ref3 = _context4.t0;
                data = _ref3.data;

                for (i = 0; i < data.list.length; i++) {
                  val = data.list[i];

                  _this5.results.push({
                    src: val.storeLogo ? val.storeLogo : "1",
                    fallbackSrc: "https://nursevideo.oss-cn-beijing.aliyuncs.com/common/piclose.png",
                    title: val.storeName,
                    desc: val.content,
                    url: "/index/" + val.id
                  });
                  _this5.loading = false;
                }
                _context4.next = 18;
                break;

              case 14:
                _context4.prev = 14;
                _context4.t1 = _context4["catch"](3);

                _this5.showMsg(_context4.t1.data.msg);
                _this5.loading = false;

              case 18:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[3, 14]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413478e8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/storelist.vue
var storelist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bg"},[_c('x-header',{attrs:{"left-options":{showBack: true}},on:{"on-click-back":function($event){return _vm.goback()}}},[_vm._v("展商介绍")]),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('div',{staticStyle:{"height":"44px"}},[_c('sticky',{ref:"sticky",attrs:{"scroll-box":"vux_view_box_body","offset":46,"check-sticky-support":false,"disabled":_vm.disabled}},[_c('search',{ref:"search",attrs:{"results":_vm.results,"position":"fixed","auto-scroll-to-top":"","top":"190px","placeholder":"搜索"},on:{"result-click":_vm.resultClick,"on-change":_vm.getResult,"on-focus":_vm.onFocus,"on-cancel":_vm.onCancel,"on-submit":_vm.onSubmit}})],1),_vm._v(" "),_c('scroller',{ref:"scrollerBottom",attrs:{"lock-x":"","height":"460px","scroll-bottom-offst":200},on:{"on-scroll-bottom":_vm.onScrollBottom}},[_c('div',{staticClass:"box2"},[_c('panel',{attrs:{"list":_vm.list,"type":_vm.type}}),_vm._v(" "),(_vm.loading)?_c('load-more',{attrs:{"tip":"正在加载"}}):_vm._e(),_vm._v(" "),(_vm.overLoading)?_c('load-more',{attrs:{"show-loading":false,"tip":"已经到底啦","background-color":"#fbf9fe"}}):_vm._e()],1)])],1)]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var storelist_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"chinese"},[_vm._v("\n      技术支持：\n       易康维\n    ")])])}]
var storelist_esExports = { render: storelist_render, staticRenderFns: storelist_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_storelist = (storelist_esExports);
// CONCATENATED MODULE: ./src/components/storelist.vue
function storelist_injectStyle (ssrContext) {
  __webpack_require__("wl8b")
}
var storelist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var storelist___vue_template_functional__ = false
/* styles */
var storelist___vue_styles__ = storelist_injectStyle
/* scopeId */
var storelist___vue_scopeId__ = "data-v-413478e8"
/* moduleIdentifier (server only) */
var storelist___vue_module_identifier__ = null
var storelist_Component = storelist_normalizeComponent(
  components_storelist,
  selectortype_template_index_0_src_components_storelist,
  storelist___vue_template_functional__,
  storelist___vue_styles__,
  storelist___vue_scopeId__,
  storelist___vue_module_identifier__
)

/* harmony default export */ var src_components_storelist = (storelist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/storedetail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var storedetail = ({
  data: function data() {
    return {
      locationImg: __webpack_require__("TL5K"),
      emailImg: __webpack_require__("wF+D"),
      officialImg: __webpack_require__("u46b"),
      cellPhoneImg: __webpack_require__("quyP"),
      logoImg: __webpack_require__("7Otq"),
      storeLogo: "",
      id: "",
      activeId: "",
      disabled: false,
      showPositionValue: false,
      loading: false,
      errorMsg: "",
      addForm: {
        storeName: "",
        content: "",
        storeLogo: "",
        address: "",
        email: ""
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.id = _this.$route.params.id;
              _this.activeId = _this.$route.params.activeId;
              _context.next = 4;
              return _this.queryInfo();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "storelist",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 获取所有活动信息
     *
     */
    queryInfo: function queryInfo() {
      var _this2 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getStoreModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + _this2.id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {
                  // 访问的活动不存在，返回到错误页面
                  _this2.$router.push({ name: "error" });
                }
                _this2.addForm = data;
                _this2.storeLogo = data.storeLogo;
                console.log(data);
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t1 = _context2["catch"](1);

                console.log(_context2.t1);
                _this2.showMsg(_context2.t1.data.msg);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 15]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/storedetail.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_storedetail = ({
  data: function data() {
    return {
      locationImg: __webpack_require__("TL5K"),
      emailImg: __webpack_require__("wF+D"),
      officialImg: __webpack_require__("u46b"),
      cellPhoneImg: __webpack_require__("quyP"),
      logoImg: __webpack_require__("7Otq"),
      storeLogo: "",
      id: "",
      activeId: "",
      disabled: false,
      showPositionValue: false,
      loading: false,
      errorMsg: "",
      addForm: {
        storeName: "",
        content: "",
        storeLogo: "",
        address: "",
        email: ""
      }
    };
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.id = _this.$route.params.id;
              _this.activeId = _this.$route.params.activeId;
              _context.next = 4;
              return _this.queryInfo();

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "storelist",
        params: { activeId: this.activeId }
      });
    },

    /**
     * 获取所有活动信息
     *
     */
    queryInfo: function queryInfo() {
      var _this2 = this;

      var param = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var getModel, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                getModel = _this2.$apis.exhibition.getStoreModel;
                _context2.prev = 1;
                _context2.next = 4;
                return _this2.$axios.get(getModel + "/" + _this2.id);

              case 4:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 7;
                  break;
                }

                _context2.t0 = {};

              case 7:
                _ref = _context2.t0;
                data = _ref.data;

                if (!data) {
                  // 访问的活动不存在，返回到错误页面
                  _this2.$router.push({ name: "error" });
                }
                _this2.addForm = data;
                _this2.storeLogo = data.storeLogo;
                console.log(data);
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t1 = _context2["catch"](1);

                console.log(_context2.t1);
                _this2.showMsg(_context2.t1.data.msg);

              case 19:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[1, 15]]);
      }))();
    },

    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-411475b4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/storedetail.vue
var storedetail_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"body-bg"},[_c('x-header',{staticClass:"goBack",attrs:{"slot":"overwrite-left"},on:{"on-click-back":function($event){return _vm.goback()}},slot:"overwrite-left"},[_vm._v("展商信息")]),_vm._v(" "),_c('div',{staticClass:"btnShow"},[_c('div',{staticClass:"body-head"},[_c('img',{attrs:{"src":_vm.storeLogo}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(this.addForm.storeName))])]),_vm._v(" "),_c('div',{staticClass:"body-line"}),_vm._v(" "),_c('div',{staticClass:"body-addr"},[_c('img',{attrs:{"src":_vm.locationImg}}),_vm._v(" "),_c('span',[_vm._v("地址："+_vm._s(this.addForm.address))])]),_vm._v(" "),_c('div',{staticClass:"body-line"}),_vm._v(" "),_c('div',{staticClass:"body-addr"},[_c('img',{attrs:{"src":_vm.cellPhoneImg}}),_vm._v(" "),_c('span',[_vm._v("电话："+_vm._s(this.addForm.cellPhone))])]),_vm._v(" "),_c('div',{staticClass:"body-linedash"}),_vm._v(" "),_c('div',{staticClass:"body-addr"},[_c('img',{attrs:{"src":_vm.emailImg}}),_vm._v(" "),_c('span',[_vm._v("邮箱："+_vm._s(this.addForm.email))])]),_vm._v(" "),_c('div',{staticClass:"body-linedash"}),_vm._v(" "),_c('div',{staticClass:"body-addr"},[_c('img',{attrs:{"src":_vm.officialImg}}),_vm._v(" "),_c('span',[_vm._v("官网："),_c('a',{attrs:{"href":this.addForm.officialUrl}},[_vm._v(_vm._s(this.addForm.officialUrl))])])]),_vm._v(" "),_c('div',{staticClass:"body-line"}),_vm._v(" "),_c('div',{staticClass:"body-detail"},[_c('span',[_vm._v("公司简介")]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('span',[_vm._v(_vm._s(this.addForm.content))])])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var storedetail_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_c('span',{staticClass:"chinese"},[_vm._v("\n      技术支持：\n       易康维\n    ")])])}]
var storedetail_esExports = { render: storedetail_render, staticRenderFns: storedetail_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_storedetail = (storedetail_esExports);
// CONCATENATED MODULE: ./src/components/storedetail.vue
function storedetail_injectStyle (ssrContext) {
  __webpack_require__("bVX/")
}
var storedetail_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var storedetail___vue_template_functional__ = false
/* styles */
var storedetail___vue_styles__ = storedetail_injectStyle
/* scopeId */
var storedetail___vue_scopeId__ = "data-v-411475b4"
/* moduleIdentifier (server only) */
var storedetail___vue_module_identifier__ = null
var storedetail_Component = storedetail_normalizeComponent(
  components_storedetail,
  selectortype_template_index_0_src_components_storedetail,
  storedetail___vue_template_functional__,
  storedetail___vue_styles__,
  storedetail___vue_scopeId__,
  storedetail___vue_module_identifier__
)

/* harmony default export */ var src_components_storedetail = (storedetail_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-pdf/src/componentFactory.js
var componentFactory = __webpack_require__("iwQb");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pdf/src/vuePdfNoSss.vue
//




if (Object({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var pdfjsWrapper = __webpack_require__("ytml").default;
	var PDFJS = __webpack_require__("nKpR");

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var PdfjsWorker = __webpack_require__("ahHh");
		PDFJS.GlobalWorkerOptions.workerPort = new PdfjsWorker();
	}

	var component = Object(componentFactory["a" /* default */])(pdfjsWrapper(PDFJS));
} else {

	var component = Object(componentFactory["a" /* default */])({});
}

/* harmony default export */ var vuePdfNoSss = (component);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-pdf/src/vuePdfNoSss.vue
//




if (Object({"NODE_ENV":"production"}).VUE_ENV !== 'server') {

	var vuePdfNoSss_pdfjsWrapper = __webpack_require__("ytml").default;
	var vuePdfNoSss_PDFJS = __webpack_require__("nKpR");

	if (typeof window !== 'undefined' && 'Worker' in window && navigator.appVersion.indexOf('MSIE 10') === -1) {

		var vuePdfNoSss_PdfjsWorker = __webpack_require__("ahHh");
		vuePdfNoSss_PDFJS.GlobalWorkerOptions.workerPort = new vuePdfNoSss_PdfjsWorker();
	}

	var vuePdfNoSss_component = Object(componentFactory["a" /* default */])(vuePdfNoSss_pdfjsWrapper(vuePdfNoSss_PDFJS));
} else {

	var vuePdfNoSss_component = Object(componentFactory["a" /* default */])({});
}

/* harmony default export */ var src_vuePdfNoSss = (vuePdfNoSss_component);
// CONCATENATED MODULE: ./node_modules/vue-pdf/src/vuePdfNoSss.vue
function vuePdfNoSss_injectStyle (ssrContext) {
  __webpack_require__("1qEj")
}
var vuePdfNoSss_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var vuePdfNoSss___vue_template_functional__ = false
/* styles */
var vuePdfNoSss___vue_styles__ = vuePdfNoSss_injectStyle
/* scopeId */
var vuePdfNoSss___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var vuePdfNoSss___vue_module_identifier__ = null
var vuePdfNoSss_Component = vuePdfNoSss_normalizeComponent(
  src_vuePdfNoSss,
  __vue_template__,
  vuePdfNoSss___vue_template_functional__,
  vuePdfNoSss___vue_styles__,
  vuePdfNoSss___vue_scopeId__,
  vuePdfNoSss___vue_module_identifier__
)

/* harmony default export */ var vue_pdf_src_vuePdfNoSss = (vuePdfNoSss_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pdfView.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var pdfView = ({
  inject: ["$oss"],
  data: function data() {
    return {
      loading: false,
      activeId: "",
      popup: false,
      writeEmail: false,
      email: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pdfSrc: "", // pdf文件地址
      pdfType: "", // 展示pdf类型
      downloadUrl: "",
      showPdfUrl: "",
      showPositionValue: false,
      errorMsg: ""
    };
  },

  components: { pdf: vue_pdf_src_vuePdfNoSss },
  created: function created() {
    this.pdfSrc = this.$route.params.pdfSrc;
    this.downloadUrl = this.$route.params.pdfSrc;
    // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    this.pdfSrc = vue_pdf_src_vuePdfNoSss.createLoadingTask(this.pdfSrc);
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              if (_this.$route.params.pdfType && _this.$route.params) {
                _this.pdfType = _this.$route.params.pdfType;
              }
              _context.next = 5;
              return _this.glGetOssClient();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.activeId }
      });
    },

    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage: function changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        // console.log(this.currentPage)
      }
    },

    // pdf加载时
    loadPdfHandler: function loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },

    /** 
     * 手机预览
     */
    previewConfirm: function previewConfirm() {
      try {
        // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
        var filename = '招商函.pdf'; // filename为自定义下载后的文件名。
        var response = {
          'content-disposition': "attachment; filename=" + encodeURIComponent(filename)
          // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
        };this.showPdfUrl = this.$oss.client.signatureUrl("meet/" + this.downloadUrl.split("/")[this.downloadUrl.split("/").length - 1], { expires: 3600 });
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("micromessenger") != -1) {
          this.showMsg("请在其他浏览器点击该按钮");
          return;
        }
        window.open(this.showPdfUrl);
      } catch (err) {
        this.showMsg("文件下载异常");
        console.log(err);
        console.log("OSS配置获取异常");
      }
    },

    /** 
     * 取消发送按钮
     */
    cancelSend: function cancelSend() {
      this.writeEmail = false;
      this.email = "";
    },

    /**
     * pdf发送邮箱
     */
    send2Email: function send2Email() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var reg, list, params, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

                if (_this2.email) {
                  _context2.next = 4;
                  break;
                }

                _this2.showMsg("请输入邮箱地址");
                return _context2.abrupt("return");

              case 4:
                if (reg.test(_this2.email)) {
                  _context2.next = 7;
                  break;
                }

                _this2.showMsg("请输入正确的邮箱地址");
                return _context2.abrupt("return");

              case 7:
                _this2.loading = true;
                list = _this2.$apis.exhibition.sendEmail;
                params = {
                  email: _this2.email,
                  certificateUrl: _this2.downloadUrl
                };
                _context2.prev = 10;
                _context2.next = 13;
                return _this2.$axios.post(list, params);

              case 13:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 16;
                  break;
                }

                _context2.t0 = {};

              case 16:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg(data);
                _this2.writeEmail = false;
                _this2.popup = false;
                _this2.loading = false;
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t1 = _context2["catch"](10);

                _this2.loading = false;
                _this2.showMsg(_context2.t1 || _context2.t1.msg || _context2.t1.data.msg);

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[10, 24]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pdfView.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_pdfView = ({
  inject: ["$oss"],
  data: function data() {
    return {
      loading: false,
      activeId: "",
      popup: false,
      writeEmail: false,
      email: "",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pdfSrc: "", // pdf文件地址
      pdfType: "", // 展示pdf类型
      downloadUrl: "",
      showPdfUrl: "",
      showPositionValue: false,
      errorMsg: ""
    };
  },

  components: { pdf: vue_pdf_src_vuePdfNoSss },
  created: function created() {
    this.pdfSrc = this.$route.params.pdfSrc;
    this.downloadUrl = this.$route.params.pdfSrc;
    // 有时PDF文件地址会出现跨域的情况,这里最好处理一下
    this.pdfSrc = vue_pdf_src_vuePdfNoSss.createLoadingTask(this.pdfSrc);
  },

  computed: {},
  mounted: function mounted() {
    var _this = this;

    return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.activeId = _this.$route.params.activeId;
              if (!_this.activeId) {
                _this.activeId = _this.$route.params.id;
              }
              if (_this.$route.params.pdfType && _this.$route.params) {
                _this.pdfType = _this.$route.params.pdfType;
              }
              _context.next = 5;
              return _this.glGetOssClient();

            case 5:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },

  methods: {
    /**
     * 显示提示信息
     *
     */
    showMsg: function showMsg(msg) {
      this.errorMsg = msg;
      this.showPositionValue = true;
    },

    /**
     * 返回首页
     *
     */
    goback: function goback() {
      this.$router.push({
        name: "loginSelect",
        params: { id: this.activeId }
      });
    },

    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage: function changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.currentPage > 1) {
        this.currentPage--;
        // console.log(this.currentPage)
      }
      if (val === 1 && this.currentPage < this.pageCount) {
        this.currentPage++;
        // console.log(this.currentPage)
      }
    },

    // pdf加载时
    loadPdfHandler: function loadPdfHandler(e) {
      this.currentPage = 1; // 加载的时候先加载第一页
    },

    /** 
     * 手机预览
     */
    previewConfirm: function previewConfirm() {
      try {
        // 配置响应头实现通过URL访问时自动下载文件，并设置下载后的文件名。
        var filename = '招商函.pdf'; // filename为自定义下载后的文件名。
        var response = {
          'content-disposition': "attachment; filename=" + encodeURIComponent(filename)
          // object-key表示从OSS下载文件时需要指定包含文件后缀在内的完整路径，例如abc/efg/123.jpg。
        };this.showPdfUrl = this.$oss.client.signatureUrl("meet/" + this.downloadUrl.split("/")[this.downloadUrl.split("/").length - 1], { expires: 3600 });
        var ua = navigator.userAgent.toLowerCase();
        if (ua.indexOf("micromessenger") != -1) {
          this.showMsg("请在其他浏览器点击该按钮");
          return;
        }
        window.open(this.showPdfUrl);
      } catch (err) {
        this.showMsg("文件下载异常");
        console.log(err);
        console.log("OSS配置获取异常");
      }
    },

    /** 
     * 取消发送按钮
     */
    cancelSend: function cancelSend() {
      this.writeEmail = false;
      this.email = "";
    },

    /**
     * pdf发送邮箱
     */
    send2Email: function send2Email() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var reg, list, params, _ref, data;

        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;

                if (_this2.email) {
                  _context2.next = 4;
                  break;
                }

                _this2.showMsg("请输入邮箱地址");
                return _context2.abrupt("return");

              case 4:
                if (reg.test(_this2.email)) {
                  _context2.next = 7;
                  break;
                }

                _this2.showMsg("请输入正确的邮箱地址");
                return _context2.abrupt("return");

              case 7:
                _this2.loading = true;
                list = _this2.$apis.exhibition.sendEmail;
                params = {
                  email: _this2.email,
                  certificateUrl: _this2.downloadUrl
                };
                _context2.prev = 10;
                _context2.next = 13;
                return _this2.$axios.post(list, params);

              case 13:
                _context2.t0 = _context2.sent;

                if (_context2.t0) {
                  _context2.next = 16;
                  break;
                }

                _context2.t0 = {};

              case 16:
                _ref = _context2.t0;
                data = _ref.data;

                _this2.showMsg(data);
                _this2.writeEmail = false;
                _this2.popup = false;
                _this2.loading = false;
                _context2.next = 28;
                break;

              case 24:
                _context2.prev = 24;
                _context2.t1 = _context2["catch"](10);

                _this2.loading = false;
                _this2.showMsg(_context2.t1 || _context2.t1.msg || _context2.t1.data.msg);

              case 28:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2, [[10, 24]]);
      }))();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-189c7630","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pdfView.vue
var pdfView_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.fileType === 'pdf'),expression:"fileType === 'pdf'"}],staticClass:"pdf"},[_c('x-header',{attrs:{"left-options":{showBack: true}},on:{"on-click-back":function($event){return _vm.goback()}}},[_vm._v(_vm._s(_vm.pdfType != 'pro'?'招商函':'大会日程'))]),_vm._v(" "),_c('ul',{staticClass:"pagination"},[_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changePdfPage(0)}}},[_vm._v("❮上一页")])]),_vm._v(" "),_c('li',[_vm._v(_vm._s(_vm.currentPage)+" / "+_vm._s(_vm.pageCount))]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"javascript:;"},on:{"click":function($event){return _vm.changePdfPage(1)}}},[_vm._v("下一页❯")])])]),_vm._v(" "),_c('pdf',{attrs:{"src":_vm.pdfSrc,"page":_vm.currentPage},on:{"num-pages":function($event){_vm.pageCount=$event},"page-loaded":function($event){_vm.currentPage=$event},"loaded":_vm.loadPdfHandler}}),_vm._v(" "),_c('div',{staticClass:"btn-next"},[_c('a',{attrs:{"target":"view_window"},on:{"click":function($event){_vm.popup = true}}},[_vm._v(_vm._s(_vm.pdfType != 'pro'?'点击下载招商函':'点击下载大会日程'))])]),_vm._v(" "),_c('popup',{model:{value:(_vm.popup),callback:function ($$v) {_vm.popup=$$v},expression:"popup"}},[_c('div',{staticClass:"popup0"},[_c('group',[_c('h2',{staticClass:"popup-tip"},[_vm._v("提示")]),_vm._v(" "),_c('span',{staticClass:"popup-con"},[_vm._v(_vm._s(_vm.pdfType != 'pro'?'下载招商函':'下载大会日程'))]),_vm._v(" "),_c('div',{staticClass:"btn-list"},[_c('div',{staticClass:"btn-item",on:{"click":function($event){_vm.writeEmail = true}}},[_vm._v("发送邮箱")]),_vm._v(" "),_c('div',{staticClass:"btn-item",on:{"click":_vm.previewConfirm}},[_vm._v("手机预览")]),_vm._v(" "),_c('div',{staticClass:"btn-item cancel",on:{"click":function($event){_vm.popup = false}}},[_vm._v("取消")])])])],1)]),_vm._v(" "),_c('popup',{model:{value:(_vm.writeEmail),callback:function ($$v) {_vm.writeEmail=$$v},expression:"writeEmail"}},[_c('popup-header',{attrs:{"left-text":"取消","right-text":"确定","title":"请输入邮箱","show-bottom-border":false},on:{"on-click-left":_vm.cancelSend,"on-click-right":_vm.send2Email}}),_vm._v(" "),_c('group',{attrs:{"gutter":"0"}},[_c('x-input',{attrs:{"is-type":"email","placeholder":"请输入邮箱"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1),_vm._v(" "),_c('toast',{attrs:{"type":"text","time":800,"is-show-mask":"","text":_vm.errorMsg,"position":"middle"},model:{value:(_vm.showPositionValue),callback:function ($$v) {_vm.showPositionValue=$$v},expression:"showPositionValue"}})],1)}
var pdfView_staticRenderFns = []
var pdfView_esExports = { render: pdfView_render, staticRenderFns: pdfView_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_components_pdfView = (pdfView_esExports);
// CONCATENATED MODULE: ./src/components/pdfView.vue
function pdfView_injectStyle (ssrContext) {
  __webpack_require__("nC7b")
}
var pdfView_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var pdfView___vue_template_functional__ = false
/* styles */
var pdfView___vue_styles__ = pdfView_injectStyle
/* scopeId */
var pdfView___vue_scopeId__ = "data-v-189c7630"
/* moduleIdentifier (server only) */
var pdfView___vue_module_identifier__ = null
var pdfView_Component = pdfView_normalizeComponent(
  components_pdfView,
  selectortype_template_index_0_src_components_pdfView,
  pdfView___vue_template_functional__,
  pdfView___vue_styles__,
  pdfView___vue_scopeId__,
  pdfView___vue_module_identifier__
)

/* harmony default export */ var src_components_pdfView = (pdfView_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js
















vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

var router_router = new vue_router_esm["a" /* default */]({
  routes: [{
    path: '/index/:id',
    name: 'index',
    component: src_components
  }, {
    path: '/loginSelect/:id',
    name: 'loginSelect',
    component: src_components_loginSelect
  }, {
    path: '/login/:id',
    name: 'login',
    component: src_components_login
  }, {
    path: '/choose/:id',
    name: 'choose',
    component: src_components_choose
  }, {
    path: '/register/:id',
    name: 'register',
    component: src_components_register
  }, {
    path: '/info',
    name: 'info',
    component: src_components_info
  }, {
    path: '/edit',
    name: 'edit',
    component: src_components_edit
  }, {
    path: '/success',
    name: 'success',
    component: src_components_success
  }, {
    path: '/error',
    name: 'error',
    component: src_components_error
  }, {
    path: '/indexlist',
    name: 'indexlist',
    component: src_components_indexlist
  }, {
    path: '/storelist/:id',
    name: 'storelist',
    component: src_components_storelist
  }, {
    path: '/storedetail/:id/:activeId',
    name: 'storedetail',
    component: src_components_storedetail
  }, {
    path: '/pdfView',
    name: 'pdfView',
    component: src_components_pdfView
  }]
});

router_router.beforeEach(function (to, from, next) {
  if (_hmt) {
    if (to.path) {
      _hmt.push(['_trackPageview', '/#' + to.fullPath]);
    }
  }
  next();
});

/* harmony default export */ var src_router = (router_router);

// const router = new Router({
//   routes: [
//     {
//       path: '/index/:id',
//       name: 'index',
//       component: index
//     },
//     {
//       path: '/loginSelect/:id',
//       name: 'loginSelect',
//       component: loginSelect
//     },
//     {
//       path: '/login/:id',
//       name: 'login',
//       component: login
//     },
//     {
//       path: '/choose/:id',
//       name: 'choose',
//       component: choose
//     },
//     {
//       path: '/register/:id',
//       name: 'register',
//       component: register
//     },
//     {
//       path: '/info',
//       name: 'info',
//       component: info
//     },
//     {
//       path: '/edit',
//       name: 'edit',
//       component: edit
//     },
//     {
//       path: '/success',
//       name: 'success',
//       component: success
//     },
//     {
//       path: '/error',
//       name: 'error',
//       component: error
//     },
//     {
//       path: '/indexlist',
//       name: 'indexlist',
//       component: indexlist
//     },
//     {
//       path: '/storelist/:id',
//       name: 'storelist',
//       component: storelist
//     },
//     {
//       path: '/storedetail/:id/:activeId',
//       name: 'storedetail',
//       component: storedetail
//     },
//     {
//       path: '/pdfView',
//       name: 'pdfView',
//       component: pdfView
//     },
//   ]
//  });

//  router.beforeEach((to, from, next) => {
//   if (_hmt) {
//     if (to.path) {
//       _hmt.push(['_trackPageview', '/#' + to.fullPath]);
//     }
//   }
// });

// export default router;
// EXTERNAL MODULE: ./node_modules/object-assign/index.js
var node_modules_object_assign = __webpack_require__("BEQ0");
var object_assign_default = /*#__PURE__*/__webpack_require__.n(node_modules_object_assign);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_x_header = ({
  name: 'x-header',
  props: {
    leftOptions: Object,
    title: String,
    transition: String,
    rightOptions: {
      type: Object,
      default: function _default() {
        return {
          showMore: false
        };
      }
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots['overwrite-title']) {
      this.shouldOverWriteTitle = true;
    }
  },

  computed: {
    _leftOptions: function _leftOptions() {
      return object_assign_default()({
        showBack: true,
        preventGoBack: false
      }, this.leftOptions || {});
    }
  },
  methods: {
    onClickBack: function onClickBack() {
      if (this._leftOptions.preventGoBack) {
        this.$emit('on-click-back');
      } else {
        this.$router ? this.$router.back() : window.history.back();
      }
    }
  },
  data: function data() {
    return {
      shouldOverWriteTitle: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-eb223dbe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-header/index.vue
var x_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-header"},[_c('div',{staticClass:"vux-header-left"},[_vm._t("overwrite-left",[_c('transition',{attrs:{"name":_vm.transition}},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"vux-header-back",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},_vm.onClickBack]}},[_vm._v(_vm._s(typeof _vm._leftOptions.backText === 'undefined' ? '返回' : _vm._leftOptions.backText))])]),_vm._v(" "),_c('transition',{attrs:{"name":_vm.transition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm._leftOptions.showBack),expression:"_leftOptions.showBack"}],staticClass:"left-arrow",on:{"click":_vm.onClickBack}})])]),_vm._v(" "),_vm._t("left")],2),_vm._v(" "),(!_vm.shouldOverWriteTitle)?_c('h1',{staticClass:"vux-header-title",on:{"click":function($event){return _vm.$emit('on-click-title')}}},[_vm._t("default",[_c('transition',{attrs:{"name":_vm.transition}},[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}]},[_vm._v(_vm._s(_vm.title))])])])],2):_vm._e(),_vm._v(" "),(_vm.shouldOverWriteTitle)?_c('div',{staticClass:"vux-header-title-area"},[_vm._t("overwrite-title")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vux-header-right"},[(_vm.rightOptions.showMore)?_c('a',{staticClass:"vux-header-more",on:{"click":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"preventDefault",undefined,$event.key,undefined)){ return null; }},function($event){return _vm.$emit('on-click-more')}]}}):_vm._e(),_vm._v(" "),_vm._t("right")],2)])}
var x_header_staticRenderFns = []
var x_header_esExports = { render: x_header_render, staticRenderFns: x_header_staticRenderFns }
/* harmony default export */ var src_components_x_header = (x_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-header/index.vue
function x_header_injectStyle (ssrContext) {
  __webpack_require__("owug")
}
var x_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_header___vue_template_functional__ = false
/* styles */
var x_header___vue_styles__ = x_header_injectStyle
/* scopeId */
var x_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_header___vue_module_identifier__ = null
var x_header_Component = x_header_normalizeComponent(
  components_x_header,
  src_components_x_header,
  x_header___vue_template_functional__,
  x_header___vue_styles__,
  x_header___vue_scopeId__,
  x_header___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_x_header = (x_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-blazy/blazy.js
var blazy = __webpack_require__("iRq5");
var blazy_default = /*#__PURE__*/__webpack_require__.n(blazy);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/webp-support.js
var webp_support = __webpack_require__("p3QP");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/mixin_uuid.js
var mixin_uuid = __webpack_require__("OFgA");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-img/index.vue
//
//
//
//





/* harmony default export */ var components_x_img = ({
  name: 'x-img',
  mixins: [mixin_uuid["a" /* default */]],
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.init);
  },

  methods: {
    init: function init() {
      var _this = this;

      this.blazy && this.blazy.destroy();
      this.$el.src = this.defaultSrc;
      this.$el.className = this.$el.className.replace('b-loaded', '');

      this.blazy = new blazy_default.a({
        scroller: this.scroller,
        container: this.container,
        selector: '#vux-ximg-' + this.uuid,
        offset: _this.offset,
        errorClass: _this.errorClass,
        successClass: _this.successClass,
        separator: _this.separator,
        success: function success(ele) {
          _this.$emit('on-success', _this.src, ele);
        },
        error: function error(ele, msg) {
          _this.$emit('on-error', _this.src, ele, msg);
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$el.setAttribute('id', 'vux-ximg-' + this.uuid);
    this.$nextTick(function () {
      setTimeout(function () {
        _this2.init();
      }, _this2.delay);
    });
    Object(webp_support["a" /* detectWebp */])();
  },

  computed: {
    currentSrc: function currentSrc() {
      if (Object(webp_support["b" /* isSupported */])() && this.webpSrc) {
        return this.webpSrc;
      }
      return this.src;
    }
  },
  props: {
    src: String,
    webpSrc: String,
    defaultSrc: {
      type: String,
      default: 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
    },
    errorClass: String,
    successClass: String,
    offset: {
      type: Number,
      default: 100
    },
    scroller: Object,
    container: String,
    delay: {
      type: Number,
      default: 0
    },
    separator: String
  },
  watch: {
    src: function src(val) {
      this.init();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.blazy && this.blazy.destroy();
    this.blazy = null;
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.init);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b5a953a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-img/index.vue
var x_img_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"vux-x-img",attrs:{"src":_vm.defaultSrc,"data-src":_vm.currentSrc}})}
var x_img_staticRenderFns = []
var x_img_esExports = { render: x_img_render, staticRenderFns: x_img_staticRenderFns }
/* harmony default export */ var src_components_x_img = (x_img_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-img/index.vue
function x_img_injectStyle (ssrContext) {
  __webpack_require__("DPlV")
}
var x_img_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_img___vue_template_functional__ = false
/* styles */
var x_img___vue_styles__ = x_img_injectStyle
/* scopeId */
var x_img___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_img___vue_module_identifier__ = null
var x_img_Component = x_img_normalizeComponent(
  components_x_img,
  src_components_x_img,
  x_img___vue_template_functional__,
  x_img___vue_styles__,
  x_img___vue_scopeId__,
  x_img___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_img = (x_img_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(keys);

// EXTERNAL MODULE: ./node_modules/vux/src/components/popup/popup.js
var popup = __webpack_require__("+v63");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/dom.js
var dom = __webpack_require__("te2A");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var src_components_popup = ({
  name: 'popup',
  props: {
    value: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    width: {
      type: String,
      default: 'auto'
    },
    showMask: {
      type: Boolean,
      default: true
    },
    isTransparent: Boolean,
    hideOnBlur: {
      type: Boolean,
      default: true
    },
    position: {
      type: String,
      default: 'bottom'
    },
    maxHeight: String,
    popupStyle: Object,
    hideOnDeactivated: {
      type: Boolean,
      default: true
    },
    shouldRerenderOnShow: {
      type: Boolean,
      default: false
    },
    shouldScrollTopOnShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // get global layout config
    if (this.$vux && this.$vux.config && this.$vux.config.$layout === 'VIEW_BOX') {
      this.layout = 'VIEW_BOX';
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.$overflowScrollingList = document.querySelectorAll('.vux-fix-safari-overflow-scrolling');
    this.$nextTick(function () {
      var _this = _this2;
      _this2.popup = new popup["a" /* default */]({
        showMask: _this.showMask,
        container: _this.$el,
        hideOnBlur: _this.hideOnBlur,
        onOpen: function onOpen() {
          _this.fixSafariOverflowScrolling('auto');
          _this.show = true;
        },
        onClose: function onClose() {
          _this.show = false;
          if (window.__$vuxPopups && keys_default()(window.__$vuxPopups).length > 1) return;
          if (document.querySelector('.vux-popup-dialog.vux-popup-mask-disabled')) return;
          setTimeout(function () {
            _this.fixSafariOverflowScrolling('touch');
          }, 300);
        }
      });
      if (_this2.value) {
        _this2.popup.show();
      }
      _this2.initialShow = false;
    });
  },
  deactivated: function deactivated() {
    if (this.hideOnDeactivated) {
      this.show = false;
    }
    this.removeModalClassName();
  },

  methods: {
    /**
    * https://github.com/airyland/vux/issues/311
    * https://benfrain.com/z-index-stacking-contexts-experimental-css-and-ios-safari/
    */
    fixSafariOverflowScrolling: function fixSafariOverflowScrolling(type) {
      if (!this.$overflowScrollingList.length) return;
      // if (!/iphone/i.test(navigator.userAgent)) return
      for (var i = 0; i < this.$overflowScrollingList.length; i++) {
        this.$overflowScrollingList[i].style.webkitOverflowScrolling = type;
      }
    },
    removeModalClassName: function removeModalClassName() {
      this.layout === 'VIEW_BOX' && dom["a" /* default */].removeClass(document.body, 'vux-modal-open');
    },
    doShow: function doShow() {
      this.popup && this.popup.show();
      this.$emit('on-show');
      this.fixSafariOverflowScrolling('auto');
      this.layout === 'VIEW_BOX' && dom["a" /* default */].addClass(document.body, 'vux-modal-open');
      if (!this.hasFirstShow) {
        this.$emit('on-first-show');
        this.hasFirstShow = true;
      }
    },
    scrollTop: function scrollTop() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$el.scrollTop = 0;
        var box = _this3.$el.querySelectorAll('.vux-scrollable');
        if (box.length) {
          for (var i = 0; i < box.length; i++) {
            box[i].scrollTop = 0;
          }
        }
      });
    }
  },
  data: function data() {
    return {
      layout: '',
      initialShow: true,
      hasFirstShow: false,
      shouldRenderBody: true,
      show: this.value
    };
  },

  computed: {
    styles: function styles() {
      var styles = {};
      if (!this.position || this.position === 'bottom' || this.position === 'top') {
        styles.height = this.height;
      } else {
        styles.width = this.width;
      }

      if (this.maxHeight) {
        styles['max-height'] = this.maxHeight;
      }

      this.isTransparent && (styles['background'] = 'transparent');
      if (this.popupStyle) {
        for (var i in this.popupStyle) {
          styles[i] = this.popupStyle[i];
        }
      }
      return styles;
    }
  },
  watch: {
    value: function value(val) {
      this.show = val;
    },
    show: function show(val) {
      var _this4 = this;

      this.$emit('input', val);
      if (val) {
        // rerender body
        if (this.shouldRerenderOnShow) {
          this.shouldRenderBody = false;
          this.$nextTick(function () {
            _this4.scrollTop();
            _this4.shouldRenderBody = true;
            _this4.doShow();
          });
        } else {
          if (this.shouldScrollTopOnShow) {
            this.scrollTop();
          }
          this.doShow();
        }
      } else {
        this.$emit('on-hide');
        this.show = false;
        this.popup.hide(false);
        setTimeout(function () {
          if (!document.querySelector('.vux-popup-dialog.vux-popup-show')) {
            _this4.fixSafariOverflowScrolling('touch');
          }
          _this4.removeModalClassName();
        }, 200);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.popup && this.popup.destroy();
    this.fixSafariOverflowScrolling('touch');
    this.removeModalClassName();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-613daa96","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup/index.vue
var popup_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":("vux-popup-animate-" + _vm.position)}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show && !_vm.initialShow),expression:"show && !initialShow"}],staticClass:"vux-popup-dialog",class:[("vux-popup-" + _vm.position), _vm.show ? 'vux-popup-show' : ''],style:(_vm.styles)},[(_vm.shouldRenderBody)?_vm._t("default"):_vm._e()],2)])}
var popup_staticRenderFns = []
var popup_esExports = { render: popup_render, staticRenderFns: popup_staticRenderFns }
/* harmony default export */ var vux_src_components_popup = (popup_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup/index.vue
function popup_injectStyle (ssrContext) {
  __webpack_require__("MUCD")
}
var popup_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup___vue_template_functional__ = false
/* styles */
var popup___vue_styles__ = popup_injectStyle
/* scopeId */
var popup___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup___vue_module_identifier__ = null
var popup_Component = popup_normalizeComponent(
  src_components_popup,
  vux_src_components_popup,
  popup___vue_template_functional__,
  popup___vue_styles__,
  popup___vue_scopeId__,
  popup___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_popup = (popup_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-header/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_popup_header = ({
  name: 'popup-header',
  props: {
    leftText: String,
    rightText: String,
    title: String,
    showBottomBorder: {
      type: Boolean,
      default: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5bfd958","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-header/index.vue
var popup_header_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-popup-header",class:_vm.showBottomBorder ? 'vux-1px-b' : ''},[_c('div',{staticClass:"vux-popup-header-left",on:{"click":function($event){return _vm.$emit('on-click-left')}}},[_vm._t("left-text",[_vm._v(_vm._s(_vm.leftText))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-title"},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2),_vm._v(" "),_c('div',{staticClass:"vux-popup-header-right",on:{"click":function($event){return _vm.$emit('on-click-right')}}},[_vm._t("right-text",[_vm._v(_vm._s(_vm.rightText))])],2)])}
var popup_header_staticRenderFns = []
var popup_header_esExports = { render: popup_header_render, staticRenderFns: popup_header_staticRenderFns }
/* harmony default export */ var src_components_popup_header = (popup_header_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-header/index.vue
function popup_header_injectStyle (ssrContext) {
  __webpack_require__("Dm7L")
}
var popup_header_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_header___vue_template_functional__ = false
/* styles */
var popup_header___vue_styles__ = popup_header_injectStyle
/* scopeId */
var popup_header___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_header___vue_module_identifier__ = null
var popup_header_Component = popup_header_normalizeComponent(
  components_popup_header,
  src_components_popup_header,
  popup_header___vue_template_functional__,
  popup_header___vue_styles__,
  popup_header___vue_scopeId__,
  popup_header___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_popup_header = (popup_header_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/clean-style.js
var clean_style = __webpack_require__("wmxo");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/group/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_group = ({
  name: 'group',
  methods: {
    cleanStyle: clean_style["a" /* default */]
  },
  props: {
    title: String,
    titleColor: String,
    labelWidth: String,
    labelAlign: String,
    labelMarginRight: String,
    gutter: [String, Number],
    footerTitle: String,
    footerTitleColor: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e216ed4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/group/index.vue
var group_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.title)?_c('div',{staticClass:"weui-cells__title",style:(_vm.cleanStyle({
    color: _vm.titleColor
  })),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),_vm._t("title"),_vm._v(" "),_c('div',{staticClass:"weui-cells",class:{
    'vux-no-group-title': !_vm.title
  },style:(_vm.cleanStyle({
    marginTop: typeof _vm.gutter === 'number' ? (_vm.gutter + 'px') : _vm.gutter
  }))},[_vm._t("after-title"),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),(_vm.footerTitle)?_c('div',{staticClass:"weui-cells__title vux-group-footer-title",style:(_vm.cleanStyle({
    color: _vm.footerTitleColor
  })),domProps:{"innerHTML":_vm._s(_vm.footerTitle)}}):_vm._e()],2)}
var group_staticRenderFns = []
var group_esExports = { render: group_render, staticRenderFns: group_staticRenderFns }
/* harmony default export */ var src_components_group = (group_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/group/index.vue
function group_injectStyle (ssrContext) {
  __webpack_require__("qHQD")
}
var group_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var group___vue_template_functional__ = false
/* styles */
var group___vue_styles__ = group_injectStyle
/* scopeId */
var group___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var group___vue_module_identifier__ = null
var group_Component = group_normalizeComponent(
  components_group,
  src_components_group,
  group___vue_template_functional__,
  group___vue_styles__,
  group___vue_scopeId__,
  group___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_group = (group_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/inline-desc/index.vue
//
//
//
//

/* harmony default export */ var components_inline_desc = ({
  name: 'inline-desc'
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-291627fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/inline-desc/index.vue
var inline_desc_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"vux-label-desc"},[_vm._t("default")],2)}
var inline_desc_staticRenderFns = []
var inline_desc_esExports = { render: inline_desc_render, staticRenderFns: inline_desc_staticRenderFns }
/* harmony default export */ var src_components_inline_desc = (inline_desc_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/inline-desc/index.vue
function inline_desc_injectStyle (ssrContext) {
  __webpack_require__("3k2l")
}
var inline_desc_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var inline_desc___vue_template_functional__ = false
/* styles */
var inline_desc___vue_styles__ = inline_desc_injectStyle
/* scopeId */
var inline_desc___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var inline_desc___vue_module_identifier__ = null
var inline_desc_Component = inline_desc_normalizeComponent(
  components_inline_desc,
  src_components_inline_desc,
  inline_desc___vue_template_functional__,
  inline_desc___vue_styles__,
  inline_desc___vue_scopeId__,
  inline_desc___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_inline_desc = (inline_desc_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/cell/props.js
var props = __webpack_require__("2IIR");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/get-parent-prop.js
var get_parent_prop = __webpack_require__("vLYD");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/cell/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_cell = ({
  name: 'cell',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: Object(props["a" /* default */])(),
  created: function created() {
    /* istanbul ignore if */
    if (false) {
      console.warn('[VUX] 抱歉，当前组件[cell]要求更新依赖 vux-loader@latest');
    }
  },
  beforeMount: function beforeMount() {
    this.hasTitleSlot = !!this.$slots.title;
    /* istanbul ignore if */
    if (this.$slots.value && "production" === 'development') {
      console.warn('[VUX] [cell] slot=value 已经废弃，请使用默认 slot 替代');
    }
  },

  computed: {
    labelStyles: function labelStyles() {
      return Object(clean_style["a" /* default */])({
        width: Object(get_parent_prop["a" /* default */])(this, 'labelWidth'),
        textAlign: Object(get_parent_prop["a" /* default */])(this, 'labelAlign'),
        marginRight: Object(get_parent_prop["a" /* default */])(this, 'labelMarginRight')
      });
    },
    valueClass: function valueClass() {
      return {
        'vux-cell-primary': this.primary === 'content' || this.valueAlign === 'left',
        'vux-cell-align-left': this.valueAlign === 'left',
        'vux-cell-arrow-transition': !!this.arrowDirection,
        'vux-cell-arrow-up': this.arrowDirection === 'up',
        'vux-cell-arrow-down': this.arrowDirection === 'down'
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    style: function style() {
      if (this.alignItems) {
        return {
          alignItems: this.alignItems
        };
      }
    }
  },
  methods: {
    onClick: function onClick() {
      /* istanbul ignore next */
      !this.disabled && Object(router["b" /* go */])(this.link, this.$router);
    }
  },
  data: function data() {
    return {
      hasTitleSlot: true,
      hasMounted: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62e51266","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/cell/index.vue
var cell_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell",class:{
    'vux-tap-active': _vm.isLink || !!_vm.link,
    'weui-cell_access': _vm.isLink || !!_vm.link,
    'vux-cell-no-border-intent': !_vm.borderIntent,
    'vux-cell-disabled': _vm.disabled
  },style:(_vm.style),on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("icon")],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-bd",class:{'vux-cell-primary': _vm.primary === 'title' && _vm.valueAlign !== 'left'}},[_c('p',[(_vm.title || _vm.hasTitleSlot)?_c('label',{staticClass:"vux-label",class:_vm.labelClass,style:(_vm.labelStyles)},[_vm._t("title",[_vm._v(_vm._s(_vm.title))])],2):_vm._e(),_vm._v(" "),_vm._t("after-title")],2),_vm._v(" "),_c('inline-desc',[_vm._t("inline-desc",[_vm._v(_vm._s(_vm.inlineDesc))])],2)],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft",class:_vm.valueClass},[_vm._t("value"),_vm._v(" "),_vm._t("default",[_vm._v(_vm._s(_vm.value))]),_vm._v(" "),(_vm.isLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e()],2),_vm._v(" "),_vm._t("child")],2)}
var cell_staticRenderFns = []
var cell_esExports = { render: cell_render, staticRenderFns: cell_staticRenderFns }
/* harmony default export */ var src_components_cell = (cell_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/cell/index.vue
function cell_injectStyle (ssrContext) {
  __webpack_require__("QX3Y")
}
var cell_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var cell___vue_template_functional__ = false
/* styles */
var cell___vue_styles__ = cell_injectStyle
/* scopeId */
var cell___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var cell___vue_module_identifier__ = null
var cell_Component = cell_normalizeComponent(
  components_cell,
  src_components_cell,
  cell___vue_template_functional__,
  cell___vue_styles__,
  cell___vue_scopeId__,
  cell___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_cell = (cell_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/libs/base.js
var base = __webpack_require__("f6Hi");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/icon/index.vue
//
//
//
//

/* harmony default export */ var components_icon = ({
  name: 'icon',
  props: {
    type: String,
    isMsg: Boolean
  },
  computed: {
    className: function className() {
      // compatible with old type param
      return 'weui-icon weui_icon_' + this.type + ' weui-icon-' + this.type.replace(/_/g, '-');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d30802","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/icon/index.vue
var icon_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:[_vm.className, _vm.isMsg ? 'weui-icon_msg' : '']})}
var icon_staticRenderFns = []
var icon_esExports = { render: icon_render, staticRenderFns: icon_staticRenderFns }
/* harmony default export */ var src_components_icon = (icon_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/icon/index.vue
function icon_injectStyle (ssrContext) {
  __webpack_require__("2lnh")
}
var icon_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var icon___vue_template_functional__ = false
/* styles */
var icon___vue_styles__ = icon_injectStyle
/* scopeId */
var icon___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var icon___vue_module_identifier__ = null
var icon_Component = icon_normalizeComponent(
  components_icon,
  src_components_icon,
  icon___vue_template_functional__,
  icon___vue_styles__,
  icon___vue_scopeId__,
  icon___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_icon = (icon_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/safari-fix.js
var safari_fix = __webpack_require__("xNvf");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/toast/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_toast = ({
  name: 'toast',
  mixins: [safari_fix["a" /* default */]],
  props: {
    value: Boolean,
    time: {
      type: Number,
      default: 2000
    },
    type: {
      type: String,
      default: 'success'
    },
    transition: String,
    width: {
      type: String,
      default: '7.6em'
    },
    isShowMask: {
      type: Boolean,
      default: false
    },
    text: String,
    position: String
  },
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (this.value) {
      this.show = true;
    }
  },

  computed: {
    currentTransition: function currentTransition() {
      if (this.transition) {
        return this.transition;
      }
      if (this.position === 'top') {
        return 'vux-slide-from-top';
      }
      if (this.position === 'bottom') {
        return 'vux-slide-from-bottom';
      }
      return 'vux-fade';
    },
    toastClass: function toastClass() {
      return {
        'weui-toast_forbidden': this.type === 'warn',
        'weui-toast_cancel': this.type === 'cancel',
        'weui-toast_success': this.type === 'success',
        'weui-toast_text': this.type === 'text',
        'vux-toast-top': this.position === 'top',
        'vux-toast-bottom': this.position === 'bottom',
        'vux-toast-middle': this.position === 'middle'
      };
    },
    style: function style() {
      if (this.type === 'text' && this.width === 'auto') {
        return { padding: '10px' };
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this = this;

      if (val) {
        this.$emit('input', true);
        this.$emit('on-show');
        this.fixSafariOverflowScrolling('auto');

        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this.show = false;
          _this.$emit('input', false);
          _this.$emit('on-hide');
          _this.fixSafariOverflowScrolling('touch');
        }, this.time);
      }
    },
    value: function value(val) {
      this.show = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25afd1ad","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/toast/index.vue
var toast_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-toast"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShowMask && _vm.show),expression:"isShowMask && show"}],staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('transition',{attrs:{"name":_vm.currentTransition}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-toast",class:_vm.toastClass,style:({width: _vm.width})},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.type !== 'text'),expression:"type !== 'text'"}],staticClass:"weui-icon-success-no-circle weui-icon_toast"}),_vm._v(" "),(_vm.text)?_c('p',{staticClass:"weui-toast__content",style:(_vm.style),domProps:{"innerHTML":_vm._s(_vm.text)}}):_c('p',{staticClass:"weui-toast__content",style:(_vm.style)},[_vm._t("default")],2)])])],1)}
var toast_staticRenderFns = []
var toast_esExports = { render: toast_render, staticRenderFns: toast_staticRenderFns }
/* harmony default export */ var src_components_toast = (toast_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/toast/index.vue
function toast_injectStyle (ssrContext) {
  __webpack_require__("kllH")
}
var toast_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var toast___vue_template_functional__ = false
/* styles */
var toast___vue_styles__ = toast_injectStyle
/* scopeId */
var toast___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var toast___vue_module_identifier__ = null
var toast_Component = toast_normalizeComponent(
  components_toast,
  src_components_toast,
  toast___vue_template_functional__,
  toast___vue_styles__,
  toast___vue_scopeId__,
  toast___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_toast = (toast_Component.exports);

// EXTERNAL MODULE: ./node_modules/validator/lib/isEmail.js
var isEmail = __webpack_require__("2LX0");
var isEmail_default = /*#__PURE__*/__webpack_require__.n(isEmail);

// EXTERNAL MODULE: ./node_modules/validator/lib/isMobilePhone.js
var isMobilePhone = __webpack_require__("Ewe+");
var isMobilePhone_default = /*#__PURE__*/__webpack_require__.n(isMobilePhone);

// EXTERNAL MODULE: ./node_modules/vux/src/tools/debounce/index.js
var debounce = __webpack_require__("nror");

// EXTERNAL MODULE: ./node_modules/vanilla-masker/lib/vanilla-masker.js
var vanilla_masker = __webpack_require__("lFEC");
var vanilla_masker_default = /*#__PURE__*/__webpack_require__.n(vanilla_masker);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-input/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var x_input_validators = {
  'email': {
    fn: isEmail_default.a,
    msg: '邮箱格式'
  },
  'china-mobile': {
    fn: function fn(str) {
      return isMobilePhone_default()(str, 'zh-CN');
    },

    msg: '手机号码'
  },
  'china-name': {
    fn: function fn(str) {
      return str.length >= 2 && str.length <= 6;
    },

    msg: '中文姓名'
  }
};
/* harmony default export */ var components_x_input = ({
  name: 'x-input',
  created: function created() {
    var _this = this;

    this.currentValue = this.value === undefined || this.value === null ? '' : this.mask ? this.maskValue(this.value) : this.value;
    /* istanbul ignore if */
    if (false) {
      if (!this.title && !this.placeholder && !this.currentValue) {
        console.warn('no title and no placeholder?');
      }
    }

    if (this.required && (typeof this.currentValue === 'undefined' || this.currentValue === '')) {
      this.valid = false;
    }
    this.handleChangeEvent = true;
    if (this.debounce) {
      this._debounce = Object(debounce["a" /* default */])(function () {
        _this.$emit('on-change', _this.currentValue);
      }, this.debounce);
    }
  },
  beforeMount: function beforeMount() {
    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    if (this.$slots && this.$slots['right-full-height']) {
      this.hasRightFullHeightSlot = true;
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._debounce) {
      this._debounce.cancel();
    }
    window.removeEventListener('resize', this.scrollIntoView);
  },

  mixins: [base["a" /* default */]],
  components: {
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc,
    Toast: vux_src_components_toast
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    value: [String, Number],
    name: String,
    readonly: Boolean,
    disabled: Boolean,
    keyboard: String,
    inlineDesc: String,
    isType: [String, Function],
    min: Number,
    max: Number,
    showClear: {
      type: Boolean,
      default: true
    },
    equalWith: String,
    textAlign: String,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    novalidate: {
      type: Boolean,
      default: false
    },
    iconType: String,
    debounce: Number,
    placeholderAlign: String,
    labelWidth: String,
    mask: String,
    shouldToastError: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: this.labelWidthComputed || $parent.labelWidth || this.labelWidthComputed,
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    },
    pattern: function pattern() {
      if (this.keyboard === 'number' || this.isType === 'china-mobile') {
        return '[0-9]*';
      }
    },
    labelWidthComputed: function labelWidthComputed() {
      var width = this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
      if (width < 10) {
        return width + 'em';
      }
    },
    hasErrors: function hasErrors() {
      return keys_default()(this.errors).length > 0;
    },
    inputStyle: function inputStyle() {
      if (this.textAlign) {
        return {
          textAlign: this.textAlign
        };
      }
    },
    showWarn: function showWarn() {
      return !this.novalidate && !this.equalWith && !this.valid && this.firstError && (this.touched || this.forceShowError);
    }
  },
  mounted: function mounted() {
    window.addEventListener('resize', this.scrollIntoView);
  },

  methods: {
    scrollIntoView: function scrollIntoView() {
      var _this2 = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      // alert('scroll into view')
      if (/iphone/i.test(navigator.userAgent)) {
        // return
      }
      if (document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA') {
        // alert('will scroll')
        setTimeout(function () {
          // alert(this.$refs.input.length)
          _this2.$refs.input.scrollIntoViewIfNeeded(true);
        }, time);
      }
    },
    onClickErrorIcon: function onClickErrorIcon() {
      if (this.shouldToastError && this.firstError) {
        this.showErrorToast = true;
      }
      this.$emit('on-click-error-icon', this.firstError);
    },
    maskValue: function maskValue(val) {
      var val1 = this.mask ? vanilla_masker_default.a.toPattern(val, this.mask) : val;
      return val1;
    },
    reset: function reset() {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.dirty = false;
      this.currentValue = value;
      this.firstError = '';
      this.valid = true;
    },
    clear: function clear() {
      this.currentValue = '';
      this.focus();
      this.$emit('on-click-clear-icon');
    },
    focus: function focus() {
      this.$refs.input.focus();
    },
    blur: function blur() {
      this.$refs.input.blur();
    },
    focusHandler: function focusHandler($event) {
      var _this3 = this;

      this.$emit('on-focus', this.currentValue, $event);
      this.isFocus = true;
      // this.scrollIntoView(500)
      // this.scrollIntoView(5000)
      setTimeout(function () {
        // 因为有1秒的延迟，如果切换了页面，input已经不存在，所以加个判断
        !_this3.$refs.input || _this3.$refs.input.scrollIntoViewIfNeeded(false);
        // this.$refs.input.scrollIntoViewIfNeeded()
      }, 1000);
      // $event.target.
    },
    onBlur: function onBlur($event) {
      this.setTouched();
      this.validate();
      this.isFocus = false;
      this.$emit('on-blur', this.currentValue, $event);
    },
    onKeyUp: function onKeyUp(e) {
      if (e.key === 'Enter') {
        e.target.blur();
        this.$emit('on-enter', this.currentValue, e);
      }
    },
    getError: function getError() {
      var key = keys_default()(this.errors)[0];
      this.firstError = this.errors[key];
    },
    validate: function validate() {
      if (typeof this.equalWith !== 'undefined') {
        this.validateEqual();
        return;
      }
      this.errors = {};

      if (!this.currentValue && !this.required) {
        this.valid = true;
        return;
      }

      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填哦';
        this.getError();
        return;
      }

      if (typeof this.isType === 'string') {
        var validator = x_input_validators[this.isType];
        if (validator) {
          var value = this.currentValue;

          if (this.isType === 'china-mobile' && this.mask === '999 9999 9999') {
            value = this.currentValue.replace(/\s+/g, '');
          }

          this.valid = validator['fn'](value);
          if (!this.valid) {
            this.forceShowError = true;
            this.errors.format = validator['msg'] + '格式不对哦~';
            this.getError();
            return;
          } else {
            delete this.errors.format;
          }
        }
      }

      if (typeof this.isType === 'function') {
        var validStatus = this.isType(this.currentValue);
        this.valid = validStatus.valid;
        if (!this.valid) {
          this.errors.format = validStatus.msg;
          this.forceShowError = true;
          this.getError();
          return;
        } else {
          delete this.errors.format;
        }
      }

      if (this.min) {
        if (this.currentValue.length < this.min) {
          this.errors.min = '\u6700\u5C11\u5E94\u8BE5\u8F93\u5165' + this.min + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.getError();
          return;
        } else {
          delete this.errors.min;
        }
      }

      if (this.max) {
        if (this.currentValue.length > this.max) {
          this.errors.max = '\u6700\u591A\u53EF\u4EE5\u8F93\u5165' + this.max + '\u4E2A\u5B57\u7B26\u54E6';
          this.valid = false;
          this.forceShowError = true;
          return;
        } else {
          this.forceShowError = false;
          delete this.errors.max;
        }
      }

      this.valid = true;
    },
    validateEqual: function validateEqual() {
      if (!this.equalWith && this.currentValue) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      }
      var willCheck = this.dirty || this.currentValue.length >= this.equalWith.length;
      // 只在长度符合时显示正确与否
      if (willCheck && this.currentValue !== this.equalWith) {
        this.valid = false;
        this.errors.equal = '输入不一致';
        return;
      } else {
        if (!this.currentValue && this.required) {
          this.valid = false;
        } else {
          this.valid = true;
          delete this.errors.equal;
        }
      }
    },

    // #2810
    _getInputMaskSelection: function _getInputMaskSelection(selection, direction, maskVal, loop) {
      if (!this.mask || loop && direction === 0) {
        return selection;
      }
      if (direction === 0) {
        direction = this.lastDirection;
      }
      if (direction > 0) {
        var maskChar = this.mask.substr(selection - direction, 1);
        if (!maskChar.match(/[9SA]/)) {
          return this._getInputMaskSelection(selection + 1, direction, maskVal, true);
        }
      }
      return selection;
    }
  },
  data: function data() {
    return {
      hasRightFullHeightSlot: false,
      hasRestrictedLabel: false,
      firstError: '',
      forceShowError: false,
      hasLengthEqual: false,
      valid: true,
      currentValue: '',
      showErrorToast: false,
      isFocus: false
    };
  },

  watch: {
    mask: function mask(val) {
      if (val && this.currentValue) {
        this.currentValue = this.maskValue(this.currentValue);
      }
    },
    valid: function valid() {
      this.getError();
    },
    value: function value(val) {
      this.currentValue = val;
    },
    equalWith: function equalWith(newVal) {
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
    },
    currentValue: function currentValue(newVal, oldVal) {
      var _this4 = this;

      var selection = null;
      if (!this.equalWith && newVal) {
        this.validateEqual();
      }
      if (newVal && this.equalWith) {
        if (newVal.length === this.equalWith.length) {
          this.hasLengthEqual = true;
        }
        this.validateEqual();
      } else {
        this.validate();
      }
      // #2960
      try {
        selection = this.$refs.input.selectionStart;
        var direction = newVal.length - oldVal.length;
        selection = this._getInputMaskSelection(selection, direction, this.maskValue(newVal));
        this.lastDirection = direction;
      } catch (e) {}
      this.$emit('input', this.maskValue(newVal));
      // #2810
      this.$nextTick(function () {
        if (_this4.$refs.input.selectionStart !== selection) {
          _this4.$refs.input.selectionStart = selection;
          _this4.$refs.input.selectionEnd = selection;
        }
        if (_this4.currentValue !== _this4.maskValue(newVal)) {
          _this4.currentValue = _this4.maskValue(newVal);
        }
      });

      if (this._debounce) {
        this._debounce();
      } else {
        this.$emit('on-change', newVal);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0aeed9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-input/index.vue
var x_input_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-input weui-cell",class:{
			'weui-cell_warn': _vm.showWarn,
			'disabled': _vm.disabled,
			'vux-x-input-has-right-full': _vm.hasRightFullHeightSlot
		}},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.labelWidth || _vm.$parent.labelWidth || _vm.labelWidthComputed, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),attrs:{"for":("vux-x-input-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd weui-cell__primary",class:_vm.placeholderAlign ? ("vux-x-input-placeholder-" + _vm.placeholderAlign) : ''},[(!_vm.type || _vm.type === 'text')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"text","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'number')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"number","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'email')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"email","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'password')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"password","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e(),_vm._v(" "),(_vm.type === 'tel')?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-input",style:(_vm.inputStyle),attrs:{"id":("vux-x-input-" + _vm.uuid),"maxlength":_vm.max,"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"type":"tel","name":_vm.name,"pattern":_vm.pattern,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.focusHandler,"blur":_vm.onBlur,"keyup":_vm.onKeyUp,"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.hasRightFullHeightSlot && !_vm.equalWith && _vm.showClear && _vm.currentValue !== '' && !_vm.readonly && !_vm.disabled && _vm.isFocus),expression:"!hasRightFullHeightSlot && !equalWith && showClear && currentValue !== '' && !readonly && !disabled && isFocus"}],attrs:{"type":"clear"},nativeOn:{"click":function($event){return _vm.clear($event)}}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.showWarn),expression:"showWarn"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":!_vm.valid ? _vm.firstError : ''},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}),_vm._v(" "),(!_vm.novalidate && _vm.hasLengthEqual && _vm.dirty && _vm.equalWith && !_vm.valid)?_c('icon',{staticClass:"vux-input-icon",attrs:{"type":"warn"},nativeOn:{"click":function($event){return _vm.onClickErrorIcon($event)}}}):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.novalidate && _vm.equalWith && _vm.equalWith === _vm.currentValue && _vm.valid),expression:"!novalidate && equalWith && equalWith === currentValue && valid"}],attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'success'),expression:"novalidate && iconType === 'success'"}],staticClass:"vux-input-icon",attrs:{"type":"success"}}),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.novalidate && _vm.iconType === 'error'),expression:"novalidate && iconType === 'error'"}],staticClass:"vux-input-icon",attrs:{"type":"warn"}}),_vm._v(" "),_vm._t("right"),_vm._v(" "),(_vm.hasRightFullHeightSlot)?_c('div',{staticClass:"vux-x-input-right-full"},[_vm._t("right-full-height")],2):_vm._e()],2),_vm._v(" "),_c('toast',{attrs:{"type":"text","width":"auto","time":600},model:{value:(_vm.showErrorToast),callback:function ($$v) {_vm.showErrorToast=$$v},expression:"showErrorToast"}},[_vm._v(_vm._s(_vm.firstError))])],1)}
var x_input_staticRenderFns = []
var x_input_esExports = { render: x_input_render, staticRenderFns: x_input_staticRenderFns }
/* harmony default export */ var src_components_x_input = (x_input_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-input/index.vue
function x_input_injectStyle (ssrContext) {
  __webpack_require__("aiyf")
}
var x_input_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_input___vue_template_functional__ = false
/* styles */
var x_input___vue_styles__ = x_input_injectStyle
/* scopeId */
var x_input___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_input___vue_module_identifier__ = null
var x_input_Component = x_input_normalizeComponent(
  components_x_input,
  src_components_x_input,
  x_input___vue_template_functional__,
  x_input___vue_styles__,
  x_input___vue_scopeId__,
  x_input___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_input = (x_input_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// EXTERNAL MODULE: ./node_modules/array-find/find.js
var find = __webpack_require__("NXHL");
var find_default = /*#__PURE__*/__webpack_require__.n(find);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/uuid.js
var uuid = __webpack_require__("KRg4");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/selector/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





var components_selector_findByKey = function findByKey(key, options) {
  var _rs = find_default()(options, function (item) {
    return item.key === key;
  });
  return _rs ? _rs.value : key;
};

/* harmony default export */ var components_selector = ({
  name: 'selector',
  mixins: [uuid["a" /* default */]],
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.currentValue = this.value;
    }
  },
  beforeMount: function beforeMount() {
    this.isIOS = /iPad|iPhone|iPod/.test(window.navigator.userAgent);
  },

  computed: {
    fixIos: function fixIos() {
      return !this.placeholder && this.isEmptyValue(this.value) && this.isIOS && this.title;
    },
    color: function color() {
      return this.showPlaceholder ? '#A9A9A9' : '';
    },
    processOptions: function processOptions() {
      var _this = this;

      if (!this.options.length) {
        return [];
      }

      var isObject = typeof_default()(this.options[0]) === 'object';

      if (isObject && !this.valueMap) {
        return this.options;
      }

      if (isObject && this.valueMap) {
        return this.options.map(function (item) {
          return {
            key: item[_this.valueMap[0]],
            value: item[_this.valueMap[1]]
          };
        });
      }

      return this.options.map(function (item) {
        return {
          key: item,
          value: item
        };
      });
    },
    showPlaceholder: function showPlaceholder() {
      if (this.isEmptyValue(this.value) && this.placeholder) {
        return true;
      }
      return false;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    isEmptyValue: function isEmptyValue(val) {
      return typeof val === 'undefined' || val === '' || val === null;
    },

    cleanStyle: clean_style["a" /* default */],
    getFullValue: function getFullValue() {
      var _this2 = this;

      if (!this.value) {
        return null;
      }
      if (!this.options.length) {
        return null;
      }
      if (typeof_default()(this.options[0]) !== 'object') {
        return this.value;
      } else {
        if (!this.valueMap) {
          return this.options.filter(function (one) {
            return one.key === _this2.value;
          });
        } else {
          return this.options.filter(function (one) {
            return one[_this2.valueMap[0]] === _this2.value;
          });
        }
      }
    }
  },
  filters: {
    findByKey: components_selector_findByKey
  },
  watch: {
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  props: {
    title: String,
    direction: String,
    options: {
      type: Array,
      required: true
    },
    name: String,
    placeholder: String,
    readonly: Boolean,
    value: [String, Number, Object, Boolean],
    valueMap: {
      type: Array,
      validator: function validator(val) {
        if (!val.length || val.length !== 2) {
          if (false) {
            console.error('[VUX error] selector prop:valueMap\'s length should be 2');
          }
          return false;
        }
        return true;
      }
    }
  },
  data: function data() {
    return {
      currentValue: '',
      isIOS: false
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bb20de40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/selector/index.vue
var selector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-selector weui-cell",class:{
    'weui-cell_select': !_vm.readonly,
    'weui-cell_select-after': _vm.title
  }},[(_vm.title)?_c('div',{staticClass:"weui-cell__hd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.cleanStyle({
        width: _vm.$parent.labelWidth,
        textAlign: _vm.$parent.labelAlign,
        marginRight: _vm.$parent.labelMarginRight
      })),attrs:{"for":("vux-selector-" + _vm.uuid)},domProps:{"innerHTML":_vm._s(_vm.title)}})]):_vm._e(),_vm._v(" "),(!_vm.readonly)?_c('div',{staticClass:"weui-cell__bd"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-select",style:(_vm.cleanStyle({
        direction: _vm.direction,
        color: _vm.color
      })),attrs:{"id":("vux-selector-" + _vm.uuid),"name":_vm.name},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.currentValue=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[(_vm.showPlaceholder)?_c('option',{domProps:{"value":_vm.value === null ? 'null' : '',"selected":_vm.isEmptyValue(_vm.value) && !!_vm.placeholder}},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.fixIos)?_c('option',{attrs:{"disabled":""}}):_vm._e(),_vm._v(" "),_vm._l((_vm.processOptions),function(one){return _c('option',{domProps:{"value":one.key}},[_vm._v(_vm._s(_vm.direction === 'rtl' ? one.value + '‎' : one.value))])})],2)]):_c('div',{staticClass:"weui-cell__ft vux-selector-readonly"},[_vm._v("\n    "+_vm._s(_vm._f("findByKey")(_vm.value,_vm.processOptions))+"\n  ")])])}
var selector_staticRenderFns = []
var selector_esExports = { render: selector_render, staticRenderFns: selector_staticRenderFns }
/* harmony default export */ var src_components_selector = (selector_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/selector/index.vue
function selector_injectStyle (ssrContext) {
  __webpack_require__("xtLV")
}
var selector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var selector___vue_template_functional__ = false
/* styles */
var selector___vue_styles__ = selector_injectStyle
/* scopeId */
var selector___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var selector___vue_module_identifier__ = null
var selector_Component = selector_normalizeComponent(
  components_selector,
  src_components_selector,
  selector___vue_template_functional__,
  selector___vue_styles__,
  selector___vue_scopeId__,
  selector___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_selector = (selector_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/scroller.js + 2 modules
var scroller = __webpack_require__("+geU");

// EXTERNAL MODULE: ./node_modules/vux/src/components/flexbox/index.js
var flexbox = __webpack_require__("F3HL");

// EXTERNAL MODULE: ./node_modules/vux/src/components/picker/chain.js
var chain = __webpack_require__("zDi5");

// EXTERNAL MODULE: ./node_modules/vux/src/filters/value2name.js
var value2name = __webpack_require__("NE4E");

// EXTERNAL MODULE: ./node_modules/vux/src/libs/is-array.js
var is_array = __webpack_require__("cEdU");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/picker/index.vue


//
//
//
//
//
//
//
//
//
//







/* harmony default export */ var components_picker = ({
  name: 'picker',
  components: {
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */]
  },
  created: function created() {
    if (this.columns !== 0) {
      var length = this.columns;
      this.store = new chain["a" /* default */](this.data, length, this.fixedColumns || this.columns);
      this.currentData = this.store.getColumns(this.value);
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this2.render(_this2.currentData, _this2.currentValue);
    });
  },

  props: {
    data: Array,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: Array,
    itemClass: {
      type: String,
      default: 'scroller-item'
    },
    columnWidth: Array
  },
  methods: {
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    getId: function getId(i) {
      return '#vux-picker-' + this.uuid + '-' + i;
    },
    render: function render(data, value) {
      this.count = this.currentData.length;
      var _this = this;
      if (!data || !data.length) {
        return;
      }
      var count = this.currentData.length;
      // set first item as value
      if (value.length < count) {
        for (var i = 0; i < count; i++) {
          if (false) {
            console.error('[VUX error] 渲染出错，如果为联动模式，需要指定 columns(列数)');
          }
          this.$set(_this.currentValue, i, data[i][0].value || data[i][0]);
        }
      }

      var _loop = function _loop(_i) {
        /**
        * Still don't know why this happens
        */
        if (!document.querySelector(_this.getId(_i))) {
          return {
            v: void 0
          };
        }

        _this.scroller[_i] && _this.scroller[_i].destroy();
        _this.scroller[_i] = new scroller["a" /* default */](_this.getId(_i), {
          data: data[_i],
          defaultValue: value[_i] || data[_i][0].value,
          itemClass: _this.itemClass,
          onSelect: function onSelect(value) {
            _this.$set(_this.currentValue, _i, value);
            if (!this.columns || this.columns && _this.getValue().length === _this.store.count) {
              _this.$nextTick(function () {
                _this.$emit('on-change', _this.getValue());
              });
            }
            if (_this.columns !== 0) {
              _this.renderChain(_i + 1);
            }
          }
        });
        if (_this.currentValue) {
          _this.scroller[_i].select(value[_i]);
        }
      };

      for (var _i = 0; _i < data.length; _i++) {
        var _ret = _loop(_i);

        if ((typeof _ret === 'undefined' ? 'undefined' : typeof_default()(_ret)) === "object") return _ret.v;
      }
    },
    renderChain: function renderChain(i) {
      if (!this.columns) {
        return;
      }

      // do not render for last scroller
      if (i > this.count - 1) {
        return;
      }

      var _this = this;
      var ID = this.getId(i);
      // destroy old one
      this.scroller[i].destroy();
      var list = this.store.getChildren(_this.getValue()[i - 1]);
      this.scroller[i] = new scroller["a" /* default */](ID, {
        data: list,
        itemClass: _this.item_class,
        onSelect: function onSelect(value) {
          _this.$set(_this.currentValue, i, value);
          _this.$nextTick(function () {
            _this.$emit('on-change', _this.getValue());
          });
          _this.renderChain(i + 1);
        }
      });
      // list is Array(empty) as maybe
      if (list.length) {
        this.$set(this.currentValue, i, list[0].value);
        this.renderChain(i + 1);
      } else {
        this.$set(this.currentValue, i, null);
      }
    },
    getValue: function getValue() {
      var data = [];
      for (var i = 0; i < this.currentData.length; i++) {
        if (this.scroller[i]) {
          data.push(this.scroller[i].value);
        } else {
          return [];
        }
      }
      return data;
    },
    emitValueChange: function emitValueChange(val) {
      if (!this.columns || this.columns && val.length === this.store.count) {
        this.$emit('on-change', val);
      }
    }
  },
  data: function data() {
    return {
      scroller: [],
      count: 0,
      uuid: '',
      currentData: this.data,
      currentValue: this.value
    };
  },

  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentValue)) {
        this.currentValue = val;
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      // render all the scroller for chain datas
      if (this.columns !== 0) {
        if (val.length > 0) {
          if (stringify_default()(val) !== stringify_default()(oldVal)) {
            this.currentData = this.store.getColumns(val);
            this.$nextTick(function () {
              this.render(this.currentData, val);
            });
          }
        } else {
          this.render(this.currentData, []);
        }
      } else {
        if (val.length) {
          for (var i = 0; i < val.length; i++) {
            if (this.scroller[i] && this.scroller[i].value !== val[i]) {
              this.scroller[i].select(val[i]);
            }
          }
        } else {
          this.render(this.currentData, []);
        }
      }
    },
    data: function data(val) {
      if (stringify_default()(val) !== stringify_default()(this.currentData)) {
        this.currentData = val;
      }
    },
    currentData: function currentData(newData) {
      var _this3 = this;

      if (Object.prototype.toString.call(newData[0]) === '[object Array]') {
        this.$nextTick(function () {
          _this3.render(newData, _this3.currentValue);
          // emit on-change after rerender
          _this3.$nextTick(function () {
            _this3.emitValueChange(_this3.getValue());

            if (stringify_default()(_this3.getValue()) !== stringify_default()(_this3.currentValue)) {
              if (!_this3.columns || _this3.columns && _this3.getValue().length === _this3.store.count) {
                _this3.currentValue = _this3.getValue();
              }
            }
          });
        });
      } else {
        if (this.columns !== 0) {
          if (!newData.length) {
            return;
          }
          var length = this.columns;
          this.store = new chain["a" /* default */](newData, length, this.fixedColumns || this.columns);
          this.currentData = this.store.getColumns(this.currentValue);
        }
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    for (var i = 0; i < this.count; i++) {
      this.scroller[i] && this.scroller[i].destroy();
      this.scroller[i] = null;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2025380c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/picker/index.vue
var picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-picker"},[_c('flexbox',{attrs:{"gutter":0}},_vm._l((_vm.currentData),function(one,index){return _c('flexbox-item',{key:index,staticStyle:{"margin-left":"0"},attrs:{"span":_vm.columnWidth && _vm.columnWidth[index]}},[_c('div',{staticClass:"vux-picker-item",attrs:{"id":("vux-picker-" + _vm.uuid + "-" + index)}})])}),1)],1)}
var picker_staticRenderFns = []
var picker_esExports = { render: picker_render, staticRenderFns: picker_staticRenderFns }
/* harmony default export */ var src_components_picker = (picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/picker/index.vue
function picker_injectStyle (ssrContext) {
  __webpack_require__("nfGx")
}
var picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var picker___vue_template_functional__ = false
/* styles */
var picker___vue_styles__ = picker_injectStyle
/* scopeId */
var picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var picker___vue_module_identifier__ = null
var picker_Component = picker_normalizeComponent(
  components_picker,
  src_components_picker,
  picker___vue_template_functional__,
  picker___vue_styles__,
  picker___vue_scopeId__,
  picker___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_picker = (picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/array2String.js
var array2String = __webpack_require__("LsKW");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = popup_picker_getObject(val);
        this.currentValue = popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', popup_picker_getObject(val));
      this.$emit('on-change', popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/popup-picker/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var components_popup_picker_getObject = function getObject(obj) {
  return JSON.parse(stringify_default()(obj));
};

/* harmony default export */ var components_popup_picker = ({
  name: 'popup-picker',
  directives: {
    TransferDom: transfer_dom["a" /* default */]
  },
  created: function created() {
    if (typeof this.show !== 'undefined') {
      this.showValue = this.show;
    }
  },

  mixins: [mixin_uuid["a" /* default */]],
  components: {
    Picker: vux_src_components_picker,
    Cell: vux_src_components_cell,
    Popup: node_modules_vux_src_components_popup,
    PopupHeader: vux_src_components_popup_header,
    Flexbox: flexbox["a" /* Flexbox */],
    FlexboxItem: flexbox["b" /* FlexboxItem */],
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    array2string: array2String["a" /* default */],
    value2name: value2name["a" /* default */]
  },
  props: {
    valueTextAlign: {
      type: String,
      default: 'right'
    },
    title: String,
    cancelText: String,
    confirmText: String,
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    placeholder: String,
    columns: {
      type: Number,
      default: 0
    },
    fixedColumns: {
      type: Number,
      default: 0
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    showName: Boolean,
    inlineDesc: [String, Number, Array, Object, Boolean],
    showCell: {
      type: Boolean,
      default: true
    },
    show: Boolean,
    displayFormat: Function,
    isTransferDom: {
      type: Boolean,
      default: true
    },
    columnWidth: Array,
    popupStyle: Object,
    popupTitle: String,
    disabled: Boolean
  },
  computed: {
    labelStyles: function labelStyles() {
      return {
        display: 'block',
        width: this.$parent && (this.$parent.labelWidth || this.$parent.$parent.labelWidth) || 'auto',
        textAlign: this.$parent && (this.$parent.labelAlign || this.$parent.$parent.labelAlign),
        marginRight: this.$parent && (this.$parent.labelMarginRight || this.$parent.$parent.labelMarginRight)
      };
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  methods: {
    value2name: value2name["a" /* default */],
    getNameValues: function getNameValues() {
      return Object(value2name["a" /* default */])(this.currentValue, this.data);
    },
    onClick: function onClick() {
      if (!this.disabled) {
        this.showValue = true;
      }
    },
    onHide: function onHide(type) {
      this.showValue = false;
      if (type) {
        this.closeType = true;
        this.currentValue = components_popup_picker_getObject(this.tempValue);
      }
      if (!type) {
        this.closeType = false;
        if (this.value.length > 0) {
          this.tempValue = components_popup_picker_getObject(this.currentValue);
        }
      }
    },
    onPopupShow: function onPopupShow() {
      // reset close type to false
      this.closeType = false;
      this.$emit('on-show');
    },
    onPopupHide: function onPopupHide(val) {
      if (this.value.length > 0) {
        this.tempValue = components_popup_picker_getObject(this.currentValue);
      }
      this.$emit('on-hide', this.closeType);
    },
    onPickerChange: function onPickerChange(val) {
      if (stringify_default()(this.currentValue) !== stringify_default()(val)) {
        // if has value, replace it
        if (this.value.length) {
          var nowData = stringify_default()(this.data);
          if (nowData !== this.currentData && this.currentData !== '[]') {
            this.tempValue = components_popup_picker_getObject(val);
          }
          this.currentData = nowData;
        } else {// if no value, stay quiet
          // if set to auto update, do update the value
        }
      }
      var _val = components_popup_picker_getObject(val);
      this.$emit('on-shadow-change', _val, Object(value2name["a" /* default */])(_val, this.data).split(' '));
    }
  },
  watch: {
    value: function value(val) {
      if (stringify_default()(val) !== stringify_default()(this.tempValue)) {
        this.tempValue = components_popup_picker_getObject(val);
        this.currentValue = components_popup_picker_getObject(val);
      }
    },
    currentValue: function currentValue(val) {
      this.$emit('input', components_popup_picker_getObject(val));
      this.$emit('on-change', components_popup_picker_getObject(val));
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  },
  data: function data() {
    return {
      onShowProcess: false,
      tempValue: components_popup_picker_getObject(this.value),
      closeType: false,
      currentData: stringify_default()(this.data), // used for detecting if it is after data change
      showValue: false,
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a333ce","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/popup-picker/index.vue
var popup_picker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-cell-box"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCell),expression:"showCell"}],staticClass:"weui-cell vux-tap-active",class:{'weui-cell_access': !_vm.disabled},on:{"click":_vm.onClick}},[_c('div',{staticClass:"weui-cell__hd"},[_vm._t("title",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyles),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e()],{"labelClass":"weui-label","labelStyle":_vm.labelStyles,"labelTitle":_vm.title}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"vux-cell-primary vux-popup-picker-select-box"},[_c('div',{staticClass:"vux-popup-picker-select",style:({textAlign: _vm.valueTextAlign})},[(!_vm.displayFormat && !_vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("array2string")(_vm.value)))]):_vm._e(),_vm._v(" "),(!_vm.displayFormat && _vm.showName && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm._f("value2name")(_vm.value,_vm.data)))]):_vm._e(),_vm._v(" "),(_vm.displayFormat && _vm.value.length)?_c('span',{staticClass:"vux-popup-picker-value vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat(_vm.value, _vm.value2name(_vm.value, _vm.data))))]):_vm._e(),_vm._v(" "),(!_vm.value.length && _vm.placeholder)?_c('span',{staticClass:"vux-popup-picker-placeholder vux-cell-placeholder",domProps:{"textContent":_vm._s(_vm.placeholder)}}):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"})]),_vm._v(" "),_c('div',{directives:[{name:"transfer-dom",rawName:"v-transfer-dom",value:(_vm.isTransferDom),expression:"isTransferDom"}]},[_c('popup',{staticClass:"vux-popup-picker",attrs:{"id":("vux-popup-picker-" + _vm.uuid),"popup-style":_vm.popupStyle},on:{"on-hide":_vm.onPopupHide,"on-show":_vm.onPopupShow},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"vux-popup-picker-container"},[_c('popup-header',{attrs:{"left-text":_vm.cancelText || '取消',"right-text":_vm.confirmText || '完成',"title":_vm.popupTitle},on:{"on-click-left":function($event){return _vm.onHide(false)},"on-click-right":function($event){return _vm.onHide(true)}}}),_vm._v(" "),_c('picker',{attrs:{"data":_vm.data,"columns":_vm.columns,"fixed-columns":_vm.fixedColumns,"container":'#vux-popup-picker-'+_vm.uuid,"column-width":_vm.columnWidth},on:{"on-change":_vm.onPickerChange},model:{value:(_vm.tempValue),callback:function ($$v) {_vm.tempValue=$$v},expression:"tempValue"}})],1)])],1)])}
var popup_picker_staticRenderFns = []
var popup_picker_esExports = { render: popup_picker_render, staticRenderFns: popup_picker_staticRenderFns }
/* harmony default export */ var src_components_popup_picker = (popup_picker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/popup-picker/index.vue
function popup_picker_injectStyle (ssrContext) {
  __webpack_require__("rFhX")
}
var popup_picker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var popup_picker___vue_template_functional__ = false
/* styles */
var popup_picker___vue_styles__ = popup_picker_injectStyle
/* scopeId */
var popup_picker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var popup_picker___vue_module_identifier__ = null
var popup_picker_Component = popup_picker_normalizeComponent(
  components_popup_picker,
  src_components_popup_picker,
  popup_picker___vue_template_functional__,
  popup_picker___vue_styles__,
  popup_picker___vue_scopeId__,
  popup_picker___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_popup_picker = (popup_picker_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/datetime/datetimepicker.js + 3 modules
var datetimepicker = __webpack_require__("zV4+");

// EXTERNAL MODULE: ./node_modules/vux/src/tools/date/format.js
var date_format = __webpack_require__("ODCk");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/datetime/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_datetime = ({
  name: 'datetime',
  mixins: [uuid["a" /* default */]],
  components: {
    Group: vux_src_components_group,
    InlineDesc: vux_src_components_inline_desc,
    Icon: vux_src_components_icon
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD',
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          return console.error('[VUX] Datetime prop:format 使用 A 时只允许的值为： YYYY-MM-DD A');
        }
        return true;
      }
    },
    title: String,
    value: {
      type: String,
      default: ''
    },
    inlineDesc: String,
    placeholder: String,
    minYear: Number,
    maxYear: Number,
    confirmText: String,
    cancelText: String,
    clearText: String,
    yearRow: {
      type: String,
      default: '{value}'
    },
    monthRow: {
      type: String,
      default: '{value}'
    },
    dayRow: {
      type: String,
      default: '{value}'
    },
    hourRow: {
      type: String,
      default: '{value}'
    },
    minuteRow: {
      type: String,
      default: '{value}'
    },
    required: {
      type: Boolean,
      default: false
    },
    minHour: {
      type: Number,
      default: 0
    },
    maxHour: {
      type: Number,
      default: 23
    },
    startDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:start-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    endDate: {
      type: String,
      validator: function validator(val) {
        /* istanbul ignore if */
        if (false) {
          console.error('[VUX] Datetime prop:end-date 必须为 YYYY-MM-DD 格式');
        }
        return val ? val.length === 10 : true;
      }
    },
    valueTextAlign: String,
    displayFormat: Function,
    readonly: Boolean,
    hourList: Array,
    minuteList: Array,
    show: Boolean,
    defaultSelectedValue: String,
    computeHoursFunction: Function,
    computeDaysFunction: Function,
    orderMap: Object
  },
  created: function created() {
    this.isFirstSetValue = false;
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentShow: false,
      currentValue: null,
      valid: true,
      errors: {}
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    var uuid = this.uuid;
    this.$el.setAttribute('id', 'vux-datetime-' + uuid);
    if (!this.readonly) {
      this.$nextTick(function () {
        _this2.render();

        if (_this2.show) {
          _this2.$nextTick(function () {
            _this2.picker && _this2.picker.show(_this2.currentValue);
          });
        }
      });
    }
  },

  computed: {
    styles: function styles() {
      if (!this.$parent) {
        return {};
      }
      return {
        width: this.$parent.labelWidth,
        textAlign: this.$parent.labelAlign,
        marginRight: this.$parent.labelMarginRight
      };
    },
    pickerOptions: function pickerOptions() {
      var _this = this;
      var options = {
        trigger: '#vux-datetime-' + this.uuid,
        format: this.format,
        value: this.currentValue,
        output: '.vux-datetime-value',
        confirmText: _this.getButtonText('confirm'),
        cancelText: _this.getButtonText('cancel'),
        clearText: _this.clearText,
        yearRow: this.yearRow,
        monthRow: this.monthRow,
        dayRow: this.dayRow,
        hourRow: this.hourRow,
        minuteRow: this.minuteRow,
        minHour: this.minHour,
        maxHour: this.maxHour,
        startDate: this.startDate,
        endDate: this.endDate,
        hourList: this.hourList,
        minuteList: this.minuteList,
        defaultSelectedValue: this.defaultSelectedValue,
        computeHoursFunction: this.computeHoursFunction,
        computeDaysFunction: this.computeDaysFunction,
        orderMap: this.orderMap || {},
        onSelect: function onSelect(type, val, wholeValue) {
          if (_this.picker && _this.picker.config.renderInline) {
            _this.$emit('input', wholeValue);
            _this.$emit('on-change', wholeValue);
          }
        },
        onConfirm: function onConfirm(value) {
          _this.currentValue = value;
        },
        onClear: function onClear(value) {
          _this.$emit('on-clear', value);
        },
        onHide: function onHide(type) {
          _this.currentShow = false;
          _this.$emit('update:show', false);
          _this.validate();
          _this.$emit('on-hide', type);
          if (type === 'cancel') {
            _this.$emit('on-cancel');
          }
          if (type === 'confirm') {
            setTimeout(function () {
              _this.$nextTick(function () {
                _this.$emit('on-confirm', _this.value);
              });
            });
          }
        },
        onShow: function onShow() {
          _this.currentShow = true;
          _this.$emit('update:show', true);
          _this.$emit('on-show');
        }
      };
      if (this.minYear) {
        options.minYear = this.minYear;
      }
      if (this.maxYear) {
        options.maxYear = this.maxYear;
      }
      return options;
    },
    firstError: function firstError() {
      var key = keys_default()(this.errors)[0];
      return this.errors[key];
    },
    labelClass: function labelClass() {
      if (!this.$parent) {
        return {};
      }
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    getButtonText: function getButtonText(type) {
      if (type === 'cancel' && this.cancelText) {
        return this.cancelText;
      } else if (type === 'confirm' && this.confirmText) {
        return this.confirmText;
      }
      return this.$el.getAttribute('data-' + type + '-text');
    },
    render: function render() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.picker && _this3.picker.destroy();
        _this3.picker = new datetimepicker["a" /* default */](_this3.pickerOptions);
      });
    },
    validate: function validate() {
      if (!this.currentValue && this.required) {
        this.valid = false;
        this.errors.required = '必填';
        return;
      }
      this.valid = true;
      this.errors = {};
    }
  },
  watch: {
    readonly: function readonly(val) {
      if (val) {
        this.picker && this.picker.destroy();
      } else {
        this.render();
      }
    },
    show: function show(val) {
      if (val === this.currentShow) return;
      if (val) {
        this.picker && this.picker.show(this.currentValue);
      } else {
        this.picker && this.picker.hide(this.currentValue);
      }
    },
    currentValue: function currentValue(val, oldVal) {
      this.$emit('input', val);
      if (!this.isFirstSetValue) {
        this.isFirstSetValue = true;
        oldVal && this.$emit('on-change', val);
      } else {
        this.$emit('on-change', val);
      }
      this.validate();
    },
    startDate: function startDate() {
      this.render();
    },
    endDate: function endDate() {
      this.render();
    },
    format: function format(val) {
      if (this.currentValue) {
        this.currentValue = Object(date_format["a" /* default */])(this.currentValue, val);
      }
      this.render();
    },
    value: function value(val) {
      // do not force render when renderInline is true
      if (this.readonly || this.picker && this.picker.config.renderInline) {
        this.currentValue = val;
        return;
      }
      if (this.currentValue !== val) {
        this.currentValue = val;
        this.render();
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.picker && this.picker.destroy();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-241efaf4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/datetime/index.vue
var datetime_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"vux-datetime weui-cell",class:{'weui-cell_access': !_vm.readonly},attrs:{"data-cancel-text":'取消',"data-confirm-text":'确定',"href":"javascript:"}},[_vm._t("default",[_c('div',[_vm._t("title",[_c('p',{class:_vm.labelClass,style:(_vm.styles),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft vux-cell-primary vux-datetime-value",style:({
        textAlign: _vm.valueTextAlign
      })},[(!_vm.currentValue && _vm.placeholder)?_c('span',{staticClass:"vux-cell-placeholder"},[_vm._v(_vm._s(_vm.placeholder))]):_vm._e(),_vm._v(" "),(_vm.currentValue)?_c('span',{staticClass:"vux-cell-value"},[_vm._v(_vm._s(_vm.displayFormat ? _vm.displayFormat(_vm.currentValue) : _vm.currentValue))]):_vm._e(),_vm._v(" "),_c('icon',{directives:[{name:"show",rawName:"v-show",value:(!_vm.valid),expression:"!valid"}],staticClass:"vux-input-icon",attrs:{"type":"warn","title":_vm.firstError}})],1)])],2)}
var datetime_staticRenderFns = []
var datetime_esExports = { render: datetime_render, staticRenderFns: datetime_staticRenderFns }
/* harmony default export */ var src_components_datetime = (datetime_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/datetime/index.vue
function datetime_injectStyle (ssrContext) {
  __webpack_require__("jYbJ")
}
var datetime_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var datetime___vue_template_functional__ = false
/* styles */
var datetime___vue_styles__ = datetime_injectStyle
/* scopeId */
var datetime___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var datetime___vue_module_identifier__ = null
var datetime_Component = datetime_normalizeComponent(
  components_datetime,
  src_components_datetime,
  datetime___vue_template_functional__,
  datetime___vue_styles__,
  datetime___vue_scopeId__,
  datetime___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_datetime = (datetime_Component.exports);

// EXTERNAL MODULE: ./node_modules/big.js/big.js
var big = __webpack_require__("gaXx");
var big_default = /*#__PURE__*/__webpack_require__.n(big);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-number/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_x_number = ({
  name: 'x-number',
  props: {
    min: Number,
    max: Number,
    readonly: Boolean,
    step: {
      type: Number,
      default: 1
    },
    value: {
      validator: function validator(value) {
        if (typeof value === 'number') {
          return true;
        } else if (typeof value === 'string') {
          return value === '';
        }
        return false;
      },

      default: 0
    },
    name: String,
    title: String,
    fillable: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50px'
    },
    buttonStyle: {
      type: String,
      default: 'square'
    },
    align: {
      type: String,
      default: 'right'
    }
  },
  created: function created() {
    this.currentValue = this.value;
  },
  data: function data() {
    return {
      currentValue: 0
    };
  },

  computed: {
    disabledMin: function disabledMin() {
      return typeof this.min === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue <= this.min;
    },
    disabledMax: function disabledMax() {
      return typeof this.max === 'undefined' ? false : this.currentValue === '' ? true : this.currentValue >= this.max;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  watch: {
    currentValue: function currentValue(newValue, old) {
      if (newValue !== '') {
        if (typeof this.min !== 'undefined' && this.currentValue < this.min) {
          this.currentValue = this.min;
        }
        if (this.max && this.currentValue > this.max) {
          this.currentValue = this.max;
        }
      }
      this.$emit('input', this.currentValue);
    },
    value: function value(newValue) {
      this.currentValue = newValue;
      this.$emit('on-change', newValue);
    }
  },
  methods: {
    add: function add() {
      if (!this.disabledMax) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.plus(this.step) * 1;
      }
    },
    sub: function sub() {
      if (!this.disabledMin) {
        var x = new big_default.a(this.currentValue);
        this.currentValue = x.minus(this.step) * 1;
      }
    },
    blur: function blur() {
      if (this.currentValue === '') {
        this.currentValue = 0;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4271d76a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-number/index.vue
var x_number_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell"},[_c('div',[_c('p',{class:_vm.labelClass,style:({width: _vm.$parent.labelWidth, textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.readonly),expression:"!readonly"}],staticClass:"weui-cell__ft vux-cell-primary",class:{'vux-number-round': _vm.buttonStyle === 'round'},staticStyle:{"font-size":"0"}},[_c('div',{style:({float:_vm.align})},[_c('a',{staticClass:"vux-number-selector vux-number-selector-sub",class:{'vux-number-disabled':_vm.disabledMin},on:{"click":_vm.sub}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18","height":"18"}},[_c('defs'),_c('path',{attrs:{"d":"M863.74455 544.00086 163.424056 544.00086c-17.664722 0-32.00086-14.336138-32.00086-32.00086s14.336138-32.00086 32.00086-32.00086l700.320495 0c17.695686 0 31.99914 14.336138 31.99914 32.00086S881.440237 544.00086 863.74455 544.00086z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model.number",value:(_vm.currentValue),expression:"currentValue",modifiers:{"number":true}}],staticClass:"vux-number-input",style:({width: _vm.width}),attrs:{"name":_vm.name,"readonly":!_vm.fillable,"pattern":"[0-9]*","type":"number"},domProps:{"value":(_vm.currentValue)},on:{"blur":[_vm.blur,function($event){return _vm.$forceUpdate()}],"input":function($event){if($event.target.composing){ return; }_vm.currentValue=_vm._n($event.target.value)}}}),_vm._v(" "),_c('a',{staticClass:"vux-number-selector vux-number-selector-plus",class:{'vux-number-disabled':_vm.disabledMax},on:{"click":_vm.add}},[_c('svg',{attrs:{"viewBox":"0 0 1024 1024","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"20","height":"20"}},[_c('defs'),_c('path',{attrs:{"d":"M863.328262 481.340895l-317.344013 0.099772L545.984249 162.816826c0-17.664722-14.336138-32.00086-32.00086-32.00086s-31.99914 14.336138-31.99914 32.00086l0 318.400215-322.368714-0.17718c-0.032684 0-0.063647 0-0.096331 0-17.632039 0-31.935493 14.239806-32.00086 31.904529-0.096331 17.664722 14.208843 32.031824 31.871845 32.095471l322.59234 0.17718 0 319.167424c0 17.695686 14.336138 32.00086 31.99914 32.00086s32.00086-14.303454 32.00086-32.00086L545.982529 545.440667l317.087703-0.099772c0.063647 0 0.096331 0 0.127295 0 17.632039 0 31.935493-14.239806 32.00086-31.904529S880.960301 481.404542 863.328262 481.340895z"}})])])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.readonly),expression:"readonly"}],staticClass:"weui-cell__ft vux-cell-primary"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n  ")])])}
var x_number_staticRenderFns = []
var x_number_esExports = { render: x_number_render, staticRenderFns: x_number_staticRenderFns }
/* harmony default export */ var src_components_x_number = (x_number_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-number/index.vue
function x_number_injectStyle (ssrContext) {
  __webpack_require__("MMr7")
}
var x_number_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_number___vue_template_functional__ = false
/* styles */
var x_number___vue_styles__ = x_number_injectStyle
/* scopeId */
var x_number___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_number___vue_module_identifier__ = null
var x_number_Component = x_number_normalizeComponent(
  components_x_number,
  src_components_x_number,
  x_number___vue_template_functional__,
  x_number___vue_styles__,
  x_number___vue_scopeId__,
  x_number___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_number = (x_number_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/datas/china_address.json
var china_address = __webpack_require__("2GJp");
var china_address_default = /*#__PURE__*/__webpack_require__.n(china_address);

// EXTERNAL MODULE: ./node_modules/vux/src/filters/name2value.js
var name2value = __webpack_require__("dH7R");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-address/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var components_x_address = ({
  name: 'x-address',
  components: {
    PopupPicker: vux_src_components_popup_picker
  },
  props: {
    title: {
      type: String,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    rawValue: Boolean,
    list: {
      type: Array,
      required: true
    },
    labelWidth: String,
    inlineDesc: String,
    placeholder: String,
    hideDistrict: Boolean,
    valueTextAlign: String,
    confirmText: String,
    cancelText: String,
    displayFormat: {
      type: Function,
      default: function _default(val, names) {
        return names;
      }
    },
    popupStyle: Object,
    popupTitle: String,
    show: Boolean,
    disabled: Boolean
  },
  created: function created() {
    if (this.currentValue.length && this.rawValue) {
      var parsedVal = Object(name2value["a" /* default */])(this.currentValue, this.list);
      if (/__/.test(parsedVal)) {
        console.error('[VUX] Wrong address value', this.currentValue);
        this.currentValue = [];
      } else {
        this.currentValue = parsedVal.split(' ');
      }
    }
    if (this.show) {
      this.showValue = true;
    }
  },

  methods: {
    emitHide: function emitHide(val) {
      this.$emit('on-hide', val);
    },
    getAddressName: function getAddressName() {
      return Object(value2name["a" /* default */])(this.value, this.list);
    },
    onShadowChange: function onShadowChange(ids, names) {
      this.$emit('on-shadow-change', ids, names);
    }
  },
  data: function data() {
    return {
      currentValue: this.value,
      showValue: false
    };
  },

  computed: {
    nameValue: function nameValue() {
      return Object(value2name["a" /* default */])(this.currentValue, this.list);
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.$parent && (this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify')
      };
    }
  },
  watch: {
    currentValue: function currentValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (val.length && !/\d+/.test(val[0])) {
        var id = Object(name2value["a" /* default */])(val, this.list).split(' ');
        if (id[0] !== '__' && id[1] !== '__') {
          this.currentValue = id;
          return;
        }
      }
      this.currentValue = val;
    },
    show: function show(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('update:show', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-56bdfb3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-address/index.vue
var x_address_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('popup-picker',{attrs:{"fixed-columns":_vm.hideDistrict ? 2 : 0,"columns":3,"data":_vm.list,"title":_vm.title,"show-name":"","inline-desc":_vm.inlineDesc,"placeholder":_vm.placeholder,"value-text-align":_vm.valueTextAlign,"confirm-text":_vm.confirmText,"cancel-text":_vm.cancelText,"display-format":_vm.displayFormat,"popup-style":_vm.popupStyle,"popup-title":_vm.popupTitle,"show":_vm.showValue,"disabled":_vm.disabled},on:{"update:show":function($event){_vm.showValue=$event},"on-shadow-change":_vm.onShadowChange,"on-hide":_vm.emitHide,"on-show":function($event){return _vm.$emit('on-show')}},scopedSlots:_vm._u([{key:"title",fn:function(props){return [_vm._t("title",[(props.labelTitle)?_c('label',{class:[props.labelClass,_vm.labelClass],style:(props.labelStyle),domProps:{"innerHTML":_vm._s(props.labelTitle)}}):_vm._e()],{"labelClass":props.labelClass,"labelStyle":props.labelStyles,"labelTitle":props.title})]}}],null,true),model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})}
var x_address_staticRenderFns = []
var x_address_esExports = { render: x_address_render, staticRenderFns: x_address_staticRenderFns }
/* harmony default export */ var src_components_x_address = (x_address_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-address/index.vue
var x_address_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_address___vue_template_functional__ = false
/* styles */
var x_address___vue_styles__ = null
/* scopeId */
var x_address___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_address___vue_module_identifier__ = null
var x_address_Component = x_address_normalizeComponent(
  components_x_address,
  src_components_x_address,
  x_address___vue_template_functional__,
  x_address___vue_styles__,
  x_address___vue_scopeId__,
  x_address___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_address = (x_address_Component.exports);

// EXTERNAL MODULE: ./node_modules/autosize/dist/autosize.js
var autosize = __webpack_require__("JnrT");
var autosize_default = /*#__PURE__*/__webpack_require__.n(autosize);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-textarea/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 // prop.autosize

/* harmony default export */ var components_x_textarea = ({
  name: 'x-textarea',
  minxins: [base["a" /* default */]],
  mounted: function mounted() {
    var _this = this;

    if (this.$slots && this.$slots['restricted-label']) {
      this.hasRestrictedLabel = true;
    }
    // prop.autosize
    this.$nextTick(function () {
      if (_this.autosize) {
        _this.bindAutosize();
      }
    });
    // prop.autosize
  },

  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  props: {
    title: String,
    inlineDesc: String,
    showCounter: {
      type: Boolean,
      default: true
    },
    max: Number,
    value: String,
    name: String,
    placeholder: String,
    readonly: Boolean,
    disabled: Boolean,
    rows: {
      type: Number,
      default: 3
    },
    cols: {
      type: Number,
      default: 30
    },
    height: Number,
    // https://github.com/yisibl/blog/issues/3
    autocomplete: {
      type: String,
      default: 'off'
    },
    autocapitalize: {
      type: String,
      default: 'off'
    },
    autocorrect: {
      type: String,
      default: 'off'
    },
    spellcheck: {
      type: String,
      default: 'false'
    },
    autosize: Boolean // prop.autosize
  },
  created: function created() {
    this.currentValue = this.value;
  },

  watch: {
    // prop.autosize
    autosize: function autosize(val) {
      this.unbindAutosize();
      if (val) {
        this.bindAutosize();
      }
    },

    // prop.autosize
    value: function value(val) {
      this.currentValue = val;
    },
    currentValue: function currentValue(newVal) {
      var _this2 = this;

      if (this.max && newVal) {
        var len = newVal.replace(/\n/g, 'aa').length;
        if (len > this.max) {
          var newLines = newVal.match(/\n/g).length;
          this.currentValue = newVal.slice(0, this.max - newLines);
          this.$nextTick(function () {
            if (_this2.autosize) {
              _this2.updateAutosize();
            }
          });
        }
      }
      this.$emit('input', this.currentValue);
      this.$emit('on-change', this.currentValue);
    }
  },
  data: function data() {
    return {
      hasRestrictedLabel: false,
      currentValue: ''
    };
  },

  computed: {
    count: function count() {
      var len = 0;
      if (this.currentValue) {
        len = this.currentValue.replace(/\n/g, 'aa').length;
      }
      return len > this.max ? this.max : len;
    },
    textareaStyle: function textareaStyle() {
      if (this.height) {
        return {
          height: this.height + 'px'
        };
      }
    },
    labelStyles: function labelStyles() {
      var _$parent = this.$parent,
          $parent = _$parent === undefined ? {} : _$parent;

      return {
        width: $parent.labelWidth || this.labelWidth + 'em',
        textAlign: $parent.labelAlign,
        marginRight: $parent.labelMarginRight
      };
    },
    labelWidth: function labelWidth() {
      return this.title.replace(/[^x00-xff]/g, '00').length / 2 + 1;
    },
    labelClass: function labelClass() {
      if (!this.$parent) return {};
      return {
        'vux-cell-justify': this.$parent.labelAlign === 'justify' || this.$parent.$parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    updateAutosize: function updateAutosize() {
      autosize_default.a.update(this.$refs.textarea);
    },

    // prop.autosize
    bindAutosize: function bindAutosize() {
      autosize_default()(this.$refs.textarea);
    },
    unbindAutosize: function unbindAutosize() {
      autosize_default.a.destroy(this.$refs.textarea);
    },

    // prop.autosize
    focus: function focus() {
      this.$refs.textarea.focus();
    }
  },
  // prop.autosize
  beforeDestroy: function beforeDestroy() {
    this.unbindAutosize();
  }
  // prop.autosize

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1665f55a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-textarea/index.vue
var x_textarea_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-cell vux-x-textarea"},[_c('div',{staticClass:"weui-cell__hd"},[(_vm.hasRestrictedLabel)?_c('div',{style:(_vm.labelStyles)},[_vm._t("restricted-label")],2):_vm._e(),_vm._v(" "),_vm._t("label",[(_vm.title)?_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:({width: _vm.$parent.labelWidth || (_vm.labelWidth + 'em'), textAlign: _vm.$parent.labelAlign, marginRight: _vm.$parent.labelMarginRight}),domProps:{"innerHTML":_vm._s(_vm.title)}}):_vm._e(),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"textarea",staticClass:"weui-textarea",style:(_vm.textareaStyle),attrs:{"autocomplete":_vm.autocomplete,"autocapitalize":_vm.autocapitalize,"autocorrect":_vm.autocorrect,"spellcheck":_vm.spellcheck,"placeholder":_vm.placeholder,"readonly":_vm.readonly,"disabled":_vm.disabled,"name":_vm.name,"rows":_vm.rows,"cols":_vm.cols,"maxlength":_vm.max},domProps:{"value":(_vm.currentValue)},on:{"focus":function($event){return _vm.$emit('on-focus')},"blur":function($event){return _vm.$emit('on-blur')},"input":function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value}}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCounter && _vm.max),expression:"showCounter && max"}],staticClass:"weui-textarea-counter",on:{"click":_vm.focus}},[_c('span',[_vm._v(_vm._s(_vm.count))]),_vm._v("/"+_vm._s(_vm.max)+"\n    ")])])])}
var x_textarea_staticRenderFns = []
var x_textarea_esExports = { render: x_textarea_render, staticRenderFns: x_textarea_staticRenderFns }
/* harmony default export */ var src_components_x_textarea = (x_textarea_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-textarea/index.vue
function x_textarea_injectStyle (ssrContext) {
  __webpack_require__("9TJo")
}
var x_textarea_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_textarea___vue_template_functional__ = false
/* styles */
var x_textarea___vue_styles__ = x_textarea_injectStyle
/* scopeId */
var x_textarea___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_textarea___vue_module_identifier__ = null
var x_textarea_Component = x_textarea_normalizeComponent(
  components_x_textarea,
  src_components_x_textarea,
  x_textarea___vue_template_functional__,
  x_textarea___vue_styles__,
  x_textarea___vue_scopeId__,
  x_textarea___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_textarea = (x_textarea_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/x-switch/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var components_x_switch = ({
  name: 'x-switch',
  components: {
    InlineDesc: vux_src_components_inline_desc
  },
  computed: {
    parent: function parent() {
      var $parent = this.$parent;

      return $parent || {};
    },
    labelStyle: function labelStyle() {
      var isHTML = /<\/?[^>]*>/.test(this.title);
      var width = Math.min(isHTML ? 5 : this.title.length + 1, 14) + 'em';
      return Object(clean_style["a" /* default */])({
        display: 'block',
        width: this.parent.labelWidth || width,
        textAlign: this.parent.labelAlign
      });
    },
    labelClass: function labelClass() {
      return {
        'vux-cell-justify': this.parent.labelAlign === 'justify'
      };
    }
  },
  methods: {
    onClick: function onClick() {
      this.$emit('on-click', !this.currentValue, this.currentValue);
    },
    toBoolean: function toBoolean(val) {
      if (!this.valueMap) {
        return val;
      } else {
        var index = this.valueMap.indexOf(val);
        return index === 1;
      }
    },
    toRaw: function toRaw(val) {
      if (!this.valueMap) {
        return val;
      } else {
        return this.valueMap[val ? 1 : 0];
      }
    }
  },
  props: {
    title: {
      type: String,
      required: true
    },
    disabled: Boolean,
    value: {
      type: [Boolean, String, Number],
      default: false
    },
    inlineDesc: [String, Boolean, Number],
    preventDefault: Boolean,
    valueMap: {
      type: Array,
      default: function _default() {
        return [false, true];
      }
    }
  },
  data: function data() {
    return {
      currentValue: this.toBoolean(this.value)
    };
  },

  watch: {
    currentValue: function currentValue(val) {
      var rawValue = this.toRaw(val);
      this.$emit('input', rawValue);
      this.$emit('on-change', rawValue);
    },
    value: function value(val) {
      this.currentValue = this.toBoolean(val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12b3ed8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/x-switch/index.vue
var x_switch_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-x-switch weui-cell weui-cell_switch"},[_c('div',{staticClass:"weui-cell__bd"},[_c('label',{staticClass:"weui-label",class:_vm.labelClass,style:(_vm.labelStyle),domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._v(" "),(_vm.inlineDesc)?_c('inline-desc',[_vm._v(_vm._s(_vm.inlineDesc))]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"weui-cell__ft"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-switch",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,null)>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),(_vm.preventDefault)?_c('div',{staticClass:"vux-x-switch-overlay",on:{"click":_vm.onClick}}):_vm._e()])])}
var x_switch_staticRenderFns = []
var x_switch_esExports = { render: x_switch_render, staticRenderFns: x_switch_staticRenderFns }
/* harmony default export */ var src_components_x_switch = (x_switch_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/x-switch/index.vue
function x_switch_injectStyle (ssrContext) {
  __webpack_require__("NxQa")
}
var x_switch_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var x_switch___vue_template_functional__ = false
/* styles */
var x_switch___vue_styles__ = x_switch_injectStyle
/* scopeId */
var x_switch___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var x_switch___vue_module_identifier__ = null
var x_switch_Component = x_switch_normalizeComponent(
  components_x_switch,
  src_components_x_switch,
  x_switch___vue_template_functional__,
  x_switch___vue_styles__,
  x_switch___vue_scopeId__,
  x_switch___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_x_switch = (x_switch_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/alert/module.js + 2 modules
var alert_module = __webpack_require__("+zLN");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tip/index.vue
//
//
//
//
//
//

/* harmony default export */ var components_tip = ({
  name: 'tip',
  props: {
    align: {
      type: String,
      default: 'left'
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09e4095d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tip/index.vue
var tip_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-group-tip",style:({'text-align':_vm.align})},[_vm._t("default")],2)}
var tip_staticRenderFns = []
var tip_esExports = { render: tip_render, staticRenderFns: tip_staticRenderFns }
/* harmony default export */ var src_components_tip = (tip_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tip/index.vue
function tip_injectStyle (ssrContext) {
  __webpack_require__("dpWl")
}
var tip_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tip___vue_template_functional__ = false
/* styles */
var tip___vue_styles__ = tip_injectStyle
/* scopeId */
var tip___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tip___vue_module_identifier__ = null
var tip_Component = tip_normalizeComponent(
  components_tip,
  src_components_tip,
  tip___vue_template_functional__,
  tip___vue_styles__,
  tip___vue_scopeId__,
  tip___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_tip = (tip_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/checklist/object-filter.js
var object_filter = __webpack_require__("q5lo");

// EXTERNAL MODULE: ./node_modules/array-shuffle/index.js
var array_shuffle = __webpack_require__("HHx2");
var array_shuffle_default = /*#__PURE__*/__webpack_require__.n(array_shuffle);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["d" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["d" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["c" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["c" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["c" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checklist/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var components_checklist = ({
  name: 'checklist',
  components: {
    Tip: vux_src_components_tip,
    Icon: vux_src_components_icon,
    InlineDesc: vux_src_components_inline_desc
  },
  filters: {
    getValue: object_filter["d" /* getValue */],
    getKey: object_filter["b" /* getKey */]
  },
  mixins: [base["a" /* default */]],
  props: {
    name: String,
    showError: Boolean,
    title: String,
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    max: Number,
    min: Number,
    fillMode: Boolean,
    randomOrder: Boolean,
    checkDisabled: {
      type: Boolean,
      default: true
    },
    labelPosition: {
      type: String,
      default: 'right'
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      currentValue: [],
      currentOptions: this.options,
      tempValue: '' // used only for radio mode
    };
  },
  beforeUpdate: function beforeUpdate() {
    if (this.isRadio) {
      var length = this.currentValue.length;
      if (length > 1) {
        this.currentValue = [this.currentValue[length - 1]];
      }
      var val = checklist_pure(this.currentValue);
      this.tempValue = val.length ? val[0] : '';
    }
  },
  created: function created() {
    this.handleChangeEvent = true;
    if (this.value) {
      this.currentValue = this.value;
      if (this.isRadio) {
        this.tempValue = this.isRadio ? this.value[0] : this.value;
      }
    }
    if (this.randomOrder) {
      this.currentOptions = array_shuffle_default()(this.options);
    } else {
      this.currentOptions = this.options;
    }
  },

  methods: {
    getValue: object_filter["d" /* getValue */],
    getKey: object_filter["b" /* getKey */],
    getInlineDesc: object_filter["a" /* getInlineDesc */],
    getFullValue: function getFullValue() {
      var labels = Object(object_filter["c" /* getLabels */])(this.options, this.value);
      return this.currentValue.map(function (one, index) {
        return {
          value: one,
          label: labels[index]
        };
      });
    },
    isDisabled: function isDisabled(key) {
      if (!this.checkDisabled) {
        return false;
      }
      if (this._max > 1) {
        return this.currentValue.indexOf(key) === -1 && this.currentValue.length === this._max;
      }
      return false;
    }
  },
  computed: {
    isRadio: function isRadio() {
      if (typeof this.max === 'undefined') {
        return false;
      } else {
        return this.max === 1;
      }
    },
    _total: function _total() {
      return this.fillMode ? this.options.length + 1 : this.options.length;
    },
    _min: function _min() {
      if (!this.required && !this.min) {
        return 0;
      }
      if (!this.required && this.min) {
        return Math.min(this._total, this.min);
      }
      if (this.required) {
        if (this.min) {
          var max = Math.max(1, this.min);
          return Math.min(this._total, max);
        } else {
          return 1;
        }
      }
    },
    _max: function _max() {
      if (!this.required && !this.max) {
        return this._total;
      }
      if (this.max) {
        if (this.max > this._total) {
          return this._total;
        }
        return this.max;
      } else {
        return this._total;
      }
    },
    valid: function valid() {
      return this.currentValue.length >= this._min && this.currentValue.length <= this._max;
    }
  },
  watch: {
    tempValue: function tempValue(val) {
      var _val = val ? [val] : [];
      this.$emit('input', _val);
      this.$emit('on-change', _val, Object(object_filter["c" /* getLabels */])(this.options, _val));
    },
    value: function value(newVal) {
      if (stringify_default()(newVal) !== stringify_default()(this.currentValue)) {
        this.currentValue = newVal;
      }
    },
    options: function options(val) {
      this.currentOptions = val;
    },
    currentValue: function currentValue(newVal) {
      var val = checklist_pure(newVal);

      if (!this.isRadio) {
        this.$emit('input', val);
        this.$emit('on-change', val, Object(object_filter["c" /* getLabels */])(this.options, val));
        var err = {};
        if (this._min) {
          if (this.required) {
            if (this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          } else {
            if (this.currentValue.length && this.currentValue.length < this._min) {
              err = {
                min: this._min
              };
            }
          }
        }
        if (!this.valid && this.dirty && keys_default()(err).length) {
          this.$emit('on-error', err);
        } else {
          this.$emit('on-clear-error');
        }
      }
    }
  }
});
function checklist_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c4e59bc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checklist/index.vue
var checklist_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.disabled ? 'vux-checklist-disabled' : ''},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.title),expression:"title"}],staticClass:"weui-cells__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_vm._t("after-title"),_vm._v(" "),_c('div',{staticClass:"weui-cells weui-cells_checkbox"},_vm._l((_vm.currentOptions),function(one,index){return _c('label',{staticClass:"weui-cell weui-check_label",class:{
        'vux-checklist-label-left': _vm.labelPosition === 'left'
      },attrs:{"for":("checkbox_" + _vm.uuid + "_" + index)}},[_c('div',{staticClass:"weui-cell__hd"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-check",attrs:{"type":"checkbox","name":("vux-checkbox-" + _vm.uuid),"id":_vm.disabled ? '' : ("checkbox_" + _vm.uuid + "_" + index),"disabled":_vm.isDisabled(_vm.getKey(one))},domProps:{"value":_vm.getKey(one),"checked":Array.isArray(_vm.currentValue)?_vm._i(_vm.currentValue,_vm.getKey(one))>-1:(_vm.currentValue)},on:{"change":function($event){var $$a=_vm.currentValue,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=_vm.getKey(one),$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.currentValue=$$a.concat([$$v]))}else{$$i>-1&&(_vm.currentValue=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.currentValue=$$c}}}}),_vm._v(" "),_c('i',{staticClass:"weui-icon-checked vux-checklist-icon-checked"})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.getValue(one))}}),_vm._v(" "),(_vm.getInlineDesc(one))?_c('inline-desc',[_vm._v(_vm._s(_vm.getInlineDesc(one)))]):_vm._e()],1)])}),0),_vm._v(" "),_vm._t("footer")],2)}
var checklist_staticRenderFns = []
var checklist_esExports = { render: checklist_render, staticRenderFns: checklist_staticRenderFns }
/* harmony default export */ var src_components_checklist = (checklist_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checklist/index.vue
function checklist_injectStyle (ssrContext) {
  __webpack_require__("jQI1")
}
var checklist_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checklist___vue_template_functional__ = false
/* styles */
var checklist___vue_styles__ = checklist_injectStyle
/* scopeId */
var checklist___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checklist___vue_module_identifier__ = null
var checklist_Component = checklist_normalizeComponent(
  components_checklist,
  src_components_checklist,
  checklist___vue_template_functional__,
  checklist___vue_styles__,
  checklist___vue_scopeId__,
  checklist___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_checklist = (checklist_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker.vue
//
//
//
//
//
//

/* harmony default export */ var checker_checker = ({
  name: 'checker',
  props: {
    defaultItemClass: String,
    selectedItemClass: String,
    disabledItemClass: String,
    type: {
      type: String,
      default: 'radio'
    },
    value: [String, Number, Array, Object],
    max: Number,
    radioRequired: Boolean
  },
  watch: {
    value: function value(newValue) {
      this.currentValue = newValue;
    },
    currentValue: function currentValue(val) {
      this.$emit('input', val);
      this.$emit('on-change', val);
    }
  },
  data: function data() {
    return {
      currentValue: this.value
    };
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a5c9f890","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker.vue
var checker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-box"},[_vm._t("default")],2)}
var checker_staticRenderFns = []
var checker_esExports = { render: checker_render, staticRenderFns: checker_staticRenderFns }
/* harmony default export */ var components_checker_checker = (checker_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker.vue
function checker_injectStyle (ssrContext) {
  __webpack_require__("Luh7")
}
var checker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker___vue_template_functional__ = false
/* styles */
var checker___vue_styles__ = checker_injectStyle
/* scopeId */
var checker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker___vue_module_identifier__ = null
var checker_Component = checker_normalizeComponent(
  checker_checker,
  components_checker_checker,
  checker___vue_template_functional__,
  checker___vue_styles__,
  checker___vue_scopeId__,
  checker___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker = (checker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/checker/checker-item.vue


//
//
//
//
//
//

/* harmony default export */ var checker_checker_item = ({
  name: 'checker-item',
  props: {
    value: {
      type: [String, Number, Object],
      required: true
    },
    disabled: Boolean
  },
  watch: {
    disabled: function disabled(val) {
      if (val && this.$parent.type === 'radio' && this.value === this.$parent.currentValue) {
        this.$parent.currentValue = '';
      }
    }
  },
  computed: {
    classNames: function classNames() {
      var _this = this;

      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      var names = {
        'vux-tap-active': !this.disabled
      };

      if (this.$parent.defaultItemClass) {
        names[this.$parent.defaultItemClass] = true;
      }

      if (this.$parent.selectedItemClass) {
        var selected = false;
        if (this.$parent.type === 'radio') {
          if (isSimpleValue && this.$parent.currentValue === this.value) {
            selected = true;
          } else if (typeof_default()(this.value) === 'object' && checker_item_isEqual(this.$parent.currentValue, this.value)) {
            selected = true;
          }
        } else {
          if (typeof this.value === 'string') {
            if (this.$parent.currentValue.indexOf(this.value) > -1) {
              selected = true;
            }
          } else if (this.$parent.currentValue && this.$parent.currentValue.length) {
            var match = this.$parent.currentValue.filter(function (one) {
              return checker_item_isEqual(one, _this.value);
            });
            selected = match.length > 0;
          }
        }
        names[this.$parent.selectedItemClass] = selected;
      }

      if (this.$parent.disabledItemClass) {
        names[this.$parent.disabledItemClass] = this.disabled;
      }

      return names;
    }
  },
  methods: {
    select: function select() {
      if (this.$parent.type === 'radio') {
        this.selectRadio();
      } else {
        this.selectCheckbox();
      }
    },
    selectRadio: function selectRadio() {
      if (!this.disabled) {
        if (this.$parent.currentValue === this.value) {
          if (!this.$parent.radioRequired) {
            this.$parent.currentValue = '';
          }
        } else {
          this.$parent.currentValue = this.value;
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    },
    selectCheckbox: function selectCheckbox() {
      if (!this.$parent.currentValue || this.$parent.currentValue === null) {
        this.$parent.currentValue = [];
      }
      var isSimpleValue = typeof this.value === 'string' || typeof this.value === 'number';
      if (!this.disabled) {
        var index = -1;
        if (isSimpleValue) {
          index = this.$parent.currentValue.indexOf(this.value);
        } else {
          index = this.$parent.currentValue.map(function (one) {
            return stringify_default()(one);
          }).indexOf(stringify_default()(this.value));
        }
        if (index > -1) {
          this.$parent.currentValue.splice(index, 1);
        } else {
          if (!this.$parent.max || this.$parent.max && this.$parent.currentValue !== null && this.$parent.currentValue.length < this.$parent.max) {
            if (!this.$parent.currentValue || !this.$parent.currentValue.length) {
              this.$parent.currentValue = [];
            }
            this.$parent.currentValue.push(this.value);
          }
        }
      }
      this.$emit('on-item-click', this.value, this.disabled);
    }
  }
});

function checker_item_isEqual(obj1, obj2) {
  return stringify_default()(obj1) === stringify_default()(obj2);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcb1243a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/checker/checker-item.vue
var checker_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-checker-item",class:_vm.classNames,on:{"click":_vm.select}},[_vm._t("default")],2)}
var checker_item_staticRenderFns = []
var checker_item_esExports = { render: checker_item_render, staticRenderFns: checker_item_staticRenderFns }
/* harmony default export */ var components_checker_checker_item = (checker_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/checker/checker-item.vue
function checker_item_injectStyle (ssrContext) {
  __webpack_require__("uGHa")
}
var checker_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var checker_item___vue_template_functional__ = false
/* styles */
var checker_item___vue_styles__ = checker_item_injectStyle
/* scopeId */
var checker_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var checker_item___vue_module_identifier__ = null
var checker_item_Component = checker_item_normalizeComponent(
  checker_checker_item,
  components_checker_checker_item,
  checker_item___vue_template_functional__,
  checker_item___vue_styles__,
  checker_item___vue_scopeId__,
  checker_item___vue_module_identifier__
)

/* harmony default export */ var src_components_checker_checker_item = (checker_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/confirm/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var src_components_confirm = ({
  name: 'confirm',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showInput: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: 'ios'
    },
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    title: String,
    confirmText: String,
    cancelText: String,
    maskTransition: {
      type: String,
      default: 'vux-fade'
    },
    maskZIndex: [Number, String],
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    content: String,
    closeOnConfirm: {
      type: Boolean,
      default: true
    },
    inputAttrs: Object,
    showContent: {
      type: Boolean,
      default: true
    },
    confirmType: {
      type: String,
      default: 'primary'
    },
    showCancelButton: {
      type: Boolean,
      default: true
    },
    showConfirmButton: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.showValue = this.show;
    if (this.value) {
      this.showValue = this.value;
    }
  },

  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      var _this = this;

      this.$emit('input', val);
      if (val) {
        if (this.showInput) {
          this.msg = '';
          setTimeout(function () {
            if (_this.$refs.input) {
              _this.setInputFocus();
            }
          }, 300);
        }
        this.$emit('on-show'); // emit just after msg is cleared
      }
    }
  },
  data: function data() {
    return {
      msg: '',
      showValue: false
    };
  },

  methods: {
    getInputAttrs: function getInputAttrs() {
      return this.inputAttrs || {
        type: 'text'
      };
    },
    setInputValue: function setInputValue(val) {
      this.msg = val;
    },
    setInputFocus: function setInputFocus(evt) {
      if (evt) {
        evt.preventDefault();
      }
      this.$refs.input.focus();
    },
    _onConfirm: function _onConfirm() {
      if (!this.showValue) {
        return;
      }
      if (this.closeOnConfirm) {
        this.showValue = false;
      }
      this.$emit('on-confirm', this.msg);
    },
    _onCancel: function _onCancel() {
      if (!this.showValue) {
        return;
      }
      this.showValue = false;
      this.$emit('on-cancel');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c48d9308","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/confirm/index.vue
var confirm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-confirm"},[_c('x-dialog',{attrs:{"dialog-class":_vm.theme === 'android' ? 'weui-dialog weui-skin_android' : 'weui-dialog',"mask-transition":_vm.maskTransition,"dialog-transition":_vm.theme === 'android' ? 'vux-fade' : _vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[(!!_vm.title)?_c('div',{staticClass:"weui-dialog__hd",class:{'with-no-content': !_vm.showContent}},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]):_vm._e(),_vm._v(" "),(_vm.showContent)?[(!_vm.showInput)?_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2):_c('div',{staticClass:"vux-prompt"},[(((_vm.getInputAttrs()).type)==='checkbox')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.msg)?_vm._i(_vm.msg,null)>-1:(_vm.msg)},on:{"touchend":_vm.setInputFocus,"change":function($event){var $$a=_vm.msg,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.msg=$$a.concat([$$v]))}else{$$i>-1&&(_vm.msg=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.msg=$$c}}}},'input',_vm.getInputAttrs(),false)):(((_vm.getInputAttrs()).type)==='radio')?_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":"radio"},domProps:{"checked":_vm._q(_vm.msg,null)},on:{"touchend":_vm.setInputFocus,"change":function($event){_vm.msg=null}}},'input',_vm.getInputAttrs(),false)):_c('input',_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.msg),expression:"msg"}],ref:"input",staticClass:"vux-prompt-msgbox",attrs:{"placeholder":_vm.placeholder,"type":(_vm.getInputAttrs()).type},domProps:{"value":(_vm.msg)},on:{"touchend":_vm.setInputFocus,"input":function($event){if($event.target.composing){ return; }_vm.msg=$event.target.value}}},'input',_vm.getInputAttrs(),false))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[(_vm.showCancelButton)?_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_default",attrs:{"href":"javascript:;"},on:{"click":_vm._onCancel}},[_vm._v(_vm._s(_vm.cancelText || '取消'))]):_vm._e(),_vm._v(" "),(_vm.showConfirmButton)?_c('a',{staticClass:"weui-dialog__btn",class:("weui-dialog__btn_" + _vm.confirmType),attrs:{"href":"javascript:;"},on:{"click":_vm._onConfirm}},[_vm._v(_vm._s(_vm.confirmText || '确定'))]):_vm._e()])],2)],1)}
var confirm_staticRenderFns = []
var confirm_esExports = { render: confirm_render, staticRenderFns: confirm_staticRenderFns }
/* harmony default export */ var vux_src_components_confirm = (confirm_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/confirm/index.vue
function confirm_injectStyle (ssrContext) {
  __webpack_require__("nnSp")
}
var confirm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var confirm___vue_template_functional__ = false
/* styles */
var confirm___vue_styles__ = confirm_injectStyle
/* scopeId */
var confirm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var confirm___vue_module_identifier__ = null
var confirm_Component = confirm_normalizeComponent(
  src_components_confirm,
  vux_src_components_confirm,
  confirm___vue_template_functional__,
  confirm___vue_styles__,
  confirm___vue_scopeId__,
  confirm___vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_confirm = (confirm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/form-preview/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_form_preview = ({
  name: 'form-preview',
  props: ['headerLabel', 'headerValue', 'bodyItems', 'footerButtons', 'name'],
  methods: {
    onButtonClick: function onButtonClick(cb, link) {
      cb && cb(this.name);
      if (link) {
        Object(router["b" /* go */])(link, this.$router);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4af8ca20","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/form-preview/index.vue
var form_preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-form-preview weui-form-preview"},[_c('div',{staticClass:"weui-form-preview__hd"},[_c('label',{staticClass:"weui-form-preview__label",domProps:{"innerHTML":_vm._s(_vm.headerLabel)}}),_vm._v(" "),_c('em',{staticClass:"weui-form-preview__value",domProps:{"innerHTML":_vm._s(_vm.headerValue || '&nbsp;')}})]),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__bd"},_vm._l((_vm.bodyItems),function(item){return _c('div',{staticClass:"weui-form-preview__item"},[_c('label',{staticClass:"weui-form-preview__label"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',{staticClass:"weui-form-preview__value"},[_vm._v(_vm._s(item.value))])])}),0),_vm._v(" "),_c('div',{staticClass:"weui-form-preview__ft"},_vm._l((_vm.footerButtons),function(button){return _c('a',{staticClass:"weui-form-preview__btn",class:{'weui-form-preview__btn_default': button.style==='default', 'weui-form-preview__btn_primary': button.style === 'primary'},attrs:{"href":"javascript:"},on:{"click":function($event){return _vm.onButtonClick(button.onButtonClick, button.link)}}},[_vm._v(_vm._s(button.text))])}),0)])}
var form_preview_staticRenderFns = []
var form_preview_esExports = { render: form_preview_render, staticRenderFns: form_preview_staticRenderFns }
/* harmony default export */ var src_components_form_preview = (form_preview_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/form-preview/index.vue
function form_preview_injectStyle (ssrContext) {
  __webpack_require__("ApxZ")
}
var form_preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var form_preview___vue_template_functional__ = false
/* styles */
var form_preview___vue_styles__ = form_preview_injectStyle
/* scopeId */
var form_preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var form_preview___vue_module_identifier__ = null
var form_preview_Component = form_preview_normalizeComponent(
  components_form_preview,
  src_components_form_preview,
  form_preview___vue_template_functional__,
  form_preview___vue_styles__,
  form_preview___vue_scopeId__,
  form_preview___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_form_preview = (form_preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/panel/index.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_panel = ({
  name: 'panel',
  props: {
    header: String,
    footer: Object,
    list: Array,
    type: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onImgError: function onImgError(item, $event) {
      this.$emit('on-img-error', JSON.parse(stringify_default()(item)), $event);
      if (item.fallbackSrc) {
        $event.target.src = item.fallbackSrc;
      }
    },
    getUrl: function getUrl(url) {
      return Object(router["a" /* getUrl */])(url, this.$router);
    },
    onClickFooter: function onClickFooter() {
      this.$emit('on-click-footer');
      Object(router["b" /* go */])(this.footer.url, this.$router);
    },
    onClickHeader: function onClickHeader() {
      this.$emit('on-click-header');
    },
    onItemClick: function onItemClick(item) {
      this.$emit('on-click-item', item);
      Object(router["b" /* go */])(item.url, this.$router);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8e11956","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/panel/index.vue
var panel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header)},on:{"click":_vm.onClickHeader}},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_vm._t("body",[(_vm.type === '1')?_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-media-box weui-media-box_appmsg",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])])}):_vm._e(),_vm._v(" "),(_vm.type === '2')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])}):_vm._e(),_vm._v(" "),(_vm.type === '3')?[_c('div',{staticClass:"weui-media-box weui-media-box_small-appmsg"},[_c('div',{staticClass:"weui-cells"},_vm._l((_vm.list),function(item){return _c('a',{staticClass:"weui-cell weui-cell_access",attrs:{"href":_vm.getUrl(item.url)},on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-cell__hd"},[_c('img',{staticStyle:{"width":"20px","margin-right":"5px","display":"block"},attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]),_vm._v(" "),_c('div',{staticClass:"weui-cell__bd"},[_c('p',{domProps:{"innerHTML":_vm._s(item.title)}})]),_vm._v(" "),_c('span',{staticClass:"weui-cell__ft"})])}),0)])]:_vm._e(),_vm._v(" "),(_vm.type === '4')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}}),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e(),_vm._v(" "),(_vm.type === '5')?_vm._l((_vm.list),function(item){return _c('div',{staticClass:"weui-media-box weui-media-box_text",on:{"click":function($event){$event.preventDefault();return _vm.onItemClick(item)}}},[_c('div',{staticClass:"weui-media-box_appmsg"},[(item.src)?_c('div',{staticClass:"weui-media-box__hd"},[_c('img',{staticClass:"weui-media-box__thumb",attrs:{"src":item.src,"alt":""},on:{"error":function($event){return _vm.onImgError(item, $event)}}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"weui-media-box__bd"},[_c('h4',{staticClass:"weui-media-box__title",domProps:{"innerHTML":_vm._s(item.title)}}),_vm._v(" "),_c('p',{staticClass:"weui-media-box__desc",domProps:{"innerHTML":_vm._s(item.desc)}})])]),_vm._v(" "),(item.meta)?_c('ul',{staticClass:"weui-media-box__info"},[_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.source)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta",domProps:{"innerHTML":_vm._s(item.meta.date)}}),_vm._v(" "),_c('li',{staticClass:"weui-media-box__info__meta weui-media-box__info__meta_extra",domProps:{"innerHTML":_vm._s(item.meta.other)}})]):_vm._e()])}):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title && _vm.type !== '3')?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":_vm.getUrl(_vm.footer.url)},on:{"click":function($event){$event.preventDefault();return _vm.onClickFooter($event)}}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()])])}
var panel_staticRenderFns = []
var panel_esExports = { render: panel_render, staticRenderFns: panel_staticRenderFns }
/* harmony default export */ var src_components_panel = (panel_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/panel/index.vue
function panel_injectStyle (ssrContext) {
  __webpack_require__("429B")
}
var panel_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var panel___vue_template_functional__ = false
/* styles */
var panel___vue_styles__ = panel_injectStyle
/* scopeId */
var panel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var panel___vue_module_identifier__ = null
var panel_Component = panel_normalizeComponent(
  components_panel,
  src_components_panel,
  panel___vue_template_functional__,
  panel___vue_styles__,
  panel___vue_scopeId__,
  panel___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_panel = (panel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/mixins/multi-items.js
var multi_items = __webpack_require__("piuB");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab = ({
  name: 'tab',
  mixins: [multi_items["b" /* parentMixin */]],
  mounted: function mounted() {
    var _this = this;

    // stop bar anmination on first loading
    this.$nextTick(function () {
      setTimeout(function () {
        _this.hasReady = true;
      }, 0);
    });
  },

  props: {
    lineWidth: {
      type: Number,
      default: 3
    },
    activeColor: String,
    barActiveColor: String,
    defaultColor: String,
    disabledColor: String,
    animate: {
      type: Boolean,
      default: true
    },
    customBarWidth: [Function, String],
    preventDefault: Boolean,
    scrollThreshold: {
      type: Number,
      default: 4
    },
    barPosition: {
      type: String,
      default: 'bottom',
      validator: function validator(val) {
        return ['bottom', 'top'].indexOf(val) !== -1;
      }
    }
  },
  computed: {
    barLeft: function barLeft() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return this.currentIndex * (100 / count) + '%';
      }
    },
    barRight: function barRight() {
      if (this.hasReady) {
        var nav = this.$refs.nav;
        var count = this.scrollable ? nav.offsetWidth / this.$children[this.currentIndex || 0].$el.getBoundingClientRect().width : this.number;
        return (count - this.currentIndex - 1) * (100 / count) + '%';
      }
    },

    // when prop:custom-bar-width
    innerBarStyle: function innerBarStyle() {
      return {
        width: typeof this.customBarWidth === 'function' ? this.customBarWidth(this.currentIndex) : this.customBarWidth,
        background: this.barActiveColor || this.activeColor
      };
    },

    // end
    barStyle: function barStyle() {
      var commonStyle = {
        left: this.barLeft,
        right: this.barRight,
        display: 'block',
        height: this.lineWidth + 'px',
        transition: !this.hasReady ? 'none' : null
      };
      if (!this.customBarWidth) {
        commonStyle.background = this.barActiveColor || this.activeColor;
      } else {
        commonStyle.background = 'transparent'; // when=prop:custom-bar-width
      }
      return commonStyle;
    },
    barClass: function barClass() {
      return {
        'vux-tab-ink-bar-transition-forward': this.direction === 'forward',
        'vux-tab-ink-bar-transition-backward': this.direction === 'backward'
      };
    },
    scrollable: function scrollable() {
      return this.number > this.scrollThreshold;
    }
  },
  watch: {
    currentIndex: function currentIndex(newIndex, oldIndex) {
      this.direction = newIndex > oldIndex ? 'forward' : 'backward';
      this.$emit('on-index-change', newIndex, oldIndex);
      this.hasReady && this.scrollToActiveTab();
    }
  },
  data: function data() {
    return {
      direction: 'forward',
      right: '100%',
      hasReady: false
    };
  },

  methods: {
    scrollToActiveTab: function scrollToActiveTab() {
      var _this2 = this;

      if (!this.scrollable || !this.$children || !this.$children.length) {
        return;
      }
      var currentIndexTab = this.$children[this.currentIndex].$el;
      var count = 0;
      // scroll animation
      var step = function step() {
        var scrollDuration = 15;
        var nav = _this2.$refs.nav;
        nav.scrollLeft += (currentIndexTab.offsetLeft - (nav.offsetWidth - currentIndexTab.offsetWidth) / 2 - nav.scrollLeft) / scrollDuration;
        if (++count < scrollDuration) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64ad2681","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab.vue
var tab_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-wrap",class:_vm.barPosition === 'top' ? 'vux-tab-bar-top' : ''},[_c('div',{staticClass:"vux-tab-container"},[_c('div',{ref:"nav",staticClass:"vux-tab",class:[{'vux-tab-no-animate': !_vm.animate},{ scrollable: _vm.scrollable }]},[_vm._t("default"),_vm._v(" "),(_vm.animate)?_c('div',{staticClass:"vux-tab-ink-bar",class:_vm.barClass,style:(_vm.barStyle)},[(_vm.customBarWidth)?_c('span',{staticClass:"vux-tab-bar-inner",style:(_vm.innerBarStyle)}):_vm._e()]):_vm._e()],2)])])}
var tab_staticRenderFns = []
var tab_esExports = { render: tab_render, staticRenderFns: tab_staticRenderFns }
/* harmony default export */ var components_tab_tab = (tab_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab.vue
function tab_injectStyle (ssrContext) {
  __webpack_require__("WDiO")
}
var tab_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab___vue_template_functional__ = false
/* styles */
var tab___vue_styles__ = tab_injectStyle
/* scopeId */
var tab___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab___vue_module_identifier__ = null
var tab_Component = tab_normalizeComponent(
  tab_tab,
  components_tab_tab,
  tab___vue_template_functional__,
  tab___vue_styles__,
  tab___vue_scopeId__,
  tab___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab = (tab_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/tab/tab-item.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var tab_tab_item = ({
  name: 'tab-item',
  mixins: [multi_items["a" /* childMixin */]],
  props: {
    activeClass: String,
    disabled: Boolean,
    badgeBackground: {
      type: String,
      default: '#f74c31'
    },
    badgeColor: {
      type: String,
      default: '#fff'
    },
    badgeLabel: String
  },
  computed: {
    style: function style() {
      return {
        borderWidth: this.$parent.lineWidth + 'px',
        borderColor: this.$parent.activeColor,
        color: this.currentSelected ? this.$parent.activeColor : this.disabled ? this.$parent.disabledColor : this.$parent.defaultColor,
        border: this.$parent.animate ? 'none' : 'auto'
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b8ab944","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-tab-item",class:[_vm.currentSelected ? _vm.activeClass : '', {
    'vux-tab-selected': _vm.currentSelected,
    'vux-tab-disabled': _vm.disabled 
  }],style:(_vm.style),on:{"click":_vm.onItemClick}},[_vm._t("default"),_vm._v(" "),(typeof _vm.badgeLabel !== 'undefined' && _vm.badgeLabel !== '')?_c('span',{staticClass:"vux-tab-item-badge",style:({
      background: _vm.badgeBackground,
      color: _vm.badgeColor
    })},[_vm._v("\n  "+_vm._s(_vm.badgeLabel))]):_vm._e()],2)}
var tab_item_staticRenderFns = []
var tab_item_esExports = { render: tab_item_render, staticRenderFns: tab_item_staticRenderFns }
/* harmony default export */ var components_tab_tab_item = (tab_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/tab/tab-item.vue
var tab_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var tab_item___vue_template_functional__ = false
/* styles */
var tab_item___vue_styles__ = null
/* scopeId */
var tab_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var tab_item___vue_module_identifier__ = null
var tab_item_Component = tab_item_normalizeComponent(
  tab_tab_item,
  components_tab_tab_item,
  tab_item___vue_template_functional__,
  tab_item___vue_styles__,
  tab_item___vue_scopeId__,
  tab_item___vue_module_identifier__
)

/* harmony default export */ var src_components_tab_tab_item = (tab_item_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux/src/components/sticky/sticky.js
var sticky = __webpack_require__("58JO");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/sticky/index.vue
//
//
//
//
//
//



/* harmony default export */ var src_components_sticky = ({
  name: 'sticky',
  data: function data() {
    return {
      initTimes: 0
    };
  },
  created: function created() {
    this.$vux && this.$vux.bus && this.$vux.bus.$on('vux:after-view-enter', this.bindSticky);
  },
  activated: function activated() {
    if (this.initTimes > 0) {
      this.bindSticky();
    }
    this.initTimes++;
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.bindSticky();
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.$vux && this.$vux.bus && this.$vux.bus.$off('vux:after-view-enter', this.bindSticky);
  },

  methods: {
    bindSticky: function bindSticky() {
      var _this2 = this;

      if (this.disabled) {
        return;
      }
      this.$nextTick(function () {
        Object(sticky["a" /* default */])(_this2.$el, {
          scrollBox: _this2.scrollBox,
          offset: _this2.offset,
          checkStickySupport: typeof _this2.checkStickySupport === 'undefined' ? true : _this2.checkStickySupport
        });
      });
    }
  },
  props: ['scrollBox', 'offset', 'checkStickySupport', 'disabled']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02f41544","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/sticky/index.vue
var sticky_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-sticky-box"},[_vm._t("default")],2)}
var sticky_staticRenderFns = []
var sticky_esExports = { render: sticky_render, staticRenderFns: sticky_staticRenderFns }
/* harmony default export */ var vux_src_components_sticky = (sticky_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/sticky/index.vue
function sticky_injectStyle (ssrContext) {
  __webpack_require__("ukTf")
}
var sticky_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var sticky___vue_template_functional__ = false
/* styles */
var sticky___vue_styles__ = sticky_injectStyle
/* scopeId */
var sticky___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var sticky___vue_module_identifier__ = null
var sticky_Component = sticky_normalizeComponent(
  src_components_sticky,
  vux_src_components_sticky,
  sticky___vue_template_functional__,
  sticky___vue_styles__,
  sticky___vue_scopeId__,
  sticky___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_sticky = (sticky_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/card/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_card = ({
  name: 'card',
  props: {
    header: Object,
    footer: Object
  },
  methods: {
    onClickFooter: function onClickFooter() {
      this.footer.link && Object(router["b" /* go */])(this.footer.link, this.$router);
      this.$emit('on-click-footer');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fc027bb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/card/index.vue
var card_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"weui-panel weui-panel_access"},[(_vm.header && _vm.header.title)?_c('div',{staticClass:"weui-panel__hd",domProps:{"innerHTML":_vm._s(_vm.header.title)},on:{"click":function($event){return _vm.$emit('on-click-header')}}}):_vm._e(),_vm._v(" "),_vm._t("header"),_vm._v(" "),_c('div',{staticClass:"weui-panel__bd"},[_c('div',{staticClass:"vux-card-content"},[_vm._t("content")],2)]),_vm._v(" "),_c('div',{staticClass:"weui-panel__ft"},[(_vm.footer && _vm.footer.title)?_c('a',{staticClass:"weui-cell weui-cell_access weui-cell_link",attrs:{"href":"javascript:"},on:{"click":_vm.onClickFooter}},[_c('div',{staticClass:"weui-cell__bd",domProps:{"innerHTML":_vm._s(_vm.footer.title)}})]):_vm._e()]),_vm._v(" "),_vm._t("footer")],2)}
var card_staticRenderFns = []
var card_esExports = { render: card_render, staticRenderFns: card_staticRenderFns }
/* harmony default export */ var src_components_card = (card_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/card/index.vue
function card_injectStyle (ssrContext) {
  __webpack_require__("Gz2+")
}
var card_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var card___vue_template_functional__ = false
/* styles */
var card___vue_styles__ = card_injectStyle
/* scopeId */
var card___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var card___vue_module_identifier__ = null
var card_Component = card_normalizeComponent(
  components_card,
  src_components_card,
  card___vue_template_functional__,
  card___vue_styles__,
  card___vue_scopeId__,
  card___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_card = (card_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
//
//
//
//

/* harmony default export */ var swiper_swiper_item = ({
  name: 'swiper-item',
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.$parent.rerender();
    });
  },
  beforeDestroy: function beforeDestroy() {
    var $parent = this.$parent;
    this.$nextTick(function () {
      $parent.rerender();
    });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4cd6837a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-swiper-item"},[_vm._t("default")],2)}
var swiper_item_staticRenderFns = []
var swiper_item_esExports = { render: swiper_item_render, staticRenderFns: swiper_item_staticRenderFns }
/* harmony default export */ var components_swiper_swiper_item = (swiper_item_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/swiper/swiper-item.vue
var swiper_item_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var swiper_item___vue_template_functional__ = false
/* styles */
var swiper_item___vue_styles__ = null
/* scopeId */
var swiper_item___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var swiper_item___vue_module_identifier__ = null
var swiper_item_Component = swiper_item_normalizeComponent(
  swiper_swiper_item,
  components_swiper_swiper_item,
  swiper_item___vue_template_functional__,
  swiper_item___vue_styles__,
  swiper_item___vue_scopeId__,
  swiper_item___vue_module_identifier__
)

/* harmony default export */ var src_components_swiper_swiper_item = (swiper_item_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/actionsheet/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var components_actionsheet = ({
  name: 'actionsheet',
  mounted: function mounted() {
    var _this = this;

    this.hasHeaderSlot = !!this.$slots.header;
    this.$nextTick(function () {
      _this.$tabbar = document.querySelector('.weui-tabbar');
      _this.$refs.iOSMenu && _this.$refs.iOSMenu.addEventListener('transitionend', _this.onTransitionEnd);
    });
  },

  props: {
    value: Boolean,
    showCancel: Boolean,
    cancelText: String,
    theme: {
      type: String,
      default: 'ios'
    },
    menus: {
      type: [Object, Array],
      default: function _default() {
        return {};
      }
    },
    closeOnClickingMask: {
      type: Boolean,
      default: true
    },
    closeOnClickingMenu: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      hasHeaderSlot: false,
      show: false
    };
  },

  methods: {
    onTransitionEnd: function onTransitionEnd() {
      this.$emit(this.show ? 'on-after-show' : 'on-after-hide');
    },
    onMenuClick: function onMenuClick(text, key) {
      if (typeof text === 'string') {
        this.emitEvent('on-click-menu', key, text);
      } else {
        if (text.type !== 'disabled' && text.type !== 'info') {
          if (text.value || text.value === 0) {
            this.emitEvent('on-click-menu', text.value, text);
          } else {
            this.emitEvent('on-click-menu', '', text);
            this.show = false;
          }
        }
      }
    },
    onClickingMask: function onClickingMask() {
      this.$emit('on-click-mask');
      this.closeOnClickingMask && (this.show = false);
    },
    emitEvent: function emitEvent(event, menu, item) {
      if (event === 'on-click-menu' && !/.noop/.test(menu)) {
        var _item = item;
        if ((typeof _item === 'undefined' ? 'undefined' : typeof_default()(_item)) === 'object') {
          _item = JSON.parse(stringify_default()(_item));
        }
        this.$emit(event, menu, _item);
        this.$emit(event + '-' + menu);
        this.closeOnClickingMenu && (this.show = false);
      }
    },
    fixIos: function fixIos(zIndex) {
      if (this.$el.parentNode && this.$el.parentNode.className.indexOf('v-transfer-dom') !== -1) {
        return;
      }
      if (this.$tabbar && /iphone/i.test(navigator.userAgent)) {
        this.$tabbar.style.zIndex = zIndex;
      }
    }
  },
  watch: {
    show: function show(val) {
      var _this2 = this;

      this.$emit('input', val);
      if (val) {
        this.fixIos(-1);
      } else {
        setTimeout(function () {
          _this2.fixIos(100);
        }, 200);
      }
    },

    value: {
      handler: function handler(val) {
        this.show = val;
      },
      immediate: true
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.fixIos(100);
    this.$refs.iOSMenu && this.$refs.iOSMenu.removeEventListener('transitionend', this.onTransitionEnd);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76e1b9a2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/actionsheet/index.vue
var actionsheet_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-actionsheet"},[_c('transition',{attrs:{"name":"vux-actionsheet-mask"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-mask weui-mask_transparent",on:{"click":_vm.onClickingMask}})]),_vm._v(" "),(_vm.theme === 'android')?_c('div',{staticClass:"weui-skin_android"},[_c('transition',{attrs:{"name":"vux-android-actionsheet"},on:{"after-enter":function($event){return _vm.$emit('on-after-show')},"after-leave":function($event){return _vm.$emit('on-after-hide')}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticClass:"weui-actionsheet"},[_c('div',{staticClass:"weui-actionsheet__menu"},_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})}),0)])])],1):_c('div',{ref:"iOSMenu",staticClass:"weui-actionsheet",class:{'weui-actionsheet_toggle': _vm.show}},[_c('div',{staticClass:"weui-actionsheet__menu"},[(_vm.hasHeaderSlot)?_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._t("header")],2):_vm._e(),_vm._v(" "),_vm._l((_vm.menus),function(text,key){return _c('div',{staticClass:"weui-actionsheet__cell",class:("vux-actionsheet-menu-" + (text.type || 'default')),domProps:{"innerHTML":_vm._s(text.label || text)},on:{"click":function($event){return _vm.onMenuClick(text, key)}}})})],2),_vm._v(" "),(_vm.showCancel)?_c('div',{staticClass:"weui-actionsheet__action",on:{"click":function($event){return _vm.emitEvent('on-click-menu', 'cancel')}}},[_c('div',{staticClass:"weui-actionsheet__cell"},[_vm._v(_vm._s(_vm.cancelText || '取消'))])]):_vm._e()])],1)}
var actionsheet_staticRenderFns = []
var actionsheet_esExports = { render: actionsheet_render, staticRenderFns: actionsheet_staticRenderFns }
/* harmony default export */ var src_components_actionsheet = (actionsheet_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/actionsheet/index.vue
function actionsheet_injectStyle (ssrContext) {
  __webpack_require__("aDjT")
}
var actionsheet_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var actionsheet___vue_template_functional__ = false
/* styles */
var actionsheet___vue_styles__ = actionsheet_injectStyle
/* scopeId */
var actionsheet___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var actionsheet___vue_module_identifier__ = null
var actionsheet_Component = actionsheet_normalizeComponent(
  components_actionsheet,
  src_components_actionsheet,
  actionsheet___vue_template_functional__,
  actionsheet___vue_styles__,
  actionsheet___vue_scopeId__,
  actionsheet___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_actionsheet = (actionsheet_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/load-more/index.vue
//
//
//
//
//
//
//

/* harmony default export */ var components_load_more = ({
  name: 'load-more',
  props: {
    showLoading: {
      type: Boolean,
      default: true
    },
    tip: String
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74122906","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/load-more/index.vue
var load_more_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-loadmore weui-loadmore",class:{'weui-loadmore_line':!_vm.showLoading, 'weui-loadmore_dot': !_vm.showLoading && !_vm.tip}},[(_vm.showLoading)?_c('i',{staticClass:"weui-loading"}):_vm._e(),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.tip || !_vm.showLoading),expression:"tip || !showLoading"}],staticClass:"weui-loadmore__tips"},[_vm._v(_vm._s(_vm.tip))])])}
var load_more_staticRenderFns = []
var load_more_esExports = { render: load_more_render, staticRenderFns: load_more_staticRenderFns }
/* harmony default export */ var src_components_load_more = (load_more_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/load-more/index.vue
function load_more_injectStyle (ssrContext) {
  __webpack_require__("j/tg")
}
var load_more_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var load_more___vue_template_functional__ = false
/* styles */
var load_more___vue_styles__ = load_more_injectStyle
/* scopeId */
var load_more___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var load_more___vue_module_identifier__ = null
var load_more_Component = load_more_normalizeComponent(
  components_load_more,
  src_components_load_more,
  load_more___vue_template_functional__,
  load_more___vue_styles__,
  load_more___vue_scopeId__,
  load_more___vue_module_identifier__
)

/* harmony default export */ var vux_src_components_load_more = (load_more_Component.exports);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/xscroll.js
var xscroll = __webpack_require__("WTNC");
var xscroll_default = /*#__PURE__*/__webpack_require__.n(xscroll);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pulldown.js
var pulldown = __webpack_require__("ypEt");
var pulldown_default = /*#__PURE__*/__webpack_require__.n(pulldown);

// EXTERNAL MODULE: ./node_modules/vux-xscroll/build/cmd/plugins/pullup.js
var pullup = __webpack_require__("qbvd");
var pullup_default = /*#__PURE__*/__webpack_require__.n(pullup);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/scroller/index.vue

//
//
//
//
//
//
//
//
//
//






var scroller_pulldownDefaultConfig = function pulldownDefaultConfig() {
  return {
    content: 'Pull Down To Refresh',
    height: 60,
    autoRefresh: false,
    downContent: 'Pull Down To Refresh',
    upContent: 'Release To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pulldown-'
  };
};

var scroller_pullupDefaultConfig = function pullupDefaultConfig() {
  return {
    content: 'Pull Up To Refresh',
    pullUpHeight: 60,
    height: 40,
    autoRefresh: false,
    downContent: 'Release To Refresh',
    upContent: 'Pull Up To Refresh',
    loadingContent: 'Loading...',
    clsPrefix: 'xs-plugin-pullup-'
  };
};

/* harmony default export */ var src_components_scroller = ({
  name: 'scroller',
  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          pulldownStatus: '',
          pullupStatus: ''
        };
      }
    },
    height: String,
    lockX: Boolean,
    lockY: Boolean,
    scrollbarX: Boolean,
    scrollbarY: Boolean,
    bounce: {
      type: Boolean,
      default: true
    },
    useOriginScroll: {
      type: Boolean,
      default: false
    },
    useTransition: {
      type: Boolean,
      default: true
    },
    preventDefault: {
      type: Boolean,
      default: false
    },
    stopPropagation: Boolean,
    boundryCheck: {
      type: Boolean,
      default: true
    },
    gpuAcceleration: {
      type: Boolean,
      default: true
    },
    usePulldown: {
      type: Boolean,
      default: false
    },
    usePullup: {
      type: Boolean,
      default: false
    },
    /**
    * refer to: http://xscroll.github.io/node_modules/xscroll/doc/PullDown.html
    */
    pulldownConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    pullupConfig: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    enableHorizontalSwiping: {
      type: Boolean,
      default: false
    },
    scrollBottomOffset: {
      type: Number,
      default: 0
    }
  },
  methods: {
    reset: function reset(scrollPosition, duration, easing) {
      if (scrollPosition) {
        if (typeof scrollPosition.left !== 'undefined') {
          this._xscroll.scrollLeft(scrollPosition.left, duration, easing);
        }
        if (typeof scrollPosition.top !== 'undefined') {
          this._xscroll.scrollTop(scrollPosition.top, duration, easing);
        }
      }
      this._xscroll && this._xscroll.resetSize();
    },
    donePulldown: function donePulldown() {
      var _this = this;

      this.pulldown.reset(function () {
        // repaint
        _this.reset();
      });
      this.currentValue.pulldownStatus = 'default';
    },
    disablePullup: function disablePullup() {
      // this._xscroll.unplug(this.pullup)
      this.pullup.stop();
      this.currentValue.pullupStatus = 'disabled';
    },
    enablePullup: function enablePullup() {
      this.currentValue.pullupStatus = 'default';
      this.pullup.restart();
    },
    donePullup: function donePullup() {
      this.pullup.complete();
      this.reset();
      this.currentValue.pullupStatus = 'default';
    },
    getStyles: function getStyles() {
      var height = this.height;
      if (!this.height && this.$el && !this.$el.style.height && this.lockX) {
        height = document.documentElement.clientHeight + 'px';
        this.reset();
      }

      if (this.height && this.height.indexOf('-') === 0) {
        height = document.documentElement.clientHeight + parseInt(this.height) + 'px';
      }
      this.styles = {
        height: '' + height
      };
    }
  },
  created: function created() {
    var _this2 = this;

    if (!this.value) {
      this.currentValue = {
        pulldownStatus: '',
        pullupStatus: ''
      };
    } else {
      this.currentValue = this.value;
    }
    this.handleOrientationchange = function () {
      setTimeout(function () {
        _this2.reset();
      }, 100);
    };
  },
  data: function data() {
    return {
      currentValue: {},
      styles: {}
    };
  },

  watch: {
    currentValue: {
      handler: function handler(val) {
        this.$emit('input', components_scroller_pure(val));
      },
      deep: true
    },
    height: function height() {
      this.getStyles();
    },

    value: {
      handler: function handler(val) {
        if (val.pullupStatus === 'default' && this.currentValue.pullupStatus !== 'default') {
          this.donePullup();
        }
        if (val.pulldownStatus === 'default' && this.currentValue.pulldownStatus !== 'default') {
          this.donePulldown();
        }
        if (val.pullupStatus === 'disabled' && this.currentValue.pullupStatus !== 'disabled') {
          this.disablePullup();
        }
        if (val.pullupStatus === 'enabled' && this.currentValue.pullupStatus === 'disabled') {
          this.enablePullup();
        }
      },
      deep: true
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    this.uuid = Math.random().toString(36).substring(3, 8);
    this.$nextTick(function () {
      _this3.$el.setAttribute('id', 'vux-scroller-' + _this3.uuid);
      var content = null;
      if (_this3.$slots.default) {
        content = _this3.$slots.default[0].elm;
      }
      if (!content) {
        throw new Error('no content is found');
      }

      _this3._xscroll = new xscroll_default.a({
        renderTo: '#vux-scroller-' + _this3.uuid,
        lockX: _this3.lockX,
        lockY: _this3.lockY,
        scrollbarX: _this3.scrollbarX,
        scrollbarY: _this3.scrollbarY,
        content: content,
        bounce: _this3.bounce,
        useOriginScroll: _this3.useOriginScroll,
        useTransition: _this3.useTransition,
        preventDefault: _this3.preventDefault,
        boundryCheck: _this3.boundryCheck,
        gpuAcceleration: _this3.gpuAcceleration,
        stopPropagation: _this3.stopPropagation
      });

      _this3._xscroll.on('scroll', function () {
        if (_this3._xscroll) {
          var top = _this3._xscroll.getScrollTop();
          _this3.$emit('on-scroll', {
            top: top,
            left: _this3._xscroll.getScrollLeft()
          });
          var containerHeight = _this3._xscroll.containerHeight;
          var scrollHeight = _this3._xscroll.height;
          if (top >= containerHeight - scrollHeight - _this3.scrollBottomOffset) {
            _this3.$emit('on-scroll-bottom');
          }
        }
      });

      if (_this3.usePulldown) {
        // if use slot=pulldown
        var container = _this3.$slots.pulldown;
        var config = object_assign_default()(scroller_pulldownDefaultConfig(), _this3.pulldownConfig);
        if (container) {
          config.container = container[0].elm;
        }
        _this3.pulldown = new pulldown_default.a(config);
        _this3._xscroll.plug(_this3.pulldown);
        _this3.pulldown.on('loading', function (e) {
          _this3.$emit('on-pulldown-loading', _this3.uuid);
        });
        _this3.pulldown.on('statuschange', function (val) {
          _this3.currentValue.pulldownStatus = val.newVal;
        });
      }

      if (_this3.usePullup) {
        // if use slot=pullup
        var _container = _this3.$slots.pullup;
        var _config = object_assign_default()(scroller_pullupDefaultConfig(), _this3.pullupConfig);

        if (_container) {
          _config.container = _container[0].elm;
        }
        _this3.pullup = new pullup_default.a(_config);
        _this3._xscroll.plug(_this3.pullup);
        _this3.pullup.on('loading', function (e) {
          _this3.$emit('on-pullup-loading', _this3.uuid);
        });
        _this3.pullup.on('statuschange', function (val) {
          _this3.currentValue.pullupStatus = val.newVal;
        });
      }

      if (_this3.enableHorizontalSwiping) {
        _this3._xscroll.on('panstart', function (e) {
          if (e.direction === 2 || e.direction === 4) {
            e.preventDefault();
            if (_this3.scrollbarY) {
              _this3._xscroll.userConfig.scrollbarY = false;
            }
            _this3._xscroll.userConfig.lockY = true;
          }
        });
        _this3._xscroll.on('panend', function () {
          if (_this3.scrollbarY) {
            _this3._xscroll.userConfig.scrollbarY = true;
          }
          _this3._xscroll.userConfig.lockY = false;
        });
      }

      _this3._xscroll.render();
      window.addEventListener('orientationchange', _this3.handleOrientationchange, false);
    });
    this.getStyles();
  },
  updated: function updated() {
    this.reset();
  },
  destroyed: function destroyed() {
    if (this.pullup) {
      this._xscroll.unplug(this.pullup);
      this.pullup.pluginDestructor();
    }
    if (this.pulldown) {
      this._xscroll.unplug(this.pulldown);
      this.pulldown.pluginDestructor();
    }
    window.removeEventListener('orientationchange', this.handleOrientationchange, false);
    this._xscroll.destroy();
    this._xscroll = null;
  }
});

function components_scroller_pure(obj) {
  return JSON.parse(stringify_default()(obj));
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fb2aed14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/scroller/index.vue
var scroller_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:(_vm.styles)},[_c('div',{staticClass:"xs-container"},[_vm._t("default"),_vm._v(" "),_vm._t("pulldown"),_vm._v(" "),_vm._t("pullup")],2)])}
var scroller_staticRenderFns = []
var scroller_esExports = { render: scroller_render, staticRenderFns: scroller_staticRenderFns }
/* harmony default export */ var vux_src_components_scroller = (scroller_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/scroller/index.vue
function scroller_injectStyle (ssrContext) {
  __webpack_require__("DbKU")
}
var scroller_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var scroller___vue_template_functional__ = false
/* styles */
var scroller___vue_styles__ = scroller_injectStyle
/* scopeId */
var scroller___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var scroller___vue_module_identifier__ = null
var scroller_Component = scroller_normalizeComponent(
  src_components_scroller,
  vux_src_components_scroller,
  scroller___vue_template_functional__,
  scroller___vue_styles__,
  scroller___vue_scopeId__,
  scroller___vue_module_identifier__
)

/* harmony default export */ var node_modules_vux_src_components_scroller = (scroller_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/search/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_search = ({
  name: 'search',
  mixins: [uuid["a" /* default */]],
  props: {
    required: {
      type: Boolean,
      default: false
    },
    placeholder: String,
    cancelText: String,
    value: {
      type: String,
      default: ''
    },
    results: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoFixed: {
      type: Boolean,
      default: true
    },
    top: {
      type: String,
      default: '0px'
    },
    position: {
      type: String,
      default: 'fixed'
    },
    autoScrollToTop: Boolean
  },
  created: function created() {
    if (this.value) {
      this.currentValue = this.value;
    }
  },

  computed: {
    fixPosition: function fixPosition() {
      if (this.isFixed) {
        return this.position === 'absolute' ? 'absolute' : 'fixed';
      }
      return 'static';
    }
  },
  methods: {
    emitEvent: function emitEvent() {
      var _this = this;

      this.$nextTick(function () {
        _this.$emit('input', _this.currentValue);
        _this.$emit('on-change', _this.currentValue);
      });
    },
    onComposition: function onComposition($event, type) {
      if (type === 'start') {
        this.onInput = true;
      }
      if (type === 'end') {
        this.onInput = false;
        this.emitEvent();
      }
      if (type === 'input') {
        if (!this.onInput) {
          this.emitEvent();
        }
      }
    },
    clear: function clear() {
      this.currentValue = '';
      this.emitEvent();
      this.isFocus = true;
      this.setFocus();
      if (this.autoFixed && !this.isFixed) {
        this.isFixed = true;
      }
      this.$emit('on-clear');
    },
    cancel: function cancel() {
      this.isCancel = true;
      this.currentValue = '';
      this.emitEvent();
      this.isFixed = false;
      this.$emit('on-cancel');
    },
    handleResultClick: function handleResultClick(item) {
      this.$emit('result-click', item); // just for compatibility
      this.$emit('on-result-click', item);
      this.isCancel = true;
      this.isFixed = false;
    },
    touch: function touch() {
      this.isCancel = false;
      if (this.autoFixed) {
        this.isFixed = true;
      }
      this.$emit('on-touch');
    },
    setFocus: function setFocus() {
      this.$refs.input.focus();
    },
    setBlur: function setBlur() {
      this.$refs.input.blur();
    },
    onFocus: function onFocus() {
      this.isFocus = true;
      this.$emit('on-focus');
      this.touch();
    },
    onBlur: function onBlur() {
      this.isFocus = false;
      this.$emit('on-blur');
    }
  },
  data: function data() {
    return {
      onInput: false,
      currentValue: '',
      isCancel: true,
      isFocus: false,
      isFixed: false
    };
  },

  watch: {
    isFixed: function isFixed(val) {
      if (val === true) {
        this.setFocus();
        this.isFocus = true;

        if (this.autoScrollToTop) {
          setTimeout(function () {
            window.scrollTo(0, 0);
          }, 150);
        }
      } else {}
    },
    value: function value(val) {
      this.currentValue = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9205242a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/search/index.vue
var search_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-search-box",class:{ 'vux-search-fixed':_vm.isFixed },style:({ top: _vm.isFixed ? _vm.top : '', position: _vm.fixPosition })},[_c('div',{staticClass:"weui-search-bar",class:{'weui-search-bar_focusing': !_vm.isCancel || _vm.currentValue}},[_vm._t("left"),_vm._v(" "),_c('form',{staticClass:"weui-search-bar__form",attrs:{"action":"."},on:{"submit":function($event){$event.preventDefault();return _vm.$emit('on-submit', _vm.value)}}},[_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFixed && _vm.autoFixed),expression:"!isFixed && autoFixed"}],staticClass:"vux-search-mask",attrs:{"for":("search_input_" + _vm.uuid)},on:{"click":_vm.touch}}),_vm._v(" "),_c('div',{staticClass:"weui-search-bar__box"},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.currentValue),expression:"currentValue"}],ref:"input",staticClass:"weui-search-bar__input",attrs:{"type":"search","autocomplete":"off","id":("search_input_" + _vm.uuid),"placeholder":_vm.placeholder,"required":_vm.required},domProps:{"value":(_vm.currentValue)},on:{"focus":_vm.onFocus,"blur":_vm.onBlur,"compositionstart":function($event){return _vm.onComposition($event, 'start')},"compositionend":function($event){return _vm.onComposition($event, 'end')},"input":[function($event){if($event.target.composing){ return; }_vm.currentValue=$event.target.value},function($event){return _vm.onComposition($event, 'input')}]}}),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.currentValue),expression:"currentValue"}],staticClass:"weui-icon-clear",attrs:{"href":"javascript:"},on:{"click":_vm.clear}})]),_vm._v(" "),_c('label',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isFocus && !_vm.value),expression:"!isFocus && !value"}],staticClass:"weui-search-bar__label",attrs:{"for":("search_input_" + _vm.uuid)}},[_c('i',{staticClass:"weui-icon-search"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.placeholder || '搜索'))])])]),_vm._v(" "),_c('a',{staticClass:"weui-search-bar__cancel-btn",attrs:{"href":"javascript:"},on:{"click":_vm.cancel}},[_vm._v(_vm._s(_vm.cancelText || '取消')+"\n    ")]),_vm._v(" "),_vm._t("right")],2),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isFixed),expression:"isFixed"}],staticClass:"weui-cells vux-search_show"},[_vm._t("default"),_vm._v(" "),_vm._l((_vm.results),function(item){return _c('div',{staticClass:"weui-cell weui-cell_access",on:{"click":function($event){return _vm.handleResultClick(item)}}},[_c('div',{staticClass:"weui-cell__bd weui-cell_primary"},[_c('p',[_vm._v(_vm._s(item.title))])])])})],2)])}
var search_staticRenderFns = []
var search_esExports = { render: search_render, staticRenderFns: search_staticRenderFns }
/* harmony default export */ var src_components_search = (search_esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/search/index.vue
function search_injectStyle (ssrContext) {
  __webpack_require__("Ngll")
}
var search_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var search___vue_template_functional__ = false
/* styles */
var search___vue_styles__ = search_injectStyle
/* scopeId */
var search___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var search___vue_module_identifier__ = null
var search_Component = search_normalizeComponent(
  components_search,
  src_components_search,
  search___vue_template_functional__,
  search___vue_styles__,
  search___vue_scopeId__,
  search___vue_module_identifier__
)


/* harmony default export */ var vux_src_components_search = (search_Component.exports);

// EXTERNAL MODULE: ./src/common/apis.js
var apis = __webpack_require__("9u+O");

// CONCATENATED MODULE: ./src/plugins/apis.js
/**
 * @file API的Vue插件（方便页面组件内部调用）
 */



apis["a" /* default */].install = function (Vue) {
  Vue.prototype.$apis = apis["a" /* default */];
};

/* harmony default export */ var plugins_apis = (apis["a" /* default */]);
// EXTERNAL MODULE: ./src/plugins/axios.js
var axios = __webpack_require__("Kkag");

// EXTERNAL MODULE: ./src/plugins/oss.js
var oss = __webpack_require__("tcjW");

// CONCATENATED MODULE: ./src/plugins/index.js
/*
 * @Author: your name
 * @Date: 2021-02-19 09:01:15
 * @LastEditTime: 2021-02-19 10:31:35
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: \show-m\src\plugins\index.js
 */





vue_esm["a" /* default */].use(plugins_apis);
vue_esm["a" /* default */].use(oss["a" /* default */]);
vue_esm["a" /* default */].use(axios["a" /* default */]);
// CONCATENATED MODULE: ./src/main.js















































vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);

vue_esm["a" /* default */].component('x-header', vux_src_components_x_header);
vue_esm["a" /* default */].component('x-img', vux_src_components_x_img);
vue_esm["a" /* default */].component('popup', node_modules_vux_src_components_popup);
vue_esm["a" /* default */].component('popup-header', vux_src_components_popup_header);
vue_esm["a" /* default */].component('group', vux_src_components_group);
vue_esm["a" /* default */].component('x-input', vux_src_components_x_input);
vue_esm["a" /* default */].component('cell', vux_src_components_cell);
vue_esm["a" /* default */].component('selector', vux_src_components_selector);
vue_esm["a" /* default */].component('popupPicker', vux_src_components_popup_picker);
vue_esm["a" /* default */].component('datetime', vux_src_components_datetime);
vue_esm["a" /* default */].component('x-number', vux_src_components_x_number);
vue_esm["a" /* default */].component('x-address', vux_src_components_x_address);
vue_esm["a" /* default */].component('x-textarea', vux_src_components_x_textarea);
vue_esm["a" /* default */].component('x-switch', vux_src_components_x_switch);
vue_esm["a" /* default */].component('x-button', vux_src_components_x_button);
vue_esm["a" /* default */].component('toast', vux_src_components_toast);
vue_esm["a" /* default */].component('alertModule', alert_module["a" /* default */]);
vue_esm["a" /* default */].component('checklist', vux_src_components_checklist);
vue_esm["a" /* default */].component('checker', src_components_checker_checker);
vue_esm["a" /* default */].component('checkerItem', src_components_checker_checker_item);
vue_esm["a" /* default */].component('confirm', node_modules_vux_src_components_confirm);
vue_esm["a" /* default */].component('divider', vux_src_components_divider);
vue_esm["a" /* default */].component('chinaAddressData', china_address_default.a);
vue_esm["a" /* default */].component('form-preview', vux_src_components_form_preview);
vue_esm["a" /* default */].component('panel', vux_src_components_panel);
vue_esm["a" /* default */].component('tab', src_components_tab_tab);
vue_esm["a" /* default */].component('tab-item', src_components_tab_tab_item);
vue_esm["a" /* default */].component('sticky', node_modules_vux_src_components_sticky);
vue_esm["a" /* default */].component('msg', vux_src_components_msg);
vue_esm["a" /* default */].component('card', vux_src_components_card);
vue_esm["a" /* default */].component('swiper', vux_src_components_swiper_swiper);
vue_esm["a" /* default */].component('swiper-item', src_components_swiper_swiper_item);
vue_esm["a" /* default */].component('actionsheet', vux_src_components_actionsheet);
vue_esm["a" /* default */].component('load-more', vux_src_components_load_more);
vue_esm["a" /* default */].component('scroller', node_modules_vux_src_components_scroller);
vue_esm["a" /* default */].component('search', vux_src_components_search);

vue_esm["a" /* default */].directive('transfer-dom', transfer_dom["a" /* default */]);

fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  router: src_router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app-box');

/***/ }),

/***/ "Ngll":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NxQa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "OJg6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "POKh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-resize-sensor/src/resize-sensor.vue
//
//
//
//
//
//



/* harmony default export */ var resize_sensor = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vue-resize-sensor/src/resize-sensor.vue
//
//
//
//
//
//



/* harmony default export */ var src_resize_sensor = ({

	// thanks to https://github.com/marcj/css-element-queries
	props: {
		initial: {
			type: Boolean,
			default: false
		}
	},
	data: function () {
		return {
			size: {
				width: -1,
				height: -1
			}
		};
	},
	methods: {
		reset: function () {

			var expand = this.$el.firstChild;
			var shrink = this.$el.lastChild;
			expand.scrollLeft = 100000;
			expand.scrollTop = 100000;
			shrink.scrollLeft = 100000;
			shrink.scrollTop = 100000;
		},
		update: function () {

			this.size.width = this.$el.offsetWidth;
			this.size.height = this.$el.offsetHeight;
		}
	},
	watch: {
		size: {
			deep: true,
			handler: function (size) {

				this.reset();
				this.$emit('resize', { width: this.size.width, height: this.size.height });
			}
		}
	},
	render: function (create) {

		var style = 'position: absolute; left: 0; top: 0; right: 0; bottom: 0; overflow: hidden; z-index: -1; visibility: hidden;';
		var styleChild = 'position: absolute; left: 0; top: 0;';

		return create('div', {
			style: style + 'animation-name: resizeSensorVisibility;',
			on: {
				'~animationstart': this.update
			}
		}, [create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 100000px; height: 100000px;'
		})]), create('div', {
			style: style,
			on: {
				scroll: this.update
			}
		}, [create('div', {
			style: styleChild + 'width: 200%; height: 200%;'
		})])]);
	},
	beforeDestroy: function () {

		this.$emit('resize', { width: 0, height: 0 });
		this.$emit('resizeSensorBeforeDestroy');
	},
	mounted: function () {

		if (this.initial === true) this.$nextTick(this.update);

		if (this.$el.offsetParent !== this.$el.parentNode) this.$el.parentNode.style.position = 'relative';

		if ('attachEvent' in this.$el && !('AnimationEvent' in window)) {

			var onresizeHandler = function () {

				this.update();
				removeOnresizeEvent();
			}.bind(this);

			var removeOnresizeEvent = function () {

				this.$el.detachEvent('onresize', onresizeHandler);
				this.$off('resizeSensorBeforeDestroy', removeOnresizeEvent);
			}.bind(this);

			this.$el.attachEvent('onresize', onresizeHandler);
			this.$on('resizeSensorBeforeDestroy', removeOnresizeEvent);
			this.reset();
		}
	}
});
// CONCATENATED MODULE: ./node_modules/vue-resize-sensor/src/resize-sensor.vue
function injectStyle (ssrContext) {
  __webpack_require__("bxgH")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_resize_sensor,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var vue_resize_sensor_src_resize_sensor = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QX3Y":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RMDY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RlV+":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zsbm.5bfd92a.jpg";

/***/ }),

/***/ "Rzzg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/04icon.0e6dea3.png";

/***/ }),

/***/ "TL5K":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "WDiO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YxJB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ var flexbox_flexbox = ({
  name: 'flexbox',
  props: {
    gutter: {
      type: Number,
      default: 8
    },
    orient: {
      type: String,
      default: 'horizontal'
    },
    justify: String,
    align: String,
    wrap: String,
    direction: String
  },
  computed: {
    styles: function styles() {
      var styles = {
        'justify-content': this.justify,
        '-webkit-justify-content': this.justify,
        'align-items': this.align,
        '-webkit-align-items': this.align,
        'flex-wrap': this.wrap,
        '-webkit-flex-wrap': this.wrap,
        'flex-direction': this.direction,
        '-webkit-flex-direction': this.direction
      };
      return styles;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28eb4a1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/flexbox/flexbox.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-flexbox",class:{
  'vux-flex-col': _vm.orient === 'vertical',
  'vux-flex-row': _vm.orient === 'horizontal'
},style:(_vm.styles)},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_flexbox_flexbox = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/flexbox/flexbox.vue
function injectStyle (ssrContext) {
  __webpack_require__("cqo/")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  flexbox_flexbox,
  components_flexbox_flexbox,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_flexbox_flexbox = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ZXp/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/show2.2b2f925.jpeg";

/***/ }),

/***/ "aDjT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aiyf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bVX/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bxgH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "chSg":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/show3.7b08519.jpeg";

/***/ }),

/***/ "cqo/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "d1Im":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpWl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "e8KX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hSo9":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/top.dbef306.jpg";

/***/ }),

/***/ "iD+u":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/03icon.3950215.png";

/***/ }),

/***/ "j/tg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jQI1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jYbJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kllH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mZb/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzja":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/vux/src/components/x-dialog/index.vue + 3 modules
var x_dialog = __webpack_require__("/kga");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./node_modules/vux/src/components/alert/index.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var src_components_alert = ({
  name: 'alert',
  components: {
    XDialog: x_dialog["a" /* default */]
  },
  created: function created() {
    if (typeof this.value !== 'undefined') {
      this.showValue = this.value;
    }
  },

  props: {
    value: Boolean,
    title: String,
    content: String,
    buttonText: String,
    hideOnBlur: {
      type: Boolean,
      default: false
    },
    maskTransition: {
      type: String,
      default: 'vux-mask'
    },
    dialogTransition: {
      type: String,
      default: 'vux-dialog'
    },
    maskZIndex: [Number, String]
  },
  data: function data() {
    return {
      showValue: false
    };
  },

  methods: {
    _onHide: function _onHide() {
      this.showValue = false;
    }
  },
  watch: {
    value: function value(val) {
      this.showValue = val;
    },
    showValue: function showValue(val) {
      this.$emit('input', val);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0222073a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vux/src/components/alert/index.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vux-alert"},[_c('x-dialog',{attrs:{"mask-transition":_vm.maskTransition,"dialog-transition":_vm.dialogTransition,"hide-on-blur":_vm.hideOnBlur,"mask-z-index":_vm.maskZIndex},on:{"on-hide":function($event){return _vm.$emit('on-hide')},"on-show":function($event){return _vm.$emit('on-show')}},model:{value:(_vm.showValue),callback:function ($$v) {_vm.showValue=$$v},expression:"showValue"}},[_c('div',{staticClass:"weui-dialog__hd"},[_c('strong',{staticClass:"weui-dialog__title"},[_vm._v(_vm._s(_vm.title))])]),_vm._v(" "),_c('div',{staticClass:"weui-dialog__bd"},[_vm._t("default",[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})])],2),_vm._v(" "),_c('div',{staticClass:"weui-dialog__ft"},[_c('a',{staticClass:"weui-dialog__btn weui-dialog__btn_primary",attrs:{"href":"javascript:;"},on:{"click":_vm._onHide}},[_vm._v(_vm._s(_vm.buttonText || '确定'))])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var vux_src_components_alert = (esExports);
// CONCATENATED MODULE: ./node_modules/vux/src/components/alert/index.vue
function injectStyle (ssrContext) {
  __webpack_require__("55wj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  src_components_alert,
  vux_src_components_alert,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)


/* harmony default export */ var node_modules_vux_src_components_alert = __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "nC7b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nCxI":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/common-foot.e335ea2.png";

/***/ }),

/***/ "nfGx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nnSp":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "owug":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qHQD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qKv7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "quyP":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "rFhX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrtQ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/zhhlxh.e1a7a8b.png";

/***/ }),

/***/ "tcjW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ali_oss__ = __webpack_require__("/Z0X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_ali_oss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_ali_oss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apis__ = __webpack_require__("9u+O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__axios__ = __webpack_require__("Kkag");


/*
 * @Author: your name
 * @Date: 2021-02-19 10:28:50
 * @LastEditTime: 2021-02-19 10:54:11
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \show-m\src\plugins\oss.js
 */




var ossPlugin = {};

ossPlugin.install = function (Vue) {
  Vue.mixin({
    methods: {
      glGetOssClient: function glGetOssClient() {
        var _this = this;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
          var _ref, data, cfg;

          return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.prev = 0;

                  if (!(_this.$oss && !_this.$oss.client)) {
                    _context.next = 13;
                    break;
                  }

                  _context.next = 4;
                  return __WEBPACK_IMPORTED_MODULE_4__axios__["a" /* default */].get(__WEBPACK_IMPORTED_MODULE_3__common_apis__["a" /* default */].common.oss);

                case 4:
                  _context.t0 = _context.sent;

                  if (_context.t0) {
                    _context.next = 7;
                    break;
                  }

                  _context.t0 = {};

                case 7:
                  _ref = _context.t0;
                  data = _ref.data;
                  cfg = {
                    endpoint: data.endpoint,
                    accessKeyId: data.appKey,
                    accessKeySecret: data.appSecret,
                    bucket: data.bucketname
                  };


                  global.$goss = global.$goss || {};
                  _this.$oss.client = global.$goss.client = new __WEBPACK_IMPORTED_MODULE_2_ali_oss___default.a(cfg);
                  _this.$oss.baseDir = global.$goss.baseDir = data.basedir;

                case 13:
                  _context.next = 18;
                  break;

                case 15:
                  _context.prev = 15;
                  _context.t1 = _context['catch'](0);

                  _this.$notify({
                    title: '提示',
                    message: _context.t1 && _context.t1.data && _context.t1.data.msg || 'oss配置获取错误',
                    type: 'error',
                    duration: 3000
                  });

                case 18:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this, [[0, 15]]);
        }))();
      }
    }
  });
};

/* harmony default export */ __webpack_exports__["a"] = (ossPlugin);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("DuR2")))

/***/ }),

/***/ "u46b":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/officialUrl.c681adb.png";

/***/ }),

/***/ "uGHa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukTf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNBe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wF+D":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wl8b":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xtLV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zyhK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/02icon.06add96.png";

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.d6f7cb8d128f6cffec43.js